{
  "15": "15",
  "- {{line}}": "- {{line}}",
  "- Licensed by …\n- Payouts in …": "- Licensed by …\n- Payouts in …",
  "–": "–",
  ", your personal AI business partner.": ", your personal AI business partner.",
  ":": ":",
  "…": "…",
  "… will be known as": "… will be known as",
  "… will be reached at": "… will be reached at",
  "… will be remembered for": "… will be remembered for",
  "· {{n}} credit": "· {{n}} credit",
  "· {{n}} credits": "· {{n}} credits",
  "(auto)": "(auto)",
  "(Optional)": "(Optional)",
  "(setup + first month)": "(setup + first month)",
  "{{address}} is set up. Its card's <0/> shows how to add it to any mail app.": "{{address}} is set up. Its card's <0/> shows how to add it to any mail app.",
  "{{amount}} ({{pct}}) last month": "{{amount}} ({{pct}}) last month",
  "{{amount}} / month": "{{amount}} / month",
  "{{amount}} / month, prorated": "{{amount}} / month, prorated",
  "{{amount}} added": "{{amount}} added",
  "{{amount}} added to your Main wallet.": "{{amount}} added to your Main wallet.",
  "{{amount}} after commission": "{{amount}} after commission",
  "{{amount}} available": "{{amount}} available",
  "{{amount}} moved to your ads budget.": "{{amount}} moved to your ads budget.",
  "{{amount}} paid. Your credits are on the way.": "{{amount}} paid. Your credits are on the way.",
  "{{amount}} was added to your wallet balance.": "{{amount}} was added to your wallet balance.",
  "{{asset}} on {{network}}": "{{asset}} on {{network}}",
  "{{beats}} beats · {{seconds}}s": "{{beats}} beats · {{seconds}}s",
  "{{beats}} beats · about {{minutes}} min to generate": "{{beats}} beats · about {{minutes}} min to generate",
  "{{brand}} · {{badge}}": "{{brand}} · {{badge}}",
  "{{brand}} Key Metrics": "{{brand}} Key Metrics",
  "{{brand}} Metrics": "{{brand}} Metrics",
  "{{brand}} website": "{{brand}} website",
  "{{brand}}: {{piece}}": "{{brand}}: {{piece}}",
  "{{brandName}} Ads Budget": "{{brandName}} Ads Budget",
  "{{brandName}} Settings": "{{brandName}} Settings",
  "{{cadence}}, a new article is written and published in {{language}}.": "{{cadence}}, a new article is written and published in {{language}}.",
  "{{cadence}}, a new article is written and published on your blog in {{language}}. The first one is written within about an hour.": "{{cadence}}, a new article is written and published on your blog in {{language}}. The first one is written within about an hour.",
  "{{casino}} collections": "{{casino}} collections",
  "{{channel}} · {{category}}": "{{channel}} · {{category}}",
  "{{conv}}% to FTD": "{{conv}}% to FTD",
  "{{count}} articles_one": "{{count}} article",
  "{{count}} articles_other": "{{count}} articles",
  "{{count}} blocked": "{{count}} blocked",
  "{{count}} credit": "{{count}} credit",
  "{{count}} credits": "{{count}} credits",
  "{{count}} failed": "{{count}} failed",
  "{{count}} feature selected": "{{count}} feature selected",
  "{{count}} features selected": "{{count}} features selected",
  "{{count}} finished": "{{count}} finished",
  "{{count}} games": "{{count}} games",
  "{{count}} games_one": "{{count}} game",
  "{{count}} games_other": "{{count}} games",
  "{{count}} games selected_one": "{{count}} game selected",
  "{{count}} games selected_other": "{{count}} games selected",
  "{{count}} in progress": "{{count}} in progress",
  "{{count}} min read": "{{count}} min read",
  "{{count}} min read_one": "{{count}} min read",
  "{{count}} min read_other": "{{count}} min read",
  "{{count}} results": "{{count}} results",
  "{{count}} results_one": "{{count}} result",
  "{{count}} results_other": "{{count}} results",
  "{{count}} selected": "{{count}} selected",
  "{{count}} sizes_one": "{{count}} size",
  "{{count}} sizes_other": "{{count}} sizes",
  "{{count}} waiting": "{{count}} waiting",
  "{{cpa}} · ${{spent}} spent today": "{{cpa}} · ${{spent}} spent today",
  "{{credits}} credit": "{{credits}} credit",
  "{{credits}} credit was added to your balance.": "{{credits}} credit was added to your balance.",
  "{{credits}} credits": "{{credits}} credits",
  "{{credits}} credits were added to your balance.": "{{credits}} credits were added to your balance.",
  "{{domain}} currently receives email at another provider. Setting up forwarding will replace that, and existing addresses on this domain will stop receiving mail.": "{{domain}} currently receives email at another provider. Setting up forwarding will replace that, and existing addresses on this domain will stop receiving mail.",
  "{{domain}} doesn't receive email anywhere yet, so you're clear to set up forwarding.": "{{domain}} doesn't receive email anywhere yet, so you're clear to set up forwarding.",
  "{{domain}} is connected through your own registrar. Add the TXT record Google gives you in your registrar's DNS settings.": "{{domain}} is connected through your own registrar. Add the TXT record Google gives you in your registrar's DNS settings.",
  "{{done}} of {{total}} formats": "{{done}} of {{total}} formats",
  "{{done}} of {{total}} parts done": "{{done}} of {{total}} parts done",
  "{{done}} of {{total}} ready": "{{done}} of {{total}} ready",
  "{{enabled}} of {{total}}": "{{enabled}} of {{total}}",
  "{{game}} · {{count}} formats_one": "{{game}} · {{count}} format",
  "{{game}} · {{count}} formats_other": "{{game}} · {{count}} formats",
  "{{impressions}} impressions · {{clicks}} clicks": "{{impressions}} impressions · {{clicks}} clicks",
  "{{label}} · Needs review": "{{label}} · Needs review",
  "{{label}} · not found: {{target}}": "{{label}} · not found: {{target}}",
  "{{label}} (optional)": "{{label}} (optional)",
  "{{label}} carousel published to your site.": "{{label}} carousel published to your site.",
  "{{label}} carousel reverted to the previous published order.": "{{label}} carousel reverted to the previous published order.",
  "{{label}} copied": "{{label}} copied",
  "{{label}} copied to clipboard": "{{label}} copied to clipboard",
  "{{label}} downloaded": "{{label}} downloaded",
  "{{label}} logo": "{{label}} logo",
  "{{label}} restored to the generated logo": "{{label}} restored to the generated logo",
  "{{label}} theme": "{{label}} theme",
  "{{label}} updated": "{{label}} updated",
  "{{layers}} · {{cast}}": "{{layers}} · {{cast}}",
  "{{length}} characters": "{{length}} characters",
  "{{level}} is not available": "{{level}} is not available",
  "{{m}} hidden": "{{m}} hidden",
  "{{m}} in your catalogue": "{{m}} in your catalogue",
  "{{m}} keep their own text": "{{m}} keep their own text",
  "{{m}} min": "{{m}} min",
  "{{m}} min {{s}} sec": "{{m}} min {{s}} sec",
  "{{margin}}% margin": "{{margin}}% margin",
  "{{memoLabel}} is required for this network": "{{memoLabel}} is required for this network",
  "{{message}}. Sign in with the mailbox password instead.": "{{message}}. Sign in with the mailbox password instead.",
  "{{min}} to {{max}} days.": "{{min}} to {{max}} days.",
  "{{model}} makes clips up to {{max}}s, so the length is now {{n}}s. For a longer ad, pick Seedance 2.5 or use the Video Ads tab.": "{{model}} makes clips up to {{max}}s, so the length is now {{n}}s. For a longer ad, pick Seedance 2.5 or use the Video Ads tab.",
  "{{month}} commission": "{{month}} commission",
  "{{n}}": "{{n}}",
  "{{n}} ad links": "{{n}} ad links",
  "{{n}} added": "{{n}} added",
  "{{n}} banners": "{{n}} banners",
  "{{n}} banners, all carousels published": "{{n}} banners, all carousels published",
  "{{n}} browsers": "{{n}} browsers",
  "{{n}} building": "{{n}} building",
  "{{n}} carousels to publish": "{{n}} carousels to publish",
  "{{n}} collections": "{{n}} collections",
  "{{n}} competitors analyzed": "{{n}} competitors analyzed",
  "{{n}} credit": "{{n}} credit",
  "{{n}} credits": "{{n}} credits",
  "{{n}} days ago": "{{n}} days ago",
  "{{n}} done": "{{n}} done",
  "{{n}} drafts": "{{n}} drafts",
  "{{n}} drafts to finish": "{{n}} drafts to finish",
  "{{n}} empty fields: {{fields}}": "{{n}} empty fields: {{fields}}",
  "{{n}} failed": "{{n}} failed",
  "{{n}} game lists": "{{n}} game lists",
  "{{n}} games": "{{n}} games",
  "{{n}} hours ago": "{{n}} hours ago",
  "{{n}} HTML5 banners": "{{n}} HTML5 banners",
  "{{n}} icons": "{{n}} icons",
  "{{n}} image banners": "{{n}} image banners",
  "{{n}} KB": "{{n}} KB",
  "{{n}} landing pages": "{{n}} landing pages",
  "{{n}} layers": "{{n}} layers",
  "{{n}} lists": "{{n}} lists",
  "{{n}} lists edited": "{{n}} lists edited",
  "{{n}} lists on your Homepage": "{{n}} lists on your Homepage",
  "{{n}} lists on your Homepage, {{m}} hidden": "{{n}} lists on your Homepage, {{m}} hidden",
  "{{n}} lists on your Homepage, 1 hidden": "{{n}} lists on your Homepage, 1 hidden",
  "{{n}} live landing pages": "{{n}} live landing pages",
  "{{n}} logos ready": "{{n}} logos ready",
  "{{n}} mailboxes": "{{n}} mailboxes",
  "{{n}} MB": "{{n}} MB",
  "{{n}} mini-games": "{{n}} mini-games",
  "{{n}} minutes ago": "{{n}} minutes ago",
  "{{n}} new articles": "{{n}} new articles",
  "{{n}} of {{max}}": "{{n}} of {{max}}",
  "{{n}} of {{total}}": "{{n}} of {{total}}",
  "{{n}} pages · {{m}} without a description": "{{n}} pages · {{m}} without a description",
  "{{n}} pages · 1 without a description": "{{n}} pages · 1 without a description",
  "{{n}} pages · none without a description": "{{n}} pages · none without a description",
  "{{n}} pages and {{m}} languages changed": "{{n}} pages and {{m}} languages changed",
  "{{n}} pages and 1 language changed": "{{n}} pages and 1 language changed",
  "{{n}} pages changed": "{{n}} pages changed",
  "{{n}} pages viewed come from people who arrived from it earlier.": "{{n}} pages viewed come from people who arrived from it earlier.",
  "{{n}} pages viewed come from people who arrived through it earlier.": "{{n}} pages viewed come from people who arrived through it earlier.",
  "{{n}} pages viewed come from people who arrived through them earlier.": "{{n}} pages viewed come from people who arrived through them earlier.",
  "{{n}} pages were viewed through it, by people a later source or link brought back, so they count there.": "{{n}} pages were viewed through it, by people a later source or link brought back, so they count there.",
  "{{n}} pages will use the new default description": "{{n}} pages will use the new default description",
  "{{n}} people": "{{n}} people",
  "{{n}} queued": "{{n}} queued",
  "{{n}} reach": "{{n}} reach",
  "{{n}} removed": "{{n}} removed",
  "{{n}} seconds": "{{n}} seconds",
  "{{n}} selected": "{{n}} selected",
  "{{n}} tracking links send visitors here. Unpublishing sends them to your casino's home page and their tracking is lost.": "{{n}} tracking links send visitors here. Unpublishing sends them to your casino's home page and their tracking is lost.",
  "{{n}} unpublished changes on {{page}}": "{{n}} unpublished changes on {{page}}",
  "{{n}} versions": "{{n}} versions",
  "{{n}} video ads": "{{n}} video ads",
  "{{n}} views": "{{n}} views",
  "{{n}} visibility": "{{n}} visibility",
  "{{n}} visitors": "{{n}} visitors",
  "{{n}}%": "{{n}}%",
  "{{n}}d ago": "{{n}}d ago",
  "{{n}}h ago": "{{n}}h ago",
  "{{n}}m ago": "{{n}}m ago",
  "{{name}}": "{{name}}",
  "{{name}} · {{kind}}": "{{name}} · {{kind}}",
  "{{name}} +{{n}}": "{{name}} +{{n}}",
  "{{name}} banner": "{{name}} banner",
  "{{name}} configurations": "{{name}} configurations",
  "{{name}} creative": "{{name}} creative",
  "{{name}} Details": "{{name}} Details",
  "{{name}} feature pack includes": "{{name}} feature pack includes",
  "{{name}} for": "{{name}} for",
  "{{name}} format": "{{name}} format",
  "{{name}} is deleted for good, with its mood board, definition and samples.": "{{name}} is deleted for good, with its mood board, definition and samples.",
  "{{name}} is live": "{{name}} is live",
  "{{name}} is now active": "{{name}} is now active",
  "{{name}} keeps running until the end of your current billing period, then stops renewing. You can re-activate it anytime.": "{{name}} keeps running until the end of your current billing period, then stops renewing. You can re-activate it anytime.",
  "{{name}} new logo preview": "{{name}} new logo preview",
  "{{name}} new look": "{{name}} new look",
  "{{name}} pack": "{{name}} pack",
  "{{name}} preview": "{{name}} preview",
  "{{name}} version": "{{name}} version",
  "{{name}} will keep renewing": "{{name}} will keep renewing",
  "{{name}} will turn off at the end of your billing period": "{{name}} will turn off at the end of your billing period",
  "{{name}}'s tracking link couldn't be sent to this page.": "{{name}}'s tracking link couldn't be sent to this page.",
  "{{name}}'s tracking link now goes to this page.": "{{name}}'s tracking link now goes to this page.",
  "{{names}} +{{n}}": "{{names}} +{{n}}",
  "{{names}}, in More": "{{names}}, in More",
  "{{offer}} · {{languages}}": "{{offer}} · {{languages}}",
  "{{offer}} · {{path}}": "{{offer}} · {{path}}",
  "{{pct}}%": "{{pct}}%",
  "{{pct}}% of them made a first deposit": "{{pct}}% of them made a first deposit",
  "{{period}} ({{from}} - {{to}}, UTC)": "{{period}} ({{from}} - {{to}}, UTC)",
  "{{period}} (UTC)": "{{period}} (UTC)",
  "{{piece}}: checking": "{{piece}}: checking",
  "{{piece}}: done ({{outcome}})": "{{piece}}: done ({{outcome}})",
  "{{piece}}: not ready yet": "{{piece}}: not ready yet",
  "{{piece}}: on its page ({{view}})": "{{piece}}: on its page ({{view}})",
  "{{piece}}: pop-up": "{{piece}}: pop-up",
  "{{piece}}: waits in Spotlight": "{{piece}}: waits in Spotlight",
  "{{place}} · {{status}}": "{{place}} · {{status}}",
  "{{place}} · {{status}} · {{time}}": "{{place}} · {{status}} · {{time}}",
  "{{price}} each": "{{price}} each",
  "{{price}} per month": "{{price}} per month",
  "{{price}}/month": "{{price}}/month",
  "{{price}}/year": "{{price}}/year",
  "{{quota}} each, same domain, same setup.": "{{quota}} each, same domain, same setup.",
  "{{ratio}} format": "{{ratio}} format",
  "{{remaining}} characters left": "{{remaining}} characters left",
  "{{s}} sec": "{{s}} sec",
  "{{source}}, one by one.": "{{source}}, one by one.",
  "{{source}}, one by one. Pick one to see only its visitors.": "{{source}}, one by one. Pick one to see only its visitors.",
  "{{source}}, one by one. Some small or very long source names count only in Other.": "{{source}}, one by one. Some small or very long source names count only in Other.",
  "{{start}}–{{end}} of {{total}}": "{{start}}–{{end}} of {{total}}",
  "{{style}} · {{count}} sizes_one": "{{style}} · {{count}} size",
  "{{style}} · {{count}} sizes_other": "{{style}} · {{count}} sizes",
  "{{style}} is flagged as mature content, which video generation models don't support. Choose a different primary art style to generate video ads.": "{{style}} is flagged as mature content, which video generation models don't support. Choose a different primary art style to generate video ads.",
  "{{symbol}}{{amount}}": "{{symbol}}{{amount}}",
  "{{symbol}}{{price}} /month": "{{symbol}}{{price}} /month",
  "{{symbol}}{{price}} per month": "{{symbol}}{{price}} per month",
  "{{tier}} benefits (max)": "{{tier}} benefits (max)",
  "{{time}} on average": "{{time}} on average",
  "{{type}} · {{dim}} ·": "{{type}} · {{dim}} ·",
  "{{type}} · {{dim}} · {{channels}}": "{{type}} · {{dim}} · {{channels}}",
  "{{type}} Record": "{{type}} Record",
  "{{url}} goes offline: until you publish it again, visitors to it are sent to your casino's home page. Tracking links to this address keep working once you republish.": "{{url}} goes offline: until you publish it again, visitors to it are sent to your casino's home page. Tracking links to this address keep working once you republish.",
  "{{url}} is live. It is taken offline first (visitors to it are sent to your casino's home page), then archived. This can take a few seconds.": "{{url}} is live. It is taken offline first (visitors to it are sent to your casino's home page), then archived. This can take a few seconds.",
  "{{used}} of {{max}}": "{{used}} of {{max}}",
  "{{used}} of {{total}} secondary keywords appear in the texts": "{{used}} of {{total}} secondary keywords appear in the texts",
  "{{used}} used": "{{used}} used",
  "{{visible}} visible · {{hidden}} hidden": "{{visible}} visible · {{hidden}} hidden",
  "{{visitors}} browsers came through these links {{period}}.": "{{visitors}} browsers came through these links {{period}}.",
  "{{visitors}} browsers came through this affiliate's links {{period}}.": "{{visitors}} browsers came through this affiliate's links {{period}}.",
  "{{visitors}} browsers came through this campaign's links {{period}}.": "{{visitors}} browsers came through this campaign's links {{period}}.",
  "{{visitors}} browsers came through this link {{period}}.": "{{visitors}} browsers came through this link {{period}}.",
  "{{visitors}} browsers came through your own links {{period}}.": "{{visitors}} browsers came through your own links {{period}}.",
  "{{visitors}} browsers visited these pages {{period}}.": "{{visitors}} browsers visited these pages {{period}}.",
  "{{visitors}} browsers visited this landing page {{period}}.": "{{visitors}} browsers visited this landing page {{period}}.",
  "{{visitors}} browsers visited this page {{period}}.": "{{visitors}} browsers visited this page {{period}}.",
  "{{visitors}} browsers visited your website {{period}}.": "{{visitors}} browsers visited your website {{period}}.",
  "{{visitors}} people came through these links {{period}}.": "{{visitors}} people came through these links {{period}}.",
  "{{visitors}} people came through this affiliate's links {{period}}.": "{{visitors}} people came through this affiliate's links {{period}}.",
  "{{visitors}} people came through this campaign's links {{period}}.": "{{visitors}} people came through this campaign's links {{period}}.",
  "{{visitors}} people came through this link {{period}}.": "{{visitors}} people came through this link {{period}}.",
  "{{visitors}} people came through your own links {{period}}.": "{{visitors}} people came through your own links {{period}}.",
  "{{visitors}} people visited these pages {{period}}.": "{{visitors}} people visited these pages {{period}}.",
  "{{visitors}} people visited this landing page {{period}}.": "{{visitors}} people visited this landing page {{period}}.",
  "{{visitors}} people visited this page {{period}}.": "{{visitors}} people visited this page {{period}}.",
  "{{visitors}} people visited your website {{period}}.": "{{visitors}} people visited your website {{period}}.",
  "{{width}} × {{height}} px · {{ratio}}": "{{width}} × {{height}} px · {{ratio}}",
  "{page} · Your brand": "{page} · Your brand",
  "**{{title}}** is ready. I saved it as a draft, so nothing is live until you publish it.": "**{{title}}** is ready. I saved it as a draft, so nothing is live until you publish it.",
  "**Jackpot!** FTUX - Getting Started's test strip is on, in this header.": "**Jackpot!** FTUX - Getting Started's test strip is on, in this header.",
  "**Jackpot!** The support@ mailbox is now visible in Settings > Mailbox.": "**Jackpot!** The support@ mailbox is now visible in Settings > Mailbox.",
  "**No win this time.** FTUX - Getting Started's test strip is off again.": "**No win this time.** FTUX - Getting Started's test strip is off again.",
  "**No win this time.** The support@ mailbox is hidden again.": "**No win this time.** The support@ mailbox is hidden again.",
  "/casino/* means every page under Casino and only sets their footer text.": "/casino/* means every page under Casino and only sets their footer text.",
  "/day": "/day",
  "/month": "/month",
  "•": "•",
  "• {{count}} Players": "• {{count}} Players",
  "• {{count}} similar brands": "• {{count}} similar brands",
  "• {{count}} Similar Brands": "• {{count}} Similar Brands",
  "• {{score}} build score": "• {{score}} build score",
  "• {{span}}": "• {{span}}",
  "• before revenue arrives": "• before revenue arrives",
  "• the opportunity ahead": "• the opportunity ahead",
  "+{{count}} more": "+{{count}} more",
  "+{{count}} more_one": "+{{count}} more",
  "+{{count}} more_other": "+{{count}} more",
  "+{{count}} others": "+{{count}} others",
  "+{{n}}": "+{{n}}",
  "+{{n}} more": "+{{n}} more",
  "<0/> is right here when you want a list of your own.": "<0/> is right here when you want a list of your own.",
  "<0/> is right here whenever you want another.": "<0/> is right here whenever you want another.",
  "~{{n}} KB": "~{{n}} KB",
  "~{{n}} MB": "~{{n}} MB",
  "${{spent}} spent today": "${{spent}} spent today",
  "1 ad link": "1 ad link",
  "1 banner": "1 banner",
  "1 banner, all carousels published": "1 banner, all carousels published",
  "1 browser": "1 browser",
  "1 browser came through these links {{period}}.": "1 browser came through these links {{period}}.",
  "1 browser came through this affiliate's links {{period}}.": "1 browser came through this affiliate's links {{period}}.",
  "1 browser came through this campaign's links {{period}}.": "1 browser came through this campaign's links {{period}}.",
  "1 browser came through this link {{period}}.": "1 browser came through this link {{period}}.",
  "1 browser came through your own links {{period}}.": "1 browser came through your own links {{period}}.",
  "1 browser visited these pages {{period}}.": "1 browser visited these pages {{period}}.",
  "1 browser visited this landing page {{period}}.": "1 browser visited this landing page {{period}}.",
  "1 browser visited this page {{period}}.": "1 browser visited this page {{period}}.",
  "1 browser visited your website {{period}}.": "1 browser visited your website {{period}}.",
  "1 carousel to publish": "1 carousel to publish",
  "1 collection": "1 collection",
  "1 day": "1 day",
  "1 draft": "1 draft",
  "1 draft to finish": "1 draft to finish",
  "1 empty field: {{fields}}": "1 empty field: {{fields}}",
  "1 game": "1 game",
  "1 game list": "1 game list",
  "1 hidden": "1 hidden",
  "1 hour ago": "1 hour ago",
  "1 HTML5 banner": "1 HTML5 banner",
  "1 image banner": "1 image banner",
  "1 keeps its own text": "1 keeps its own text",
  "1 landing page": "1 landing page",
  "1 list": "1 list",
  "1 list edited": "1 list edited",
  "1 list on your Homepage": "1 list on your Homepage",
  "1 list on your Homepage, hidden": "1 list on your Homepage, hidden",
  "1 live landing page": "1 live landing page",
  "1 logo ready": "1 logo ready",
  "1 mailbox": "1 mailbox",
  "1 mini-game": "1 mini-game",
  "1 minute ago": "1 minute ago",
  "1 new article": "1 new article",
  "1 page · {{m}} without a description": "1 page · {{m}} without a description",
  "1 page · 1 without a description": "1 page · 1 without a description",
  "1 page · none without a description": "1 page · none without a description",
  "1 page and {{m}} languages changed": "1 page and {{m}} languages changed",
  "1 page and 1 language changed": "1 page and 1 language changed",
  "1 page changed": "1 page changed",
  "1 page viewed comes from someone who arrived from it earlier.": "1 page viewed comes from someone who arrived from it earlier.",
  "1 page viewed comes from someone who arrived through it earlier.": "1 page viewed comes from someone who arrived through it earlier.",
  "1 page viewed comes from someone who arrived through them earlier.": "1 page viewed comes from someone who arrived through them earlier.",
  "1 page was viewed through it, by someone a later source or link brought back, so they count there.": "1 page was viewed through it, by someone a later source or link brought back, so they count there.",
  "1 page will use the new default description": "1 page will use the new default description",
  "1 person": "1 person",
  "1 person came through these links {{period}}.": "1 person came through these links {{period}}.",
  "1 person came through this affiliate's links {{period}}.": "1 person came through this affiliate's links {{period}}.",
  "1 person came through this campaign's links {{period}}.": "1 person came through this campaign's links {{period}}.",
  "1 person came through this link {{period}}.": "1 person came through this link {{period}}.",
  "1 person came through your own links {{period}}.": "1 person came through your own links {{period}}.",
  "1 person visited these pages {{period}}.": "1 person visited these pages {{period}}.",
  "1 person visited this landing page {{period}}.": "1 person visited this landing page {{period}}.",
  "1 person visited this page {{period}}.": "1 person visited this page {{period}}.",
  "1 person visited your website {{period}}.": "1 person visited your website {{period}}.",
  "1 tracking link sends visitors here. Unpublishing sends them to your casino's home page and its tracking is lost.": "1 tracking link sends visitors here. Unpublishing sends them to your casino's home page and its tracking is lost.",
  "1 unpublished change on {{page}}": "1 unpublished change on {{page}}",
  "1 video ad": "1 video ad",
  "1 view": "1 view",
  "1 visitor": "1 visitor",
  "12 digits": "12 digits",
  "12 Months Trajectory": "12 Months Trajectory",
  "14 days": "14 days",
  "18 digits": "18 digits",
  "18+": "18+",
  "20% of monthly revenue": "20% of monthly revenue",
  "3 digits": "3 digits",
  "30 days": "30 days",
  "30-day Retention": "30-day Retention",
  "5 digits": "5 digits",
  "6-digit code": "6-digit code",
  "7 days": "7 days",
  "9 digits": "9 digits",
  "90 days": "90 days",
  "A 60-90 word plain answer, shown in a box before the article": "A 60-90 word plain answer, shown in a box before the article",
  "A behind-the-scenes look at your website: its identifiers, web address, build dates and the live status of its content deployment.": "A behind-the-scenes look at your website: its identifiers, web address, build dates and the live status of its content deployment.",
  "A blog that keeps posting keeps players coming back. With Autopilot, a new article is written and published on {{brand}}'s blog about every 2 days, paid with your AI credits.": "A blog that keeps posting keeps players coming back. With Autopilot, a new article is written and published on {{brand}}'s blog about every 2 days, paid with your AI credits.",
  "A blog that keeps posting keeps players coming back. With Autopilot, new articles are written and published for you.": "A blog that keeps posting keeps players coming back. With Autopilot, new articles are written and published for you.",
  "A bold, trending-style frame of {{brand}}, high-contrast and punchy, the \"{{headline}}\" offer set as loud on-brand headline text.": "A bold, trending-style frame of {{brand}}, high-contrast and punchy, the \"{{headline}}\" offer set as loud on-brand headline text.",
  "A browser can have both counted and excluded visits, so browsers do not add up across rows.": "A browser can have both counted and excluded visits, so browsers do not add up across rows.",
  "A browser counts once across an address and its lp. and app. forms. Every figure counts under the source that last brought the browser.": "A browser counts once across an address and its lp. and app. forms. Every figure counts under the source that last brought the browser.",
  "A browser counts once on each address, and the total adds your addresses.": "A browser counts once on each address, and the total adds your addresses.",
  "A build step needs attention before your website can go live.": "A build step needs attention before your website can go live.",
  "A celebratory shot of the {{brand}} win, glowing coins framing the \"{{subtitle}}\" detail shown as crisp on-brand text.": "A celebratory shot of the {{brand}} win, glowing coins framing the \"{{subtitle}}\" detail shown as crisp on-brand text.",
  "A celebratory shot of the {{brand}} win, glowing coins framing the \"{{subtitle}}\" detail.": "A celebratory shot of the {{brand}} win, glowing coins framing the \"{{subtitle}}\" detail.",
  "A clean hero shot of the \"{{headline}}\" offer, the \"{{subtitle}}\" detail crisp and well lit.": "A clean hero shot of the \"{{headline}}\" offer, the \"{{subtitle}}\" detail crisp and well lit.",
  "A clean hero shot of the \"{{headline}}\" offer, the \"{{subtitle}}\" detail shown as crisp, legible on-brand text.": "A clean hero shot of the \"{{headline}}\" offer, the \"{{subtitle}}\" detail shown as crisp, legible on-brand text.",
  "A confident closing frame of the {{brand}} promotion with the \"{{cta}}\" button front and centre.": "A confident closing frame of the {{brand}} promotion with the \"{{cta}}\" button front and centre.",
  "A confident closing frame of the {{brand}} promotion with the \"{{cta}}\" call to action rendered prominently as a bold button.": "A confident closing frame of the {{brand}} promotion with the \"{{cta}}\" call to action rendered prominently as a bold button.",
  "A confident closing frame with the offer and call to action clearly in view.": "A confident closing frame with the offer and call to action clearly in view.",
  "a day ago": "a day ago",
  "A different one each time": "A different one each time",
  "A do-not-miss closing frame with the \"{{cta}}\" call to action rendered prominently as a bold button over the {{brand}} scene.": "A do-not-miss closing frame with the \"{{cta}}\" call to action rendered prominently as a bold button over the {{brand}} scene.",
  "A euphoric closing frame of the {{brand}} jackpot with the \"{{cta}}\" call to action as a glowing button and the \"{{subtitle}}\" detail shown as clean on-brand text.": "A euphoric closing frame of the {{brand}} jackpot with the \"{{cta}}\" call to action as a glowing button and the \"{{subtitle}}\" detail shown as clean on-brand text.",
  "A euphoric win moment for {{brand}}, coins and confetti raining, the \"{{subtitle}}\" detail shown as crisp, glowing on-brand text.": "A euphoric win moment for {{brand}}, coins and confetti raining, the \"{{subtitle}}\" detail shown as crisp, glowing on-brand text.",
  "a few images with the look you want.": "a few images with the look you want.",
  "A full-screen game or a regular offer page. Every template leads to your welcome offer.": "A full-screen game or a regular offer page. Every template leads to your welcome offer.",
  "A guide, a game review, the week's news: every post gives players a reason to come back to {{brand}}.": "A guide, a game review, the week's news: every post gives players a reason to come back to {{brand}}.",
  "A high-end closing frame of the {{brand}} promotion with the \"{{cta}}\" call to action rendered as a clean, premium button.": "A high-end closing frame of the {{brand}} promotion with the \"{{cta}}\" call to action rendered as a clean, premium button.",
  "A high-energy closing frame with the \"{{cta}}\" button glowing over the {{brand}} artwork.": "A high-energy closing frame with the \"{{cta}}\" button glowing over the {{brand}} artwork.",
  "A high-energy closing frame with the \"{{cta}}\" call to action rendered prominently as a bold button over the {{brand}} artwork.": "A high-energy closing frame with the \"{{cta}}\" call to action rendered prominently as a bold button over the {{brand}} artwork.",
  "A high-energy closing frame with the \"{{cta}}\" call to action rendered prominently as a bold button over the {{brand}} streak.": "A high-energy closing frame with the \"{{cta}}\" call to action rendered prominently as a bold button over the {{brand}} streak.",
  "A high-energy neon frame of the {{brand}} win, coins and light streaks exploding across the composition.": "A high-energy neon frame of the {{brand}} win, coins and light streaks exploding across the composition.",
  "A high-urgency frame of {{brand}}, the \"{{headline}}\" offer set as bold on-brand headline text with a countdown pulse.": "A high-urgency frame of {{brand}}, the \"{{headline}}\" offer set as bold on-brand headline text with a countdown pulse.",
  "A lavish, high-roller frame of {{brand}} in gold and black, the \"{{headline}}\" offer set as elegant on-brand headline text.": "A lavish, high-roller frame of {{brand}} in gold and black, the \"{{headline}}\" offer set as elegant on-brand headline text.",
  "A link to this page that credits the visits and sign-ups it brings to you.": "A link to this page that credits the visits and sign-ups it brings to you.",
  "A live preview arrives with your banner tools. Meanwhile, edit your brand marks in the Banners tab.": "A live preview arrives with your banner tools. Meanwhile, edit your brand marks in the Banners tab.",
  "a minute ago": "a minute ago",
  "A name couldn't be suggested. Please try again.": "A name couldn't be suggested. Please try again.",
  "A neon-drenched night frame of {{brand}}, glowing signage and reflections, the \"{{headline}}\" offer set as electric on-brand headline text.": "A neon-drenched night frame of {{brand}}, glowing signage and reflections, the \"{{headline}}\" offer set as electric on-brand headline text.",
  "A new article is written and published for you {{cadence}}. Turn it off here anytime.": "A new article is written and published for you {{cadence}}. Turn it off here anytime.",
  "A new group": "A new group",
  "A new language starts from the default language's copy. Lumio writes every language when you generate.": "A new language starts from the default language's copy. Lumio writes every language when you generate.",
  "A new style couldn't be started. Please try again.": "A new style couldn't be started. Please try again.",
  "A new version is ready": "A new version is ready",
  "a newer version saved this run": "a newer version saved this run",
  "A page": "A page",
  "A peak-momentum shot of the {{brand}} streak, cascading wins and coins framing the \"{{subtitle}}\" detail as crisp on-brand text.": "A peak-momentum shot of the {{brand}} streak, cascading wins and coins framing the \"{{subtitle}}\" detail as crisp on-brand text.",
  "A person can appear in more than one row.": "A person can appear in more than one row.",
  "A person can have both counted and excluded visits, so people do not add up across rows.": "A person can have both counted and excluded visits, so people do not add up across rows.",
  "A personal AI assistant. Let me show you around.": "A personal AI assistant. Let me show you around.",
  "A polished hero shot of the \"{{headline}}\" game with the \"{{subtitle}}\" detail highlighted.": "A polished hero shot of the \"{{headline}}\" game with the \"{{subtitle}}\" detail highlighted.",
  "A polished hero shot of the \"{{headline}}\" game with the \"{{subtitle}}\" detail shown as crisp, legible on-brand text.": "A polished hero shot of the \"{{headline}}\" game with the \"{{subtitle}}\" detail shown as crisp, legible on-brand text.",
  "A polished hero shot of the new {{brand}} game with the \"{{subtitle}}\" detail shown as crisp, legible on-brand text.": "A polished hero shot of the new {{brand}} game with the \"{{subtitle}}\" detail shown as crisp, legible on-brand text.",
  "A premium, cinematic frame of {{brand}} with rich lighting and depth, the \"{{headline}}\" offer set as refined on-brand headline text.": "A premium, cinematic frame of {{brand}} with rich lighting and depth, the \"{{headline}}\" offer set as refined on-brand headline text.",
  "A prestige closing frame of the {{brand}} promotion with the \"{{cta}}\" call to action rendered as a refined gold button.": "A prestige closing frame of the {{brand}} promotion with the \"{{cta}}\" call to action rendered as a refined gold button.",
  "A punchy closing frame with the \"{{cta}}\" call to action rendered prominently as a bold button over the {{brand}} scene.": "A punchy closing frame with the \"{{cta}}\" call to action rendered prominently as a bold button over the {{brand}} scene.",
  "A question readers ask": "A question readers ask",
  "A quick landing page promotes the brand's marketing offer, and this brand has none yet. Add one, then try again.": "A quick landing page promotes the brand's marketing offer, and this brand has none yet. Add one, then try again.",
  "A ready-made starting point": "A ready-made starting point",
  "A regular offer page or a full-screen game. Every template leads to your welcome offer. You can change it later.": "A regular offer page or a full-screen game. Every template leads to your welcome offer. You can change it later.",
  "A route can't contain ? or #": "A route can't contain ? or #",
  "A section (footer only)": "A section (footer only)",
  "A short summary": "A short summary",
  "A single clip advertises one subject. Keep one, or use the Video Ads tab for more.": "A single clip advertises one subject. Keep one, or use the Video Ads tab for more.",
  "A site in {{look}}": "A site in {{look}}",
  "A site with your design in this look (not your own content).": "A site with your design in this look (not your own content).",
  "A sleek closing frame of the {{brand}} game with the \"{{cta}}\" button front and centre.": "A sleek closing frame of the {{brand}} game with the \"{{cta}}\" button front and centre.",
  "A sleek closing frame of the {{brand}} game with the \"{{cta}}\" call to action rendered prominently as a bold button.": "A sleek closing frame of the {{brand}} game with the \"{{cta}}\" call to action rendered prominently as a bold button.",
  "A title is required.": "A title is required.",
  "A triumphant closing frame of the {{brand}} coin storm with the \"{{cta}}\" call to action rendered prominently as a glowing button.": "A triumphant closing frame of the {{brand}} coin storm with the \"{{cta}}\" call to action rendered prominently as a glowing button.",
  "A triumphant closing frame with the \"{{cta}}\" call to action rendered prominently as a glowing button over the {{brand}} celebration.": "A triumphant closing frame with the \"{{cta}}\" call to action rendered prominently as a glowing button over the {{brand}} celebration.",
  "A unique tracking link will be generated automatically. Share it with the influencer so all registrations are attributed correctly.": "A unique tracking link will be generated automatically. Share it with the influencer so all registrations are attributed correctly.",
  "A unique tracking link will be generated automatically. Share it with the partner so all registrations are attributed correctly.": "A unique tracking link will be generated automatically. Share it with the partner so all registrations are attributed correctly.",
  "A vibrant social-first shot of the \"{{headline}}\" offer, the \"{{subtitle}}\" detail shown as crisp, legible on-brand text.": "A vibrant social-first shot of the \"{{headline}}\" offer, the \"{{subtitle}}\" detail shown as crisp, legible on-brand text.",
  "A visitor is one phone or computer, so someone who visits on two devices counts twice. Numbers update every few minutes.": "A visitor is one phone or computer, so someone who visits on two devices counts twice. Numbers update every few minutes.",
  "A vivid neon shot of the \"{{headline}}\" offer, the \"{{subtitle}}\" detail shown as crisp, glowing on-brand text.": "A vivid neon shot of the \"{{headline}}\" offer, the \"{{subtitle}}\" detail shown as crisp, glowing on-brand text.",
  "A wealth-explosion frame for {{brand}}, cascading coins framing the \"{{subtitle}}\" detail as crisp, glowing on-brand text.": "A wealth-explosion frame for {{brand}}, cascading coins framing the \"{{subtitle}}\" detail as crisp, glowing on-brand text.",
  "About {{days}} days until your Pulse page is available": "About {{days}} days until your Pulse page is available",
  "About {{n}} min per beat": "About {{n}} min per beat",
  "About {{n}} min per clip": "About {{n}} min per clip",
  "About 1 day until your Pulse page is available": "About 1 day until your Pulse page is available",
  "About a minute": "About a minute",
  "About every {{n}} days": "About every {{n}} days",
  "About every {{n}} hours": "About every {{n}} hours",
  "About every {{n}} minutes": "About every {{n}} minutes",
  "About every day": "About every day",
  "About every hour": "About every hour",
  "About every minute": "About every minute",
  "About the author": "About the author",
  "About the initial order of the games": "About the initial order of the games",
  "About this plan": "About this plan",
  "About two minutes": "About two minutes",
  "Above market": "Above market",
  "Above the fold": "Above the fold",
  "Above the offer": "Above the offer",
  "Accelerate through the streak as wins cascade and the \"{{subtitle}}\" detail rises in as bright supporting text.": "Accelerate through the streak as wins cascade and the \"{{subtitle}}\" detail rises in as bright supporting text.",
  "Accent": "Accent",
  "Account": "Account",
  "Account & Sign In": "Account & Sign In",
  "Account details": "Account details",
  "ACCOUNT DETAILS": "ACCOUNT DETAILS",
  "Account number": "Account number",
  "Account type": "Account type",
  "Acquisition": "Acquisition",
  "ACQUISITION": "ACQUISITION",
  "Acquisition · Affiliates": "Acquisition · Affiliates",
  "Acquisition Channels": "Acquisition Channels",
  "Acquisition source": "Acquisition source",
  "Acquisition, then <0/>, whenever you want partners.": "Acquisition, then <0/>, whenever you want partners.",
  "Across {{n}} tracking link(s) for {{name}}.": "Across {{n}} tracking link(s) for {{name}}.",
  "Across {{n}} tracking link(s) for {{name}}. Clicks are not in this data set; they live in the affiliate reports.": "Across {{n}} tracking link(s) for {{name}}. Clicks are not in this data set; they live in the affiliate reports.",
  "Action": "Action",
  "Action needed": "Action needed",
  "Action required": "Action required",
  "Actions for {{name}}": "Actions for {{name}}",
  "Actions for {{size}}": "Actions for {{size}}",
  "Activate": "Activate",
  "Activate {{name}} to": "Activate {{name}} to",
  "Activate {{name}} to unlock": "Activate {{name}} to unlock",
  "Activate a new campaign": "Activate a new campaign",
  "Activate a suggested campaign to launch your first one, it shows up here while it runs.": "Activate a suggested campaign to launch your first one, it shows up here while it runs.",
  "Activate a suggested promotion to launch your first one, it shows up here while it runs.": "Activate a suggested promotion to launch your first one, it shows up here while it runs.",
  "Activate now": "Activate now",
  "Activate now for free": "Activate now for free",
  "Activate the casino blog": "Activate the casino blog",
  "Activate this campaign and get promoted on popular websites like:": "Activate this campaign and get promoted on popular websites like:",
  "Activate this promotion to advertise to players via:": "Activate this promotion to advertise to players via:",
  "Activated Players": "Activated Players",
  "Activating…": "Activating…",
  "Activation Benefits": "Activation Benefits",
  "Active": "Active",
  "Active invite links": "Active invite links",
  "Active Players": "Active Players",
  "Activity": "Activity",
  "Activity is loaded for your top {{count}} players by amount wagered. Players beyond that show as having none yet.": "Activity is loaded for your top {{count}} players by amount wagered. Players beyond that show as having none yet.",
  "AD": "AD",
  "Ad budget": "Ad budget",
  "Ad budget top-up": "Ad budget top-up",
  "Ad budget views": "Ad budget views",
  "Ad copy": "Ad copy",
  "Ad servers": "Ad servers",
  "Ad spend": "Ad spend",
  "Ad Spend": "Ad Spend",
  "Adapted for": "Adapted for",
  "Adapting the sizes…": "Adapting the sizes…",
  "Add": "Add",
  "Add {{n}} credits": "Add {{n}} credits",
  "Add {{name}} to list": "Add {{name}} to list",
  "Add {page} where the page name goes": "Add {page} where the page name goes",
  "Add ${{tuAmount}} to your acquisition budget.": "Add ${{tuAmount}} to your acquisition budget.",
  "Add a category name before saving": "Add a category name before saving",
  "Add a focus keyword to score this page": "Add a focus keyword to score this page",
  "Add a headline": "Add a headline",
  "Add a hero image.": "Add a hero image.",
  "Add a keyword": "Add a keyword",
  "Add a link": "Add a link",
  "Add a meta description for search results.": "Add a meta description for search results.",
  "Add a mood board, and a direction or characters if you like. Lumio reads them, writes your style and draws four samples in it.": "Add a mood board, and a direction or characters if you like. Lumio reads them, writes your style and draws four samples in it.",
  "Add a question": "Add a question",
  "Add a source": "Add a source",
  "Add a subheadline": "Add a subheadline",
  "Add a tag and press Enter": "Add a tag and press Enter",
  "Add a tag and press Space": "Add a tag and press Space",
  "Add a takeaway": "Add a takeaway",
  "Add a title and some body content, then come back to this.": "Add a title and some body content, then come back to this.",
  "Add a title before saving": "Add a title before saving",
  "Add address": "Add address",
  "Add affiliate": "Add affiliate",
  "Add Affiliate": "Add Affiliate",
  "Add all {{n}}": "Add all {{n}}",
  "Add an At-a-glance summary.": "Add an At-a-glance summary.",
  "Add an element": "Add an element",
  "Add an image and Lumio names it": "Add an image and Lumio names it",
  "Add an image first.": "Add an image first.",
  "Add another prize label": "Add another prize label",
  "Add at least one game": "Add at least one game",
  "Add at least one mood board image": "Add at least one mood board image",
  "Add at least one mood board image first.": "Add at least one mood board image first.",
  "Add at least one mood board image to extract a style.": "Add at least one mood board image to extract a style.",
  "Add at least one to extract a style.": "Add at least one to extract a style.",
  "Add banner": "Add banner",
  "Add banners": "Add banners",
  "Add banners from your pool to show them here, in the order you choose.": "Add banners from your pool to show them here, in the order you choose.",
  "Add beat": "Add beat",
  "Add billing details →": "Add billing details →",
  "Add campaign": "Add campaign",
  "Add character": "Add character",
  "Add character image": "Add character image",
  "Add column": "Add column",
  "Add credits": "Add credits",
  "Add engagement features for your brand": "Add engagement features for your brand",
  "Add free mail on {{domain}}": "Add free mail on {{domain}}",
  "Add funds to Main wallet": "Add funds to Main wallet",
  "Add Funds to Main Wallet": "Add Funds to Main Wallet",
  "Add games": "Add games",
  "Add games: open the game search": "Add games: open the game search",
  "Add gamification elements to make your casino more dynamic and engaging.": "Add gamification elements to make your casino more dynamic and engaging.",
  "Add image": "Add image",
  "Add images": "Add images",
  "Add influencer": "Add influencer",
  "Add Influencer": "Add Influencer",
  "Add ingredients": "Add ingredients",
  "Add list": "Add list",
  "Add List": "Add List",
  "Add logo": "Add logo",
  "Add mascot": "Add mascot",
  "Add mascot image": "Add mascot image",
  "Add money to your wallet balance with your card.": "Add money to your wallet balance with your card.",
  "Add mood image": "Add mood image",
  "Add Partner & Generate Link": "Add Partner & Generate Link",
  "Add prize": "Add prize",
  "Add route": "Add route",
  "Add row": "Add row",
  "Add section": "Add section",
  "Add step": "Add step",
  "Add the CLABE above as the destination account.": "Add the CLABE above as the destination account.",
  "Add the details we need to pay out withdrawals from your main wallet: a bank account and/or a crypto wallet, plus the identity details we use for verification. We use these only for verification and payouts.": "Add the details we need to pay out withdrawals from your main wallet: a bank account and/or a crypto wallet, plus the identity details we use for verification. We use these only for verification and payouts.",
  "Add the DNS records to finish connecting this domain.": "Add the DNS records to finish connecting this domain.",
  "Add the ones you want": "Add the ones you want",
  "Add the question this article answers.": "Add the question this article answers.",
  "Add these records at {{registrar}} so {{domain}} stays pointed at your Whitelabels.com site.": "Add these records at {{registrar}} so {{domain}} stays pointed at your Whitelabels.com site.",
  "Add tier": "Add tier",
  "Add to DNS": "Add to DNS",
  "Add translation": "Add translation",
  "Add your ingredients first": "Add your ingredients first",
  "Adding is paused while your ad is generating": "Adding is paused while your ad is generating",
  "Adding logo & CTA": "Adding logo & CTA",
  "Adding motion and sound to scene {{n}}": "Adding motion and sound to scene {{n}}",
  "Adding music and sound effects": "Adding music and sound effects",
  "Adding the final light": "Adding the final light",
  "Adding the finishing touches": "Adding the finishing touches",
  "Adding the record…": "Adding the record…",
  "Adding the SEO details…": "Adding the SEO details…",
  "Adding to your wallet": "Adding to your wallet",
  "Adding…": "Adding…",
  "Address": "Address",
  "Address contains the focus keyword": "Address contains the focus keyword",
  "Address copied": "Address copied",
  "Addresses": "Addresses",
  "Addresses are fixed": "Addresses are fixed",
  "Adjusting a few details in scene {{n}}": "Adjusting a few details in scene {{n}}",
  "Adjusting scene {{n}} for the video service": "Adjusting scene {{n}} for the video service",
  "Adjusting your clip for the video service's rules": "Adjusting your clip for the video service's rules",
  "Ads Budget": "Ads Budget",
  "Ads Budget & Daily Limits": "Ads Budget & Daily Limits",
  "Ads sending visitors here": "Ads sending visitors here",
  "Ads that move get noticed where still ones get scrolled past.": "Ads that move get noticed where still ones get scrolled past.",
  "Ads that move get noticed where still ones get scrolled past. HTML5 banners bring your offer to life, live text and all, in every display size.": "Ads that move get noticed where still ones get scrolled past. HTML5 banners bring your offer to life, live text and all, in every display size.",
  "Ads that move get noticed. HTML5 banners bring your offer to life, in every display size.": "Ads that move get noticed. HTML5 banners bring your offer to life, in every display size.",
  "Advanced": "Advanced",
  "Advanced Affiliates Dashboard": "Advanced Affiliates Dashboard",
  "Advanced dashboard": "Advanced dashboard",
  "Advanced Editor": "Advanced Editor",
  "Advanced Settings": "Advanced Settings",
  "Advanced Video": "Advanced Video",
  "Advertise a promotion": "Advertise a promotion",
  "Advertisement": "Advertisement",
  "Advertises: {{name}}": "Advertises: {{name}}",
  "ADVERTISING CREDIT": "ADVERTISING CREDIT",
  "Affiliate": "Affiliate",
  "Affiliate #{{n}}": "Affiliate #{{n}}",
  "Affiliate activated": "Affiliate activated",
  "Affiliate campaign #{{n}}": "Affiliate campaign #{{n}}",
  "Affiliate commission": "Affiliate commission",
  "Affiliate created": "Affiliate created",
  "Affiliate paused": "Affiliate paused",
  "Affiliate program not available yet": "Affiliate program not available yet",
  "Affiliate Site": "Affiliate Site",
  "Affiliate updated": "Affiliate updated",
  "Affiliate: {{name}}": "Affiliate: {{name}}",
  "Affiliates": "Affiliates",
  "Affiliates not enabled": "Affiliates not enabled",
  "Affiliates promote {{brand}} to their own audience and earn a commission on the players they bring. They live here, in <0/>.": "Affiliates promote {{brand}} to their own audience and earn a commission on the players they bring. They live here, in <0/>.",
  "Affiliates promote {{brand}} to their own audience and earn a commission on the players they bring. Whenever you want partners, they are here: open <0/>.": "Affiliates promote {{brand}} to their own audience and earn a commission on the players they bring. Whenever you want partners, they are here: open <0/>.",
  "Affiliates send players to {{brand}} and earn a commission on the ones they bring. Invite one by email or with a link, and follow their players in one place.": "Affiliates send players to {{brand}} and earn a commission on the ones they bring. Invite one by email or with a link, and follow their players in one place.",
  "Africa": "Africa",
  "Afrikaans": "Afrikaans",
  "after checkout": "after checkout",
  "After commission": "After commission",
  "Agência (branch)": "Agência (branch)",
  "Ahead of market": "Ahead of market",
  "AI assistants": "AI assistants",
  "AI credits": "AI credits",
  "AI Credits": "AI Credits",
  "AI credits used": "AI credits used",
  "AI models can train on your site": "AI models can train on your site",
  "AI search and answers can read your site": "AI search and answers can read your site",
  "Align {{a}}": "Align {{a}}",
  "Alignment": "Alignment",
  "All": "All",
  "All {{n}} logos ready": "All {{n}} logos ready",
  "All affiliates": "All affiliates",
  "All brands": "All brands",
  "All but {{names}}": "All but {{names}}",
  "All campaigns": "All campaigns",
  "All casinos": "All casinos",
  "All countries": "All countries",
  "All formats": "All formats",
  "All games": "All games",
  "All in your catalogue": "All in your catalogue",
  "All internal addresses": "All internal addresses",
  "All known links": "All known links",
  "All links": "All links",
  "All marketing assets": "All marketing assets",
  "All pages": "All pages",
  "All Promotions & Creatives": "All Promotions & Creatives",
  "All providers": "All providers",
  "All public addresses": "All public addresses",
  "All recorded": "All recorded",
  "All recorded browsers = counted only + counted and excluded + excluded only": "All recorded browsers = counted only + counted and excluded + excluded only",
  "All recorded people = counted only + counted and excluded + excluded only": "All recorded people = counted only + counted and excluded + excluded only",
  "All selected hosts and dates, before page, source, link, campaign, and country filters": "All selected hosts and dates, before page, source, link, campaign, and country filters",
  "All Set! {{brand}} is live": "All Set! {{brand}} is live",
  "All sources": "All sources",
  "All tags": "All tags",
  "All text in this asset is written in this language.": "All text in this asset is written in this language.",
  "All the pages people looked at": "All the pages people looked at",
  "All visible to players": "All visible to players",
  "Allocation": "Allocation",
  "Allow {{name}}": "Allow {{name}}",
  "Allow all": "Allow all",
  "Allow Lumio to manage daily budget": "Allow Lumio to manage daily budget",
  "Allowed": "Allowed",
  "Almost there, hang tight…": "Almost there, hang tight…",
  "Already have an account?": "Already have an account?",
  "Also on {{path}}": "Also on {{path}}",
  "Alt text": "Alt text",
  "Alt text also becomes the image description search engines read.": "Alt text also becomes the image description search engines read.",
  "Always at hand: {{doors}}. Click {{more}} to open the whole menu.": "Always at hand: {{doors}}. Click {{more}} to open the whole menu.",
  "Always at hand: {{numbers}} for the numbers, {{site}} for what players see. Click {{more}} to open the whole menu.": "Always at hand: {{numbers}} for the numbers, {{site}} for what players see. Click {{more}} to open the whole menu.",
  "Always on the page: its button claims your welcome offer. Lumio writes the copy and draws the art around what the page promotes.": "Always on the page: its button claims your welcome offer. Lumio writes the copy and draws the art around what the page promotes.",
  "Always shown on a mini-game, with your market's standard wording.": "Always shown on a mini-game, with your market's standard wording.",
  "Always use the dark theme": "Always use the dark theme",
  "Always use the light theme": "Always use the light theme",
  "Amazon Pay": "Amazon Pay",
  "America": "America",
  "Amount": "Amount",
  "Amount exceeds your available balance of {{amount}}": "Amount exceeds your available balance of {{amount}}",
  "Amount to transfer": "Amount to transfer",
  "An answer that is wrong": "An answer that is wrong",
  "An average visit covers {{pages}} pages.": "An average visit covers {{pages}} pages.",
  "An average visit lasts {{time}} and covers {{pages}} pages.": "An average visit lasts {{time}} and covers {{pages}} pages.",
  "An average visit lasts {{time}}, usually on a single page.": "An average visit lasts {{time}}, usually on a single page.",
  "An electric closing frame with the \"{{cta}}\" call to action rendered prominently as a glowing neon button over the {{brand}} scene.": "An electric closing frame with the \"{{cta}}\" call to action rendered prominently as a glowing neon button over the {{brand}} scene.",
  "An elegant hero shot of the \"{{headline}}\" offer, the \"{{subtitle}}\" detail shown as crisp, refined on-brand text.": "An elegant hero shot of the \"{{headline}}\" offer, the \"{{subtitle}}\" detail shown as crisp, refined on-brand text.",
  "An email is on the way": "An email is on the way",
  "An energetic, meme-ready frame of the {{brand}} win with coins and sparkles exploding across the composition.": "An energetic, meme-ready frame of the {{brand}} win with coins and sparkles exploding across the composition.",
  "An escalating win frame for {{brand}}, stacked multipliers and glowing coins building momentum.": "An escalating win frame for {{brand}}, stacked multipliers and glowing coins building momentum.",
  "An existing landing page": "An existing landing page",
  "an hour ago": "an hour ago",
  "An opulent hero shot of the \"{{headline}}\" offer, the \"{{subtitle}}\" detail shown as crisp, premium on-brand text.": "An opulent hero shot of the \"{{headline}}\" offer, the \"{{subtitle}}\" detail shown as crisp, premium on-brand text.",
  "An urgent shot of the {{brand}} offer, racing lights and the \"{{subtitle}}\" detail shown as crisp on-brand text.": "An urgent shot of the {{brand}} offer, racing lights and the \"{{subtitle}}\" detail shown as crisp on-brand text.",
  "Analysis complete. Presenting your strategic packages.": "Analysis complete. Presenting your strategic packages.",
  "Analyzed competitors": "Analyzed competitors",
  "Analyzing competitors": "Analyzing competitors",
  "Analyzing competitors …": "Analyzing competitors …",
  "Analyzing top competitors from {{country}}{{dots}}": "Analyzing top competitors from {{country}}{{dots}}",
  "And you: profile, mailbox, billing and how you sign in. That's the studio.": "And you: profile, mailbox, billing and how you sign in. That's the studio.",
  "Android (Gmail app): open Settings, then Add account, then Other.": "Android (Gmail app): open Settings, then Add account, then Other.",
  "Android phone": "Android phone",
  "Android tablet": "Android tablet",
  "Animate {{name}}": "Animate {{name}}",
  "Animate the \"{{headline}}\" promotion ({{subtitle}}) into a short, premium promotional video that keeps its look and branding.": "Animate the \"{{headline}}\" promotion ({{subtitle}}) into a short, premium promotional video that keeps its look and branding.",
  "Animate the \"{{headline}}\" promotion into a short, premium promotional video that keeps its look and branding.": "Animate the \"{{headline}}\" promotion into a short, premium promotional video that keeps its look and branding.",
  "Animate the sizes of an image banner you already generated and export them as HTML5. Nothing new is generated.": "Animate the sizes of an image banner you already generated and export them as HTML5. Nothing new is generated.",
  "Animate this promotion into a short, premium promotional video that keeps its look and branding.": "Animate this promotion into a short, premium promotional video that keeps its look and branding.",
  "Animated banners, ready for ad networks.": "Animated banners, ready for ad networks.",
  "Animated HTML5 exports are not available in this environment yet.": "Animated HTML5 exports are not available in this environment yet.",
  "Animating beat {{k}} of {{n}}": "Animating beat {{k}} of {{n}}",
  "Animating beat {{n}}": "Animating beat {{n}}",
  "Animating scene {{n}}, frame by frame": "Animating scene {{n}}, frame by frame",
  "Animating the banner…": "Animating the banner…",
  "Another live page of your brand already uses this path.": "Another live page of your brand already uses this path.",
  "Answer": "Answer",
  "Any banner's <0/> opens it whenever you want a new version.": "Any banner's <0/> opens it whenever you want a new version.",
  "Any game, list or provider.": "Any game, list or provider.",
  "Any game's <0/> menu changes its place whenever you want.": "Any game's <0/> menu changes its place whenever you want.",
  "Any provider": "Any provider",
  "Any theme": "Any theme",
  "Any time": "Any time",
  "Any type": "Any type",
  "Anyone who opens it joins your program.": "Anyone who opens it joins your program.",
  "Anyone with the link": "Anyone with the link",
  "Apartment / suite (optional)": "Apartment / suite (optional)",
  "App": "App",
  "App ${{amount}}": "App ${{amount}}",
  "App Networks": "App Networks",
  "Apple Mail": "Apple Mail",
  "Applied your brand kit.": "Applied your brand kit.",
  "Applied your brand.": "Applied your brand.",
  "Applies to every page under {{wildcard}}": "Applies to every page under {{wildcard}}",
  "Apply": "Apply",
  "Apply brand kit": "Apply brand kit",
  "Apply to site": "Apply to site",
  "Applying images isn't available right now. Please try again later.": "Applying images isn't available right now. Please try again later.",
  "Applying replaces the live creative. Your site updates on its next refresh.": "Applying replaces the live creative. Your site updates on its next refresh.",
  "Applying your brand theme and colors": "Applying your brand theme and colors",
  "Applying your mood board style": "Applying your mood board style",
  "Applying…": "Applying…",
  "Approved": "Approved",
  "Apps": "Apps",
  "Archive": "Archive",
  "Archive this banner kit?": "Archive this banner kit?",
  "Archive this HTML5 banner?": "Archive this HTML5 banner?",
  "Archive this image banner?": "Archive this image banner?",
  "Archive this landing page?": "Archive this landing page?",
  "Archive this mini-game?": "Archive this mini-game?",
  "Archived": "Archived",
  "Archived banner kits ({{n}})": "Archived banner kits ({{n}})",
  "Archived HTML5 banners ({{n}})": "Archived HTML5 banners ({{n}})",
  "Archived image banners ({{n}})": "Archived image banners ({{n}})",
  "Archived landing pages ({{n}})": "Archived landing pages ({{n}})",
  "Archived mini-games ({{n}})": "Archived mini-games ({{n}})",
  "Archived video ads ({{n}})": "Archived video ads ({{n}})",
  "Are you withdrawing as an individual or a business?": "Are you withdrawing as an individual or a business?",
  "Argentinian": "Argentinian",
  "Arrange later": "Arrange later",
  "Art": "Art",
  "Art direction": "Art direction",
  "Art style": "Art style",
  "Art Style": "Art Style",
  "Art style:": "Art style:",
  "Art style: {{name}}": "Art style: {{name}}",
  "Art styles are not available here yet.": "Art styles are not available here yet.",
  "Article actions": "Article actions",
  "Article deleted": "Article deleted",
  "Article details": "Article details",
  "Article generation is not configured for this environment": "Article generation is not configured for this environment",
  "Article not found": "Article not found",
  "Article preview": "Article preview",
  "Article published": "Article published",
  "Article settings": "Article settings",
  "Article title": "Article title",
  "Article unpublished": "Article unpublished",
  "Articles that bring players from search.": "Articles that bring players from search.",
  "Articles will be published without a byline.": "Articles will be published without a byline.",
  "Articles will be signed by {{name}}.": "Articles will be signed by {{name}}.",
  "Articles will reuse the byline of your latest article that has one.": "Articles will reuse the byline of your latest article that has one.",
  "Artwork": "Artwork",
  "Ask Lumio": "Ask Lumio",
  "Ask me anything else …": "Ask me anything else …",
  "Ask me anything...": "Ask me anything...",
  "Ask us to delete your Whitelabels.com account and the personal data linked to it.": "Ask us to delete your Whitelabels.com account and the personal data linked to it.",
  "Aspect ratio": "Aspect ratio",
  "Assembling your ad": "Assembling your ad",
  "Asset": "Asset",
  "Assign a category": "Assign a category",
  "Assign plan": "Assign plan",
  "At a glance": "At a glance",
  "At least 1200×630 looks best. Up to 5 MB.": "At least 1200×630 looks best. Up to 5 MB.",
  "At least 512px on the longest side": "At least 512px on the longest side",
  "at least one image with the look you want. It sets the rendering, light, materials and colour.": "at least one image with the look you want. It sets the rendering, light, materials and colour.",
  "At most three loops, and every size is still by 30 seconds.": "At most three loops, and every size is still by 30 seconds.",
  "Attach images to guide the result; we keep them as close as we can.": "Attach images to guide the result; we keep them as close as we can.",
  "Audio": "Audio",
  "Author": "Author",
  "Author links": "Author links",
  "Author page": "Author page",
  "auto": "auto",
  "Auto": "Auto",
  "Auto-generated if empty...": "Auto-generated if empty...",
  "Auto-generation is not available for this blog yet": "Auto-generation is not available for this blog yet",
  "Auto-generation is not available while the blog is suspended": "Auto-generation is not available while the blog is suspended",
  "Auto-generation needs a brand owner": "Auto-generation needs a brand owner",
  "Auto-updating": "Auto-updating",
  "Automate the blog with Autopilot": "Automate the blog with Autopilot",
  "Automated Operations": "Automated Operations",
  "Automatic": "Automatic",
  "Automatic · choose at least one filter": "Automatic · choose at least one filter",
  "Automatic · new games that match these filters join the list on their own": "Automatic · new games that match these filters join the list on their own",
  "Automatic budget allocation": "Automatic budget allocation",
  "Automatic characters": "Automatic characters",
  "Automatic, by filters": "Automatic, by filters",
  "Autopilot": "Autopilot",
  "Autopilot is not available for this blog.": "Autopilot is not available for this blog.",
  "Autopilot is off": "Autopilot is off",
  "Autopilot is on": "Autopilot is on",
  "Autopilot needs credits": "Autopilot needs credits",
  "Autopilot on, next article {{when}}": "Autopilot on, next article {{when}}",
  "Autopilot wrote and published it on your blog.": "Autopilot wrote and published it on your blog.",
  "Autopilot wrote and published them on your blog.": "Autopilot wrote and published them on your blog.",
  "Available {{amount}}": "Available {{amount}}",
  "Available Lumio campaigns": "Available Lumio campaigns",
  "Available once your domain is live.": "Available once your domain is live.",
  "Average first deposit": "Average first deposit",
  "Avg Dep": "Avg Dep",
  "Avg Deposit / FTD": "Avg Deposit / FTD",
  "Avg FTD Value": "Avg FTD Value",
  "Avoid": "Avoid",
  "Back": "Back",
  "Back to {{name}}": "Back to {{name}}",
  "Back to editing": "Back to editing",
  "Back to filters": "Back to filters",
  "Back to home": "Back to home",
  "Back to Mailbox": "Back to Mailbox",
  "Back to Marketing": "Back to Marketing",
  "Back to pages": "Back to pages",
  "Back to settings": "Back to settings",
  "Back to sign in": "Back to sign in",
  "Back to the banner kit": "Back to the banner kit",
  "Back to the HTML5 banner": "Back to the HTML5 banner",
  "Back to the mini-game": "Back to the mini-game",
  "Back to the original look": "Back to the original look",
  "Back to the pages": "Back to the pages",
  "Back to the video ad": "Back to the video ad",
  "Back to versions": "Back to versions",
  "Back to Website": "Back to Website",
  "Background": "Background",
  "Background removed · saved at {{width}} × {{height}} px": "Background removed · saved at {{width}} × {{height}} px",
  "Background, desktop": "Background, desktop",
  "Background, mobile": "Background, mobile",
  "Backup image": "Backup image",
  "Badge": "Badge",
  "Balance after": "Balance after",
  "Balancing the composition…": "Balancing the composition…",
  "Balancing the sound and transitions": "Balancing the sound and transitions",
  "Bank": "Bank",
  "Bank account": "Bank account",
  "Bank account country": "Bank account country",
  "Bank address": "Bank address",
  "Bank code": "Bank code",
  "Bank code (código do banco)": "Bank code (código do banco)",
  "Bank name": "Bank name",
  "Bank transfer": "Bank transfer",
  "Banner": "Banner",
  "Banner kit": "Banner kit",
  "Banner kit downloads are not available in this environment yet.": "Banner kit downloads are not available in this environment yet.",
  "Banner kit name": "Banner kit name",
  "Banner Kits": "Banner Kits",
  "Banner kits are not available in this environment yet.": "Banner kits are not available in this environment yet.",
  "Banner link": "Banner link",
  "Banner versions": "Banner versions",
  "Banners": "Banners",
  "Banners and carousels on your site.": "Banners and carousels on your site.",
  "Banners are the first thing players click on {{brand}}, and every one of them lives here, in Website Creatives. Want a new version of yours?": "Banners are the first thing players click on {{brand}}, and every one of them lives here, in Website Creatives. Want a new version of yours?",
  "Banners are the first thing players click on {{brand}}. Open any of them, create a new version and publish it when you like it.": "Banners are the first thing players click on {{brand}}. Open any of them, create a new version and publish it when you like it.",
  "Banners are the first thing players click. Keep yours, or create a new version of any of them.": "Banners are the first thing players click. Keep yours, or create a new version of any of them.",
  "Based on what players love to play in {{country}}": "Based on what players love to play in {{country}}",
  "Basic gamification mechanisms to entertain your players.": "Basic gamification mechanisms to entertain your players.",
  "Beat {{n}}": "Beat {{n}}",
  "Beat {{n}} took too long to generate and was stopped. Try again, or pick a shorter target length. Your credits were refunded.": "Beat {{n}} took too long to generate and was stopped. Try again, or pick a shorter target length. Your credits were refunded.",
  "Beat {{n}} took too long to generate and was stopped. Your credits were refunded. Try a shorter beat duration, then resume.": "Beat {{n}} took too long to generate and was stopped. Your credits were refunded. Try a shorter beat duration, then resume.",
  "Beat {{n}} was blocked by the video provider's content policy. Regenerate the storyboard, then try again. Your credits were refunded.": "Beat {{n}} was blocked by the video provider's content policy. Regenerate the storyboard, then try again. Your credits were refunded.",
  "Beat {{n}} was rejected by the video provider: {{reason}}. Adjust that beat on the storyboard above, then resume. Your credits were refunded.": "Beat {{n}} was rejected by the video provider: {{reason}}. Adjust that beat on the storyboard above, then resume. Your credits were refunded.",
  "Beat {{n}} was rejected by the video provider: {{reason}}. Regenerate the storyboard, then try again. Your credits were refunded.": "Beat {{n}} was rejected by the video provider: {{reason}}. Regenerate the storyboard, then try again. Your credits were refunded.",
  "Before you continue": "Before you continue",
  "being designed": "being designed",
  "Below market": "Below market",
  "Below market level": "Below market level",
  "Benchmarking against the network": "Benchmarking against the network",
  "Benchmarks across similar brands aren't available yet": "Benchmarks across similar brands aren't available yet",
  "Beneficial owner date of birth": "Beneficial owner date of birth",
  "Beneficial owner first name": "Beneficial owner first name",
  "Beneficial owner last name": "Beneficial owner last name",
  "Beneficiary": "Beneficiary",
  "Best configuration for": "Best configuration for",
  "Best CPA on the account, scaled up": "Best CPA on the account, scaled up",
  "Best value": "Best value",
  "Bet amount": "Bet amount",
  "Bets": "Bets",
  "Bets placed": "Bets placed",
  "Big win hype": "Big win hype",
  "Big win hype storyboard": "Big win hype storyboard",
  "BIK (bank code)": "BIK (bank code)",
  "billed monthly": "billed monthly",
  "Billing address": "Billing address",
  "Billing Information": "Billing Information",
  "Billing Summary": "Billing Summary",
  "Billing term": "Billing term",
  "Bio": "Bio",
  "Bitcoin": "Bitcoin",
  "BL": "BL",
  "Blended CPA": "Blended CPA",
  "Blending in your mood board's vibe": "Blending in your mood board's vibe",
  "Block all": "Block all",
  "Block source": "Block source",
  "Blocked": "Blocked",
  "Blocked by the content policy. Reword this beat, then resume.": "Blocked by the content policy. Reword this beat, then resume.",
  "Blocked countries: {{count}}. Players from everywhere else can use your website.": "Blocked countries: {{count}}. Players from everywhere else can use your website.",
  "Blog": "Blog",
  "BLOG": "BLOG",
  "Blog articles": "Blog articles",
  "Blog on": "Blog on",
  "Blog:": "Blog:",
  "BNB Smart Chain (BEP-20)": "BNB Smart Chain (BEP-20)",
  "Bold": "Bold",
  "Bonus awarded": "Bonus awarded",
  "Bonus cost": "Bonus cost",
  "Bonus GGR": "Bonus GGR",
  "Bonus transformed": "Bonus transformed",
  "Bonus/GGR Ratio": "Bonus/GGR Ratio",
  "Both": "Both",
  "BR": "BR",
  "Branch / head-office address": "Branch / head-office address",
  "Branch code": "Branch code",
  "Branch transit number": "Branch transit number",
  "Brand": "Brand",
  "Brand colours": "Brand colours",
  "Brand Deployment": "Brand Deployment",
  "Brand image": "Brand image",
  "Brand logo": "Brand logo",
  "Brand logos": "Brand logos",
  "Brand name": "Brand name",
  "Brand theme": "Brand theme",
  "Brazil": "Brazil",
  "Brazilian": "Brazilian",
  "Breadcrumb": "Breadcrumb",
  "Breakdown dimension": "Breakdown dimension",
  "Breaks the channel's rules": "Breaks the channel's rules",
  "Brighter and more energetic": "Brighter and more energetic",
  "Bring {{layer}} forward": "Bring {{layer}} forward",
  "Bring a game up front": "Bring a game up front",
  "Bring forward": "Bring forward",
  "Bring in players through affiliates": "Bring in players through affiliates",
  "Bring to front": "Bring to front",
  "Bringing in your character": "Bringing in your character",
  "Bringing in your mascot": "Bringing in your mascot",
  "Bringing scene {{n}} to life": "Bringing scene {{n}} to life",
  "Browse {{count}} themes": "Browse {{count}} themes",
  "Browse games": "Browse games",
  "Browse suggestions": "Browse suggestions",
  "Browser counts are unavailable for this selection by page or over time.": "Browser counts are unavailable for this selection by page or over time.",
  "Browser tab title (optional)": "Browser tab title (optional)",
  "Browsers": "Browsers",
  "Browsers and visits count where they arrived. Pages viewed and time count under the source that last brought them.": "Browsers and visits count where they arrived. Pages viewed and time count under the source that last brought them.",
  "Browsers on each of your addresses": "Browsers on each of your addresses",
  "Browsers over time": "Browsers over time",
  "BSB (Bank-State-Branch)": "BSB (Bank-State-Branch)",
  "Budget spent": "Budget spent",
  "Budget top-up": "Budget top-up",
  "Budgets": "Budgets",
  "Build complete": "Build complete",
  "Build it": "Build it",
  "Build it · {{n}} credits": "Build it · {{n}} credits",
  "Build your image banners": "Build your image banners",
  "Build your video ad": "Build your video ad",
  "Building": "Building",
  "Building the final prompt…": "Building the final prompt…",
  "Building the live casino lobby": "Building the live casino lobby",
  "Building the preview…": "Building the preview…",
  "Bullet list": "Bullet list",
  "Business / company": "Business / company",
  "Business / legal entity name": "Business / legal entity name",
  "Business details": "Business details",
  "Business Optimization Score": "Business Optimization Score",
  "Business type": "Business type",
  "Business Value": "Business Value",
  "Button": "Button",
  "Button colour": "Button colour",
  "Button label": "Button label",
  "Button link": "Button link",
  "Buy {{n}} credit": "Buy {{n}} credit",
  "Buy {{n}} credits": "Buy {{n}} credits",
  "Buy AI credits": "Buy AI credits",
  "Buy credits": "Buy credits",
  "By dimension": "By dimension",
  "By link": "By link",
  "By version": "By version",
  "Calendar": "Calendar",
  "Calendar and reward prize images": "Calendar and reward prize images",
  "Calendars, tournaments, rewards.": "Calendars, tournaments, rewards.",
  "Calibrating market competitiveness and scores": "Calibrating market competitiveness and scores",
  "Calibrating your business value": "Calibrating your business value",
  "Calibrating your Pulse page": "Calibrating your Pulse page",
  "Call to action": "Call to action",
  "Call to play": "Call to play",
  "Callout: {{kind}}": "Callout: {{kind}}",
  "Came from": "Came from",
  "Camera": "Camera",
  "Campaign": "Campaign",
  "Campaign activated": "Campaign activated",
  "Campaign created": "Campaign created",
  "Campaign made available to Affiliates": "Campaign made available to Affiliates",
  "Campaign name": "Campaign name",
  "Campaign offering": "Campaign offering",
  "Campaign paused": "Campaign paused",
  "Campaign Performance": "Campaign Performance",
  "Campaign period {{period}}": "Campaign period {{period}}",
  "Campaign period: {{period}}": "Campaign period: {{period}}",
  "Campaign updated": "Campaign updated",
  "Campaign: {{name}}": "Campaign: {{name}}",
  "Campaigns": "Campaigns",
  "Campaigns are archived here once they finish.": "Campaigns are archived here once they finish.",
  "Campaigns Assets": "Campaigns Assets",
  "Campaigns in {{channel}}": "Campaigns in {{channel}}",
  "Campaigns you pause will wait here until you resume them.": "Campaigns you pause will wait here until you resume them.",
  "Can't publish yet. {{where}}: {{message}}": "Can't publish yet. {{where}}: {{message}}",
  "Canadian French": "Canadian French",
  "Cancel": "Cancel",
  "Cancel anytime, no extra fees": "Cancel anytime, no extra fees",
  "Cancel invoice": "Cancel invoice",
  "Cancel this invoice?": "Cancel this invoice?",
  "Cancel this upgrade?": "Cancel this upgrade?",
  "Cancel upgrade": "Cancel upgrade",
  "Cancelled": "Cancelled",
  "Cancelled invoices": "Cancelled invoices",
  "Cancelling…": "Cancelling…",
  "Canonical URL": "Canonical URL",
  "Caption": "Caption",
  "Card": "Card",
  "Card payment isn't available for this invoice yet. Pay from your wallet to complete it.": "Card payment isn't available for this invoice yet. Pay from your wallet to complete it.",
  "Carousel": "Carousel",
  "Cash": "Cash",
  "Casino": "Casino",
  "Casino (default)": "Casino (default)",
  "Casino & Sports": "Casino & Sports",
  "Casino ID": "Casino ID",
  "Casino menu": "Casino menu",
  "Casino name": "Casino name",
  "Casino preview": "Casino preview",
  "Casino type updated": "Casino type updated",
  "Casino Wallet": "Casino Wallet",
  "Casinos": "Casinos",
  "Casinos in your market": "Casinos in your market",
  "Casual": "Casual",
  "Categories": "Categories",
  "Category": "Category",
  "Category cards": "Category cards",
  "Category deleted": "Category deleted",
  "Category not found": "Category not found",
  "Category saved": "Category saved",
  "Category still has articles": "Category still has articles",
  "Category: {{value}}": "Category: {{value}}",
  "Center": "Center",
  "Central America": "Central America",
  "Change": "Change",
  "Change country": "Change country",
  "Change country or region": "Change country or region",
  "Change game": "Change game",
  "Change in Logos": "Change in Logos",
  "Change its password": "Change its password",
  "Change pack": "Change pack",
  "Change password": "Change password",
  "Change style": "Change style",
  "Change template": "Change template",
  "Change text": "Change text",
  "Change time range": "Change time range",
  "Change tracking link": "Change tracking link",
  "Change traffic source": "Change traffic source",
  "Change your password": "Change your password",
  "changed": "changed",
  "Changed": "Changed",
  "Changed by the platform since your last publish": "Changed by the platform since your last publish",
  "Changes not published yet.": "Changes not published yet.",
  "Changes saved": "Changes saved",
  "Changes show in this preview only. Publishing game lists is not available yet.": "Changes show in this preview only. Publishing game lists is not available yet.",
  "Changing…": "Changing…",
  "Channel": "Channel",
  "Channel: {{value}}": "Channel: {{value}}",
  "Character": "Character",
  "Character {{n}}": "Character {{n}}",
  "Character image": "Character image",
  "Character name": "Character name",
  "Character:": "Character:",
  "Character: {{name}}": "Character: {{name}}",
  "Characters": "Characters",
  "Charged once, at creation": "Charged once, at creation",
  "Charged once, when it is created. You confirm on the next step before anything is charged.": "Charged once, when it is created. You confirm on the next step before anything is charged.",
  "Charged once, when this mailbox was created. Nothing is charged after that.": "Charged once, when this mailbox was created. Nothing is charged after that.",
  "Chart metric": "Chart metric",
  "Chart mode": "Chart mode",
  "Chasing the market": "Chasing the market",
  "Check again": "Check again",
  "Check the [bracketed] placeholders before publishing.": "Check the [bracketed] placeholders before publishing.",
  "Check the banners players click first": "Check the banners players click first",
  "Check the logo players see first": "Check the logo players see first",
  "Check the text": "Check the text",
  "Check the wording": "Check the wording",
  "Check your email": "Check your email",
  "Check your email to finish signing in.": "Check your email to finish signing in.",
  "Check your inbox for an email from DocuSign.": "Check your inbox for an email from DocuSign.",
  "Checking": "Checking",
  "Checking the available options to link your domain …": "Checking the available options to link your domain …",
  "Checking the price…": "Checking the price…",
  "checking the site": "checking the site",
  "Checking the tracking links that send visitors here…": "Checking the tracking links that send visitors here…",
  "Checking your balance…": "Checking your balance…",
  "Checking your wallet balance…": "Checking your wallet balance…",
  "Chilean": "Chilean",
  "Choose": "Choose",
  "Choose a base theme, select your brand colors, and pick an art style to create your unique casino platform.": "Choose a base theme, select your brand colors, and pick an art style to create your unique casino platform.",
  "Choose a credits pack to top up your AI balance.": "Choose a credits pack to top up your AI balance.",
  "Choose a different file": "Choose a different file",
  "Choose a different logo file": "Choose a different logo file",
  "Choose a domain": "Choose a domain",
  "Choose a game": "Choose a game",
  "Choose a game list": "Choose a game list",
  "Choose a game that fits this subject and its formats.": "Choose a game that fits this subject and its formats.",
  "Choose a game to start.": "Choose a game to start.",
  "Choose a language": "Choose a language",
  "Choose a layout": "Choose a layout",
  "Choose a logo file": "Choose a logo file",
  "Choose a new password for your account.": "Choose a new password for your account.",
  "Choose a page": "Choose a page",
  "Choose a style": "Choose a style",
  "Choose a style that fits this subject and its sizes.": "Choose a style that fits this subject and its sizes.",
  "Choose a style to start.": "Choose a style to start.",
  "Choose a template": "Choose a template",
  "Choose a template first.": "Choose a template first.",
  "Choose a template to see the page.": "Choose a template to see the page.",
  "Choose a template to start.": "Choose a template to start.",
  "Choose a website name": "Choose a website name",
  "Choose addresses": "Choose addresses",
  "Choose an image": "Choose an image",
  "Choose an image banner to animate": "Choose an image banner to animate",
  "Choose an image to place in this spot": "Choose an image to place in this spot",
  "Choose an image to upload": "Choose an image to upload",
  "Choose at least one address to see its numbers.": "Choose at least one address to see its numbers.",
  "Choose at least one filter": "Choose at least one filter",
  "Choose at least one payout method: bank account or crypto wallet.": "Choose at least one payout method: bank account or crypto wallet.",
  "Choose from generated logos": "Choose from generated logos",
  "Choose games": "Choose games",
  "Choose gamification features": "Choose gamification features",
  "Choose how many credits to add. Pay from your Main wallet or by card.": "Choose how many credits to add. Pay from your Main wallet or by card.",
  "Choose how many credits to add. You'll pay from your Main wallet.": "Choose how many credits to add. You'll pay from your Main wallet.",
  "Choose how you'd like to receive withdrawals from your wallet. You can set up one or both.": "Choose how you'd like to receive withdrawals from your wallet. You can set up one or both.",
  "Choose individual or business above and we'll ask for the right details.": "Choose individual or business above and we'll ask for the right details.",
  "Choose language": "Choose language",
  "Choose logo.": "Choose logo.",
  "Choose Name & Web domain": "Choose Name & Web domain",
  "Choose one of the game lists on this page of your site and put its games in the order you want.": "Choose one of the game lists on this page of your site and put its games in the order you want.",
  "Choose or drop an image": "Choose or drop an image",
  "Choose payment method": "Choose payment method",
  "Choose Pix Copia e Cola and paste the code.": "Choose Pix Copia e Cola and paste the code.",
  "Choose promotions": "Choose promotions",
  "Choose providers": "Choose providers",
  "Choose the country where the casino will operate.": "Choose the country where the casino will operate.",
  "Choose the game": "Choose the game",
  "Choose the games this ad advertises": "Choose the games this ad advertises",
  "Choose the gamification features this ad advertises": "Choose the gamification features this ad advertises",
  "Choose the hero image": "Choose the hero image",
  "Choose the path the page lives at.": "Choose the path the page lives at.",
  "Choose the promotion this banner kit advertises": "Choose the promotion this banner kit advertises",
  "Choose the promotion this HTML5 banner advertises": "Choose the promotion this HTML5 banner advertises",
  "Choose the promotion this image banner advertises": "Choose the promotion this image banner advertises",
  "Choose the promotion this landing page promotes": "Choose the promotion this landing page promotes",
  "Choose the promotion this mini-game advertises": "Choose the promotion this mini-game advertises",
  "Choose the promotion this page is about": "Choose the promotion this page is about",
  "Choose the promotions this ad advertises": "Choose the promotions this ad advertises",
  "Choose themes": "Choose themes",
  "Choose this style": "Choose this style",
  "Choose types": "Choose types",
  "Choose upgrade": "Choose upgrade",
  "Choose website name and web domain.": "Choose website name and web domain.",
  "Choose where affiliates send players": "Choose where affiliates send players",
  "Choose whether we can use marketing and analytics cookies to measure how our site and campaigns are performing. This mirrors the cookie choice you made on our website, and you can change it here at any time.": "Choose whether we can use marketing and analytics cookies to measure how our site and campaigns are performing. This mirrors the cookie choice you made on our website, and you can change it here at any time.",
  "Choose whether your brand experience is centered on Sport, Casino, or a balance of both": "Choose whether your brand experience is centered on Sport, Casino, or a balance of both",
  "Choose which currencies players can deposit and play with.": "Choose which currencies players can deposit and play with.",
  "Choose your audience": "Choose your audience",
  "Choose your audience type": "Choose your audience type",
  "Choose your bank's country above and we'll ask for exactly the details that corridor needs (IBAN + BIC for SEPA; account number, SWIFT, local clearing code and bank address for international wires).": "Choose your bank's country above and we'll ask for exactly the details that corridor needs (IBAN + BIC for SEPA; account number, SWIFT, local clearing code and bank address for international wires).",
  "Choose your brand colors and pick an art style to give your platform its own look and feel.": "Choose your brand colors and pick an art style to give your platform its own look and feel.",
  "Choose your own mix": "Choose your own mix",
  "Choose your perfect logo": "Choose your perfect logo",
  "Choose your promotions and vibe": "Choose your promotions and vibe",
  "Choose your theme": "Choose your theme",
  "Choose your welcome offer": "Choose your welcome offer",
  "Chosen domain to link": "Chosen domain to link",
  "Chosen when the page was created. Its button always claims your welcome offer, and Lumio writes the copy and draws the art around what the page promotes.": "Chosen when the page was created. Its button always claims your welcome offer, and Lumio writes the copy and draws the art around what the page promotes.",
  "Chromebook": "Chromebook",
  "Churn prevention": "Churn prevention",
  "Cinematic reveal": "Cinematic reveal",
  "City": "City",
  "CLABE": "CLABE",
  "Claim bonus": "Claim bonus",
  "Clear": "Clear",
  "Clear all": "Clear all",
  "Clear all filters": "Clear all filters",
  "Clear filter": "Clear filter",
  "Clear filters": "Clear filters",
  "Clear search": "Clear search",
  "Clear search text": "Clear search text",
  "Clear the author": "Clear the author",
  "Click <0/> to create yours.": "Click <0/> to create yours.",
  "Click <0/> to open it.": "Click <0/> to open it.",
  "Click <0/> to open them.": "Click <0/> to open them.",
  "Click a game list on your site to reorder it. Changes show in this preview only.": "Click a game list on your site to reorder it. Changes show in this preview only.",
  "Click an element to edit it. Drag to move, double-click text to type, corners to resize, top handle to rotate.": "Click an element to edit it. Drag to move, double-click text to type, corners to resize, top handle to rotate.",
  "Click an element to edit it. Drag to move, double-click text to type.": "Click an element to edit it. Drag to move, double-click text to type.",
  "Click any banner on your site to edit it with Lumio.": "Click any banner on your site to edit it with Lumio.",
  "Click or drop to upload your logo": "Click or drop to upload your logo",
  "Click Start below.": "Click Start below.",
  "Click to browse your files (PNG, JPG or SVG).": "Click to browse your files (PNG, JPG or SVG).",
  "Click to edit": "Click to edit",
  "Clicks": "Clicks",
  "Clip length set to {{n}}s, a length {{model}} supports.": "Clip length set to {{n}}s, a length {{model}} supports.",
  "Close": "Close",
  "Close game search": "Close game search",
  "Close Lumio": "Close Lumio",
  "Close preview": "Close preview",
  "Close Preview": "Close Preview",
  "Close search": "Close search",
  "Closed chest": "Closed chest",
  "CNAPS code": "CNAPS code",
  "Code block": "Code block",
  "Coin storm": "Coin storm",
  "Collapse": "Collapse",
  "Collapse deployment": "Collapse deployment",
  "Collections": "Collections",
  "Collections across all casinos": "Collections across all casinos",
  "Colombian": "Colombian",
  "Color & styling": "Color & styling",
  "Colors": "Colors",
  "Colors ({{shown}}/{{total}})": "Colors ({{shown}}/{{total}})",
  "Colors & art style": "Colors & art style",
  "Colors & Art Style": "Colors & Art Style",
  "Colour": "Colour",
  "Colours": "Colours",
  "Colours, button and fonts come from your website's theme. Lumio sets the game up for your subject.": "Colours, button and fonts come from your website's theme. Lumio sets the game up for your subject.",
  "Colours, button and fonts come from your website's theme. Lumio tunes the motion for your subject.": "Colours, button and fonts come from your website's theme. Lumio tunes the motion for your subject.",
  "Colours, button and fonts come from your website's theme. Lumio writes the copy and settings.": "Colours, button and fonts come from your website's theme. Lumio writes the copy and settings.",
  "Coming soon": "Coming soon",
  "Commission": "Commission",
  "Commission plan": "Commission plan",
  "Commission plan assigned": "Commission plan assigned",
  "Commission plan removed": "Commission plan removed",
  "Common": "Common",
  "Communication Preferences": "Communication Preferences",
  "Company": "Company",
  "Company (optional)": "Company (optional)",
  "Company name": "Company name",
  "Compiling the responsive front-end": "Compiling the responsive front-end",
  "Completed": "Completed",
  "Completed {{x}}/{{y}}": "Completed {{x}}/{{y}}",
  "Completed: {{x}} of {{y}}": "Completed: {{x}} of {{y}}",
  "Composer views": "Composer views",
  "Composing the tile": "Composing the tile",
  "Composing your storyboard…": "Composing your storyboard…",
  "Computer": "Computer",
  "Configurator": "Configurator",
  "Configure list": "Configure list",
  "Configure your own": "Configure your own",
  "Configuring KYC and compliance checks": "Configuring KYC and compliance checks",
  "Confirm": "Confirm",
  "Confirm change": "Confirm change",
  "Confirm Operating Region": "Confirm Operating Region",
  "Confirm package selection": "Confirm package selection",
  "Confirm the copy before generating the banners.": "Confirm the copy before generating the banners.",
  "Confirm the copy before generating the kit.": "Confirm the copy before generating the kit.",
  "Confirm the copy to redraw.": "Confirm the copy to redraw.",
  "Confirm top-up": "Confirm top-up",
  "Confirm website's operating region": "Confirm website's operating region",
  "Confirmed tests": "Confirmed tests",
  "Confirming…": "Confirming…",
  "Connect": "Connect",
  "Connect domain": "Connect domain",
  "Connect with": "Connect with",
  "Connect your own domain": "Connect your own domain",
  "Connected": "Connected",
  "Connected accounts": "Connected accounts",
  "Connected as": "Connected as",
  "Connected via Entri": "Connected via Entri",
  "Connecting …": "Connecting …",
  "Connecting your account...": "Connecting your account...",
  "Connecting your payment providers": "Connecting your payment providers",
  "Console": "Console",
  "Contact": "Contact",
  "CONTACT": "CONTACT",
  "Contact info": "Contact info",
  "Contact support": "Contact support",
  "Content": "Content",
  "Content items: {{n}}": "Content items: {{n}}",
  "Context for Lumio on every page, never a page's focus keyword.": "Context for Lumio on every page, never a page's focus keyword.",
  "Continue": "Continue",
  "Continue building your website": "Continue building your website",
  "Continue draft": "Continue draft",
  "Continue setup": "Continue setup",
  "Continue to {{name}}": "Continue to {{name}}",
  "Continue to {{step}}": "Continue to {{step}}",
  "Continue to Art Style": "Continue to Art Style",
  "Continue to checkout": "Continue to checkout",
  "Continue to Colors": "Continue to Colors",
  "Continue to Colors & Art Style": "Continue to Colors & Art Style",
  "Continue to Domain Selection": "Continue to Domain Selection",
  "Continue to features": "Continue to features",
  "Continue to Features": "Continue to Features",
  "Continue to finish": "Continue to finish",
  "Continue to Logo": "Continue to Logo",
  "Continue to Operating Region": "Continue to Operating Region",
  "Continue to Owner Studio": "Continue to Owner Studio",
  "Continue to payment": "Continue to payment",
  "Continue to players": "Continue to players",
  "Continue to review": "Continue to review",
  "Continue to Review": "Continue to Review",
  "Continue with {{name}}": "Continue with {{name}}",
  "Continue with Automatic": "Continue with Automatic",
  "Continue with Hand-picked": "Continue with Hand-picked",
  "Continue with the market": "Continue with the market",
  "Contract sent": "Contract sent",
  "Contract sent again": "Contract sent again",
  "Conversion": "Conversion",
  "Conversion from Handle to Gross Profit": "Conversion from Handle to Gross Profit",
  "Copied": "Copied",
  "Copy": "Copy",
  "Copy {{label}}": "Copy {{label}}",
  "Copy address": "Copy address",
  "Copy code": "Copy code",
  "Copy data": "Copy data",
  "Copy email": "Copy email",
  "Copy host": "Copy host",
  "Copy link": "Copy link",
  "Copy live link": "Copy live link",
  "Copy name": "Copy name",
  "Copy password": "Copy password",
  "Copy prompt": "Copy prompt",
  "Copy the Pix code above.": "Copy the Pix code above.",
  "Copy the TXT record Google shows you and paste it here.": "Copy the TXT record Google shows you and paste it here.",
  "Copy TTL": "Copy TTL",
  "Copy value": "Copy value",
  "Copy, every language": "Copy, every language",
  "Copyright": "Copyright",
  "Corporation": "Corporation",
  "Cost / FTD": "Cost / FTD",
  "Cost per acquisition": "Cost per acquisition",
  "Cost per Acquisition": "Cost per Acquisition",
  "Could not change where the link goes. Please try again.": "Could not change where the link goes. Please try again.",
  "Could not connect Telegram. Please try again.": "Could not connect Telegram. Please try again.",
  "Could not copy": "Could not copy",
  "Could not create the campaign": "Could not create the campaign",
  "Could not create the tracking link": "Could not create the tracking link",
  "Could not create the tracking link. Please try again.": "Could not create the tracking link. Please try again.",
  "Could not load affiliates": "Could not load affiliates",
  "Could not load campaigns": "Could not load campaigns",
  "Could not load invite links": "Could not load invite links",
  "Could not load Lumio campaigns": "Could not load Lumio campaigns",
  "Could not load players": "Could not load players",
  "Could not load reports": "Could not load reports",
  "Could not load stats": "Could not load stats",
  "Could not load the commission plan": "Could not load the commission plan",
  "Could not load the tracking link": "Could not load the tracking link",
  "Could not mark as read": "Could not mark as read",
  "Could not save your changes": "Could not save your changes",
  "Could not send your message. Please try again.": "Could not send your message. Please try again.",
  "Could not start checkout. Please try again.": "Could not start checkout. Please try again.",
  "Could not start the landing page": "Could not start the landing page",
  "Could not update your connected accounts. Please try again.": "Could not update your connected accounts. Please try again.",
  "Couldn't activate {{name}}. Please try again.": "Couldn't activate {{name}}. Please try again.",
  "Couldn't apply the voucher. Please try again.": "Couldn't apply the voucher. Please try again.",
  "Couldn't be drawn": "Couldn't be drawn",
  "Couldn't be packaged": "Couldn't be packaged",
  "Couldn't be read. Reload the page to try again.": "Couldn't be read. Reload the page to try again.",
  "Couldn't cancel the invoice. Please try again.": "Couldn't cancel the invoice. Please try again.",
  "Couldn't cancel the upgrade for {{name}}. Please try again.": "Couldn't cancel the upgrade for {{name}}. Please try again.",
  "Couldn't copy to clipboard": "Couldn't copy to clipboard",
  "Couldn't deactivate {{name}}. Please try again.": "Couldn't deactivate {{name}}. Please try again.",
  "Couldn't finish the payment for {{name}}. Please try again.": "Couldn't finish the payment for {{name}}. Please try again.",
  "Couldn't load": "Couldn't load",
  "Couldn’t load conversations.": "Couldn’t load conversations.",
  "Couldn't load SEO for this site.": "Couldn't load SEO for this site.",
  "Couldn’t load suggestions.": "Couldn’t load suggestions.",
  "Couldn’t load the configurator. Please try again.": "Couldn’t load the configurator. Please try again.",
  "Couldn't load your country settings.": "Couldn't load your country settings.",
  "Couldn't load your site's images.": "Couldn't load your site's images.",
  "Couldn’t open that conversation.": "Couldn’t open that conversation.",
  "Couldn't prepare the logo archive": "Couldn't prepare the logo archive",
  "Couldn't publish to your live site. Please try again.": "Couldn't publish to your live site. Please try again.",
  "Couldn't reactivate {{name}}. Please try again.": "Couldn't reactivate {{name}}. Please try again.",
  "Couldn't refresh. Your edits are kept.": "Couldn't refresh. Your edits are kept.",
  "Couldn't render this size": "Couldn't render this size",
  "Couldn't save your country settings. Please try again.": "Couldn't save your country settings. Please try again.",
  "Couldn't search right now": "Couldn't search right now",
  "Couldn't update the banner. Please try again.": "Couldn't update the banner. Please try again.",
  "Couldn't write {{failed}} (not charged).": "Couldn't write {{failed}} (not charged).",
  "Countdown": "Countdown",
  "Countdown rush": "Countdown rush",
  "Counted from the tracking links that lead to it": "Counted from the tracking links that lead to it",
  "Countries": "Countries",
  "Country": "Country",
  "Country (optional)": "Country (optional)",
  "Country access": "Country access",
  "Country access becomes available once your website is deployed.": "Country access becomes available once your website is deployed.",
  "Country access saved": "Country access saved",
  "CPA": "CPA",
  "CPA {{amount}}": "CPA {{amount}}",
  "CPA amount": "CPA amount",
  "CPA Amount": "CPA Amount",
  "CPA commission": "CPA commission",
  "CPA pending · ${{spent}} spent today": "CPA pending · ${{spent}} spent today",
  "CPAs": "CPAs",
  "Crafting {{name}}": "Crafting {{name}}",
  "Crafting your website": "Crafting your website",
  "Create": "Create",
  "Create a blog article": "Create a blog article",
  "Create a brand-new creative": "Create a brand-new creative",
  "Create a creative for anywhere": "Create a creative for anywhere",
  "Create a custom game list": "Create a custom game list",
  "Create a custom list": "Create a custom list",
  "Create a mailbox": "Create a mailbox",
  "Create a marketing asset": "Create a marketing asset",
  "Create a new banner kit": "Create a new banner kit",
  "Create a new category": "Create a new category",
  "Create a new creative": "Create a new creative",
  "Create a new HTML5 banner": "Create a new HTML5 banner",
  "Create a new image banner": "Create a new image banner",
  "Create a new landing page": "Create a new landing page",
  "Create a new list": "Create a new list",
  "Create a new mini-game": "Create a new mini-game",
  "Create a new video ad": "Create a new video ad",
  "Create a paid mailbox": "Create a paid mailbox",
  "Create a password": "Create a password",
  "Create a tracking link": "Create a tracking link",
  "Create account": "Create account",
  "Create an affiliate campaign": "Create an affiliate campaign",
  "Create animated HTML5 banners": "Create animated HTML5 banners",
  "Create banner ads in every size": "Create banner ads in every size",
  "Create custom list": "Create custom list",
  "Create free mailbox": "Create free mailbox",
  "Create later": "Create later",
  "Create link": "Create link",
  "Create list": "Create list",
  "Create Logo & Identity": "Create Logo & Identity",
  "Create mailbox": "Create mailbox",
  "Create mini-game ads": "Create mini-game ads",
  "Create new": "Create new",
  "Create new version from this one": "Create new version from this one",
  "Create the casino's art style": "Create the casino's art style",
  "Create video ads": "Create video ads",
  "Create your account in under a minute": "Create your account in under a minute",
  "Create your first marketing asset": "Create your first marketing asset",
  "Create your free mailbox": "Create your free mailbox",
  "Created": "Created",
  "Creating campaign...": "Creating campaign...",
  "Creating link…": "Creating link…",
  "Creating list…": "Creating list…",
  "Creating the mailbox": "Creating the mailbox",
  "Creating the video ad…": "Creating the video ad…",
  "Creating…": "Creating…",
  "Creative": "Creative",
  "Creative generations": "Creative generations",
  "Creative name": "Creative name",
  "Creatives": "Creatives",
  "CREATIVES": "CREATIVES",
  "Creatives, targeting and bid optimization are handled automatically. Toggle campaigns on/off and manage your daily budget, Lumio does the rest.": "Creatives, targeting and bid optimization are handled automatically. Toggle campaigns on/off and manage your daily budget, Lumio does the rest.",
  "Credit card or other options": "Credit card or other options",
  "Credit or context, shown under the cover": "Credit or context, shown under the cover",
  "credits": "credits",
  "Credits added": "Credits added",
  "Credits added to your balance.": "Credits added to your balance.",
  "Credits power Lumio's AI creative work: generating and restyling banners, and generating backgrounds in the custom studio. Each action spends credits based on the work it takes, so the exact cost depends on what you're creating.": "Credits power Lumio's AI creative work: generating and restyling banners, and generating backgrounds in the custom studio. Each action spends credits based on the work it takes, so the exact cost depends on what you're creating.",
  "Credits power Lumio's AI creative work. You spend them each time you generate or restyle a creative, or generate a background in the custom studio.": "Credits power Lumio's AI creative work. You spend them each time you generate or restyle a creative, or generate a background in the custom studio.",
  "Credits power Lumio's AI to generate visuals and content.": "Credits power Lumio's AI to generate visuals and content.",
  "CRM": "CRM",
  "Cross-sell": "Cross-sell",
  "Crypto": "Crypto",
  "Crypto ${{amount}}": "Crypto ${{amount}}",
  "Crypto only": "Crypto only",
  "Crypto Sites": "Crypto Sites",
  "Crypto wallet": "Crypto wallet",
  "CTA pressed: in the live ad it opens {{url}}": "CTA pressed: in the live ad it opens {{url}}",
  "Currency": "Currency",
  "Current": "Current",
  "Current {{name}} creative": "Current {{name}} creative",
  "Current Ads Budget": "Current Ads Budget",
  "Current Ads Budget for {{brandName}}": "Current Ads Budget for {{brandName}}",
  "Current banner": "Current banner",
  "Current configuration": "Current configuration",
  "Current Theme": "Current Theme",
  "Custom": "Custom",
  "Custom AI creatives arrive with your banner tools. For now, open any creative in the In-Website tab to replace it with your own artwork.": "Custom AI creatives arrive with your banner tools. For now, open any creative in the In-Website tab to replace it with your own artwork.",
  "Custom amount": "Custom amount",
  "Custom colours": "Custom colours",
  "Custom creative": "Custom creative",
  "Custom credit amount": "Custom credit amount",
  "Custom range": "Custom range",
  "Custom URL": "Custom URL",
  "Custom_list": "Custom",
  "Customise": "Customise",
  "Customize website": "Customize website",
  "Customizer": "Customizer",
  "Cut-out": "Cut-out",
  "Daily ad budget": "Daily ad budget",
  "Daily ad budget top-up": "Daily ad budget top-up",
  "Daily budget reached": "Daily budget reached",
  "Daily Limit": "Daily Limit",
  "Daily Limits": "Daily Limits",
  "Daily Spend": "Daily Spend",
  "Daily trend": "Daily trend",
  "Dark": "Dark",
  "Darken for text": "Darken for text",
  "Data": "Data",
  "Data Deletion": "Data Deletion",
  "Data notes ({{n}})": "Data notes ({{n}})",
  "Data shown is from {{date}}. Any limit and budget adjustments take effect the following day.": "Data shown is from {{date}}. Any limit and budget adjustments take effect the following day.",
  "Date": "Date",
  "Date of birth": "Date of birth",
  "Day before": "Day before",
  "Deactivate": "Deactivate",
  "Deactivate {{name}}?": "Deactivate {{name}}?",
  "Deactivating…": "Deactivating…",
  "Deal Type": "Deal Type",
  "Deals, bonuses and partner offers.": "Deals, bonuses and partner offers.",
  "Debit or credit card": "Debit or credit card",
  "Decide later": "Decide later",
  "Declined": "Declined",
  "Decoration": "Decoration",
  "DEDUCTIONS FROM NET REVENUE": "DEDUCTIONS FROM NET REVENUE",
  "DEEP DIVE": "DEEP DIVE",
  "Default": "Default",
  "Default description": "Default description",
  "Default keywords": "Default keywords",
  "Default language": "Default language",
  "Default list": "Default list",
  "Default share image": "Default share image",
  "Definition": "Definition",
  "Delete": "Delete",
  "Delete {{address}}?": "Delete {{address}}?",
  "Delete draft": "Delete draft",
  "Delete forever?": "Delete forever?",
  "Delete list": "Delete list",
  "Delete mailbox": "Delete mailbox",
  "Delete Mailbox": "Delete Mailbox",
  "Delete permanently": "Delete permanently",
  "Delete route": "Delete route",
  "Delete style": "Delete style",
  "Delete table": "Delete table",
  "Delete the block": "Delete the block",
  "Delete this article?": "Delete this article?",
  "Delete this category?": "Delete this category?",
  "Delete this draft?": "Delete this draft?",
  "Delete this list": "Delete this list",
  "Delete this list?": "Delete this list?",
  "Delete this style?": "Delete this style?",
  "Delete version": "Delete version",
  "Delete your account": "Delete your account",
  "Deleted": "Deleted",
  "Deleted_mailbox": "Deleted",
  "Deleting…": "Deleting…",
  "Delivery": "Delivery",
  "Demo control": "Demo control",
  "Demo mode — no real payment is taken.": "Demo mode — no real payment is taken.",
  "Demo mode: no real payment is taken.": "Demo mode: no real payment is taken.",
  "Deploy steps": "Deploy steps",
  "Deployed": "Deployed",
  "Deploying": "Deploying",
  "Deployment progress": "Deployment progress",
  "Deployment session": "Deployment session",
  "Deployment summary": "Deployment summary",
  "Deposit": "Deposit",
  "Deposit funds": "Deposit funds",
  "Deposit successful": "Deposit successful",
  "Deposit volume": "Deposit volume",
  "Deposits": "Deposits",
  "Describe a background": "Describe a background",
  "Describe a background for Lumio to generate, e.g. neon city skyline at night": "Describe a background for Lumio to generate, e.g. neon city skyline at night",
  "Describe the ad you want (optional). Steers how the beats are written.": "Describe the ad you want (optional). Steers how the beats are written.",
  "Describe the clip you want to create.": "Describe the clip you want to create.",
  "Describe the creative you want": "Describe the creative you want",
  "Describe the feel you want, in your own words.": "Describe the feel you want, in your own words.",
  "Describe the image for readers who cannot see it": "Describe the image for readers who cannot see it",
  "Describe what you want and Lumio generates it inside your brand's art style, then you place it wherever it belongs. Pick a spot to start.": "Describe what you want and Lumio generates it inside your brand's art style, then you place it wherever it belongs. Pick a spot to start.",
  "Describe your video": "Describe your video",
  "Description": "Description",
  "Description length 120–158": "Description length 120–158",
  "Description not used by another page": "Description not used by another page",
  "Design": "Design",
  "Design a custom landing page": "Design a custom landing page",
  "Design an on-brand image for social, ads, or anywhere off your site. Pick a size to start, then compose it and generate a background with Lumio.": "Design an on-brand image for social, ads, or anywhere off your site. Pick a size to start, then compose it and generate a background with Lumio.",
  "Design an on-brand image for social, ads, or anywhere off your site. Pick a size, then compose it and generate a background with Lumio.": "Design an on-brand image for social, ads, or anywhere off your site. Pick a size, then compose it and generate a background with Lumio.",
  "Design your brand": "Design your brand",
  "Designing how scene {{n}} ends": "Designing how scene {{n}} ends",
  "Desktop": "Desktop",
  "Desktop only": "Desktop only",
  "Desktop preview": "Desktop preview",
  "Destination": "Destination",
  "Destination tag": "Destination tag",
  "Device": "Device",
  "Didn't get it?": "Didn't get it?",
  "Different browsers that opened these pages": "Different browsers that opened these pages",
  "Different browsers that opened this page": "Different browsers that opened this page",
  "Different browsers that opened your website": "Different browsers that opened your website",
  "Different people who opened these pages": "Different people who opened these pages",
  "Different people who opened this page": "Different people who opened this page",
  "Different people who opened your website": "Different people who opened your website",
  "Direct": "Direct",
  "Directing every shot of your ad": "Directing every shot of your ad",
  "Direction": "Direction",
  "Discard": "Discard",
  "Discard this website?": "Discard this website?",
  "Discard website": "Discard website",
  "Disconnect": "Disconnect",
  "Discount Voucher": "Discount Voucher",
  "Discover how can I help you with your Marketing Promotions": "Discover how can I help you with your Marketing Promotions",
  "Discover our full catalog of casino themes": "Discover our full catalog of casino themes",
  "Dismiss": "Dismiss",
  "Display": "Display",
  "Display & affiliates": "Display & affiliates",
  "Display name": "Display name",
  "Divider line": "Divider line",
  "DKIM record, so your mail is signed": "DKIM record, so your mail is signed",
  "DMARC policy, so receivers know what to trust": "DMARC policy, so receivers know what to trust",
  "DNS is configured automatically — nothing to do here.": "DNS is configured automatically — nothing to do here.",
  "DNS is configured automatically, nothing to do here.": "DNS is configured automatically, nothing to do here.",
  "DNS settings": "DNS settings",
  "DNS settings for {{domain}}": "DNS settings for {{domain}}",
  "Do this, in order": "Do this, in order",
  "Document sent": "Document sent",
  "DocuSign": "DocuSign",
  "Domain": "Domain",
  "Don’t have a brand yet?": "Don’t have a brand yet?",
  "Done": "Done",
  "Done so far": "Done so far",
  "Done. The link now sends people to {{where}}.": "Done. The link now sends people to {{where}}.",
  "Done. The link now sends people to your website.": "Done. The link now sends people to your website.",
  "Dormant": "Dormant",
  "Double-check the address and network before saving. Crypto payouts can't be reversed, and some exchange deposits also need a memo / destination tag.": "Double-check the address and network before saving. Crypto payouts can't be reversed, and some exchange deposits also need a memo / destination tag.",
  "Download": "Download",
  "Download {{label}}": "Download {{label}}",
  "Download {{name}}": "Download {{name}}",
  "Download {{title}} receipt": "Download {{title}} receipt",
  "Download all": "Download all",
  "Download all formats (.zip)": "Download all formats (.zip)",
  "Download contract": "Download contract",
  "Download invoice {{number}}": "Download invoice {{number}}",
  "Download PDF": "Download PDF",
  "Download Report": "Download Report",
  "Download the ZIP": "Download the ZIP",
  "Download the ZIP or export HTML5": "Download the ZIP or export HTML5",
  "Download this size": "Download this size",
  "Download video": "Download video",
  "Download ZIP": "Download ZIP",
  "Downloaded {{count}} logos as a zip": "Downloaded {{count}} logos as a zip",
  "Draft": "Draft",
  "Draft · not published": "Draft · not published",
  "Draft saved": "Draft saved",
  "Draft with Lumio": "Draft with Lumio",
  "Drafting…": "Drafting…",
  "Drafts": "Drafts",
  "drag": "drag",
  "Drag a game by its handle, or press and hold it, then preview the result on your site.": "Drag a game by its handle, or press and hold it, then preview the result on your site.",
  "Drag a row or use the arrows. Your site updates once you publish.": "Drag a row or use the arrows. Your site updates once you publish.",
  "Drag games to reorder, then preview the result on your site.": "Drag games to reorder, then preview the result on your site.",
  "Drag games to reorder.": "Drag games to reorder.",
  "Drag it on the canvas to move, corners to resize, the top handle to rotate.": "Drag it on the canvas to move, corners to resize, the top handle to rotate.",
  "Drag the logo on the canvas to place it.": "Drag the logo on the canvas to place it.",
  "Drag to reorder, then Publish to site to commit.": "Drag to reorder, then Publish to site to commit.",
  "Drag to set the order readers walk through this category. Rows above the last Start here guide are Start here guides themselves.": "Drag to set the order readers walk through this category. Rows above the last Start here guide are Start here guides themselves.",
  "Drag to set the order readers walk through this category. The Start here guide always comes first.": "Drag to set the order readers walk through this category. The Start here guide always comes first.",
  "Drag won't work in this preview — click to pick a file.": "Drag won't work in this preview — click to pick a file.",
  "Drag won't work in this preview, click to pick a file.": "Drag won't work in this preview, click to pick a file.",
  "Draw": "Draw",
  "Draw all samples": "Draw all samples",
  "Draw and switch": "Draw and switch",
  "Draw samples": "Draw samples",
  "Draw samples to see it at work": "Draw samples to see it at work",
  "Draw without an art style": "Draw without an art style",
  "Drawing": "Drawing",
  "Drawing a new image…": "Drawing a new image…",
  "Drawing new look…": "Drawing new look…",
  "Drawing samples": "Drawing samples",
  "Drawing this banner in your art style": "Drawing this banner in your art style",
  "Drawing your website art": "Drawing your website art",
  "Drawing your website art in {{style}}": "Drawing your website art in {{style}}",
  "Drawing…": "Drawing…",
  "Drawn by Lumio": "Drawn by Lumio",
  "Drawn by Lumio · Needs review": "Drawn by Lumio · Needs review",
  "Drawn from these references": "Drawn from these references",
  "Drawn in your art style, not live yet": "Drawn in your art style, not live yet",
  "Drawn onto every size when you download, so changing it never re-renders the art.": "Drawn onto every size when you download, so changing it never re-renders the art.",
  "Drawn with": "Drawn with",
  "Drawn with {{renderer}}": "Drawn with {{renderer}}",
  "Drawn with {{style}}": "Drawn with {{style}}",
  "Drawn with {{style}} and {{character}}": "Drawn with {{style}} and {{character}}",
  "Drawn without mood board images": "Drawn without mood board images",
  "Drift across the reveal to present the game while the \"{{subtitle}}\" detail settles in as clean supporting text.": "Drift across the reveal to present the game while the \"{{subtitle}}\" detail settles in as clean supporting text.",
  "Drift across the scene to present the \"{{headline}}\" offer as the featured moment.": "Drift across the scene to present the \"{{headline}}\" offer as the featured moment.",
  "Drift across the scene to present the \"{{headline}}\" offer while the \"{{subtitle}}\" detail settles in as clean supporting text.": "Drift across the scene to present the \"{{headline}}\" offer while the \"{{subtitle}}\" detail settles in as clean supporting text.",
  "Drop an image here or choose a file": "Drop an image here or choose a file",
  "Drop it here": "Drop it here",
  "Drop, paste, or attach images to guide the result; we keep them as close as we can.": "Drop, paste, or attach images to guide the result; we keep them as close as we can.",
  "Due": "Due",
  "Duplicate": "Duplicate",
  "Duration": "Duration",
  "Dynamic page": "Dynamic page",
  "Dynamic routes": "Dynamic routes",
  "e.g. 750": "e.g. 750",
  "e.g. A festive Día de Muertos hero with marigolds and warm lights": "e.g. A festive Día de Muertos hero with marigolds and warm lights",
  "e.g. Sponsorship fee...": "e.g. Sponsorship fee...",
  "Each article costs {{count}} credit, charged to your AI credits when it is written.": "Each article costs {{count}} credit, charged to your AI credits when it is written.",
  "Each article costs {{count}} credit.": "Each article costs {{count}} credit.",
  "Each article costs {{count}} credits, charged to your AI credits when it is written.": "Each article costs {{count}} credits, charged to your AI credits when it is written.",
  "Each article costs {{count}} credits.": "Each article costs {{count}} credits.",
  "Each article is charged to your AI credits when it is written.": "Each article is charged to your AI credits when it is written.",
  "Each article is paid with your AI credits.": "Each article is paid with your AI credits.",
  "Each browser counts once, under the source that last brought it, by the country of its latest visit.": "Each browser counts once, under the source that last brought it, by the country of its latest visit.",
  "Each browser counts once, under the source that last brought it.": "Each browser counts once, under the source that last brought it.",
  "Each browser on a phone or computer counts on its own, so someone who uses two devices counts twice.": "Each browser on a phone or computer counts on its own, so someone who uses two devices counts twice.",
  "Each person counts once, under the source that last brought them, by the country of their latest visit.": "Each person counts once, under the source that last brought them, by the country of their latest visit.",
  "Each person counts once, under the source that last brought them.": "Each person counts once, under the source that last brought them.",
  "Each size becomes an animated HTML5 ad: the art slowly pushes in, a light sweeps across it and the call to action pulses, with the legal line as live text. It stops after three loops.": "Each size becomes an animated HTML5 ad: the art slowly pushes in, a light sweeps across it and the call to action pulses, with the legal line as live text. It stops after three loops.",
  "Each size gets its own background, painted to leave room for the text.": "Each size gets its own background, painted to leave room for the text.",
  "Each visitor counts once, under the source that last brought them, by the country of their latest visit.": "Each visitor counts once, under the source that last brought them, by the country of their latest visit.",
  "Each visitor counts once, under the source that last brought them.": "Each visitor counts once, under the source that last brought them.",
  "Each visitor counts once, under the source that last brought them. Pick one to see only its visitors.": "Each visitor counts once, under the source that last brought them. Pick one to see only its visitors.",
  "Earlier style": "Earlier style",
  "Earnings": "Earnings",
  "Ease back to reveal the full promotion and let the \"{{cta}}\" call to action glow into view.": "Ease back to reveal the full promotion and let the \"{{cta}}\" call to action glow into view.",
  "Ease back to reveal the full promotion as the \"{{cta}}\" call to action lights up as a bold on-screen button.": "Ease back to reveal the full promotion as the \"{{cta}}\" call to action lights up as a bold on-screen button.",
  "Ease into a confident final composition as the \"{{cta}}\" call to action resolves smoothly as a premium on-screen button.": "Ease into a confident final composition as the \"{{cta}}\" call to action resolves smoothly as a premium on-screen button.",
  "Ease onto the full teaser as the \"{{cta}}\" call to action fades smoothly in as a bold on-screen button.": "Ease onto the full teaser as the \"{{cta}}\" call to action fades smoothly in as a bold on-screen button.",
  "Easy to adjust, game by game": "Easy to adjust, game by game",
  "Edit": "Edit",
  "Edit {{name}}": "Edit {{name}}",
  "Edit {{name}} creative": "Edit {{name}} creative",
  "Edit affiliate": "Edit affiliate",
  "Edit alt and caption": "Edit alt and caption",
  "Edit amount": "Edit amount",
  "Edit article": "Edit article",
  "Edit banner": "Edit banner",
  "Edit Billing Information": "Edit Billing Information",
  "Edit Billing Information →": "Edit Billing Information →",
  "Edit campaign": "Edit campaign",
  "Edit carousels": "Edit carousels",
  "Edit category": "Edit category",
  "Edit domain": "Edit domain",
  "Edit games": "Edit games",
  "Edit gamification features": "Edit gamification features",
  "Edit influencer": "Edit influencer",
  "Edit ingredients": "Edit ingredients",
  "Edit layers": "Edit layers",
  "Edit layers · {{size}}": "Edit layers · {{size}}",
  "Edit list": "Edit list",
  "Edit name": "Edit name",
  "Edit promotions": "Edit promotions",
  "Edit section": "Edit section",
  "Edit the block source": "Edit the block source",
  "Edit with Lumio": "Edit with Lumio",
  "Edited": "Edited",
  "Email": "Email",
  "Email (optional)": "Email (optional)",
  "Email A–Z": "Email A–Z",
  "Email address": "Email address",
  "Email copied to clipboard": "Email copied to clipboard",
  "Email domain": "Email domain",
  "Email invite": "Email invite",
  "Email me a code": "Email me a code",
  "Email or password is incorrect": "Email or password is incorrect",
  "Email verified": "Email verified",
  "Email Z–A": "Email Z–A",
  "Embed code": "Embed code",
  "Embed code · {{format}}": "Embed code · {{format}}",
  "Embed URL": "Embed URL",
  "Enable affiliates for this brand to create a campaign for this ad.": "Enable affiliates for this brand to create a campaign for this ad.",
  "Enable affiliates for this brand to track video-ad performance.": "Enable affiliates for this brand to track video-ad performance.",
  "Enable to power up": "Enable to power up",
  "Enabled": "Enabled",
  "Enabled Features": "Enabled Features",
  "Enabled in {{channel}}": "Enabled in {{channel}}",
  "Enabling fraud and risk monitoring": "Enabling fraud and risk monitoring",
  "End date (optional)": "End date (optional)",
  "End-card call to action": "End-card call to action",
  "Ended": "Ended",
  "Ended Campaign Details": "Ended Campaign Details",
  "Ended on": "Ended on",
  "Ended Promotion Details": "Ended Promotion Details",
  "Engine found profitable traffic but ran out of budget at {{time}}. Consider increasing daily limit.": "Engine found profitable traffic but ran out of budget at {{time}}. Consider increasing daily limit.",
  "English": "English",
  "Enter a valid {{label}}": "Enter a valid {{label}}",
  "Enter a valid {{memoLabel}}": "Enter a valid {{memoLabel}}",
  "Enter a valid date of birth (18+)": "Enter a valid date of birth (18+)",
  "Enter a valid email address to pay by card.": "Enter a valid email address to pay by card.",
  "Enter a valid email address.": "Enter a valid email address.",
  "Enter a valid wallet address for this network": "Enter a valid wallet address for this network",
  "Enter an amount greater than $0": "Enter an amount greater than $0",
  "Enter an amount of at least {{amount}}": "Enter an amount of at least {{amount}}",
  "Enter or a comma finishes an entry.": "Enter or a comma finishes an entry.",
  "Enter the address, the password and the server settings shown below.": "Enter the address, the password and the server settings shown below.",
  "Enter the address, then the server settings below with the password.": "Enter the address, then the server settings below with the password.",
  "Enter the code we emailed you and choose a new password.": "Enter the code we emailed you and choose a new password.",
  "Enter the name of the signatory.": "Enter the name of the signatory.",
  "Enter the operator name.": "Enter the operator name.",
  "Enter the part before the @ sign.": "Enter the part before the @ sign.",
  "Enter the server settings shown below, then sign in.": "Enter the server settings shown below, then sign in.",
  "Enter voucher code": "Enter voucher code",
  "Enter your code": "Enter your code",
  "Enter your domain": "Enter your domain",
  "Enter your email": "Enter your email",
  "Enter your email and we will send you a link to set a new password.": "Enter your email and we will send you a link to set a new password.",
  "Enter your email below to get a fresh sign-in link.": "Enter your email below to get a fresh sign-in link.",
  "Enter your email to begin": "Enter your email to begin",
  "Enter your email to begin. Your progress is saved automatically.": "Enter your email to begin. Your progress is saved automatically.",
  "Enter your first and last name, as they appear on your bank account.": "Enter your first and last name, as they appear on your bank account.",
  "Enter your name": "Enter your name",
  "Enter your name, the address and the password, then click Done.": "Enter your name, the address and the password, then click Done.",
  "Enter your name, the address and the password.": "Enter your name, the address and the password.",
  "Enter your own name": "Enter your own name",
  "Enter your password": "Enter your password",
  "Enter your payment details to launch your brand.": "Enter your payment details to launch your brand.",
  "Entities": "Entities",
  "Estimated commission": "Estimated commission",
  "Estimated from this player's activity and the affiliate's commission plan. The affiliates platform settles commission monthly across all of an affiliate's players, so the amount paid can differ.": "Estimated from this player's activity and the affiliate's commission plan. The affiliates platform settles commission monthly across all of an affiliate's players, so the amount paid can differ.",
  "Estimated NGR after commission": "Estimated NGR after commission",
  "Ethereum (ERC-20)": "Ethereum (ERC-20)",
  "EU / SEPA transfer. We pay the account holder named above, in EUR by default.": "EU / SEPA transfer. We pay the account holder named above, in EUR by default.",
  "Europe": "Europe",
  "Every article needs a category. It is the first part of the article's public URL and the group it is read in on your casino blog. Pick one, or create a new one here.": "Every article needs a category. It is the first part of the article's public URL and the group it is read in on your casino blog. Pick one, or create a new one here.",
  "Every article needs a category. It is the first part of the article's public URL and the group it is read in on your casino blog. There are no categories yet, so create the first one here.": "Every article needs a category. It is the first part of the article's public URL and the group it is read in on your casino blog. There are no categories yet, so create the first one here.",
  "Every article you publish goes live on {{domain}}.": "Every article you publish goes live on {{domain}}.",
  "Every banner kit you have generated. Open one to edit or regenerate it, download the ZIP or archive it, or create a new one.": "Every banner kit you have generated. Open one to edit or regenerate it, download the ZIP or archive it, or create a new one.",
  "Every country is allowed by default. Turn a country off to block players from it.": "Every country is allowed by default. Turn a country off to block players from it.",
  "Every country is blocked: no player can use your website.": "Every country is blocked: no player can use your website.",
  "Every creative on your site, editable with Lumio and on-brand.": "Every creative on your site, editable with Lumio and on-brand.",
  "Every device signed in to this mailbox stops working until you enter the new password.": "Every device signed in to this mailbox stops working until you enter the new password.",
  "Every game ends on your offer, never on a simulated win.": "Every game ends on your offer, never on a simulated win.",
  "Every game ends on your offer, never on a simulated win. The game stays once it is chosen.": "Every game ends on your offer, never on a simulated win. The game stays once it is chosen.",
  "Every game ends on your offer, never on a simulated win. You can change it later.": "Every game ends on your offer, never on a simulated win. You can change it later.",
  "Every game that matches appears here, and new games that match join on their own.": "Every game that matches appears here, and new games that match join on their own.",
  "Every HTML5 banner you have made, animated in every display size. Open one to edit it, generate its art or export it, archive it, or create a new one.": "Every HTML5 banner you have made, animated in every display size. Open one to edit it, generate its art or export it, archive it, or create a new one.",
  "Every image banner you have generated, one ad in every size. Open one to edit or regenerate it, download the ZIP or archive it, or create a new one.": "Every image banner you have generated, one ad in every size. Open one to edit or regenerate it, download the ZIP or archive it, or create a new one.",
  "Every mini-game you have made. Open one to edit it, generate its art or export it, archive it, or create a new one.": "Every mini-game you have made. Open one to edit it, generate its art or export it, archive it, or create a new one.",
  "Every month we will deduct {{price}} from your balance": "Every month we will deduct {{price}} from your balance",
  "Every month we will deduct the monthly feature price from your balance": "Every month we will deduct the monthly feature price from your balance",
  "Every month, we will deduct {{price}} from your primary wallet.": "Every month, we will deduct {{price}} from your primary wallet.",
  "Every one after it costs {{price}}, charged once.": "Every one after it costs {{price}}, charged once.",
  "Every one after it is a paid mailbox.": "Every one after it is a paid mailbox.",
  "every page": "every page",
  "Every post starts here. Press <0/>: write it yourself, or give a topic and get a draft.": "Every post starts here. Press <0/>: write it yourself, or give a topic and get a draft.",
  "Every video ad you have generated. Open one to edit or regenerate it, download or delete it, or create a new one.": "Every video ad you have generated. Open one to edit or regenerate it, download or delete it, or create a new one.",
  "Everyone": "Everyone",
  "Everything is already written. Clear a field to let Lumio write it.": "Everything is already written. Clear a field to let Lumio write it.",
  "Everything is ready for launch. Take a final look.": "Everything is ready for launch. Take a final look.",
  "Everything they deposited": "Everything they deposited",
  "Everything you advertise your casino with.": "Everything you advertise your casino with.",
  "Everything your players see on your casino site.": "Everything your players see on your casino site.",
  "Example: {{example}}": "Example: {{example}}",
  "Examples": "Examples",
  "Excellent for staying competitive with the market.": "Excellent for staying competitive with the market.",
  "Excluded": "Excluded",
  "Executed": "Executed",
  "Executing": "Executing",
  "Exhausted {{time}}": "Exhausted {{time}}",
  "Exit full screen": "Exit full screen",
  "Expand deployment": "Expand deployment",
  "Expired": "Expired",
  "Expires in": "Expires in",
  "Expires in {{n}} day": "Expires in {{n}} day",
  "Expires in {{n}} days": "Expires in {{n}} days",
  "Expires in {{time}}": "Expires in {{time}}",
  "Expires in days": "Expires in days",
  "Explore and activate individual gamification features.": "Explore and activate individual gamification features.",
  "Explore how": "Explore how",
  "Exploring colors…": "Exploring colors…",
  "Explosive punch-in on the artwork as gold coins burst outward and the \"{{headline}}\" offer slams in as huge, high-energy on-brand headline text.": "Explosive punch-in on the artwork as gold coins burst outward and the \"{{headline}}\" offer slams in as huge, high-energy on-brand headline text.",
  "Export": "Export",
  "Export animated HTML5": "Export animated HTML5",
  "Export as PDF": "Export as PDF",
  "Export CSV": "Export CSV",
  "Export HTML5": "Export HTML5",
  "Export profiles are not available in this environment yet.": "Export profiles are not available in this environment yet.",
  "Export ZIP": "Export ZIP",
  "Exported {{date}}": "Exported {{date}}",
  "Express checkout": "Express checkout",
  "External reference (optional)": "External reference (optional)",
  "Extract a style first, then draw samples to see it at work.": "Extract a style first, then draw samples to see it at work.",
  "Extract a style first.": "Extract a style first.",
  "Extract again": "Extract again",
  "Extract again to include them.": "Extract again to include them.",
  "Extract style": "Extract style",
  "Extract your style again to draw new samples.": "Extract your style again to draw new samples.",
  "Extract your style with the button under your ingredients (free)": "Extract your style with the button under your ingredients (free)",
  "Facebook / X preview": "Facebook / X preview",
  "Failed": "Failed",
  "Failed to load the blog": "Failed to load the blog",
  "Fair password": "Fair password",
  "FAQ": "FAQ",
  "Fast cut as the stakes rise, numbers and lights racing while the \"{{subtitle}}\" detail snaps in as bright supporting text.": "Fast cut as the stakes rise, numbers and lights racing while the \"{{subtitle}}\" detail snaps in as bright supporting text.",
  "Fast handheld whip-pan onto the artwork with a punchy zoom as the \"{{headline}}\" offer pops in as bold, scroll-stopping on-brand text.": "Fast handheld whip-pan onto the artwork with a punchy zoom as the \"{{headline}}\" offer pops in as bold, scroll-stopping on-brand text.",
  "Fast push-in on the artwork as a win lands and the \"{{headline}}\" offer snaps in as bold, on-brand headline text.": "Fast push-in on the artwork as a win lands and the \"{{headline}}\" offer snaps in as bold, on-brand headline text.",
  "Favicon": "Favicon",
  "Feature": "Feature",
  "Feature benchmark": "Feature benchmark",
  "feature pack includes": "feature pack includes",
  "Feature status": "Feature status",
  "Features": "Features",
  "Fiat & Crypto": "Fiat & Crypto",
  "Fiat only": "Fiat only",
  "Figure": "Figure",
  "File Size: Maximum 12MB": "File Size: Maximum 12MB",
  "Fill in every shot's action and camera, and the music line. Quoted text is removed, so it doesn't count.": "Fill in every shot's action and camera, and the music line. Quoted text is removed, so it doesn't count.",
  "Fill with Lumio": "Fill with Lumio",
  "Filling…": "Filling…",
  "Filter by name, ID or provider": "Filter by name, ID or provider",
  "Filter games": "Filter games",
  "Filter players": "Filter players",
  "Filter:": "Filter:",
  "Filters": "Filters",
  "filters changed": "filters changed",
  "Filters decide. New games that match are added for you.": "Filters decide. New games that match are added for you.",
  "Filters: none": "Filters: none",
  "Final prize": "Final prize",
  "Finalize payment": "Finalize payment",
  "Financial Performance": "Financial Performance",
  "Find a list": "Find a list",
  "Find a page": "Find a page",
  "Find games with the search": "Find games with the search",
  "Find my pack": "Find my pack",
  "Find the best gamification pack": "Find the best gamification pack",
  "Find your way around": "Find your way around",
  "Finding an angle the video service accepts": "Finding an angle the video service accepts",
  "Finish": "Finish",
  "Finish or discard the waiting redraw first.": "Finish or discard the waiting redraw first.",
  "Finish paying to activate your {{name}} subscription": "Finish paying to activate your {{name}} subscription",
  "Finish payment": "Finish payment",
  "Finish payment for {{name}}": "Finish payment for {{name}}",
  "Finish payment to activate {{name}}": "Finish payment to activate {{name}}",
  "Finish payment to upgrade {{name}}": "Finish payment to upgrade {{name}}",
  "Finish setting up {{name}}": "Finish setting up {{name}}",
  "Finish setting up the website you purchased {{when}}": "Finish setting up the website you purchased {{when}}",
  "Finish setting up your new website": "Finish setting up your new website",
  "Finish setup": "Finish setup",
  "Finish your upgrade": "Finish your upgrade",
  "Finished": "Finished",
  "Finished ad": "Finished ad",
  "Finishing setup…": "Finishing setup…",
  "Finishing up": "Finishing up",
  "First deposit": "First deposit",
  "First name": "First name",
  "First Name": "First Name",
  "First signals": "First signals",
  "First Time Depositors": "First Time Depositors",
  "Fit": "Fit",
  "Fit to screen": "Fit to screen",
  "Fitting your artwork to the video frame": "Fitting your artwork to the video frame",
  "Fix the fields marked in red first": "Fix the fields marked in red first",
  "Fix the highlighted fields before publishing": "Fix the highlighted fields before publishing",
  "Fixed": "Fixed",
  "Fixed cost (one-time fee, optional)": "Fixed cost (one-time fee, optional)",
  "Fixed cost note": "Fixed cost note",
  "Fixed costs will be distributed across all FTDs to calculate the true acquisition cost per player.": "Fixed costs will be distributed across all FTDs to calculate the true acquisition cost per player.",
  "Fixed fee": "Fixed fee",
  "Fixed fee {{amount}}": "Fixed fee {{amount}}",
  "Fixed fee amount": "Fixed fee amount",
  "Flagged after an image was refused": "Flagged after an image was refused",
  "Flagged from your mood board": "Flagged from your mood board",
  "Flat rate": "Flat rate",
  "Flip the <0/> switch: a new article is written and published for you {{cadence}}. Turn it off here anytime.": "Flip the <0/> switch: a new article is written and published for you {{cadence}}. Turn it off here anytime.",
  "Flip the switch and it goes live on {{domain}}.": "Flip the switch and it goes live on {{domain}}.",
  "Focus": "Focus",
  "Focus keyword": "Focus keyword",
  "Focus keyword in a footer heading": "Focus keyword in a footer heading",
  "Focus keyword in the description": "Focus keyword in the description",
  "Focus keyword in the footer's first paragraph": "Focus keyword in the footer's first paragraph",
  "Focus keyword in the title": "Focus keyword in the title",
  "Focus keyword: {{keyword}}": "Focus keyword: {{keyword}}",
  "Footer": "Footer",
  "footer only": "footer only",
  "Footer SEO text": "Footer SEO text",
  "Footer text can't be edited for this site yet.": "Footer text can't be edited for this site yet.",
  "Footer wildcard": "Footer wildcard",
  "For {{language}}, which isn't one of your site's languages: {{message}}": "For {{language}}, which isn't one of your site's languages: {{message}}",
  "For example Hacksaw, Pragmatic, Spribe": "For example Hacksaw, Pragmatic, Spribe",
  "For example Halloween, Egypt, Fruits": "For example Halloween, Egypt, Fruits",
  "For example Slots, Crash, Live casino": "For example Slots, Crash, Live casino",
  "For example: + 100 free spins": "For example: + 100 free spins",
  "For example: $30,000": "For example: $30,000",
  "For example: 100% bonus": "For example: 100% bonus",
  "For example: 100% up to €500 + 100 free spins": "For example: 100% up to €500 + 100 free spins",
  "For example: 18+ · T&Cs apply": "For example: 18+ · T&Cs apply",
  "For example: 18+ new players only. T&Cs apply. The game is illustrative.": "For example: 18+ new players only. T&Cs apply. The game is illustrative.",
  "For example: 300": "For example: 300",
  "For example: Claim your bonus": "For example: Claim your bonus",
  "For example: Congratulations!": "For example: Congratulations!",
  "For example: free spins": "For example: free spins",
  "For example: make it gold with a soft glow.": "For example: make it gold with a soft glow.",
  "For example: make the CTA button larger, or move the logo to the top.": "For example: make the CTA button larger, or move the logo to the top.",
  "For example: My hot picks": "For example: My hot picks",
  "For example: neon night, deep purple and gold.": "For example: neon night, deep purple and gold.",
  "For example: New customers. Min deposit €20. 35x wagering.": "For example: New customers. Min deposit €20. 35x wagering.",
  "For example: Our picks": "For example: Our picks",
  "For example: Scratch here": "For example: Scratch here",
  "For example: Spin the wheel and claim your bonus!": "For example: Spin the wheel and claim your bonus!",
  "For example: Up to": "For example: Up to",
  "For example: welcome bonus": "For example: welcome bonus",
  "For example: Welcome bonus": "For example: Welcome bonus",
  "For example: Your welcome bonus is waiting": "For example: Your welcome bonus is waiting",
  "For the initial order of the games, we took inspiration from top-performing sites in the Mexican region, including: {{sites}}.": "For the initial order of the games, we took inspiration from top-performing sites in the Mexican region, including: {{sites}}.",
  "Forgot password?": "Forgot password?",
  "Format": "Format",
  "Format: PNG or SVG": "Format: PNG or SVG",
  "Formats": "Formats",
  "Forwarding is not a mailbox: rejected mail is lost, and spam filtering may catch some legitimate messages. If you need to keep mail, buy a real mailbox and turn this off first.": "Forwarding is not a mailbox: rejected mail is lost, and spam filtering may catch some legitimate messages. If you need to keep mail, buy a real mailbox and turn this off first.",
  "Four formats drawn in your style, so you can judge it before you use it.": "Four formats drawn in your style, so you can judge it before you use it.",
  "Four of your promotions drawn in your style, so you can judge it before you use it.": "Four of your promotions drawn in your style, so you can judge it before you use it.",
  "Four steps to an art style": "Four steps to an art style",
  "Frame {{i}}": "Frame {{i}}",
  "Frame description": "Frame description",
  "Frame source": "Frame source",
  "Framing the story": "Framing the story",
  "Free": "Free",
  "FREE": "FREE",
  "Free campaign": "Free campaign",
  "Free during the pilot.": "Free during the pilot.",
  "Free of charge": "Free of charge",
  "Frequently asked questions": "Frequently asked questions",
  "Fresh posts give players a reason to come back to {{brand}}: a guide, a game review, the week's news. Every post starts from New article, written by you or drafted from a topic.": "Fresh posts give players a reason to come back to {{brand}}: a guide, a game review, the week's news. Every post starts from New article, written by you or drafted from a topic.",
  "Fresh posts give players a reason to come back. Every post on your blog starts in one place: New article.": "Fresh posts give players a reason to come back. Every post on your blog starts in one place: New article.",
  "Fri": "Fri",
  "Friend": "Friend",
  "From": "From",
  "From {{date}}": "From {{date}}",
  "from {{from}}": "from {{from}}",
  "from {{from}} to {{to}}": "from {{from}} to {{to}}",
  "From {{min}} to {{max}} items.": "From {{min}} to {{max}} items.",
  "From 1 (the top of the page) to {{last}} (the bottom).": "From 1 (the top of the page) to {{last}} (the bottom).",
  "From an Image Banners kit": "From an Image Banners kit",
  "From date": "From date",
  "From its definition": "From its definition",
  "From library": "From library",
  "From site defaults": "From site defaults",
  "From the current banner": "From the current banner",
  "From the market": "From the market",
  "From the opening frame": "From the opening frame",
  "From your own website, in the formats Website Creatives uses.": "From your own website, in the formats Website Creatives uses.",
  "From your website": "From your website",
  "From your website's default footer": "From your website's default footer",
  "From your website's own licence text": "From your website's own licence text",
  "From: {{name}}": "From: {{name}}",
  "FTD": "FTD",
  "FTD Deposits": "FTD Deposits",
  "FTD Val": "FTD Val",
  "FTD value": "FTD value",
  "FTD Value": "FTD Value",
  "FTDs": "FTDs",
  "FTUX test": "FTUX test",
  "FTUX test controls": "FTUX test controls",
  "FTUX tests are off while you are signed in as this owner.": "FTUX tests are off while you are signed in as this owner.",
  "Full control over every game": "Full control over every game",
  "Full definition": "Full definition",
  "Full meter": "Full meter",
  "Full month": "Full month",
  "Full name": "Full name",
  "Fully enabled": "Fully enabled",
  "Funds are held in your wallet while each request is reviewed.": "Funds are held in your wallet while each request is reviewed.",
  "Funds are held while each payout request is reviewed.": "Funds are held while each payout request is reviewed.",
  "Funds move from your main wallet": "Funds move from your main wallet",
  "Funds returned to your balance": "Funds returned to your balance",
  "Gambling ad rules frown on promising wins or free play: {{words}}. You can keep it, the choice is yours.": "Gambling ad rules frown on promising wins or free play: {{words}}. You can keep it, the choice is yours.",
  "Game": "Game",
  "Game · {{kind}}": "Game · {{kind}}",
  "Game ad": "Game ad",
  "Game carousel": "Game carousel",
  "Game carousel with jackpot": "Game carousel with jackpot",
  "Game grid": "Game grid",
  "Game list": "Game list",
  "Game Lists": "Game Lists",
  "Game lists are read from your live website. Check that it is online, then try again.": "Game lists are read from your live website. Check that it is online, then try again.",
  "Game lists are read from your live website. They will show here once your site is online.": "Game lists are read from your live website. They will show here once your site is online.",
  "Game lists on this page": "Game lists on this page",
  "Game name": "Game name",
  "Game order": "Game order",
  "Game providers": "Game providers",
  "Game settings": "Game settings",
  "Game text": "Game text",
  "Game thumbnails": "Game thumbnails",
  "Games": "Games",
  "Games in this list": "Games in this list",
  "Games reordered": "Games reordered",
  "Games you add from the results appear here. You can remove them any time before saving.": "Games you add from the results appear here. You can remove them any time before saving.",
  "Games you add show up here. You can hide or remove them any time before saving.": "Games you add show up here. You can hide or remove them any time before saving.",
  "Games you add show up here. You can remove them any time before saving.": "Games you add show up here. You can remove them any time before saving.",
  "Games your mini-game can be": "Games your mini-game can be",
  "Gamification": "Gamification",
  "Gamification ad": "Gamification ad",
  "Gamification art: {{name}}": "Gamification art: {{name}}",
  "Gamification features": "Gamification features",
  "Gamification Features": "Gamification Features",
  "GAMIFICATION FEES": "GAMIFICATION FEES",
  "Gamification Packages": "Gamification Packages",
  "Gamification Packages for": "Gamification Packages for",
  "Gathering player base insights": "Gathering player base insights",
  "Gathering your artwork and brand details": "Gathering your artwork and brand details",
  "Generate": "Generate",
  "Generate ({{total}} credits)": "Generate ({{total}} credits)",
  "Generate (1 credit)": "Generate (1 credit)",
  "Generate a link to share with a partner. Anyone who opens it registers as an affiliate in your program.": "Generate a link to share with a partner. Anyone who opens it registers as an affiliate in your program.",
  "Generate a link to share with partners. Up to 100 people can register with it as affiliates in your program.": "Generate a link to share with partners. Up to 100 people can register with it as affiliates in your program.",
  "Generate a tracking link to see performance.": "Generate a tracking link to see performance.",
  "Generate all formats": "Generate all formats",
  "Generate all formats · {{n}} credits": "Generate all formats · {{n}} credits",
  "Generate art": "Generate art",
  "Generate art in this style": "Generate art in this style",
  "Generate article": "Generate article",
  "Generate banners": "Generate banners",
  "Generate from description": "Generate from description",
  "Generate hero image": "Generate hero image",
  "Generate invite link": "Generate invite link",
  "Generate it first to get a tracking link.": "Generate it first to get a tracking link.",
  "Generate kit": "Generate kit",
  "Generate password": "Generate password",
  "Generate site defaults": "Generate site defaults",
  "Generate site defaults with Lumio?": "Generate site defaults with Lumio?",
  "Generate storyboard": "Generate storyboard",
  "Generate storyboard ad": "Generate storyboard ad",
  "Generate the art first. The embed publishes the selected version.": "Generate the art first. The embed publishes the selected version.",
  "Generate the art first. The export packages the selected version.": "Generate the art first. The export packages the selected version.",
  "Generate the article body": "Generate the article body",
  "Generate the banners": "Generate the banners",
  "Generate the hero image": "Generate the hero image",
  "Generate the SEO fields": "Generate the SEO fields",
  "Generate the storyboard": "Generate the storyboard",
  "Generate the video to get a tracking link.": "Generate the video to get a tracking link.",
  "Generate video": "Generate video",
  "Generate Video": "Generate Video",
  "Generate with Lumio": "Generate with Lumio",
  "Generated frame": "Generated frame",
  "Generated from": "Generated from",
  "Generated from your Whitelabels.com owner wallet.": "Generated from your Whitelabels.com owner wallet.",
  "Generated variants": "Generated variants",
  "Generating": "Generating",
  "Generating · {{done}} of {{total}}": "Generating · {{done}} of {{total}}",
  "Generating · {{when}}": "Generating · {{when}}",
  "Generating a background. We'll drop it in when it's ready.": "Generating a background. We'll drop it in when it's ready.",
  "Generating a new version": "Generating a new version",
  "Generating all formats. This can take a couple of minutes.": "Generating all formats. This can take a couple of minutes.",
  "Generating formats": "Generating formats",
  "Generating image…": "Generating image…",
  "Generating saves the article first, so anything you have changed here goes live straight away.": "Generating saves the article first, so anything you have changed here goes live straight away.",
  "Generating this version's formats…": "Generating this version's formats…",
  "Generating your clip": "Generating your clip",
  "Generating your creative. We'll add it here when it's ready.": "Generating your creative. We'll add it here when it's ready.",
  "Generating your logo…": "Generating your logo…",
  "Generating your video. This can take a couple of minutes.": "Generating your video. This can take a couple of minutes.",
  "Generating…": "Generating…",
  "Generation failed here. Resume to retry from this beat.": "Generation failed here. Resume to retry from this beat.",
  "Gently settle on the offer as the \"{{headline}}\" wording brightens and lifts into focus.": "Gently settle on the offer as the \"{{headline}}\" wording brightens and lifts into focus.",
  "Gently settle on the offer while the \"{{headline}}\" headline holds and the \"{{subtitle}}\" detail rises in as clean supporting text.": "Gently settle on the offer while the \"{{headline}}\" headline holds and the \"{{subtitle}}\" detail rises in as clean supporting text.",
  "Get a free email address for the casino": "Get a free email address for the casino",
  "Get a tracking link": "Get a tracking link",
  "Get its tracking link, or point an ad's link here, to see performance.": "Get its tracking link, or point an ad's link here, to see performance.",
  "Get promoted on": "Get promoted on",
  "Get started": "Get started",
  "Get tracking link": "Get tracking link",
  "Get unique tracking link": "Get unique tracking link",
  "Getting started": "Getting started",
  "Getting your details…": "Getting your details…",
  "Getting your next promotion ready": "Getting your next promotion ready",
  "GGR": "GGR",
  "Give people a branded address at {{domain}}. Mail forwards straight to an inbox they already use, and they can send as that address too. Nothing new to check, nothing stored here.": "Give people a branded address at {{domain}}. Mail forwards straight to an inbox they already use, and they can send as that address too. Nothing new to check, nothing stored here.",
  "Glide through the neon scene as the offer lights up and the \"{{subtitle}}\" detail pulses in as clean supporting text.": "Glide through the neon scene as the offer lights up and the \"{{subtitle}}\" detail pulses in as clean supporting text.",
  "Global Daily Spend Limit": "Global Daily Spend Limit",
  "Gmail": "Gmail",
  "Gmail on the web can only pull this mailbox over POP3, which downloads mail and leaves the sent copy behind. The Gmail mobile app does support IMAP; use that, or another client, for the full mailbox.": "Gmail on the web can only pull this mailbox over POP3, which downloads mail and leaves the sent copy behind. The Gmail mobile app does support IMAP; use that, or another client, for the full mailbox.",
  "Go back and get a new code": "Go back and get a new code",
  "Go live": "Go live",
  "Go to Blog": "Go to Blog",
  "Go to dashboard": "Go to dashboard",
  "Go to marketing assets": "Go to marketing assets",
  "Go to sign in": "Go to sign in",
  "Go to step {{n}}": "Go to step {{n}}",
  "GO VIRAL": "GO VIRAL",
  "Goes to:": "Goes to:",
  "Good choice for starting small and growing later.": "Good choice for starting small and growing later.",
  "Good for promos and seasonal picks": "Good for promos and seasonal picks",
  "Google preview": "Google preview",
  "Google Search Console": "Google Search Console",
  "Google verification record": "Google verification record",
  "google-site-verification=…": "google-site-verification=…",
  "Got it": "Got it",
  "Graceful glide across the scene as the offer is unveiled and the \"{{subtitle}}\" detail settles in as clean supporting text.": "Graceful glide across the scene as the offer is unveiled and the \"{{subtitle}}\" detail settles in as clean supporting text.",
  "Gradient {{name}}": "Gradient {{name}}",
  "Grid": "Grid",
  "Gross gaming revenue": "Gross gaming revenue",
  "Gross Gaming Revenue": "Gross Gaming Revenue",
  "Gross Revenue": "Gross Revenue",
  "GROSS REVENUE": "GROSS REVENUE",
  "Grow the casino": "Grow the casino",
  "Grow your brand": "Grow your brand",
  "Hand-picked": "Hand-picked",
  "Hand-picked · the list changes only when you edit it": "Hand-picked · the list changes only when you edit it",
  "Hard cut to the payoff as the \"{{cta}}\" call to action snaps in as a bold, tappable on-screen button.": "Hard cut to the payoff as the \"{{cta}}\" call to action snaps in as a bold, tappable on-screen button.",
  "Hard drive to the payoff as the \"{{cta}}\" call to action slams in as a bold, act-now on-screen button.": "Hard drive to the payoff as the \"{{cta}}\" call to action slams in as a bold, act-now on-screen button.",
  "Hardening security and access controls": "Hardening security and access controls",
  "Has an error that blocks Publish": "Has an error that blocks Publish",
  "Has deposited": "Has deposited",
  "Has placed bets": "Has placed bets",
  "Have a question or run into something? Send us a message and the Whitelabels.com team will get back to you by email.": "Have a question or run into something? Send us a message and the Whitelabels.com team will get back to you by email.",
  "Have a voucher code?": "Have a voucher code?",
  "Headline": "Headline",
  "Heads up": "Heads up",
  "hello": "hello",
  "Hello 👋🏼": "Hello 👋🏼",
  "HERE": "HERE",
  "Here are the specifications for the logo:": "Here are the specifications for the logo:",
  "Hero": "Hero",
  "Hero {{aspect}}": "Hero {{aspect}}",
  "Hero {{aspect}} · up to {{n}} steps": "Hero {{aspect}} · up to {{n}} steps",
  "Hero art": "Hero art",
  "Hero banner": "Hero banner",
  "Hero banners": "Hero banners",
  "Hero image": "Hero image",
  "Hero image details": "Hero image details",
  "Hero image preview": "Hero image preview",
  "Hi, I'm <0/>.": "Hi, I'm <0/>.",
  "Hidden": "Hidden",
  "Hidden on your site": "Hidden on your site",
  "Hidden sections": "Hidden sections",
  "Hide": "Hide",
  "Hide {{layer}}": "Hide {{layer}}",
  "Hide {{name}}": "Hide {{name}}",
  "Hide {{name}} from players": "Hide {{name}} from players",
  "Hide {{name}} from your site": "Hide {{name}} from your site",
  "Hide deploy steps": "Hide deploy steps",
  "Hide details": "Hide details",
  "Hide DNS Settings": "Hide DNS Settings",
  "Hide filters": "Hide filters",
  "Hide final prompt": "Hide final prompt",
  "Hide from Google (noindex)": "Hide from Google (noindex)",
  "Hide from players": "Hide from players",
  "Hide from this page": "Hide from this page",
  "Hide invitations": "Hide invitations",
  "Hide list": "Hide list",
  "Hide password": "Hide password",
  "Hide prompt": "Hide prompt",
  "Hide search": "Hide search",
  "Hide the {{kit}} sizes": "Hide the {{kit}} sizes",
  "Hide the sections you don't want on this page and add your own game lists where you want them. The other sections keep their order.": "Hide the sections you don't want on this page and add your own game lists where you want them. The other sections keep their order.",
  "Hide while it works": "Hide while it works",
  "History": "History",
  "Hold on the reward moment while coins and light shimmer to show the win paying off.": "Hold on the reward moment while coins and light shimmer to show the win paying off.",
  "Hold on the reward moment while coins shimmer and the \"{{subtitle}}\" detail settles in as clean supporting text.": "Hold on the reward moment while coins shimmer and the \"{{subtitle}}\" detail settles in as clean supporting text.",
  "Hold steadily on the final scene and invite the viewer to act.": "Hold steadily on the final scene and invite the viewer to act.",
  "Home": "Home",
  "Home page": "Home page",
  "Homepage": "Homepage",
  "Homepage hero": "Homepage hero",
  "Homepage, first list": "Homepage, first list",
  "Hook": "Hook",
  "Horizontal · dark": "Horizontal · dark",
  "Host": "Host",
  "Host copied to clipboard": "Host copied to clipboard",
  "Hosted embed": "Hosted embed",
  "Hosted embeds are not available in this environment yet.": "Hosted embeds are not available in this environment yet.",
  "Hot streak": "Hot streak",
  "HOT TOPICS": "HOT TOPICS",
  "How can we help?": "How can we help?",
  "How do you want to start?": "How do you want to start?",
  "How it works": "How it works",
  "How it works?": "How it works?",
  "How long a visit lasts on average": "How long a visit lasts on average",
  "How long people stay on these pages": "How long people stay on these pages",
  "How long people stay on this page": "How long people stay on this page",
  "How many browsers came, day by day": "How many browsers came, day by day",
  "How many browsers came, hour by hour": "How many browsers came, hour by hour",
  "How many people are coming in and are they converting?": "How many people are coming in and are they converting?",
  "How many people came, day by day": "How many people came, day by day",
  "How many people came, hour by hour": "How many people came, hour by hour",
  "How many times these pages were viewed": "How many times these pages were viewed",
  "How many times this page was viewed": "How many times this page was viewed",
  "How should it look?": "How should it look?",
  "How should this list be built?": "How should this list be built?",
  "How the banner moves. Every style shows the copy of what you advertise as live text. The style stays once it is chosen.": "How the banner moves. Every style shows the copy of what you advertise as live text. The style stays once it is chosen.",
  "How the banner moves. Every style shows the copy of what you advertise as live text. You can change the style later.": "How the banner moves. Every style shows the copy of what you advertise as live text. You can change the style later.",
  "How the banner moves. Every style shows your headline, offer line and call to action as live text. You can change it later.": "How the banner moves. Every style shows your headline, offer line and call to action as live text. You can change it later.",
  "How to edit": "How to edit",
  "How to pay": "How to pay",
  "How you sign in: password, linked Google or Telegram accounts and active sessions": "How you sign in: password, linked Google or Telegram accounts and active sessions",
  "How your pages show on Google, in shares and in AI answers.": "How your pages show on Google, in shares and in AI answers.",
  "HTML: paragraphs, lists and bold only.": "HTML: paragraphs, lists and bold only.",
  "HTML5": "HTML5",
  "HTML5 banner": "HTML5 banner",
  "HTML5 banner art is not available in this environment yet.": "HTML5 banner art is not available in this environment yet.",
  "HTML5 banner exports are not available in this environment yet.": "HTML5 banner exports are not available in this environment yet.",
  "HTML5 banner name": "HTML5 banner name",
  "HTML5 banner performance": "HTML5 banner performance",
  "HTML5 banner preview": "HTML5 banner preview",
  "HTML5 banner preview, {{size}}": "HTML5 banner preview, {{size}}",
  "HTML5 banners": "HTML5 banners",
  "HTML5 Banners": "HTML5 Banners",
  "HTML5 Banners are on their way.": "HTML5 Banners are on their way.",
  "HTML5 ZIP": "HTML5 ZIP",
  "https://… (optional)": "https://… (optional)",
  "https://… or /slots": "https://… or /slots",
  "Hybrid": "Hybrid",
  "I agree to receive marketing communications about Whitelabels.com products, promotions and updates.": "I agree to receive marketing communications about Whitelabels.com products, promotions and updates.",
  "I am still writing the previous article. Let me finish that one first.": "I am still writing the previous article. Let me finish that one first.",
  "I confirm this copy is final": "I confirm this copy is final",
  "I could not record that decision. Please try again.": "I could not record that decision. Please try again.",
  "I have my own domain": "I have my own domain",
  "I have my own logo": "I have my own logo",
  "I have my own name": "I have my own name",
  "I have my own name & domain": "I have my own name & domain",
  "I want to decide fast": "I want to decide fast",
  "I’m": "I’m",
  "I’m putting it together…": "I’m putting it together…",
  "I've made the payment": "I've made the payment",
  "I've made the transfer": "I've made the transfer",
  "IBAN": "IBAN",
  "Icon image URLs": "Icon image URLs",
  "ID {{id}}": "ID {{id}}",
  "ID {{id}} · {{provider}}": "ID {{id}} · {{provider}}",
  "Identifying market tailwinds": "Identifying market tailwinds",
  "If an account exists for this email, a reset link is on the way.": "If an account exists for this email, a reset link is on the way.",
  "If DocuSign first asks whether you recognize this document, continue to open it.": "If DocuSign first asks whether you recognize this document, continue to open it.",
  "If the code no longer works, go back to get a new one.": "If the code no longer works, go back to get a new one.",
  "If you already paid with this code, do not get a new one.": "If you already paid with this code, do not get a new one.",
  "If your site already shows this style, players see the new art as each part is drawn. Otherwise your site switches to it once all of it is drawn.": "If your site already shows this style, players see the new art as each part is drawn. Otherwise your site switches to it once all of it is drawn.",
  "IFSC code": "IFSC code",
  "illustrative": "illustrative",
  "Image Ads": "Image Ads",
  "Image banner": "Image banner",
  "Image banner downloads are not available in this environment yet.": "Image banner downloads are not available in this environment yet.",
  "Image banner name": "Image banner name",
  "Image banner performance": "Image banner performance",
  "image banners": "image banners",
  "Image banners": "Image banners",
  "Image Banners": "Image Banners",
  "Image banners are not available in this environment yet.": "Image banners are not available in this environment yet.",
  "Image uploads are not configured for this environment": "Image uploads are not configured for this environment",
  "Image URL for {{layer}}": "Image URL for {{layer}}",
  "Images": "Images",
  "Important notifications": "Important notifications",
  "In Gmail on the web, open Settings, then Accounts and Import, then Check mail from other accounts.": "In Gmail on the web, open Settings, then Accounts and Import, then Check mail from other accounts.",
  "In progress": "In progress",
  "In Search Console, add a Domain property for {{domain}} and choose \"Any DNS provider\".": "In Search Console, add a Domain property for {{domain}} and choose \"Any DNS provider\".",
  "in the last 30 days": "in the last 30 days",
  "in the last 7 days": "in the last 7 days",
  "in the last 90 days": "in the last 90 days",
  "In this list": "In this list",
  "In this order, top to bottom:": "In this order, top to bottom:",
  "In your own words": "In your own words",
  "In-app": "In-app",
  "In-app Ads": "In-app Ads",
  "In-Website": "In-Website",
  "Inactive": "Inactive",
  "Inbox": "Inbox",
  "Include {{size}}": "Include {{size}}",
  "Included": "Included",
  "Included with your brand": "Included with your brand",
  "Included with your brand, free forever. It is never charged.": "Included with your brand, free forever. It is never charged.",
  "Includes {{n}} suspected": "Includes {{n}} suspected",
  "Incoming mail is on its way": "Incoming mail is on its way",
  "Increase daily budget": "Increase daily budget",
  "Individual (private person)": "Individual (private person)",
  "Influencers": "Influencers",
  "Ingredients": "Ingredients",
  "Ingredients changed": "Ingredients changed",
  "Initial": "Initial",
  "Inline code": "Inline code",
  "Inline SVG. Anything the public renderer will not accept is dropped from the page.": "Inline SVG. Anything the public renderer will not accept is dropped from the page.",
  "Insert a quiz": "Insert a quiz",
  "Insert a quiz, written by Lumio": "Insert a quiz, written by Lumio",
  "Insert a quiz, written by Lumio · {{n}} credit": "Insert a quiz, written by Lumio · {{n}} credit",
  "Insert a quiz, written by Lumio · {{n}} credits": "Insert a quiz, written by Lumio · {{n}} credits",
  "Insert an expandable answer": "Insert an expandable answer",
  "Insert an infographic": "Insert an infographic",
  "Insert game name": "Insert game name",
  "Insert image": "Insert image",
  "Insert table": "Insert table",
  "Institution number": "Institution number",
  "Instruction": "Instruction",
  "Integrating your game studios": "Integrating your game studios",
  "Interface": "Interface",
  "Intermediary bank account / reference": "Intermediary bank account / reference",
  "Intermediary bank SWIFT / BIC": "Intermediary bank SWIFT / BIC",
  "Internal": "Internal",
  "Internal addresses only": "Internal addresses only",
  "Internal site": "Internal site",
  "International": "International",
  "International wire. Funds go to the account holder named above, at the billing address below; an intermediary / correspondent bank is only needed on certain corridors.": "International wire. Funds go to the account holder named above, at the billing address below; an intermediary / correspondent bank is only needed on certain corridors.",
  "Interstitial": "Interstitial",
  "Introducing Lumio": "Introducing Lumio",
  "Invitation prepared for {{email}}": "Invitation prepared for {{email}}",
  "Invite": "Invite",
  "Invite a specific partner by email. They show as a pending invitation until they join.": "Invite a specific partner by email. They show as a pending invitation until they join.",
  "Invite affiliate": "Invite affiliate",
  "Invite affiliates to bring players": "Invite affiliates to bring players",
  "Invite an affiliate": "Invite an affiliate",
  "Invite expires": "Invite expires",
  "Invite later": "Invite later",
  "Invite link copied": "Invite link copied",
  "Invite link created": "Invite link created",
  "Invite mode": "Invite mode",
  "Invite revoked": "Invite revoked",
  "Invite the first one": "Invite the first one",
  "Invite your first affiliate": "Invite your first affiliate",
  "Invoice": "Invoice",
  "Invoice #{{number}} for {{amount}} will be cancelled. This can't be undone, and you won't be charged.": "Invoice #{{number}} for {{amount}} will be cancelled. This can't be undone, and you won't be charged.",
  "Invoice cancelled": "Invoice cancelled",
  "Invoice details": "Invoice details",
  "Invoice no.": "Invoice no.",
  "Invoice receipt": "Invoice receipt",
  "Invoices": "Invoices",
  "Invoices awaiting payment appear here, including deposit top-ups still being confirmed.": "Invoices awaiting payment appear here, including deposit top-ups still being confirmed.",
  "Invoices you cancelled before payment appear here, so they stay out of Pending.": "Invoices you cancelled before payment appear here, so they stay out of Pending.",
  "iPad": "iPad",
  "iPhone": "iPhone",
  "iPhone / Android": "iPhone / Android",
  "iPhone: open Settings, then Apps, then Mail, then Mail Accounts, then Add Account, then Other.": "iPhone: open Settings, then Apps, then Mail, then Mail Accounts, then Add Account, then Other.",
  "iPod": "iPod",
  "Issued": "Issued",
  "Issuing SSL security certificates": "Issuing SSL security certificates",
  "It can take a few hours and runs to the end once started. You can leave this page.": "It can take a few hours and runs to the end once started. You can leave this page.",
  "It can take a few hours; you can leave this page.": "It can take a few hours; you can leave this page.",
  "It can take tens of minutes and runs to the end once started. You can leave this page.": "It can take tens of minutes and runs to the end once started. You can leave this page.",
  "It goes live with the rest of your website art once all of it is drawn.": "It goes live with the rest of your website art once all of it is drawn.",
  "It is shown once and stored nowhere.": "It is shown once and stored nowhere.",
  "It is the style in use, so new banners and images will no longer follow an art style.": "It is the style in use, so new banners and images will no longer follow an art style.",
  "It may take a few moments for the payment to be fully processed and your balance to update.": "It may take a few moments for the payment to be fully processed and your balance to update.",
  "It may take a few moments for your balance to update.": "It may take a few moments for your balance to update.",
  "It may take a few moments for your credit balance to update.": "It may take a few moments for your credit balance to update.",
  "It stays as it is.": "It stays as it is.",
  "It stopped making progress, so it was ended.": "It stopped making progress, so it was ended.",
  "It takes about two minutes. You can keep working on the banner meanwhile.": "It takes about two minutes. You can keep working on the banner meanwhile.",
  "It takes about two minutes. You can keep working on the kit meanwhile.": "It takes about two minutes. You can keep working on the kit meanwhile.",
  "It waits for you here.": "It waits for you here.",
  "It waits for you.": "It waits for you.",
  "It was stopped.": "It was stopped.",
  "It will be moved to Archived banner kits, where you can restore it later or permanently delete it.": "It will be moved to Archived banner kits, where you can restore it later or permanently delete it.",
  "It will be moved to Archived HTML5 banners, where you can restore it later or permanently delete it.": "It will be moved to Archived HTML5 banners, where you can restore it later or permanently delete it.",
  "It will be moved to Archived image banners, where you can restore it later or permanently delete it.": "It will be moved to Archived image banners, where you can restore it later or permanently delete it.",
  "It will be moved to Archived landing pages, where you can restore it later or permanently delete it. A live page stays live until you unpublish it.": "It will be moved to Archived landing pages, where you can restore it later or permanently delete it. A live page stays live until you unpublish it.",
  "It will be moved to Archived mini-games, where you can restore it later or permanently delete it.": "It will be moved to Archived mini-games, where you can restore it later or permanently delete it.",
  "It will be moved to Archived video ads, where you can restore it later or permanently delete it. It will not show in your library.": "It will be moved to Archived video ads, where you can restore it later or permanently delete it. It will not show in your library.",
  "It will log you in if you have a Whitelabels.com account.": "It will log you in if you have a Whitelabels.com account.",
  "Italic": "Italic",
  "Its sizes play as an animated HTML5 banner, using the art you already generated.": "Its sizes play as an animated HTML5 banner, using the art you already generated.",
  "Jackpot drop": "Jackpot drop",
  "Jackpots": "Jackpots",
  "Join now": "Join now",
  "Joined {{date}}": "Joined {{date}}",
  "Joined with the invite link": "Joined with the invite link",
  "Jump to {{step}}": "Jump to {{step}}",
  "Jump to a step": "Jump to a step",
  "Just a heads up!": "Just a heads up!",
  "Just activated": "Just activated",
  "just now": "just now",
  "Just now": "Just now",
  "Keep building": "Keep building",
  "Keep invoice": "Keep invoice",
  "Keep it": "Keep it",
  "Keep reading": "Keep reading",
  "Keep upgrade": "Keep upgrade",
  "Keeps the style in harmony with your brand colours.": "Keeps the style in harmony with your brand colours.",
  "kept": "kept",
  "Kept as it is": "Kept as it is",
  "Kept what you wrote for {{languages}} while Lumio was writing.": "Kept what you wrote for {{languages}} while Lumio was writing.",
  "Key facts": "Key facts",
  "Key Metrics": "Key Metrics",
  "Key point": "Key point",
  "Key takeaway": "Key takeaway",
  "Key takeaways": "Key takeaways",
  "Key visual": "Key visual",
  "Keyword checklist": "Keyword checklist",
  "Keyword density {{density}}% (0.5–2.5%)": "Keyword density {{density}}% (0.5–2.5%)",
  "Keyword score": "Keyword score",
  "Keyword score {{passed}} of {{total}}": "Keyword score {{passed}} of {{total}}",
  "Keywords": "Keywords",
  "Kits": "Kits",
  "Know the numbers": "Know the numbers",
  "Knowledge base": "Knowledge base",
  "L": "L",
  "Label": "Label",
  "Label / nickname (optional)": "Label / nickname (optional)",
  "Landing page": "Landing page",
  "Landing page generation is not available in this environment yet.": "Landing page generation is not available in this environment yet.",
  "Landing page name": "Landing page name",
  "Landing page performance": "Landing page performance",
  "Landing page preview": "Landing page preview",
  "Landing page previews aren't available in this environment yet.": "Landing page previews aren't available in this environment yet.",
  "Landing pages": "Landing pages",
  "Landing Pages": "Landing Pages",
  "Landing pages aren't available in this environment yet.": "Landing pages aren't available in this environment yet.",
  "Landing URL (optional)": "Landing URL (optional)",
  "Landscape (16:9)": "Landscape (16:9)",
  "Language": "Language",
  "Languages": "Languages",
  "Large": "Large",
  "Last 1 day": "Last 1 day",
  "Last 1 Year": "Last 1 Year",
  "Last 2 years": "Last 2 years",
  "Last 30 days": "Last 30 days",
  "Last 30 days, across the {{n}} tracking links landing here (this page's own link included).": "Last 30 days, across the {{n}} tracking links landing here (this page's own link included).",
  "Last 30 days, from the one tracking link landing here.": "Last 30 days, from the one tracking link landing here.",
  "Last 30 days: {{registrations}} registrations · {{ftds}} FTDs · {{deposits}} deposits": "Last 30 days: {{registrations}} registrations · {{ftds}} FTDs · {{deposits}} deposits",
  "Last 6 months": "Last 6 months",
  "Last 6 Months": "Last 6 Months",
  "Last 60 days": "Last 60 days",
  "Last 7 days": "Last 7 days",
  "Last 90 days": "Last 90 days",
  "Last article {{when}}": "Last article {{when}}",
  "Last export · {{profile}}": "Last export · {{profile}}",
  "Last name": "Last name",
  "Last Name": "Last Name",
  "Last received {{ago}}": "Last received {{ago}}",
  "Last seen": "Last seen",
  "Last seen {{time}}": "Last seen {{time}}",
  "Last signed in": "Last signed in",
  "Last updated": "Last updated",
  "Last year": "Last year",
  "later": "later",
  "Latest · {{when}}": "Latest · {{when}}",
  "Layer canvas. Drag a layer to move it; the arrow keys nudge the selected one.": "Layer canvas. Drag a layer to move it; the arrow keys nudge the selected one.",
  "Layer editing is not available in this environment yet.": "Layer editing is not available in this environment yet.",
  "Layer editing is not available yet.": "Layer editing is not available yet.",
  "Layers": "Layers",
  "Lead with the welcome offer": "Lead with the welcome offer",
  "Leading the market": "Leading the market",
  "Leave blank to send an invite link": "Leave blank to send an invite link",
  "Leave it off and they keep their current artwork, which will no longer match.": "Leave it off and they keep their current artwork, which will no longer match.",
  "Leave it off and your file is used exactly as it is.": "Leave it off and your file is used exactly as it is.",
  "Left": "Left",
  "Legal": "Legal",
  "Legal footer (from your website)": "Legal footer (from your website)",
  "Legal line": "Legal line",
  "Legal text": "Legal text",
  "Let Lumio choose": "Let Lumio choose",
  "Let Lumio prepare it": "Let Lumio prepare it",
  "Let me assist you in finding the perfect Affiliate Partner": "Let me assist you in finding the perfect Affiliate Partner",
  "Let the blog post by itself": "Let the blog post by itself",
  "Lettering, offer and button": "Lettering, offer and button",
  "Level {{current}}/{{total}}": "Level {{current}}/{{total}}",
  "Level {{level}} benefits (max)": "Level {{level}} benefits (max)",
  "Level {{level}}/{{max}}": "Level {{level}}/{{max}}",
  "Licence": "Licence",
  "Light": "Light",
  "Limited liability company (LLC / Ltd)": "Limited liability company (LLC / Ltd)",
  "Lining up scene {{next}} to continue from scene {{n}}": "Lining up scene {{next}} to continue from scene {{n}}",
  "Link": "Link",
  "Link address": "Link address",
  "Link goes to": "Link goes to",
  "Link your domain": "Link your domain",
  "Link your own domain": "Link your own domain",
  "Link your own domain to {{brand}} casino": "Link your own domain to {{brand}} casino",
  "Links": "Links",
  "Links · {{n}}": "Links · {{n}}",
  "Links to this page": "Links to this page",
  "Linux PC": "Linux PC",
  "List layout": "List layout",
  "List name": "List name",
  "List name in {{language}}": "List name in {{language}}",
  "List: {{name}}": "List: {{name}}",
  "Lists on this page changed": "Lists on this page changed",
  "Live": "Live",
  "LIVE": "LIVE",
  "Live · {{surface}}": "Live · {{surface}}",
  "Live and original versions can't be archived": "Live and original versions can't be archived",
  "Live and original versions can't be deleted": "Live and original versions can't be deleted",
  "Live at {{url}}": "Live at {{url}}",
  "Live on {{domain}}": "Live on {{domain}}",
  "Live on {{domain}}.": "Live on {{domain}}.",
  "Live on your site now. Shares and Google can take up to 24 hours to show it.": "Live on your site now. Shares and Google can take up to 24 hours to show it.",
  "Live operations feed": "Live operations feed",
  "Live preview": "Live preview",
  "Live Preview": "Live Preview",
  "Live previews are not available in this environment yet.": "Live previews are not available in this environment yet.",
  "Live RTP": "Live RTP",
  "Live website preview": "Live website preview",
  "Live-text banner": "Live-text banner",
  "llms.txt": "llms.txt",
  "Load more": "Load more",
  "Load more ({{shown}} of {{total}})": "Load more ({{shown}} of {{total}})",
  "Load more campaign assets": "Load more campaign assets",
  "Load more campaigns": "Load more campaigns",
  "Load more promotions": "Load more promotions",
  "loading": "loading",
  "Loading conversation": "Loading conversation",
  "Loading features…": "Loading features…",
  "Loading games…": "Loading games…",
  "Loading preview…": "Loading preview…",
  "Loading promotions…": "Loading promotions…",
  "Loading the game catalog": "Loading the game catalog",
  "Loading the game catalogue...": "Loading the game catalogue...",
  "Loading the layers…": "Loading the layers…",
  "Loading themes…": "Loading themes…",
  "Loading your banner kits…": "Loading your banner kits…",
  "Loading your HTML5 banners…": "Loading your HTML5 banners…",
  "Loading your image banners…": "Loading your image banners…",
  "Loading your landing pages…": "Loading your landing pages…",
  "Loading your mini-games…": "Loading your mini-games…",
  "Loading your video ads…": "Loading your video ads…",
  "Loading…": "Loading…",
  "Loads Google Analytics and the Facebook Pixel. When off, neither one ever runs.": "Loads Google Analytics and the Facebook Pixel. When off, neither one ever runs.",
  "Localizing currencies and languages": "Localizing currencies and languages",
  "Locating…": "Locating…",
  "Locations are estimated from each device's IP address and may be approximate.": "Locations are estimated from each device's IP address and may be approximate.",
  "Locked": "Locked",
  "Log out": "Log out",
  "Log out of {{name}}": "Log out of {{name}}",
  "Log out of all devices": "Log out of all devices",
  "Logging out {{name}}…": "Logging out {{name}}…",
  "Logging out of all devices…": "Logging out of all devices…",
  "Logging out…": "Logging out…",
  "Logo": "Logo",
  "Logo & CTA appear here": "Logo & CTA appear here",
  "Logo changes are locked — {{registeredUsers}} players have registered, past the {{maxUsers}}-player limit for changes.": "Logo changes are locked — {{registeredUsers}} players have registered, past the {{maxUsers}}-player limit for changes.",
  "Logo changes are locked — it's been {{daysSinceLaunch}} days since launch (limit {{maxDays}}) and {{registeredUsers}} players have registered (limit {{maxUsers}}).": "Logo changes are locked — it's been {{daysSinceLaunch}} days since launch (limit {{maxDays}}) and {{registeredUsers}} players have registered (limit {{maxUsers}}).",
  "Logo changes are locked — it's been {{daysSinceLaunch}} days since launch, past the {{maxDays}}-day window for changes.": "Logo changes are locked — it's been {{daysSinceLaunch}} days since launch, past the {{maxDays}}-day window for changes.",
  "Logo changes are locked. {{registeredUsers}} players have registered, past the {{maxUsers}}-player limit for changes.": "Logo changes are locked. {{registeredUsers}} players have registered, past the {{maxUsers}}-player limit for changes.",
  "Logo changes are locked. It's been {{daysSinceLaunch}} days since launch (limit {{maxDays}}) and {{registeredUsers}} players have registered (limit {{maxUsers}}).": "Logo changes are locked. It's been {{daysSinceLaunch}} days since launch (limit {{maxDays}}) and {{registeredUsers}} players have registered (limit {{maxUsers}}).",
  "Logo changes are locked. It's been {{daysSinceLaunch}} days since launch, past the {{maxDays}}-day window for changes.": "Logo changes are locked. It's been {{daysSinceLaunch}} days since launch, past the {{maxDays}}-day window for changes.",
  "Logo size": "Logo size",
  "Logo uploaded successfully!": "Logo uploaded successfully!",
  "Logo variants": "Logo variants",
  "Logos": "Logos",
  "Logout": "Logout",
  "Looking ahead": "Looking ahead",
  "LTV": "LTV",
  "Lumio": "Lumio",
  "Lumio Budget and Limits": "Lumio Budget and Limits",
  "Lumio builds and publishes a landing page for {{name}}": "Lumio builds and publishes a landing page for {{name}}",
  "Lumio builds and publishes a landing page for {{name}} · {{credits}} credits": "Lumio builds and publishes a landing page for {{name}} · {{credits}} credits",
  "Lumio builds and publishes a landing page for this ad": "Lumio builds and publishes a landing page for this ad",
  "Lumio builds and publishes a landing page for this asset · {{credits}} credits": "Lumio builds and publishes a landing page for this asset · {{credits}} credits",
  "Lumio can draw your welcome bonus, hero, promotion and gamification art in it. Players keep seeing your current look until you set it as primary.": "Lumio can draw your welcome bonus, hero, promotion and gamification art in it. Players keep seeing your current look until you set it as primary.",
  "Lumio can't reach the art service right now. No credits were used. Please try again later.": "Lumio can't reach the art service right now. No credits were used. Please try again later.",
  "Lumio can't reach the art service right now. Please try again later.": "Lumio can't reach the art service right now. Please try again later.",
  "Lumio cannot build a landing page right now. Please try again later.": "Lumio cannot build a landing page right now. Please try again later.",
  "Lumio Channels": "Lumio Channels",
  "Lumio couldn't change that layer. Your credits were refunded. Please try again.": "Lumio couldn't change that layer. Your credits were refunded. Please try again.",
  "Lumio couldn't describe your characters.": "Lumio couldn't describe your characters.",
  "Lumio couldn't draft the copy right now. Write your own, or try again.": "Lumio couldn't draft the copy right now. Write your own, or try again.",
  "Lumio couldn't fill this HTML5 banner right now. Edit it yourself, or try again.": "Lumio couldn't fill this HTML5 banner right now. Edit it yourself, or try again.",
  "Lumio couldn't fill this mini-game right now. Edit it yourself, or try again.": "Lumio couldn't fill this mini-game right now. Edit it yourself, or try again.",
  "Lumio couldn't read a style from these ingredients. No credits were used. Try other mood board images or a different direction.": "Lumio couldn't read a style from these ingredients. No credits were used. Try other mood board images or a different direction.",
  "Lumio couldn't read a style from these ingredients. Try other mood board images or a different direction.": "Lumio couldn't read a style from these ingredients. Try other mood board images or a different direction.",
  "Lumio couldn’t respond. Please try again.": "Lumio couldn’t respond. Please try again.",
  "Lumio couldn't write that. Please try again.": "Lumio couldn't write that. Please try again.",
  "Lumio draws all of your website art in {{look}}, next to your current look.": "Lumio draws all of your website art in {{look}}, next to your current look.",
  "Lumio draws every layer in your art style when you generate with Scene art on. Press a layer to use your own image instead.": "Lumio draws every layer in your art style when you generate with Scene art on. Press a layer to use your own image instead.",
  "Lumio draws four sample formats in your style as soon as it has one.": "Lumio draws four sample formats in your style as soon as it has one.",
  "Lumio draws the art across your website in {{style}}, then switches your site to it.": "Lumio draws the art across your website in {{style}}, then switches your site to it.",
  "Lumio draws the artwork in this style, with its look and colours.": "Lumio draws the artwork in this style, with its look and colours.",
  "Lumio draws the hero in your art style and writes the copy in every language of your website.": "Lumio draws the hero in your art style and writes the copy in every language of your website.",
  "Lumio draws the hero in your art style and writes the copy of every language.": "Lumio draws the hero in your art style and writes the copy of every language.",
  "Lumio draws the hero in your art style when you generate.": "Lumio draws the hero in your art style when you generate.",
  "Lumio draws the offer and the button as lettering in your art style when you generate with Lettering on.": "Lumio draws the offer and the button as lettering in your art style when you generate with Lettering on.",
  "Lumio draws the scene in your art style and writes the copy in every language of your website.": "Lumio draws the scene in your art style and writes the copy in every language of your website.",
  "Lumio draws the scene in your art style and writes the copy of every language.": "Lumio draws the scene in your art style and writes the copy of every language.",
  "Lumio features up to two of your characters. Pick them yourself: the first stands left of the game, the second right.": "Lumio features up to two of your characters. Pick them yourself: the first stands left of the game, the second right.",
  "Lumio features up to two of your characters. Pick them yourself: the first stands left of the offer, the second right.": "Lumio features up to two of your characters. Pick them yourself: the first stands left of the offer, the second right.",
  "Lumio found profitable traffic but reached the daily budget. Consider increasing the daily limit to keep players coming.": "Lumio found profitable traffic but reached the daily budget. Consider increasing the daily limit to keep players coming.",
  "Lumio generated": "Lumio generated",
  "Lumio generates every other variant again from this artwork. You can still replace any of them one by one afterwards.": "Lumio generates every other variant again from this artwork. You can still replace any of them one by one afterwards.",
  "Lumio has enough to go on.": "Lumio has enough to go on.",
  "Lumio is analyzing your players and preparing fresh promotions to keep them playing and grow your revenue. They will appear here ready to launch.": "Lumio is analyzing your players and preparing fresh promotions to keep them playing and grow your revenue. They will appear here ready to launch.",
  "Lumio is building your content. This finishes on its own.": "Lumio is building your content. This finishes on its own.",
  "Lumio is building your landing page": "Lumio is building your landing page",
  "Lumio is creating your creative. This can take a minute.": "Lumio is creating your creative. This can take a minute.",
  "Lumio is drawing the hero image": "Lumio is drawing the hero image",
  "Lumio is drawing your hero image": "Lumio is drawing your hero image",
  "Lumio is drawing your website art in this look. Players keep seeing your current look.": "Lumio is drawing your website art in this look. Players keep seeing your current look.",
  "Lumio is generating content for {{name}}": "Lumio is generating content for {{name}}",
  "Lumio is generating your content": "Lumio is generating your content",
  "Lumio is naming it…": "Lumio is naming it…",
  "Lumio is preparing your banners": "Lumio is preparing your banners",
  "Lumio is preparing your logos": "Lumio is preparing your logos",
  "Lumio is redrawing the layer…": "Lumio is redrawing the layer…",
  "Lumio is studying your players and preparing fresh campaigns to bring more of them in. They will appear here ready to launch.": "Lumio is studying your players and preparing fresh campaigns to bring more of them in. They will appear here ready to launch.",
  "Lumio is thinking": "Lumio is thinking",
  "Lumio is writing": "Lumio is writing",
  "Lumio is writing the article body": "Lumio is writing the article body",
  "Lumio is writing the SEO fields": "Lumio is writing the SEO fields",
  "Lumio is writing this section": "Lumio is writing this section",
  "Lumio is writing your article": "Lumio is writing your article",
  "Lumio is writing your article. This takes a few minutes.": "Lumio is writing your article. This takes a few minutes.",
  "Lumio is writing your style": "Lumio is writing your style",
  "Lumio Managed Channel": "Lumio Managed Channel",
  "Lumio needs to rate this style before it can draw samples. Extract it again to rate it.": "Lumio needs to rate this style before it can draw samples. Extract it again to rate it.",
  "Lumio needs to rate this style before it can update your website. Extract it again to rate it.": "Lumio needs to rate this style before it can update your website. Extract it again to rate it.",
  "Lumio paints a background for each size and cuts out your subject. The copy is drawn live.": "Lumio paints a background for each size and cuts out your subject. The copy is drawn live.",
  "Lumio paints one hero image with your subject's own copy, then renders every size from it.": "Lumio paints one hero image with your subject's own copy, then renders every size from it.",
  "Lumio paints one hero image, then every size from it.": "Lumio paints one hero image, then every size from it.",
  "Lumio paints the background and the game's sprites. Everything else is drawn live.": "Lumio paints the background and the game's sprites. Everything else is drawn live.",
  "Lumio picks the colours and sets the game up for your subject.": "Lumio picks the colours and sets the game up for your subject.",
  "Lumio picks the colours and tunes the motion for your subject.": "Lumio picks the colours and tunes the motion for your subject.",
  "Lumio reads your mood board, direction and characters, then writes the style every banner and image follows.": "Lumio reads your mood board, direction and characters, then writes the style every banner and image follows.",
  "Lumio reads your mood board, direction and mascot, then writes the style every banner and image follows.": "Lumio reads your mood board, direction and mascot, then writes the style every banner and image follows.",
  "Lumio redraws the art across your website in {{style}}.": "Lumio redraws the art across your website in {{style}}.",
  "Lumio redraws this layer with the new words, keeping its font, colour, size and position.": "Lumio redraws this layer with the new words, keeping its font, colour, size and position.",
  "Lumio redraws your other logo variants from this artwork. You can still replace any of them one by one afterwards.": "Lumio redraws your other logo variants from this artwork. You can still replace any of them one by one afterwards.",
  "Lumio rewrites the copy of every language from your promotion and offer when you generate with Copy on.": "Lumio rewrites the copy of every language from your promotion and offer when you generate with Copy on.",
  "Lumio separates this size into layers (logo, headline, sub-line, call to action, subject and decorations), so you can move, resize, hide or rewrite each one.": "Lumio separates this size into layers (logo, headline, sub-line, call to action, subject and decorations), so you can move, resize, hide or rewrite each one.",
  "Lumio summary": "Lumio summary",
  "Lumio translated the promotion's text: the website has none in this language.": "Lumio translated the promotion's text: the website has none in this language.",
  "Lumio writes the body and leaves everything else alone: the title you chose, the SEO fields and the hero all stay as they are.": "Lumio writes the body and leaves everything else alone: the title you chose, the SEO fields and the hero all stay as they are.",
  "Lumio writes the copy and draws the hero from this promotion.": "Lumio writes the copy and draws the hero from this promotion.",
  "Lumio writes the copy and draws the scene from this promotion.": "Lumio writes the copy and draws the scene from this promotion.",
  "Lumio writes the copy and the prizes from this promotion.": "Lumio writes the copy and the prizes from this promotion.",
  "Lumio writes the copy in every language of your website.": "Lumio writes the copy in every language of your website.",
  "Lumio writes the copy of every language.": "Lumio writes the copy of every language.",
  "Lumio writes the copy, picks the colours and sets the game up from your subject.": "Lumio writes the copy, picks the colours and sets the game up from your subject.",
  "Lumio writes the headline, the offer line and the call to action from your subject.": "Lumio writes the headline, the offer line and the call to action from your subject.",
  "Lumio writes the whole article: the title, the body, the SEO fields and a hero image. Anything already in the form is replaced.": "Lumio writes the whole article: the title, the body, the SEO fields and a hero image. Anything already in the form is replaced.",
  "Lumio writes your style, then draws four samples in it.": "Lumio writes your style, then draws four samples in it.",
  "Lumio's check could not confirm this hero is free of text, logos and numbers. Look it over, or generate it again.": "Lumio's check could not confirm this hero is free of text, logos and numbers. Look it over, or generate it again.",
  "Lumio's check could not run on this hero. Look it over before you use it.": "Lumio's check could not run on this hero. Look it over before you use it.",
  "Lumio's check found lettering on this hero. Look it over, or generate it again.": "Lumio's check found lettering on this hero. Look it over, or generate it again.",
  "Lumio's check found numbers on this hero. Look it over, or generate it again.": "Lumio's check found numbers on this hero. Look it over, or generate it again.",
  "Lumio's check found what may be a logo on this hero. Look it over, or generate it again.": "Lumio's check found what may be a logo on this hero. Look it over, or generate it again.",
  "Lumio's pick: {{title}}": "Lumio's pick: {{title}}",
  "Lumio’s recommended domain for “{{name}}”": "Lumio’s recommended domain for “{{name}}”",
  "Lumio’s recommended domains for “{{name}}”": "Lumio’s recommended domains for “{{name}}”",
  "Lumio’s suggestions for {{country}}": "Lumio’s suggestions for {{country}}",
  "Lumio’s suggestions for your Casino": "Lumio’s suggestions for your Casino",
  "Luxurious glide around the offer as the \"{{subtitle}}\" detail settles in as clean, refined supporting text.": "Luxurious glide around the offer as the \"{{subtitle}}\" detail settles in as clean, refined supporting text.",
  "M": "M",
  "Mac": "Mac",
  "Made for": "Made for",
  "Magic link": "Magic link",
  "Mail": "Mail",
  "Mail app": "Mail app",
  "Mail on this domain is not available to your account.": "Mail on this domain is not available to your account.",
  "Mail on your own domain, in any mail app.": "Mail on your own domain, in any mail app.",
  "Mail setup failed": "Mail setup failed",
  "Mailbox": "Mailbox",
  "Mailbox address": "Mailbox address",
  "Mailbox deleted.": "Mailbox deleted.",
  "Mailboxes": "Mailboxes",
  "Mailboxes could not be loaded": "Mailboxes could not be loaded",
  "Main site": "Main site",
  "Main subject": "Main subject",
  "Main wallet": "Main wallet",
  "Main wallet · ${{mainWalletBalance}}": "Main wallet · ${{mainWalletBalance}}",
  "Main Wallet Balance": "Main Wallet Balance",
  "Make an ad or a landing page, then share its tracking link. The ones that bring you players rank here.": "Make an ad or a landing page, then share its tracking link. The ones that bring you players rank here.",
  "Make available to Affiliates": "Make available to Affiliates",
  "Make current": "Make current",
  "Make it match my logo": "Make it match my logo",
  "Making a landing page for {{name}}. Once it is published, its tracking link goes here.": "Making a landing page for {{name}}. Once it is published, its tracking link goes here.",
  "Making sure nothing important gets cropped": "Making sure nothing important gets cropped",
  "Making your offer the star of scene {{n}}": "Making your offer the star of scene {{n}}",
  "Manage": "Manage",
  "Manage Affiliates": "Manage Affiliates",
  "Manage art style": "Manage art style",
  "Manage budget and limits": "Manage budget and limits",
  "Manage feature": "Manage feature",
  "Manage in Product": "Manage in Product",
  "Manage lists": "Manage lists",
  "Manage the account": "Manage the account",
  "Managed by Whitelabels": "Managed by Whitelabels",
  "Managed in the console": "Managed in the console",
  "Mark all read": "Mark all read",
  "Market": "Market",
  "Market comparison": "Market comparison",
  "Market competitive": "Market competitive",
  "Market Score": "Market Score",
  "Marketing": "Marketing",
  "MARKETING": "MARKETING",
  "Marketing · HTML5 Banners": "Marketing · HTML5 Banners",
  "Marketing · Image Banners": "Marketing · Image Banners",
  "Marketing · Mini-games": "Marketing · Mini-games",
  "Marketing · Video Ads": "Marketing · Video Ads",
  "Marketing & analytics": "Marketing & analytics",
  "Marketing asset stats are unavailable right now.": "Marketing asset stats are unavailable right now.",
  "Marketing Assets": "Marketing Assets",
  "Marketing Assets sections": "Marketing Assets sections",
  "Marketing offer": "Marketing offer",
  "Marketing ROI": "Marketing ROI",
  "Marketing, then <0/>, whenever you want {{kind}}.": "Marketing, then <0/>, whenever you want {{kind}}.",
  "Marketing: HTML5 banners": "Marketing: HTML5 banners",
  "Marketing: Image banners": "Marketing: Image banners",
  "Marketing: Mini-games": "Marketing: Mini-games",
  "Marketing: Video ads": "Marketing: Video ads",
  "Mascot": "Mascot",
  "Mascot name": "Mascot name",
  "Mascot:": "Mascot:",
  "Mascot: {{name}}": "Mascot: {{name}}",
  "Mascots": "Mascots",
  "Mastercard": "Mastercard",
  "Match your system appearance": "Match your system appearance",
  "Match your system, or always use light or dark.": "Match your system, or always use light or dark.",
  "Matching games": "Matching games",
  "Matching your mood board's colors and light": "Matching your mood board's colors and light",
  "Mature content": "Mature content",
  "Mature content isn't compatible with video generation.": "Mature content isn't compatible with video generation.",
  "Max": "Max",
  "May still be drawing": "May still be drawing",
  "Median": "Median",
  "Medium": "Medium",
  "Meet your new ": "Meet your new ",
  "Memo": "Memo",
  "Memorizing the look so every scene matches": "Memorizing the look so every scene matches",
  "Message": "Message",
  "Message Lumio": "Message Lumio",
  "Message sent ✓": "Message sent ✓",
  "Messages": "Messages",
  "Meta description": "Meta description",
  "Meta is set on the site's pages, not on a group of paths.": "Meta is set on the site's pages, not on a group of paths.",
  "Meta title": "Meta title",
  "Method": "Method",
  "Metric": "Metric",
  "Metrics": "Metrics",
  "Mexican": "Mexican",
  "min": "min",
  "Min revenue": "Min revenue",
  "min. {{n}}": "min. {{n}}",
  "Mini-game": "Mini-game",
  "Mini-game art is not available in this environment yet.": "Mini-game art is not available in this environment yet.",
  "Mini-game exports are not available in this environment yet.": "Mini-game exports are not available in this environment yet.",
  "Mini-game name": "Mini-game name",
  "Mini-game performance": "Mini-game performance",
  "Mini-game preview": "Mini-game preview",
  "mini-games": "mini-games",
  "Mini-games": "Mini-games",
  "Minimum Resolution: 300 DPI": "Minimum Resolution: 300 DPI",
  "Missing Features": "Missing Features",
  "Missing opportunity": "Missing opportunity",
  "missing video for this highlight": "missing video for this highlight",
  "Mixed grid": "Mixed grid",
  "Mobile": "Mobile",
  "Mobile only": "Mobile only",
  "Mobile preview": "Mobile preview",
  "Model": "Model",
  "Model default": "Model default",
  "Monetization": "Monetization",
  "Money Flow": "Money Flow",
  "Money wagered": "Money wagered",
  "Money wagered by players": "Money wagered by players",
  "Monochrome": "Monochrome",
  "MONTH BALANCE": "MONTH BALANCE",
  "Monthly": "Monthly",
  "Mood board": "Mood board",
  "Mood board image": "Mood board image",
  "Mood board images set the look: rendering, light, materials and colour.": "Mood board images set the look: rendering, light, materials and colour.",
  "More": "More",
  "More actions": "More actions",
  "More details": "More details",
  "More guides": "More guides",
  "More in this series": "More in this series",
  "More mailboxes": "More mailboxes",
  "More options": "More options",
  "Most deposited": "Most deposited",
  "Most plays start with the first games on your homepage. Put them in the order you like, your favourites first, then publish the list.": "Most plays start with the first games on your homepage. Put them in the order you like, your favourites first, then publish the list.",
  "Most profitable": "Most profitable",
  "Most visited pages": "Most visited pages",
  "Most wagered": "Most wagered",
  "Most withdrawn": "Most withdrawn",
  "Most won": "Most won",
  "Motion": "Motion",
  "Move": "Move",
  "Move {{name}}": "Move {{name}}",
  "Move {{name}} down": "Move {{name}} down",
  "Move {{name}} up": "Move {{name}} up",
  "Move beat left": "Move beat left",
  "Move beat right": "Move beat right",
  "Move down": "Move down",
  "Move its articles to another category first": "Move its articles to another category first",
  "Move to bottom": "Move to bottom",
  "Move to top": "Move to top",
  "Move up": "Move up",
  "Moves, sizes, order and visibility are kept when you save.": "Moves, sizes, order and visibility are kept when you save.",
  "moving on": "moving on",
  "Multiple audiences": "Multiple audiences",
  "Music": "Music",
  "Music and sound effects": "Music and sound effects",
  "MX record, so mail reaches it": "MX record, so mail reaches it",
  "My creatives": "My creatives",
  "N/A": "N/A",
  "Name": "Name",
  "Name and layout": "Name and layout",
  "Name of signatory": "Name of signatory",
  "Name on the bank account": "Name on the bank account",
  "Name the list and create it": "Name the list and create it",
  "Name the subject and anything it has to cover.": "Name the subject and anything it has to cover.",
  "Name this banner kit": "Name this banner kit",
  "Name this creative": "Name this creative",
  "Name this HTML5 banner": "Name this HTML5 banner",
  "Name this image banner": "Name this image banner",
  "Name this landing page": "Name this landing page",
  "Name this mini-game": "Name this mini-game",
  "Name this video ad": "Name this video ad",
  "Name your character": "Name your character",
  "Name your list": "Name your list",
  "Name your list to create it": "Name your list to create it",
  "Name your mascot": "Name your mascot",
  "Name your style": "Name your style",
  "Named things: providers, regulators, games": "Named things: providers, regulators, games",
  "Navigation bar": "Navigation bar",
  "Nearing budget": "Nearing budget",
  "Nearing daily budget. Consider increasing the daily limit to keep players coming.": "Nearing daily budget. Consider increasing the daily limit to keep players coming.",
  "Need help? ": "Need help? ",
  "Needs a marketing offer": "Needs a marketing offer",
  "Needs attention": "Needs attention",
  "Needs credits": "Needs credits",
  "Needs marketing cost data": "Needs marketing cost data",
  "Needs regenerating": "Needs regenerating",
  "Needs review": "Needs review",
  "Needs you": "Needs you",
  "Negative prompt": "Negative prompt",
  "Neon nightlife: deep purples and a cyan glow": "Neon nightlife: deep purples and a cyan glow",
  "Neon nights": "Neon nights",
  "Net cash": "Net cash",
  "Net gaming revenue": "Net gaming revenue",
  "Net Revenue": "Net Revenue",
  "NET REVENUE": "NET REVENUE",
  "Network / chain": "Network / chain",
  "Never": "Never",
  "Never signed in": "Never signed in",
  "New": "New",
  "New {{name}}": "New {{name}}",
  "New {{name}} creative": "New {{name}} creative",
  "New article": "New article",
  "New banners and images follow this style from now on.": "New banners and images follow this style from now on.",
  "New banners and images Lumio makes for your brand follow it.": "New banners and images Lumio makes for your brand follow it.",
  "New banners from Lumio": "New banners from Lumio",
  "New brand": "New brand",
  "New campaigns are on the way": "New campaigns are on the way",
  "New category": "New category",
  "New conversation": "New conversation",
  "New creative": "New creative",
  "New creative, ready to review": "New creative, ready to review",
  "New features and improvements to your hub.": "New features and improvements to your hub.",
  "New game teaser": "New game teaser",
  "New game teaser storyboard": "New game teaser storyboard",
  "New images follow your art style. Manage it on the Art Style tab.": "New images follow your art style. Manage it on the Art Style tab.",
  "New landing page": "New landing page",
  "New landing page…": "New landing page…",
  "New look": "New look",
  "New look failed": "New look failed",
  "New look ready": "New look ready",
  "New matching games join automatically.": "New matching games join automatically.",
  "New mini-game": "New mini-game",
  "New notification": "New notification",
  "New plan": "New plan",
  "New Players": "New Players",
  "New Players Joining Your Casino": "New Players Joining Your Casino",
  "New players joining your website": "New players joining your website",
  "New primary logo uploaded, generating variants…": "New primary logo uploaded, generating variants…",
  "New primary logo uploaded. We'll regenerate the variants from it.": "New primary logo uploaded. We'll regenerate the variants from it.",
  "New promotions are on the way": "New promotions are on the way",
  "New style": "New style",
  "New text": "New text",
  "New variant": "New variant",
  "New variant, from the selected version": "New variant, from the selected version",
  "New version from this": "New version from this",
  "Newer version": "Newer version",
  "Newest first": "Newest first",
  "Newsletter & tips": "Newsletter & tips",
  "Next": "Next",
  "Next article published around {{when}}": "Next article published around {{when}}",
  "Next invoice": "Next invoice",
  "Next match": "Next match",
  "Next page": "Next page",
  "Next steps": "Next steps",
  "Next suggestions": "Next suggestions",
  "Next to the lists {{brand}} came with, a list of your own holds the games you hand-pick, or fills itself from the filters you set. Players find their favourites faster, and stay longer.": "Next to the lists {{brand}} came with, a list of your own holds the games you hand-pick, or fills itself from the filters you set. Players find their favourites faster, and stay longer.",
  "NGR": "NGR",
  "No": "No",
  "No {{filter}} promotions in this view.": "No {{filter}} promotions in this view.",
  "No {{filter}} promotions match “{{term}}”.": "No {{filter}} promotions match “{{term}}”.",
  "No {{filterLabel}} campaigns in this view.": "No {{filterLabel}} campaigns in this view.",
  "No {{filterLabel}} campaigns match “{{term}}”.": "No {{filterLabel}} campaigns match “{{term}}”.",
  "No active invite links": "No active invite links",
  "No activity yet": "No activity yet",
  "No ad sends visitors here yet. An ad can send its traffic here from its tracking link's “Link goes to”.": "No ad sends visitors here yet. An ad can send its traffic here from its tracking link's “Link goes to”.",
  "No ad sends visitors here yet. Pick this page when you create or change an ad's tracking link.": "No ad sends visitors here yet. Pick this page when you create or change an ad's tracking link.",
  "No address chosen": "No address chosen",
  "No affiliates match this filter": "No affiliates match this filter",
  "No affiliates match your search": "No affiliates match your search",
  "No affiliates match your search.": "No affiliates match your search.",
  "No affiliates yet": "No affiliates yet",
  "No AI credit activity yet": "No AI credit activity yet",
  "No alternative looks are available for your art style yet.": "No alternative looks are available for your art style yet.",
  "No archived banner kits.": "No archived banner kits.",
  "No archived HTML5 banners.": "No archived HTML5 banners.",
  "No archived image banners.": "No archived image banners.",
  "No archived landing pages.": "No archived landing pages.",
  "No archived mini-games.": "No archived mini-games.",
  "No archived versions": "No archived versions",
  "No archived video ads.": "No archived video ads.",
  "No art style is active, so the artwork follows your subject's key art.": "No art style is active, so the artwork follows your subject's key art.",
  "No art yet": "No art yet",
  "No articles in this view yet.": "No articles in this view yet.",
  "No banner kits yet. Create your first one.": "No banner kits yet. Create your first one.",
  "No banners in this carousel yet": "No banners in this carousel yet",
  "No banners yet": "No banners yet",
  "No brand images available.": "No brand images available.",
  "no brand is selected": "no brand is selected",
  "No brand logo on file for this brand yet.": "No brand logo on file for this brand yet.",
  "No brand logo on file yet.": "No brand logo on file yet.",
  "No brand selected": "No brand selected",
  "No browsers counted here {{period}}.": "No browsers counted here {{period}}.",
  "No campaigns are live": "No campaigns are live",
  "No campaigns are running in {{channel}} yet.": "No campaigns are running in {{channel}} yet.",
  "No campaigns in this view.": "No campaigns in this view.",
  "No campaigns match “{{term}}”.": "No campaigns match “{{term}}”.",
  "No campaigns match this filter": "No campaigns match this filter",
  "No campaigns match your search": "No campaigns match your search",
  "No campaigns match your search.": "No campaigns match your search.",
  "No campaigns yet": "No campaigns yet",
  "No cancelled invoices": "No cancelled invoices",
  "No categories yet. Every article needs one.": "No categories yet. Every article needs one.",
  "No changes": "No changes",
  "No character": "No character",
  "No characters": "No characters",
  "No collection matches your search": "No collection matches your search",
  "No collections are published for your market yet": "No collections are published for your market yet",
  "No commission plan to remove": "No commission plan to remove",
  "No commission plan yet": "No commission plan yet",
  "No countries match “{{query}}”.": "No countries match “{{query}}”.",
  "No countries match your search.": "No countries match your search.",
  "No country matches your search.": "No country matches your search.",
  "No credit card required. Free to explore.": "No credit card required. Free to explore.",
  "No credit packs are available right now.": "No credit packs are available right now.",
  "No data for this period yet": "No data for this period yet",
  "No deployment pipeline details are available for this casino yet.": "No deployment pipeline details are available for this casino yet.",
  "No description yet": "No description yet",
  "No enabled features yet.": "No enabled features yet.",
  "No ended campaigns": "No ended campaigns",
  "No ended promotions": "No ended promotions",
  "No formats for this version yet.": "No formats for this version yet.",
  "No game chosen yet": "No game chosen yet",
  "No game is available for this subject yet.": "No game is available for this subject yet.",
  "No game lists on this page": "No game lists on this page",
  "No games found.": "No games found.",
  "No games match these filters yet": "No games match these filters yet",
  "No games match these filters yet. Matching games will join as soon as they are released.": "No games match these filters yet. Matching games will join as soon as they are released.",
  "No games match these filters.": "No games match these filters.",
  "No games match your search.": "No games match your search.",
  "No highlights yet.": "No highlights yet.",
  "No HTML5 banners yet": "No HTML5 banners yet",
  "No HTML5 banners yet. Create your first one.": "No HTML5 banners yet. Create your first one.",
  "No image banner has been generated yet. Generate one in Image Banners first.": "No image banner has been generated yet. Generate one in Image Banners first.",
  "No image banners yet": "No image banners yet",
  "No image banners yet. Create your first one.": "No image banners yet. Create your first one.",
  "No image yet": "No image yet",
  "No images from your site's art yet": "No images from your site's art yet",
  "No invoices yet": "No invoices yet",
  "No landing pages yet. Create your first one.": "No landing pages yet. Create your first one.",
  "No layers were found in this size.": "No layers were found in this size.",
  "No legal line is drawn. You are responsible for what your market requires.": "No legal line is drawn. You are responsible for what your market requires.",
  "No link": "No link",
  "No link or unknown link": "No link or unknown link",
  "No lists match.": "No lists match.",
  "No live landing pages yet": "No live landing pages yet",
  "No live operations yet": "No live operations yet",
  "No logo set available yet": "No logo set available yet",
  "No logos yet": "No logos yet",
  "No longer in the catalogue": "No longer in the catalogue",
  "No longer in the catalogue · ID {{id}}": "No longer in the catalogue · ID {{id}}",
  "No longer in the catalogue. Players don't see it.": "No longer in the catalogue. Players don't see it.",
  "No longer on the site": "No longer on the site",
  "No longer on your site; its meta is not published": "No longer on your site; its meta is not published",
  "No Lumio campaigns to import": "No Lumio campaigns to import",
  "No mail on {{domain}} yet": "No mail on {{domain}} yet",
  "No mailboxes yet": "No mailboxes yet",
  "No mascot": "No mascot",
  "No matches": "No matches",
  "No matches.": "No matches.",
  "No mini-games yet": "No mini-games yet",
  "No mini-games yet. Create your first one.": "No mini-games yet. Create your first one.",
  "No notifications yet": "No notifications yet",
  "No offer": "No offer",
  "No one arrived from these sources {{period}}.": "No one arrived from these sources {{period}}.",
  "No one arrived from this source {{period}}.": "No one arrived from this source {{period}}.",
  "No one arrived through these links {{period}}.": "No one arrived through these links {{period}}.",
  "No one arrived through this affiliate's links {{period}}.": "No one arrived through this affiliate's links {{period}}.",
  "No one arrived through this campaign's links {{period}}.": "No one arrived through this campaign's links {{period}}.",
  "No one arrived through this link {{period}}.": "No one arrived through this link {{period}}.",
  "No one arrived through your own links {{period}}.": "No one arrived through your own links {{period}}.",
  "No other versions yet": "No other versions yet",
  "No page matches {{q}}": "No page matches {{q}}",
  "No page on your site starts with {{prefix}}": "No page on your site starts with {{prefix}}",
  "No page will use the new default description": "No page will use the new default description",
  "No pages match your search.": "No pages match your search.",
  "No pages match.": "No pages match.",
  "No pages visited in this period yet.": "No pages visited in this period yet.",
  "No paid invoices yet": "No paid invoices yet",
  "No past conversations yet.": "No past conversations yet.",
  "No pending invoices": "No pending invoices",
  "No people counted here {{period}}.": "No people counted here {{period}}.",
  "No plan": "No plan",
  "No player activity yet": "No player activity yet",
  "No players came through your tracking links in this period yet.": "No players came through your tracking links in this period yet.",
  "No players match these filters.": "No players match these filters.",
  "No players match your search.": "No players match your search.",
  "No players through your links yet": "No players through your links yet",
  "No players yet.": "No players yet.",
  "No preview for this page": "No preview for this page",
  "No primary style yet": "No primary style yet",
  "No promotions are live": "No promotions are live",
  "No promotions in this view.": "No promotions in this view.",
  "No promotions match “{{term}}”.": "No promotions match “{{term}}”.",
  "No public address yet": "No public address yet",
  "No public address yet, so these numbers count your internal addresses.": "No public address yet, so these numbers count your internal addresses.",
  "No public address yet. Choose addresses to see their numbers.": "No public address yet. Choose addresses to see their numbers.",
  "No report data for this month yet": "No report data for this month yet",
  "No restrictions: players from every country can use your website.": "No restrictions: players from every country can use your website.",
  "No single-clip video ads yet. Create your first one.": "No single-clip video ads yet. Create your first one.",
  "No site IDs yet": "No site IDs yet",
  "No size could be packaged. Each size below says why.": "No size could be packaged. Each size below says why.",
  "No sources match your search.": "No sources match your search.",
  "No style": "No style",
  "No style is available for this subject yet.": "No style is available for this subject yet.",
  "No template chosen yet": "No template chosen yet",
  "No template is available yet.": "No template is available yet.",
  "No title yet": "No title yet",
  "No tracking link lands here yet. Get the page's tracking link, or point an ad's link here, to see who it brings in.": "No tracking link lands here yet. Get the page's tracking link, or point an ad's link here, to see who it brings in.",
  "No tracking link leads to this page yet": "No tracking link leads to this page yet",
  "No tracking link yet. Get a tracking link to see who it brings in.": "No tracking link yet. Get a tracking link to see who it brings in.",
  "No tracking link yet. Get one in the composer, under the preview.": "No tracking link yet. Get one in the composer, under the preview.",
  "No tracking link yet. Publish the page, then get its unique tracking link in the composer.": "No tracking link yet. Publish the page, then get its unique tracking link in the composer.",
  "No tracking links yet. Get a tracking link for a finished version to start collecting stats.": "No tracking links yet. Get a tracking link for a finished version to start collecting stats.",
  "No versions yet": "No versions yet",
  "No video ads yet": "No video ads yet",
  "No video ads yet. Create your first one.": "No video ads yet. Create your first one.",
  "No video for this version yet. Generate it to render this storyboard.": "No video for this version yet. Generate it to render this storyboard.",
  "No visitors counted here {{period}}.": "No visitors counted here {{period}}.",
  "No visits in this period yet.": "No visits in this period yet.",
  "No visits to these pages yet {{period}}.": "No visits to these pages yet {{period}}.",
  "No visits to this landing page yet {{period}}.": "No visits to this landing page yet {{period}}.",
  "No visits to this page yet {{period}}.": "No visits to this page yet {{period}}.",
  "No visits with a known country in this period.": "No visits with a known country in this period.",
  "No visits yet {{period}}.": "No visits yet {{period}}.",
  "No website address yet": "No website address yet",
  "No website art in this look yet. Generate it to preview this look with your own content.": "No website art in this look yet. Generate it to preview this look with your own content.",
  "No website traffic yet": "No website traffic yet",
  "No welcome promotion: the page carries the offer alone.": "No welcome promotion: the page carries the offer alone.",
  "No, keep it": "No, keep it",
  "No, text only": "No, text only",
  "Non-depositor": "Non-depositor",
  "None": "None",
  "None active": "None active",
  "None in your catalogue": "None in your catalogue",
  "None yet": "None yet",
  "North America": "North America",
  "Not a translation": "Not a translation",
  "Not attributed": "Not attributed",
  "Not available right now": "Not available right now",
  "Not collected yet": "Not collected yet",
  "Not connected": "Not connected",
  "Not drawn yet": "Not drawn yet",
  "not enabled": "not enabled",
  "Not enough · {{amount}} available": "Not enough · {{amount}} available",
  "Not enough AI credits": "Not enough AI credits",
  "Not enough balance to pay from your wallet.": "Not enough balance to pay from your wallet.",
  "Not enough credits": "Not enough credits",
  "Not enough in your main wallet for this top-up.": "Not enough in your main wallet for this top-up.",
  "Not finished": "Not finished",
  "Not generated · {{when}}": "Not generated · {{when}}",
  "Not generated yet": "Not generated yet",
  "Not generated yet. Lumio draws up to 10 floating symbols (coins, chips, gems) for the scene.": "Not generated yet. Lumio draws up to 10 floating symbols (coins, chips, gems) for the scene.",
  "Not live": "Not live",
  "Not live · {{where}}": "Not live · {{where}}",
  "Not live yet": "Not live yet",
  "Not now": "Not now",
  "Not on your site yet": "Not on your site yet",
  "Not priced yet": "Not priced yet",
  "Not published": "Not published",
  "Not published yet": "Not published yet",
  "Not published yet · {{name}}": "Not published yet · {{name}}",
  "Not qualified": "Not qualified",
  "Not saved": "Not saved",
  "Not secured": "Not secured",
  "Not selected": "Not selected",
  "Not sent": "Not sent",
  "Not set": "Not set",
  "Not set yet": "Not set yet",
  "Not started: {{reason}}": "Not started: {{reason}}",
  "Not written in this language yet": "Not written in this language yet",
  "Not yet": "Not yet",
  "Note": "Note",
  "Nothing generated yet. Your AI creatives will appear here as you make them.": "Nothing generated yet. Your AI creatives will appear here as you make them.",
  "Nothing is charged before you confirm on the next step.": "Nothing is charged before you confirm on the next step.",
  "Nothing is charged when it is created.": "Nothing is charged when it is created.",
  "Nothing is deleted automatically. A member of our data protection team reviews every request, may ask you to confirm your identity, and emails you at each step.": "Nothing is deleted automatically. A member of our data protection team reviews every request, may ask you to confirm your identity, and emails you at each step.",
  "Nothing is redrawn. Players see the change in a few minutes.": "Nothing is redrawn. Players see the change in a few minutes.",
  "Nothing is redrawn. Players see the change once this is done.": "Nothing is redrawn. Players see the change once this is done.",
  "Nothing paused": "Nothing paused",
  "Nothing selected": "Nothing selected",
  "Nothing to fill": "Nothing to fill",
  "Nothing to show yet": "Nothing to show yet",
  "Noticed": "Noticed",
  "noticed something": "noticed something",
  "Notifications": "Notifications",
  "Notifications could not be loaded": "Notifications could not be loaded",
  "Noting the colors, lighting and people": "Noting the colors, lighting and people",
  "now": "now",
  "now a carousel": "now a carousel",
  "now a grid": "now a grid",
  "now a mixed grid": "now a mixed grid",
  "now a row": "now a row",
  "now automatic": "now automatic",
  "Now extract your style": "Now extract your style",
  "now hand-picked": "now hand-picked",
  "Now playing at {{brand}}": "Now playing at {{brand}}",
  "Now showing the platform's text": "Now showing the platform's text",
  "Now showing the text from {{path}}": "Now showing the text from {{path}}",
  "Nowhere to send the link yet": "Nowhere to send the link yet",
  "NUBAN account number": "NUBAN account number",
  "Number of deposits": "Number of deposits",
  "Number of First Time Deposits": "Number of First Time Deposits",
  "Numbered list": "Numbered list",
  "Numbers update every few minutes.": "Numbers update every few minutes.",
  "Occasional best-practice tips and product news.": "Occasional best-practice tips and product news.",
  "Off": "Off",
  "Off: your samples and website art follow your style in words only.": "Off: your samples and website art follow your style in words only.",
  "Offer": "Offer",
  "Offer line": "Offer line",
  "Offer personalized prizes": "Offer personalized prizes",
  "Offer title": "Offer title",
  "Offering": "Offering",
  "Older version": "Older version",
  "Oldest first": "Oldest first",
  "On": "On",
  "on {{day}}": "on {{day}}",
  "On it. I am writing an article about {{topic}}, you can watch it appear in your blog list.": "On it. I am writing an article about {{topic}}, you can watch it appear in your blog list.",
  "On the page": "On the page",
  "On this page": "On this page",
  "On track with the market": "On track with the market",
  "Onboarding": "Onboarding",
  "Onboarding & emails": "Onboarding & emails",
  "Once it is drawn, set it as primary to show it to players.": "Once it is drawn, set it as primary to show it to players.",
  "Once this brand has promotions, you can turn one into a short video here.": "Once this brand has promotions, you can turn one into a short video here.",
  "Once this brand has promotions, you can turn one into a storyboard ad here.": "Once this brand has promotions, you can turn one into a storyboard ad here.",
  "Once this page is published, the ad's tracking link goes here.": "Once this page is published, the ad's tracking link goes here.",
  "Once this page is published, the ads' tracking links go here.": "Once this page is published, the ads' tracking links go here.",
  "Once your landing domain is set up, the pages live on it show here and yours can be published to it. You can already compose and preview a new page.": "Once your landing domain is set up, the pages live on it show here and yours can be published to it. You can already compose and preview a new page.",
  "One ad, ready in every size.": "One ad, ready in every size.",
  "One automation check is off: paired website and landing visits are not checked.": "One automation check is off: paired website and landing visits are not checked.",
  "One brand": "One brand",
  "One browser on your site and on a landing page counts on each.": "One browser on your site and on a landing page counts on each.",
  "One image per aspect ratio, kept in sync across your site's placements.": "One image per aspect ratio, kept in sync across your site's placements.",
  "One image URL per line": "One image URL per line",
  "One is free": "One is free",
  "One line per point the article makes, printed in this order above the body.": "One line per point the article makes, printed in this order above the body.",
  "One line per top affiliate": "One line per top affiliate",
  "One mailbox comes with {{brand}}, free forever. Press <0/>, give it a name and it is ready in seconds.": "One mailbox comes with {{brand}}, free forever. Press <0/>, give it a name and it is ready in seconds.",
  "One mailbox is included with your brand, free forever. Real storage, IMAP and SMTP. Add it to any mail client.": "One mailbox is included with your brand, free forever. Real storage, IMAP and SMTP. Add it to any mail client.",
  "One of this brand's landing pages.": "One of this brand's landing pages.",
  "One option per line as - [ ] or - [x], the right one marked with an x. Every other line is the explanation.": "One option per line as - [ ] or - [x], the right one marked with an x. Every other line is the explanation.",
  "One prize per play, in order. The final prize is your headline offer.": "One prize per play, in order. The final prize is your headline offer.",
  "one time": "one time",
  "One time": "One time",
  "One Time Top Up Amount": "One Time Top Up Amount",
  "Only {{n}} images fit here.": "Only {{n}} images fit here.",
  "Open": "Open",
  "Open {{name}}": "Open {{name}}",
  "Open {{name}} in a new tab": "Open {{name}} in a new tab",
  "Open {{value}} in a new tab": "Open {{value}} in a new tab",
  "Open <0/> {{more}}": "Open <0/> {{more}}",
  "Open a game's <0/> menu and choose <1/>, or <2/> the game into place.": "Open a game's <0/> menu and choose <1/>, or <2/> the game into place.",
  "Open a type to pick its kinds": "Open a type to pick its kinds",
  "Open Account Settings, then Account Actions, then Add Mail Account.": "Open Account Settings, then Account Actions, then Add Mail Account.",
  "Open affiliate console": "Open affiliate console",
  "Open Affiliates": "Open Affiliates",
  "Open art style": "Open art style",
  "Open banners": "Open banners",
  "Open blog": "Open blog",
  "Open character image": "Open character image",
  "Open chest": "Open chest",
  "Open Email App": "Open Email App",
  "Open File, then Add Account.": "Open File, then Add Account.",
  "Open game lists": "Open game lists",
  "open Home": "open Home",
  "Open image": "Open image",
  "Open in a new tab": "Open in a new tab",
  "Open in composer": "Open in composer",
  "Open in Marketing": "Open in Marketing",
  "Open it in the composer to check on it.": "Open it in the composer to check on it.",
  "Open it in the composer to finish and publish it, or pick another destination.": "Open it in the composer to finish and publish it, or pick another destination.",
  "Open its page": "Open its page",
  "Open link": "Open link",
  "Open link in a new tab": "Open link in a new tab",
  "Open live page": "Open live page",
  "Open logos": "Open logos",
  "Open Lumio": "Open Lumio",
  "Open Mail, then Settings, then Accounts, then Add Account, then Other Mail Account.": "Open Mail, then Settings, then Accounts, then Add Account, then Other Mail Account.",
  "Open mood board image": "Open mood board image",
  "Open on your site": "Open on your site",
  "Open one of your assets and get its tracking link. The ads and landing pages that bring you players show up here, with what they brought in.": "Open one of your assets and get its tracking link. The ads and landing pages that bring you players show up here, with what they brought in.",
  "Open reference image": "Open reference image",
  "Open result": "Open result",
  "Open Search Console": "Open Search Console",
  "Open SEO": "Open SEO",
  "Open the composer": "Open the composer",
  "Open the email from DocuSign and click Review Document.": "Open the email from DocuSign and click Review Document.",
  "Open the email from DocuSign in your inbox and click Review Document.": "Open the email from DocuSign in your inbox and click Review Document.",
  "Open the internal site in a new tab": "Open the internal site in a new tab",
  "Open the landing page": "Open the landing page",
  "Open the landing page composer for this ad. The link sends people there once you publish the page.": "Open the landing page composer for this ad. The link sends people there once you publish the page.",
  "Open the live page in a new tab": "Open the live page in a new tab",
  "Open the source image": "Open the source image",
  "Open this video ad": "Open this video ad",
  "Open to all affiliates": "Open to all affiliates",
  "Open website settings": "Open website settings",
  "Open your bank app and choose Pix.": "Open your bank app and choose Pix.",
  "Open your bank's app or website and choose a SPEI transfer.": "Open your bank's app or website and choose a SPEI transfer.",
  "Open your banking app, add the account below as a new SPEI recipient, and send the exact amount. Your brand is reserved while we wait for the transfer.": "Open your banking app, add the account below as a new SPEI recipient, and send the exact amount. Your brand is reserved while we wait for the transfer.",
  "Opened App": "Opened App",
  "Opening frame": "Opening frame",
  "Opens the composer": "Opens the composer",
  "Operating Area": "Operating Area",
  "Operating Country": "Operating Country",
  "Operation": "Operation",
  "Operational Performance": "Operational Performance",
  "Operations": "Operations",
  "OPERATIONS": "OPERATIONS",
  "Operations & Platform": "Operations & Platform",
  "Operator name": "Operator name",
  "Optimal": "Optimal",
  "Optimizing assets for the global CDN": "Optimizing assets for the global CDN",
  "OPTION {{n}}": "OPTION {{n}}",
  "Optional": "Optional",
  "Optional. Style, mood or colours, for example: neon night, deep purple and gold.": "Optional. Style, mood or colours, for example: neon night, deep purple and gold.",
  "optional. The feel you want, in your own words; they win when they disagree with the images.": "optional. The feel you want, in your own words; they win when they disagree with the images.",
  "Optional. Transparent PNG cut-outs work best.": "Optional. Transparent PNG cut-outs work best.",
  "optional. Your brand's own characters, up to 4 images of each.": "optional. Your brand's own characters, up to 4 images of each.",
  "OR": "OR",
  "Or a custom amount": "Or a custom amount",
  "Or continue with": "Or continue with",
  "Order changed. Not published yet.": "Order changed. Not published yet.",
  "Order total": "Order total",
  "Organic": "Organic",
  "Original": "Original",
  "Other": "Other",
  "Other / unclassified": "Other / unclassified",
  "Other ads": "Other ads",
  "Other payment methods": "Other payment methods",
  "Other prizes on the game": "Other prizes on the game",
  "Other websites": "Other websites",
  "Outdated": "Outdated",
  "Outlining the article…": "Outlining the article…",
  "Outlook": "Outlook",
  "Over 30 days ago": "Over 30 days ago",
  "Over the {{kb}} KB budget": "Over the {{kb}} KB budget",
  "Override URL (optional)": "Override URL (optional)",
  "Overrides the title in search results": "Overrides the title in search results",
  "Own list": "Own list",
  "Owner ID": "Owner ID",
  "Owner link": "Owner link",
  "Owner-tracked links": "Owner-tracked links",
  "Owners Hub home": "Owners Hub home",
  "Package benchmark": "Package benchmark",
  "Page": "Page",
  "Page {{n}}": "Page {{n}}",
  "Page {{n}} of {{total}}": "Page {{n}} of {{total}}",
  "Page not found": "Page not found",
  "Page section": "Page section",
  "Page views": "Page views",
  "Page: {{name}}": "Page: {{name}}",
  "Page: {{parent}}, {{name}}": "Page: {{parent}}, {{name}}",
  "Pages": "Pages",
  "Pages on your own domain that turn clicks into players.": "Pages on your own domain that turn clicks into players.",
  "Pages under {{name}}": "Pages under {{name}}",
  "Pages viewed": "Pages viewed",
  "Pages viewed for this selection": "Pages viewed for this selection",
  "Pages viewed over time": "Pages viewed over time",
  "Pages your website banners link to": "Pages your website banners link to",
  "Paid": "Paid",
  "Paid from your balance": "Paid from your balance",
  "Paid from your Main wallet.": "Paid from your Main wallet.",
  "Paid invoices": "Paid invoices",
  "Paid mailbox": "Paid mailbox",
  "Paid platform invoices and completed wallet deposits appear here.": "Paid platform invoices and completed wallet deposits appear here.",
  "Painting a cover…": "Painting a cover…",
  "Painting it in your style": "Painting it in your style",
  "Painting the art · {{done}} of {{total}}": "Painting the art · {{done}} of {{total}}",
  "Painting the hero image…": "Painting the hero image…",
  "Part of the public URL: /blog/category/slug": "Part of the public URL: /blog/category/slug",
  "Partly drawn": "Partly drawn",
  "Partner deal": "Partner deal",
  "Partner Name": "Partner Name",
  "Partners who join show up here": "Partners who join show up here",
  "Partners with their own audience bring players to your casino for a commission. Invite one by email or with a link.": "Partners with their own audience bring players to your casino for a commission. Invite one by email or with a link.",
  "Partnership": "Partnership",
  "Passed": "Passed",
  "Password": "Password",
  "Password (optional)": "Password (optional)",
  "Password changed.": "Password changed.",
  "Password updated": "Password updated",
  "PASSWORD_VALIDATOR.DIGIT": "PASSWORD_VALIDATOR.DIGIT",
  "PASSWORD_VALIDATOR.EMPTY_SPACE": "PASSWORD_VALIDATOR.EMPTY_SPACE",
  "PASSWORD_VALIDATOR.LETTER": "PASSWORD_VALIDATOR.LETTER",
  "PASSWORD_VALIDATOR.LOWERCASE": "PASSWORD_VALIDATOR.LOWERCASE",
  "PASSWORD_VALIDATOR.SPECIAL": "PASSWORD_VALIDATOR.SPECIAL",
  "PASSWORD_VALIDATOR.UPPERCASE": "PASSWORD_VALIDATOR.UPPERCASE",
  "Past conversations": "Past conversations",
  "Paste a link (https://... or slug:article-slug)": "Paste a link (https://... or slug:article-slug)",
  "Paste the destination wallet address": "Paste the destination wallet address",
  "Path": "Path",
  "Pause Campaign": "Pause Campaign",
  "Pause Promotion": "Pause Promotion",
  "Pause style": "Pause style",
  "Paused": "Paused",
  "Paused Campaign Details": "Paused Campaign Details",
  "Paused on": "Paused on",
  "Paused Promotion Details": "Paused Promotion Details",
  "Paused: {{reason}}": "Paused: {{reason}}",
  "Paused: the next article needs {{count}} credit. Top up to continue.": "Paused: the next article needs {{count}} credit. Top up to continue.",
  "Paused: the next article needs {{count}} credits. Top up to continue.": "Paused: the next article needs {{count}} credits. Top up to continue.",
  "Pay": "Pay",
  "Pay {{amount}}": "Pay {{amount}}",
  "Pay {{amount}} to activate": "Pay {{amount}} to activate",
  "Pay {{price}} from your balance to complete this payment": "Pay {{price}} from your balance to complete this payment",
  "Pay {{price}} to activate": "Pay {{price}} to activate",
  "Pay by bank transfer": "Pay by bank transfer",
  "Pay by card": "Pay by card",
  "Pay by card instead": "Pay by card instead",
  "Pay by card or SPEI bank transfer to launch your brand.": "Pay by card or SPEI bank transfer to launch your brand.",
  "Pay by SPEI bank transfer to launch your brand.": "Pay by SPEI bank transfer to launch your brand.",
  "Pay for your brand": "Pay for your brand",
  "Pay from Main wallet": "Pay from Main wallet",
  "Pay from your banking app": "Pay from your banking app",
  "Pay out to a bank account": "Pay out to a bank account",
  "Pay out to a crypto wallet": "Pay out to a crypto wallet",
  "Pay securely with your card. Your credits are added the moment the payment clears.": "Pay securely with your card. Your credits are added the moment the payment clears.",
  "Pay to activate": "Pay to activate",
  "Pay with Pix": "Pay with Pix",
  "Paying by card cancels the bank transfer details you were given. Any transfer you have already made would not count towards this order.": "Paying by card cancels the bank transfer details you were given. Any transfer you have already made would not count towards this order.",
  "Paying by card replaces your Pix code. Do not pay the Pix code after switching, it would not count towards this order.": "Paying by card replaces your Pix code. Do not pay the Pix code after switching, it would not count towards this order.",
  "Paying from another device?": "Paying from another device?",
  "Paying from your wallet…": "Paying from your wallet…",
  "Payment": "Payment",
  "Payment concept": "Payment concept",
  "Payment did not go through. Nothing was charged. Try again, or close this and come back.": "Payment did not go through. Nothing was charged. Try again, or close this and come back.",
  "Payment failed": "Payment failed",
  "Payment failed. Please try again.": "Payment failed. Please try again.",
  "Payment icons": "Payment icons",
  "Payment method": "Payment method",
  "Payment pending": "Payment pending",
  "Payment processing": "Payment processing",
  "Payment received for {{name}}. Reload to see it live.": "Payment received for {{name}}. Reload to see it live.",
  "Payment review": "Payment review",
  "Payment successful": "Payment successful",
  "Payout": "Payout",
  "Payout destination": "Payout destination",
  "Payout method": "Payout method",
  "Payout rejected": "Payout rejected",
  "Pending": "Pending",
  "Pending invitation": "Pending invitation",
  "Pending invitations": "Pending invitations",
  "Pending invoices": "Pending invoices",
  "Pending payout requests": "Pending payout requests",
  "Pending withdrawals": "Pending withdrawals",
  "People": "People",
  "People and visits count where they arrived. Pages viewed and time count under the source that last brought them.": "People and visits count where they arrived. Pages viewed and time count under the source that last brought them.",
  "People are credited once per person, under the source that last brought them. Visits are credited once per session.": "People are credited once per person, under the source that last brought them. Visits are credited once per session.",
  "People are estimated. We link visits to the same verified account where possible. Without that link, each browser counts separately. A shared browser can represent more than one person.": "People are estimated. We link visits to the same verified account where possible. Without that link, each browser counts separately. A shared browser can represent more than one person.",
  "People counts are unavailable for this selection by page or over time.": "People counts are unavailable for this selection by page or over time.",
  "People on each of your addresses": "People on each of your addresses",
  "People over time": "People over time",
  "People spend {{time}} on these pages on average.": "People spend {{time}} on these pages on average.",
  "People spend {{time}} on this page on average.": "People spend {{time}} on this page on average.",
  "People who made their first deposit": "People who made their first deposit",
  "People who signed up after coming through a link": "People who signed up after coming through a link",
  "Per Channel": "Per Channel",
  "per FTD": "per FTD",
  "per month · complete the payment to switch it on.": "per month · complete the payment to switch it on.",
  "Perfect, the current logo stays.": "Perfect, the current logo stays.",
  "Performance over time": "Performance over time",
  "Performance Overview": "Performance Overview",
  "Personalize later": "Personalize later",
  "Personalize your iGaming website and make it available to the world.": "Personalize your iGaming website and make it available to the world.",
  "Peruvian": "Peruvian",
  "Phone": "Phone",
  "Phone (optional)": "Phone (optional)",
  "Phone or computer?": "Phone or computer?",
  "Photo URL": "Photo URL",
  "Pick {{name}}": "Pick {{name}}",
  "Pick a base theme for your casino platform. You can fine-tune the colors and art style next.": "Pick a base theme for your casino platform. You can fine-tune the colors and art style next.",
  "Pick a brand to see how many people visit its website.": "Pick a brand to see how many people visit its website.",
  "Pick a brand to set its art style.": "Pick a brand to set its art style.",
  "Pick a category": "Pick a category",
  "Pick a category before publishing": "Pick a category before publishing",
  "Pick a category to set this article's place in its reading order.": "Pick a category to set this article's place in its reading order.",
  "Pick a collection": "Pick a collection",
  "Pick a collection to continue": "Pick a collection to continue",
  "Pick a collection to start from": "Pick a collection to start from",
  "Pick a model and generate the video": "Pick a model and generate the video",
  "Pick a new banner look": "Pick a new banner look",
  "Pick a page": "Pick a page",
  "Pick a prize": "Pick a prize",
  "Pick a size to start": "Pick a size to start",
  "Pick a storyboard and a promotion, tune the beats on the canvas, and Lumio animates, brands and assembles a multi-scene video ad.": "Pick a storyboard and a promotion, tune the beats on the canvas, and Lumio animates, brands and assembles a multi-scene video ad.",
  "Pick at least one of the three above. You can combine them, and every game that matches shows up here.": "Pick at least one of the three above. You can combine them, and every game that matches shows up here.",
  "Pick at least one to continue": "Pick at least one to continue",
  "Pick banners from your pool and order them for the {{label}} carousel.": "Pick banners from your pool and order them for the {{label}} carousel.",
  "Pick banners from your pool and order them for the {{label}} carousel. Drag to reorder, then Publish to site to commit.": "Pick banners from your pool and order them for the {{label}} carousel. Drag to reorder, then Publish to site to commit.",
  "Pick banners from your pool and order them for the {{label}} carousel. Drag to reorder; this doesn't create new banners.": "Pick banners from your pool and order them for the {{label}} carousel. Drag to reorder; this doesn't create new banners.",
  "Pick one name to reveal domains": "Pick one name to reveal domains",
  "Pick one or more": "Pick one or more",
  "Pick one to start from. Its games, in order, become your list, and you can edit them after.": "Pick one to start from. Its games, in order, become your list, and you can edit them after.",
  "Pick one. Its art becomes the hero of the page instead of Lumio drawing one.": "Pick one. Its art becomes the hero of the page instead of Lumio drawing one.",
  "Pick one. Its key art and copy are the starting point for every size.": "Pick one. Its key art and copy are the starting point for every size.",
  "Pick one. Its key art and copy go on every size.": "Pick one. Its key art and copy go on every size.",
  "Pick one. Its offer is what the game reveals.": "Pick one. Its offer is what the game reveals.",
  "Pick one. Lumio writes the copy and draws the hero from it.": "Pick one. Lumio writes the copy and draws the hero from it.",
  "Pick one. The page leads with it, and its button always claims your welcome offer.": "Pick one. The page leads with it, and its button always claims your welcome offer.",
  "Pick one. The page leads with it; your welcome offer stays its button.": "Pick one. The page leads with it; your welcome offer stays its button.",
  "Pick one. The page's button claims it.": "Pick one. The page's button claims it.",
  "Pick providers, types or themes. Every matching game is added, and new ones join on their own.": "Pick providers, types or themes. Every matching game is added, and new ones join on their own.",
  "Pick the sizes you need": "Pick the sizes you need",
  "Pick what to advertise and how it moves. Lumio paints a background for each size and cuts out your subject, and the copy comes from what you advertise.": "Pick what to advertise and how it moves. Lumio paints a background for each size and cuts out your subject, and the copy comes from what you advertise.",
  "Pick what to advertise and how it moves. Lumio paints a background for each size and cuts out your subject, and the copy stays live text you can edit any time.": "Pick what to advertise and how it moves. Lumio paints a background for each size and cuts out your subject, and the copy stays live text you can edit any time.",
  "Pick where people land when they open this ad's tracking link.": "Pick where people land when they open this ad's tracking link.",
  "Pick your preferred method": "Pick your preferred method",
  "Picking up where scene {{n}} left off": "Picking up where scene {{n}} left off",
  "Pillar article": "Pillar article",
  "Pillar article: the category \"Start here\" guide": "Pillar article: the category \"Start here\" guide",
  "Pipeline ID": "Pipeline ID",
  "Pix": "Pix",
  "Pix code": "Pix code",
  "Pix payments are confirmed within seconds. We'll email you the moment yours lands.": "Pix payments are confirmed within seconds. We'll email you the moment yours lands.",
  "Pix QR code": "Pix QR code",
  "Place image": "Place image",
  "Placement": "Placement",
  "Placing your logo and call to action on the final shot": "Placing your logo and call to action on the final shot",
  "Placing…": "Placing…",
  "Plan": "Plan",
  "Plan Features": "Plan Features",
  "Plan name": "Plan name",
  "Platform default": "Platform default",
  "Platform Fee": "Platform Fee",
  "PLATFORM FEE (25%)": "PLATFORM FEE (25%)",
  "Platform footer texts reach your site at your next publish.": "Platform footer texts reach your site at your next publish.",
  "Platform invoices appear here once you set up a website or purchase a feature.": "Platform invoices appear here once you set up a website or purchase a feature.",
  "Play beat {{n}}": "Play beat {{n}}",
  "Play now": "Play now",
  "Play video": "Play video",
  "Playable ads players try in one tap.": "Playable ads players try in one tap.",
  "Player #{{id}}": "Player #{{id}}",
  "Player Acquisition has campaigns to activate": "Player Acquisition has campaigns to activate",
  "Player Acquisition is doing well": "Player Acquisition is doing well",
  "Player Acquisition is low on budget": "Player Acquisition is low on budget",
  "Player Acquisition is on track": "Player Acquisition is on track",
  "Player Acquisition needs attention": "Player Acquisition needs attention",
  "Player Acquisition needs budget and campaigns": "Player Acquisition needs budget and campaigns",
  "Player Average Wager": "Player Average Wager",
  "Player Balance": "Player Balance",
  "Player details": "Player details",
  "Player engagement suite included": "Player engagement suite included",
  "Player ID": "Player ID",
  "Player LTV": "Player LTV",
  "Player value tiers aren't available yet": "Player value tiers aren't available yet",
  "Player wallet": "Player wallet",
  "Players": "Players",
  "PLAYERS": "PLAYERS",
  "Players by value": "Players by value",
  "Players choose either traditional currencies or crypto when they deposit.": "Players choose either traditional currencies or crypto when they deposit.",
  "Players click ads that look like the casino they land on.": "Players click ads that look like the casino they land on.",
  "Players click ads that look like the casino they land on. Pick a promotion or a game, and your banner comes in every size the ad networks need.": "Players click ads that look like the casino they land on. Pick a promotion or a game, and your banner comes in every size the ad networks need.",
  "Players click ads that look like the casino they land on. Your banner, in every size the ad networks need.": "Players click ads that look like the casino they land on. Your banner, in every size the ad networks need.",
  "Players come back to a blog that keeps posting, and {{brand}}'s can post on its own.": "Players come back to a blog that keeps posting, and {{brand}}'s can post on its own.",
  "Players come back to casinos that keep them in the loop. {{brand}} has a blog ready for your guides, game reviews and news: turn it on and your players can read it.": "Players come back to casinos that keep them in the loop. {{brand}} has a blog ready for your guides, game reviews and news: turn it on and your players can read it.",
  "Players come back to casinos that keep them in the loop. {{brand}}'s blog is ready for guides, game reviews and news. It lives here, on <0/>.": "Players come back to casinos that keep them in the loop. {{brand}}'s blog is ready for guides, game reviews and news. It lives here, on <0/>.",
  "Players come back to casinos that keep them in the loop. Turn your blog on and share guides, game reviews and news.": "Players come back to casinos that keep them in the loop. Turn your blog on and share guides, game reviews and news.",
  "Players deposit and play with cryptocurrencies (BTC, ETH, USDT, …).": "Players deposit and play with cryptocurrencies (BTC, ETH, USDT, …).",
  "Players deposit and play with traditional currencies (USD, EUR, …).": "Players deposit and play with traditional currencies (USD, EUR, …).",
  "Players don't see it. Remove it from the list.": "Players don't see it. Remove it from the list.",
  "Players engaged": "Players engaged",
  "Players judge {{brand}} by its logo before they read a word. Want one of your own? You can swap it until your 50th player registers.": "Players judge {{brand}} by its logo before they read a word. Want one of your own? You can swap it until your 50th player registers.",
  "Players judge a casino by its logo before they read a word. Want one of your own? Swap it in with Replace logo.": "Players judge a casino by its logo before they read a word. Want one of your own? Swap it in with Replace logo.",
  "Players keep seeing your current look while it is drawn.": "Players keep seeing your current look while it is drawn.",
  "Players keep seeing your current look while this is drawn. It can take a while; you can leave this page.": "Players keep seeing your current look while this is drawn. It can take a while; you can leave this page.",
  "Players love to play before they sign up.": "Players love to play before they sign up.",
  "Players love to play before they sign up. A mini-game turns your ad into a game that ends on your offer.": "Players love to play before they sign up. A mini-game turns your ad into a game that ends on your offer.",
  "Players love to play before they sign up. Mini-games like an offer wheel or a scratch card turn your ad into a game that ends on your offer.": "Players love to play before they sign up. Mini-games like an offer wheel or a scratch card turn your ad into a game that ends on your offer.",
  "Players meet your banners first. Press <0/>, then <1/>, and publish the new version when you like it. Every other banner works the same way.": "Players meet your banners first. Press <0/>, then <1/>, and publish the new version when you like it. Every other banner works the same way.",
  "Players pick a gift; it opens on your offer.": "Players pick a gift; it opens on your offer.",
  "Players remember a casino with a look of its own. Classic, gothic or sporty, create the style that fits {{brand}}: your banners, ads and blog covers are drawn in it.": "Players remember a casino with a look of its own. Classic, gothic or sporty, create the style that fits {{brand}}: your banners, ads and blog covers are drawn in it.",
  "Players remember a casino with a look of its own. Your art style sets how everything for {{brand}} is drawn: banners, ads and blog covers. It lives here, on <0/>.": "Players remember a casino with a look of its own. Your art style sets how everything for {{brand}} is drawn: banners, ads and blog covers. It lives here, on <0/>.",
  "Players remember a casino with its own look. Create your style once, and every new banner, ad and blog cover matches it.": "Players remember a casino with its own look. Create your style once, and every new banner, ad and blog cover matches it.",
  "Players scratch the card; your offer is under it.": "Players scratch the card; your offer is under it.",
  "Players see this art now.": "Players see this art now.",
  "Players see your logo before anything else, everywhere {{brand}} shows up. Every size of it lives here, in <0/>. Have one of your own you would rather use?": "Players see your logo before anything else, everywhere {{brand}} shows up. Every size of it lives here, in <0/>. Have one of your own you would rather use?",
  "Players see your new order once it is published. Press <0/> when you are done; until then, keep moving games with <1/> or a <2/>.": "Players see your new order once it is published. Press <0/> when you are done; until then, keep moving games with <1/> or a <2/>.",
  "Players spin; the wheel lands on your offer.": "Players spin; the wheel lands on your offer.",
  "Players stay longer when the games they love are easy to find. Create lists of your own for {{brand}}, hand-picked or kept filled by filters.": "Players stay longer when the games they love are easy to find. Create lists of your own for {{brand}}, hand-picked or kept filled by filters.",
  "Players stay longer when their favourites are easy to find. Add a list of your own next to the ones your site came with.": "Players stay longer when their favourites are easy to find. Add a list of your own next to the ones your site came with.",
  "Players stay where they find a favourite fast. Put the games you want them to meet first at the top of your lists.": "Players stay where they find a favourite fast. Put the games you want them to meet first at the top of your lists.",
  "Players trust a casino that writes from its own address. One mailbox on {{brand}}'s domain is free forever, and ready in seconds.": "Players trust a casino that writes from its own address. One mailbox on {{brand}}'s domain is free forever, and ready in seconds.",
  "Players trust mail from {{domain}} more than from a free address. Your mailbox lives here in Settings.": "Players trust mail from {{domain}} more than from a free address. Your mailbox lives here in Settings.",
  "Players trust mail from your own domain more than a free address. One mailbox comes with your brand, free forever.": "Players trust mail from your own domain more than a free address. One mailbox comes with your brand, free forever.",
  "Playful and bright, soft 3D shapes": "Playful and bright, soft 3D shapes",
  "Plays": "Plays",
  "Please add a subject": "Please add a subject",
  "Please check your details and try again.": "Please check your details and try again.",
  "Please choose individual or business": "Please choose individual or business",
  "Please enter a valid email address": "Please enter a valid email address",
  "Please enter a valid email address.": "Please enter a valid email address.",
  "Please enter your email address": "Please enter your email address",
  "Please enter your name": "Please enter your name",
  "Please request a new verification email and try again.": "Please request a new verification email and try again.",
  "Please return to the login page and try again.": "Please return to the login page and try again.",
  "Please select a business type": "Please select a business type",
  "Please select a country": "Please select a country",
  "Please select a currency": "Please select a currency",
  "Please select a network": "Please select a network",
  "Please select a token": "Please select a token",
  "Please select the bank account country": "Please select the bank account country",
  "Please select your casino operating area": "Please select your casino operating area",
  "Please try again in a moment.": "Please try again in a moment.",
  "Please try again.": "Please try again.",
  "Please verify your email to continue with personalizing and taking your website live.": "Please verify your email to continue with personalizing and taking your website live.",
  "Please verify your email to continue with personalizing and taking your website live. We'll confirm separately once your SPEI transfer arrives.": "Please verify your email to continue with personalizing and taking your website live. We'll confirm separately once your SPEI transfer arrives.",
  "Please wait…": "Please wait…",
  "Please write your message": "Please write your message",
  "PNG, JPG or SVG": "PNG, JPG or SVG",
  "PNG, JPG or SVG, up to 10 MB": "PNG, JPG or SVG, up to 10 MB",
  "PNG, JPG or SVG, up to 10 MB · a transparent PNG works best": "PNG, JPG or SVG, up to 10 MB · a transparent PNG works best",
  "Polishing the details": "Polishing the details",
  "Polygon": "Polygon",
  "Poor": "Poor",
  "Popular": "Popular",
  "Popular in": "Popular in",
  "Port": "Port",
  "Portrait (9:16)": "Portrait (9:16)",
  "Portuguese": "Portuguese",
  "Position {{v}} {{h}}": "Position {{v}} {{h}}",
  "Position on the page": "Position on the page",
  "Post from here": "Post from here",
  "Post later": "Post later",
  "Postal / ZIP code": "Postal / ZIP code",
  "Powered by": "Powered by",
  "Powered by Stripe": "Powered by Stripe",
  "Preferences Summary": "Preferences Summary",
  "Preferred language": "Preferred language",
  "Preparing AI research agents": "Preparing AI research agents",
  "Preparing AI research agents{{dots}}": "Preparing AI research agents{{dots}}",
  "Preparing frames": "Preparing frames",
  "Preparing market calibrated packs": "Preparing market calibrated packs",
  "Preparing scene {{n}}": "Preparing scene {{n}}",
  "Preparing secure checkout…": "Preparing secure checkout…",
  "Preparing the opening frame": "Preparing the opening frame",
  "Preparing the promotion's text in this language...": "Preparing the promotion's text in this language...",
  "Preparing the text in this language…": "Preparing the text in this language…",
  "Preparing your banner kit ZIP…": "Preparing your banner kit ZIP…",
  "Preparing your HTML5 banner export…": "Preparing your HTML5 banner export…",
  "Preparing your image banner ZIP…": "Preparing your image banner ZIP…",
  "Preparing your logo": "Preparing your logo",
  "Preparing your logo…": "Preparing your logo…",
  "Preparing your mini-game export…": "Preparing your mini-game export…",
  "Preparing your PDF…": "Preparing your PDF…",
  "Preparing your style…": "Preparing your style…",
  "Preparing…": "Preparing…",
  "Press <0/> and upload your file. A PNG or an SVG works best.": "Press <0/> and upload your file. A PNG or an SVG works best.",
  "Press <0/> to create it, then follow its steps: how the games are chosen, which games, then a name and a layout.": "Press <0/> to create it, then follow its steps: how the games are chosen, which games, then a name and a layout.",
  "Press <0/> to give your casino a look of its own. In short, here is what you'll do:": "Press <0/> to give your casino a look of its own. In short, here is what you'll do:",
  "Press <0/>, pick a promotion or a game, then a style: how your banner moves, in every display size.": "Press <0/>, pick a promotion or a game, then a style: how your banner moves, in every display size.",
  "Press <0/>, pick a promotion or a game: the storyboard comes first, then the clip.": "Press <0/>, pick a promotion or a game: the storyboard comes first, then the clip.",
  "Press <0/>, pick what to advertise, and your banner comes in every size.": "Press <0/>, pick what to advertise, and your banner comes in every size.",
  "Press <0/>: invite a partner by email, or pick <1/> for one link any partner can sign up with.": "Press <0/>: invite a partner by email, or pick <1/> for one link any partner can sign up with.",
  "Press <0/>: it starts on your welcome bonus. Choose a game, and every play ends on your offer.": "Press <0/>: it starts on your welcome bonus. Choose a game, and every play ends on your offer.",
  "Press and hold a game to reorder.": "Press and hold a game to reorder.",
  "Preview": "Preview",
  "Preview {{format}}": "Preview {{format}}",
  "Preview appears after you generate": "Preview appears after you generate",
  "Preview article": "Preview article",
  "Preview device": "Preview device",
  "Preview on site": "Preview on site",
  "Preview on your site": "Preview on your site",
  "Preview unavailable": "Preview unavailable",
  "Preview unavailable on this domain": "Preview unavailable on this domain",
  "Preview Website": "Preview Website",
  "Preview width": "Preview width",
  "Previews only: they never appear on your website.": "Previews only: they never appear on your website.",
  "Previous": "Previous",
  "Previous match": "Previous match",
  "Previous page": "Previous page",
  "Previous steps": "Previous steps",
  "Previous suggestions": "Previous suggestions",
  "Primary": "Primary",
  "Primary logo": "Primary logo",
  "Privacy": "Privacy",
  "Privacy Policy": "Privacy Policy",
  "Privacy Policy.": "Privacy Policy.",
  "Prize {{n}}": "Prize {{n}}",
  "Prize plate": "Prize plate",
  "Prizes": "Prizes",
  "Processed": "Processed",
  "Processing": "Processing",
  "Processing…": "Processing…",
  "Product": "Product",
  "PRODUCT": "PRODUCT",
  "Product Features": "Product Features",
  "Product strength": "Product strength",
  "Product updates": "Product updates",
  "Profile": "Profile",
  "Profitability": "Profitability",
  "Progress Until Go Live": "Progress Until Go Live",
  "Projected annual Net if current pace holds": "Projected annual Net if current pace holds",
  "Promo": "Promo",
  "Promo {{n}}": "Promo {{n}}",
  "Promo Content": "Promo Content",
  "Promo focus": "Promo focus",
  "Promote your brand": "Promote your brand",
  "Promotion": "Promotion",
  "Promotion also in use for Acquisition": "Promotion also in use for Acquisition",
  "Promotion banner: {{name}}": "Promotion banner: {{name}}",
  "Promotion tile": "Promotion tile",
  "Promotion: {{name}}": "Promotion: {{name}}",
  "Promotions": "Promotions",
  "Promotions & offers": "Promotions & offers",
  "Promotions are archived here once they finish.": "Promotions are archived here once they finish.",
  "Promotions for players": "Promotions for players",
  "Promotions Page": "Promotions Page",
  "Promotions you pause will wait here until you resume them.": "Promotions you pause will wait here until you resume them.",
  "Promotions, banners, emails and marketing material. Lumio is crafting it all so your website launches ready to win.": "Promotions, banners, emails and marketing material. Lumio is crafting it all so your website launches ready to win.",
  "Prompt": "Prompt",
  "Proof": "Proof",
  "Proposals": "Proposals",
  "Prorated": "Prorated",
  "Protocol": "Protocol",
  "Provider": "Provider",
  "Provider {{id}}": "Provider {{id}}",
  "Providers": "Providers",
  "Provisional": "Provisional",
  "Provisioning": "Provisioning",
  "Provisioning your cloud infrastructure": "Provisioning your cloud infrastructure",
  "Public": "Public",
  "Publish": "Publish",
  "Publish actions": "Publish actions",
  "Publish again": "Publish again",
  "Publish all changes": "Publish all changes",
  "Publish all changes puts your game-list orders on your site. Section changes are a preview for now, until publishing sections is available.": "Publish all changes puts your game-list orders on your site. Section changes are a preview for now, until publishing sections is available.",
  "Publish changes": "Publish changes",
  "Publish changes ({{n}})": "Publish changes ({{n}})",
  "Publish destination": "Publish destination",
  "Publish embed": "Publish embed",
  "Publish failed": "Publish failed",
  "Publish this article?": "Publish this article?",
  "Publish this landing page?": "Publish this landing page?",
  "Publish this list": "Publish this list",
  "Publish this version as an iframe you can paste into any page. It is served from a separate, sandboxed domain, and its plays, reveals and clicks show on the mini-game's card.": "Publish this version as an iframe you can paste into any page. It is served from a separate, sandboxed domain, and its plays, reveals and clicks show on the mini-game's card.",
  "Publish this version to {{where}}? It replaces what is currently live there.": "Publish this version to {{where}}? It replaces what is currently live there.",
  "Publish this version to your live site? It replaces the current banner across every placement, and the mobile crops are regenerated to match.": "Publish this version to your live site? It replaces the current banner across every placement, and the mobile crops are regenerated to match.",
  "Publish this version to your live site? It replaces the live banner across every placement and format.": "Publish this version to your live site? It replaces the live banner across every placement and format.",
  "Publish this version to your live site? It replaces what is currently live in the pool.": "Publish this version to your live site? It replaces what is currently live in the pool.",
  "Publish to": "Publish to",
  "Publish to site": "Publish to site",
  "Publish to your live site": "Publish to your live site",
  "Publish to your site?": "Publish to your site?",
  "Published": "Published",
  "Published {{date}}": "Published {{date}}",
  "Published {{done}} of {{total}} changes. Try the rest again.": "Published {{done}} of {{total}} changes. Try the rest again.",
  "Published {{done}} of {{total}} lists. Try the rest again.": "Published {{done}} of {{total}} lists. Try the rest again.",
  "Published {{n}} lists. Your site now shows them.": "Published {{n}} lists. Your site now shows them.",
  "Published 1 list. Your site now shows it.": "Published 1 list. Your site now shows it.",
  "Published to your site.": "Published to your site.",
  "Published. Your site now shows these orders.": "Published. Your site now shows these orders.",
  "Published. Your site now shows this list.": "Published. Your site now shows this list.",
  "Published. Your site now shows this order.": "Published. Your site now shows this order.",
  "Published. Your site now shows your changes.": "Published. Your site now shows your changes.",
  "Publishing failed": "Publishing failed",
  "Publishing game lists is not available yet.": "Publishing game lists is not available yet.",
  "Publishing game lists is not available yet. Your changes are a preview only and are lost when you leave this page.": "Publishing game lists is not available yet. Your changes are a preview only and are lost when you leave this page.",
  "Publishing is not available yet. Your changes are a preview only and are lost when you leave this page.": "Publishing is not available yet. Your changes are a preview only and are lost when you leave this page.",
  "Publishing is only possible if all formats are generated": "Publishing is only possible if all formats are generated",
  "Publishing isn't available in this environment yet.": "Publishing isn't available in this environment yet.",
  "Publishing isn't available yet. Changes are a preview only.": "Publishing isn't available yet. Changes are a preview only.",
  "Publishing page sections is not available yet.": "Publishing page sections is not available yet.",
  "Publishing page sections is not available yet. Your changes are a preview only and are lost when you leave this page.": "Publishing page sections is not available yet. Your changes are a preview only and are lost when you leave this page.",
  "Publishing puts these games on your site in this order.": "Publishing puts these games on your site in this order.",
  "Publishing the order of lists is not available yet. Your changes are a preview only and are lost when you leave this page.": "Publishing the order of lists is not available yet. Your changes are a preview only and are lost when you leave this page.",
  "Publishing the page…": "Publishing the page…",
  "Publishing to your live site": "Publishing to your live site",
  "Publishing to your live site. It will update shortly.": "Publishing to your live site. It will update shortly.",
  "Publishing your changes. Save order is available when it finishes.": "Publishing your changes. Save order is available when it finishes.",
  "Publishing your website to the world": "Publishing your website to the world",
  "Publishing…": "Publishing…",
  "Publishing… checking the site": "Publishing… checking the site",
  "Publishing… finishing": "Publishing… finishing",
  "Publishing… putting the previous values back": "Publishing… putting the previous values back",
  "Publishing… redeploying the site": "Publishing… redeploying the site",
  "Publishing… updating the footer": "Publishing… updating the footer",
  "Publishing… writing the page settings": "Publishing… writing the page settings",
  "Pull out to the full promotion as the \"{{cta}}\" call to action lights up boldly as an on-screen button.": "Pull out to the full promotion as the \"{{cta}}\" call to action lights up boldly as an on-screen button.",
  "Pull out to the full promotion as the \"{{cta}}\" call to action lights up boldly.": "Pull out to the full promotion as the \"{{cta}}\" call to action lights up boldly.",
  "Pulse": "Pulse",
  "Punch into the party energy as coins and light streaks burst across the neon scene.": "Punch into the party energy as coins and light streaks burst across the neon scene.",
  "Punchy push-in on the \"{{headline}}\" artwork as sparks of light rise around it.": "Punchy push-in on the \"{{headline}}\" artwork as sparks of light rise around it.",
  "Punchy push-in on the artwork as the \"{{headline}}\" offer slams in as bold, high-energy on-brand headline text.": "Punchy push-in on the artwork as the \"{{headline}}\" offer slams in as bold, high-energy on-brand headline text.",
  "Push": "Push",
  "Push up into a rising storm of gold coins as the \"{{headline}}\" offer erupts in as huge, on-brand headline text.": "Push up into a rising storm of gold coins as the \"{{headline}}\" offer erupts in as huge, on-brand headline text.",
  "Put it live": "Put it live",
  "Putting your offer front and center in scene {{n}}": "Putting your offer front and center in scene {{n}}",
  "Putting your original look back": "Putting your original look back",
  "Qualified": "Qualified",
  "Question": "Question",
  "Question and answer": "Question and answer",
  "Question this article answers": "Question this article answers",
  "Questions": "Questions",
  "Questions and answers, printed under the article and published as structured data.": "Questions and answers, printed under the article and published as structured data.",
  "Queued": "Queued",
  "Queued for rendering": "Queued for rendering",
  "Queued…": "Queued…",
  "Quick dolly as a second win hits, multiplier lights stacking and the energy climbing.": "Quick dolly as a second win hits, multiplier lights stacking and the energy climbing.",
  "Quick landing page": "Quick landing page",
  "Quick snap-cut push toward the offer as the \"{{subtitle}}\" detail flicks in as clean supporting text.": "Quick snap-cut push toward the offer as the \"{{subtitle}}\" detail flicks in as clean supporting text.",
  "Quote": "Quote",
  "Rank": "Rank",
  "Ranked by first-time depositors": "Ranked by first-time depositors",
  "Rapid punch-in on the reaction moment as coins and sparkles burst for a shareable beat.": "Rapid punch-in on the reaction moment as coins and sparkles burst for a shareable beat.",
  "Rate %": "Rate %",
  "Re-apply": "Re-apply",
  "Re: Friday plans": "Re: Friday plans",
  "Reactivate": "Reactivate",
  "Reactivation": "Reactivation",
  "Read-only": "Read-only",
  "Reading order": "Reading order",
  "Reading this month's signals": "Reading this month's signals",
  "Reading your brief…": "Reading your brief…",
  "Reading your market's collections…": "Reading your market's collections…",
  "Reading your mood board": "Reading your mood board",
  "Ready": "Ready",
  "Ready to apply your preferences": "Ready to apply your preferences",
  "Ready to launch": "Ready to launch",
  "Ready to review": "Ready to review",
  "Reason": "Reason",
  "Reason given: {{reason}}": "Reason given: {{reason}}",
  "Rebuild my other logos from it": "Rebuild my other logos from it",
  "Rebuilding your other logos…": "Rebuilding your other logos…",
  "Receipt · {{generatedAt}}": "Receipt · {{generatedAt}}",
  "Receive a SEPA (EU) or international bank transfer.": "Receive a SEPA (EU) or international bank transfer.",
  "Receive payouts to a crypto wallet on a supported network.": "Receive payouts to a crypto wallet on a supported network.",
  "Receiving": "Receiving",
  "Recent activity": "Recent activity",
  "Recent creatives": "Recent creatives",
  "Recently seen": "Recently seen",
  "Recommended": "Recommended",
  "Recommended {{width}} × {{height}} px · {{ratio}}": "Recommended {{width}} × {{height}} px · {{ratio}}",
  "Records added here stay on your domain. Contact support if you need one removed.": "Records added here stay on your domain. Contact support if you need one removed.",
  "Recover version": "Recover version",
  "Redo": "Redo",
  "Redraw": "Redraw",
  "Redraw {{size}}": "Redraw {{size}}",
  "Redraw {{slot}}": "Redraw {{slot}}",
  "Redraw {{slot}} for {{n}} credit": "Redraw {{slot}} for {{n}} credit",
  "Redraw {{slot}} for {{n}} credits": "Redraw {{slot}} for {{n}} credits",
  "Redraw copy": "Redraw copy",
  "Redraw the whole scene": "Redraw the whole scene",
  "Redraw with instruction": "Redraw with instruction",
  "Redrawing images isn't available right now.": "Redrawing images isn't available right now.",
  "Redrawing your website art. This takes a while.": "Redrawing your website art. This takes a while.",
  "Redrawing…": "Redrawing…",
  "Redrawn": "Redrawn",
  "Redraws the art across your website in this style.": "Redraws the art across your website in this style.",
  "Reference": "Reference",
  "Reference image": "Reference image",
  "Reference image {{n}}": "Reference image {{n}}",
  "Refining the details…": "Refining the details…",
  "Reframing the shot in scene {{n}}": "Reframing the shot in scene {{n}}",
  "Refresh": "Refresh",
  "Refresh suggestions": "Refresh suggestions",
  "Refund": "Refund",
  "Reg": "Reg",
  "Reg → FTD": "Reg → FTD",
  "Regenerate": "Regenerate",
  "Regenerate all assets": "Regenerate all assets",
  "Regenerate quiz": "Regenerate quiz",
  "Regenerate quiz · {{n}} credit": "Regenerate quiz · {{n}} credit",
  "Regenerate quiz · {{n}} credits": "Regenerate quiz · {{n}} credits",
  "Regenerate samples": "Regenerate samples",
  "Regenerate storyboard": "Regenerate storyboard",
  "Regenerate website art": "Regenerate website art",
  "Regenerated from": "Regenerated from",
  "Regenerates from": "Regenerates from",
  "Regenerating starts from the selected version.": "Regenerating starts from the selected version.",
  "Regenerating starts from the selected version. 'Make current' only changes what shows here; use 'Publish to site' to update your live website.": "Regenerating starts from the selected version. 'Make current' only changes what shows here; use 'Publish to site' to update your live website.",
  "Regenerating starts from the selected version. The 'Published' tag marks what's live on your site; use 'Publish to site' to change it.": "Regenerating starts from the selected version. The 'Published' tag marks what's live on your site; use 'Publish to site' to change it.",
  "Regenerating website art is not available yet.": "Regenerating website art is not available yet.",
  "Regenerating your cards: {{done}} of {{total}} images": "Regenerating your cards: {{done}} of {{total}} images",
  "Register.": "Register.",
  "Registered": "Registered",
  "Registered At": "Registered At",
  "Registering your domain and DNS records": "Registering your domain and DNS records",
  "registrar": "registrar",
  "Registrar": "Registrar",
  "Registrations": "Registrations",
  "Regs": "Regs",
  "Regular": "Regular",
  "Rejected": "Rejected",
  "Rejected: {{reason}}": "Rejected: {{reason}}",
  "Related articles": "Related articles",
  "Reload": "Reload",
  "Remaining Budget": "Remaining Budget",
  "Remove": "Remove",
  "Remove {{keyword}}": "Remove {{keyword}}",
  "Remove {{name}}": "Remove {{name}}",
  "Remove {{name}} from list": "Remove {{name}} from list",
  "Remove all": "Remove all",
  "Remove beat": "Remove beat",
  "Remove character": "Remove character",
  "Remove character image": "Remove character image",
  "Remove entry": "Remove entry",
  "Remove filter": "Remove filter",
  "Remove filter {{name}}": "Remove filter {{name}}",
  "Remove from carousel": "Remove from carousel",
  "Remove from list": "Remove from list",
  "Remove image": "Remove image",
  "Remove mascot": "Remove mascot",
  "Remove mascot image": "Remove mascot image",
  "Remove mood image": "Remove mood image",
  "Remove reference image": "Remove reference image",
  "Remove section": "Remove section",
  "Remove step {{n}}": "Remove step {{n}}",
  "Remove the spaces at the start or end. Spaces inside are fine.": "Remove the spaces at the start or end. Spaces inside are fine.",
  "Remove this translation": "Remove this translation",
  "Remove voucher": "Remove voucher",
  "Removes the background and adapts your logo to fit the places it's used.": "Removes the background and adapts your logo to fit the places it's used.",
  "Removing the background so it looks sharp on every surface.": "Removing the background so it looks sharp on every surface.",
  "Rename {{name}}": "Rename {{name}}",
  "renamed": "renamed",
  "Rendering sizes · {{done}} of {{total}}": "Rendering sizes · {{done}} of {{total}}",
  "Rendering…": "Rendering…",
  "Reorder": "Reorder",
  "Reorder {{list}}": "Reorder {{list}}",
  "Reorder {{name}}": "Reorder {{name}}",
  "Reorder {{title}}": "Reorder {{title}}",
  "Reorder games": "Reorder games",
  "Reorder lists": "Reorder lists",
  "Reorder Lists": "Reorder Lists",
  "Reorder the games in {{name}}": "Reorder the games in {{name}}",
  "Reorder the games in {{name}} (this list has unpublished changes)": "Reorder the games in {{name}} (this list has unpublished changes)",
  "Reorder the games in this list": "Reorder the games in this list",
  "reordered": "reordered",
  "Replace": "Replace",
  "Replace {{label}}": "Replace {{label}}",
  "Replace image": "Replace image",
  "Replace later": "Replace later",
  "Replace logo": "Replace logo",
  "Replace primary logo": "Replace primary logo",
  "Replace the [bracketed] placeholders with your own facts": "Replace the [bracketed] placeholders with your own facts",
  "Replace the current plan?": "Replace the current plan?",
  "Replacing the primary logo is no longer available for this website.": "Replacing the primary logo is no longer available for this website.",
  "Replacing…": "Replacing…",
  "Replay": "Replay",
  "Reporting period": "Reporting period",
  "Reports": "Reports",
  "Republish": "Republish",
  "Republishing…": "Republishing…",
  "Request": "Request",
  "Request {{amount}}": "Request {{amount}}",
  "Request a new link": "Request a new link",
  "Request a new link below.": "Request a new link below.",
  "Request account deletion": "Request account deletion",
  "Request payout": "Request payout",
  "Request Payout": "Request Payout",
  "Request sent": "Request sent",
  "Requested {{date}}": "Requested {{date}}",
  "Requesting…": "Requesting…",
  "Required DNS records": "Required DNS records",
  "Resend code": "Resend code",
  "Resend contract": "Resend contract",
  "Reset from template": "Reset from template",
  "Reset game order": "Reset game order",
  "Reset page": "Reset page",
  "Reset position": "Reset position",
  "Reset to brand theme": "Reset to brand theme",
  "Reset to default": "Reset to default",
  "Reset to platform default": "Reset to platform default",
  "Reset to suggested": "Reset to suggested",
  "Reset your password": "Reset your password",
  "Resize the editor": "Resize the editor",
  "Resizing your artwork for this format": "Resizing your artwork for this format",
  "Resolution": "Resolution",
  "Responsible gambling": "Responsible gambling",
  "Responsive": "Responsive",
  "Responsive fills the screen, for embeds and in-app placements.": "Responsive fills the screen, for embeds and in-app placements.",
  "Restart": "Restart",
  "Restore": "Restore",
  "Restored. This version is current now.": "Restored. This version is current now.",
  "Restoring your checkout…": "Restoring your checkout…",
  "Restyle": "Restyle",
  "Restyle for the holidays": "Restyle for the holidays",
  "Results": "Results",
  "Resume Campaign": "Resume Campaign",
  "Resume from beat {{n}}": "Resume from beat {{n}}",
  "Resume Promotion": "Resume Promotion",
  "Retention": "Retention",
  "Retry": "Retry",
  "Retry payment": "Retry payment",
  "Return on ad spend": "Return on ad spend",
  "Rev / FTD": "Rev / FTD",
  "Rev share": "Rev share",
  "Rev Share": "Rev Share",
  "Rev share {{percent}}%": "Rev share {{percent}}%",
  "Rev share {{percent}}% + CPA {{amount}}": "Rev share {{percent}}% + CPA {{amount}}",
  "Rev share %": "Rev share %",
  "Rev share commission": "Rev share commission",
  "Reveal label": "Reveal label",
  "Reveals": "Reveals",
  "Revenue": "Revenue",
  "REVENUE": "REVENUE",
  "Revenue per player": "Revenue per player",
  "Revenue Share": "Revenue Share",
  "Revert last publish": "Revert last publish",
  "Revert to initial state": "Revert to initial state",
  "Reverting…": "Reverting…",
  "Review": "Review",
  "Review & Go Live": "Review & Go Live",
  "Review & Pay": "Review & Pay",
  "Review and publish": "Review and publish",
  "Review Document": "Review Document",
  "Review later": "Review later",
  "Review your details": "Review your details",
  "Revoke": "Revoke",
  "Reward item": "Reward item",
  "Rewards": "Rewards",
  "Reworking scene {{n}} to meet the video service's rules": "Reworking scene {{n}} to meet the video service's rules",
  "Ride the momentum to the payoff as the \"{{cta}}\" call to action ignites as a bold on-screen button.": "Ride the momentum to the payoff as the \"{{cta}}\" call to action ignites as a bold on-screen button.",
  "Right": "Right",
  "Rising crane on the artwork as the jackpot detonates, coins erupting while the \"{{headline}}\" offer explodes in as massive, on-brand headline text.": "Rising crane on the artwork as the jackpot detonates, coins erupting while the \"{{headline}}\" offer explodes in as massive, on-brand headline text.",
  "ROI": "ROI",
  "Role": "Role",
  "Romanian": "Romanian",
  "Route": "Route",
  "Routes": "Routes",
  "Routing number (ABA)": "Routing number (ABA)",
  "Row": "Row",
  "Rows per page": "Rows per page",
  "Rules version: {{version}}": "Rules version: {{version}}",
  "Run the website and ads": "Run the website and ads",
  "Running": "Running",
  "Running Campaign Details": "Running Campaign Details",
  "Running final health checks": "Running final health checks",
  "Running Promotion Details": "Running Promotion Details",
  "S": "S",
  "Same deal as another affiliate": "Same deal as another affiliate",
  "Sample {{n}}": "Sample {{n}}",
  "Samples": "Samples",
  "Save": "Save",
  "Save {{pct}}%": "Save {{pct}}%",
  "Save {{percent}}%": "Save {{percent}}%",
  "Save and generate": "Save and generate",
  "Save as new version": "Save as new version",
  "Save block": "Save block",
  "Save changes": "Save changes",
  "Save creates a new version of the banner with this size redrawn from its layers.": "Save creates a new version of the banner with this size redrawn from its layers.",
  "Save creates a new version of the kit with this size redrawn from its layers.": "Save creates a new version of the kit with this size redrawn from its layers.",
  "Save custom pack": "Save custom pack",
  "Save Daily Limits": "Save Daily Limits",
  "Save draft": "Save draft",
  "Save order": "Save order",
  "Save section": "Save section",
  "Save withdrawal details": "Save withdrawal details",
  "Saved": "Saved",
  "Saved {{pct}}%": "Saved {{pct}}%",
  "Saved ✓": "Saved ✓",
  "Saved addresses are no longer available; choose addresses.": "Saved addresses are no longer available; choose addresses.",
  "Saved as a hand-picked list": "Saved as a hand-picked list",
  "Saved as a new version.": "Saved as a new version.",
  "Saved to your creatives.": "Saved to your creatives.",
  "Saving a new version…": "Saving a new version…",
  "Saving landing pages isn't available in this environment yet.": "Saving landing pages isn't available in this environment yet.",
  "Saving your ad": "Saving your ad",
  "Saving your own game lists is not available yet.": "Saving your own game lists is not available yet.",
  "Saving…": "Saving…",
  "Say a little more, at least {{missing}} more characters.": "Say a little more, at least {{missing}} more characters.",
  "Scan or copy the code in your bank app": "Scan or copy the code in your bank app",
  "Scan the code with your bank app, or copy the Pix code and paste it under Pix Copia e Cola. Your brand is reserved while we wait for the payment.": "Scan the code with your bank app, or copy the Pix code and paste it under Pix Copia e Cola. Your brand is reserved while we wait for the payment.",
  "Scanning competitors": "Scanning competitors",
  "Scene": "Scene",
  "Scene art": "Scene art",
  "Scene art is priced per image: {{bgs}} backgrounds and up to {{cuts}} cut-outs.": "Scene art is priced per image: {{bgs}} backgrounds and up to {{cuts}} cut-outs.",
  "Scene art, {{n}} missing": "Scene art, {{n}} missing",
  "Scene art: {{bgs}} backgrounds and up to {{cuts}} cut-outs. Credits per image: {{bg}} a background, {{cut}} a cut-out.": "Scene art: {{bgs}} backgrounds and up to {{cuts}} cut-outs. Credits per image: {{bg}} a background, {{cut}} a cut-out.",
  "Scene layers": "Scene layers",
  "Scheduled": "Scheduled",
  "Scope": "Scope",
  "Scope: {{value}}": "Scope: {{value}}",
  "Scroll to next": "Scroll to next",
  "Scroll to previous": "Scroll to previous",
  "Search": "Search",
  "Search ads": "Search ads",
  "Search affiliates": "Search affiliates",
  "Search affiliates…": "Search affiliates…",
  "Search by email…": "Search by email…",
  "Search campaigns": "Search campaigns",
  "Search campaigns…": "Search campaigns…",
  "Search collections or games": "Search collections or games",
  "Search countries": "Search countries",
  "Search country or region": "Search country or region",
  "Search engines": "Search engines",
  "Search games": "Search games",
  "Search games by name": "Search games by name",
  "Search games by name or ID": "Search games by name or ID",
  "Search pages": "Search pages",
  "Search players by email": "Search players by email",
  "Search promotions": "Search promotions",
  "Search promotions…": "Search promotions…",
  "Search providers": "Search providers",
  "Search result": "Search result",
  "Search sources": "Search sources",
  "Search the catalogue and choose every game yourself. The list changes only when you edit it.": "Search the catalogue and choose every game yourself. The list changes only when you edit it.",
  "Search themes": "Search themes",
  "Search your site's pages": "Search your site's pages",
  "Searching...": "Searching...",
  "Seasonal": "Seasonal",
  "sec": "sec",
  "Section actions": "Section actions",
  "Section heading": "Section heading",
  "Sections": "Sections",
  "Sections on the page": "Sections on the page",
  "Secure your {{brandName}} brand": "Secure your {{brandName}} brand",
  "Secure your brand": "Secure your brand",
  "Secure your brand by signing the License Holder Declaration with DocuSign. In it, Starfall, the license holder, declares that your domain, your brand and your player base belong to you.": "Secure your brand by signing the License Holder Declaration with DocuSign. In it, Starfall, the license holder, declares that your domain, your brand and your player base belong to you.",
  "Secured": "Secured",
  "Security": "Security",
  "Security & account alerts": "Security & account alerts",
  "See all": "See all",
  "See articles": "See articles",
  "See detailed view": "See detailed view",
  "See details": "See details",
  "See less": "See less",
  "See less features": "See less features",
  "See more": "See more",
  "See more features": "See more features",
  "See new banners": "See new banners",
  "See players": "See players",
  "See players by version:": "See players by version:",
  "See prompt": "See prompt",
  "Select {{name}}": "Select {{name}}",
  "Select a brand to create a campaign.": "Select a brand to create a campaign.",
  "Select a brand to create a tracking link.": "Select a brand to create a tracking link.",
  "Select a brand to see its stats.": "Select a brand to see its stats.",
  "Select a brand to see its video-ad stats.": "Select a brand to see its video-ad stats.",
  "Select a business type": "Select a business type",
  "Select a casino to see its technical details.": "Select a casino to see its technical details.",
  "Select a category before publishing the article": "Select a category before publishing the article",
  "Select a country": "Select a country",
  "Select a currency": "Select a currency",
  "Select a layer on the canvas or in the list to move, resize, hide or rewrite it.": "Select a layer on the canvas or in the list to move, resize, hide or rewrite it.",
  "Select a network": "Select a network",
  "Select a network first": "Select a network first",
  "Select a promotion": "Select a promotion",
  "Select a token": "Select a token",
  "Select account type": "Select account type",
  "Select all": "Select all",
  "Select logo": "Select logo",
  "Select period": "Select period",
  "Select the {{layer}} layer": "Select the {{layer}} layer",
  "Select the operating area": "Select the operating area",
  "Selected": "Selected",
  "Selected name & domain": "Selected name & domain",
  "Selected pack": "Selected pack",
  "Selected package": "Selected package",
  "Selected style": "Selected style",
  "Selecting a country will provide tailored recommendations specific to that location": "Selecting a country will provide tailored recommendations specific to that location",
  "Self-managed Channels": "Self-managed Channels",
  "Send {{layer}} backward": "Send {{layer}} backward",
  "Send backward": "Send backward",
  "Send invite": "Send invite",
  "Send it here": "Send it here",
  "Send link here": "Send link here",
  "Send magic link": "Send magic link",
  "Send message": "Send message",
  "Send reset link": "Send reset link",
  "Send the exact amount, quoting the reference and concept above.": "Send the exact amount, quoting the reference and concept above.",
  "Sending": "Sending",
  "Sending {{name}}'s tracking link to this page…": "Sending {{name}}'s tracking link to this page…",
  "Sending request…": "Sending request…",
  "Sending the ad's tracking link to this page…": "Sending the ad's tracking link to this page…",
  "Sending…": "Sending…",
  "Sent Notifications": "Sent Notifications",
  "SEO": "SEO",
  "SEO editing isn't available for this site yet": "SEO editing isn't available for this site yet",
  "SEO isn't available yet": "SEO isn't available yet",
  "SEO isn't set up yet": "SEO isn't set up yet",
  "Separate layers": "Separate layers",
  "Separating layers…": "Separating layers…",
  "Server": "Server",
  "Server settings": "Server settings",
  "Set a commission plan": "Set a commission plan",
  "Set a new password": "Set a new password",
  "Set a style as primary first.": "Set a style as primary first.",
  "Set as primary": "Set as primary",
  "Set by the prompt": "Set by the prompt",
  "Set by you": "Set by you",
  "Set it up in your mail app": "Set it up in your mail app",
  "Set new password": "Set new password",
  "Set or change the password you sign in with.": "Set or change the password you sign in with.",
  "Set this style as primary first.": "Set this style as primary first.",
  "Set up": "Set up",
  "Set up an art style": "Set up an art style",
  "Set up your affiliate program": "Set up your affiliate program",
  "Set up your art style": "Set up your art style",
  "Set up your style": "Set up your style",
  "Set your promotion and vibe, then generate a storyboard. Your shot list previews here, and you pick a model and render the video after that.": "Set your promotion and vibe, then generate a storyboard. Your shot list previews here, and you pick a model and render the video after that.",
  "Set your promotions and vibe, then generate a storyboard. Your beats preview here, and you pick a model and render the video after that.": "Set your promotions and vibe, then generate a storyboard. Your beats preview here, and you pick a model and render the video after that.",
  "Setting": "Setting",
  "Setting the scene": "Setting the scene",
  "Setting the stage…": "Setting the stage…",
  "Setting up": "Setting up",
  "Setting up {{address}}": "Setting up {{address}}",
  "Setting up {{brand}}": "Setting up {{brand}}",
  "Setting up analytics and reporting": "Setting up analytics and reporting",
  "Setting up scene {{n}}'s closing moment": "Setting up scene {{n}}'s closing moment",
  "Setting up the first version…": "Setting up the first version…",
  "Setting up the player database": "Setting up the player database",
  "Setting up your HTML5 banner…": "Setting up your HTML5 banner…",
  "Setting up your iGaming brand.": "Setting up your iGaming brand.",
  "Setting up your landing page…": "Setting up your landing page…",
  "Setting up your mini-game with your welcome bonus…": "Setting up your mini-game with your welcome bonus…",
  "Setting up your video run": "Setting up your video run",
  "Settings": "Settings",
  "SETTINGS": "SETTINGS",
  "Settings · Mailbox": "Settings · Mailbox",
  "Settings, then <0/>, whenever you want it.": "Settings, then <0/>, whenever you want it.",
  "Settle into a confident, exclusive final frame as the \"{{cta}}\" call to action resolves as a polished, premium on-screen button.": "Settle into a confident, exclusive final frame as the \"{{cta}}\" call to action resolves as a polished, premium on-screen button.",
  "Settle on the full teaser and let the \"{{cta}}\" call to action fade smoothly into view.": "Settle on the full teaser and let the \"{{cta}}\" call to action fade smoothly into view.",
  "Settle on the full teaser as the \"{{cta}}\" call to action fades smoothly into view as a bold on-screen button.": "Settle on the full teaser as the \"{{cta}}\" call to action fades smoothly into view as a bold on-screen button.",
  "Settlement Breakdown": "Settlement Breakdown",
  "Setup": "Setup",
  "Setup Fee": "Setup Fee",
  "Setup Mailbox": "Setup Mailbox",
  "Shaping the reward": "Shaping the reward",
  "Share": "Share",
  "Share a marketing asset's tracking link to see which assets bring you players.": "Share a marketing asset's tracking link to see which assets bring you players.",
  "Share image": "Share image",
  "Share preview": "Share preview",
  "Share this link if the invite email does not arrive:": "Share this link if the invite email does not arrive:",
  "Share this link to attribute sign-ups to this ad.": "Share this link to attribute sign-ups to this ad.",
  "Share this one-time invite link with the partner so they can set their own password. It is shown only once.": "Share this one-time invite link with the partner so they can set their own password. It is shown only once.",
  "Shareable link": "Shareable link",
  "Shared prize, challenge and shop icons": "Shared prize, challenge and shop icons",
  "Shared with other sites": "Shared with other sites",
  "Short name": "Short name",
  "Short Videos": "Short Videos",
  "Short videos for social and ad networks.": "Short videos for social and ad networks.",
  "Shorten the category name to 48 characters or less": "Shorten the category name to 48 characters or less",
  "Shot {{n}}": "Shot {{n}}",
  "Shot list": "Shot list",
  "Show": "Show",
  "Show {{count}} more of {{left}}": "Show {{count}} more of {{left}}",
  "Show {{layer}}": "Show {{layer}}",
  "Show {{n}} games": "Show {{n}} games",
  "Show {{name}}": "Show {{name}}",
  "Show {{name}} on your site": "Show {{name}} on your site",
  "Show {{name}} to players": "Show {{name}} to players",
  "Show 1 game": "Show 1 game",
  "Show a legal line": "Show a legal line",
  "Show all {{n}} links": "Show all {{n}} links",
  "Show all countries": "Show all countries",
  "Show as": "Show as",
  "Show call to action": "Show call to action",
  "Show details": "Show details",
  "Show filters": "Show filters",
  "Show ingredients": "Show ingredients",
  "Show invitations": "Show invitations",
  "Show less": "Show less",
  "Show less details": "Show less details",
  "Show list": "Show list",
  "Show logo": "Show logo",
  "Show me": "Show me",
  "Show me how": "Show me how",
  "Show me how to arrange them": "Show me how to arrange them",
  "Show me where": "Show me where",
  "Show more": "Show more",
  "Show more ({{shown}} of {{total}})": "Show more ({{shown}} of {{total}})",
  "Show on this page": "Show on this page",
  "Show only blocked countries": "Show only blocked countries",
  "Show password": "Show password",
  "Show the {{kit}} sizes": "Show the {{kit}} sizes",
  "Show the best games first": "Show the best games first",
  "Show the kinds of {{name}}": "Show the kinds of {{name}}",
  "Show the stats of one page": "Show the stats of one page",
  "Show to players": "Show to players",
  "Showing {{shown}} of {{total}} players": "Showing {{shown}} of {{total}} players",
  "Showing the last numbers while we ask again.": "Showing the last numbers while we ask again.",
  "Showing your {{count}} most recent players. Older registrations aren't loaded.": "Showing your {{count}} most recent players. Older registrations aren't loaded.",
  "Shown after your next save": "Shown after your next save",
  "Shown as {{title}}": "Shown as {{title}}",
  "Shown as a row of trust badges.": "Shown as a row of trust badges.",
  "Shown as the intro of the public category page": "Shown as the intro of the public category page",
  "Shown at the foot of the page exactly as on your website. Change it in your website settings.": "Shown at the foot of the page exactly as on your website. Change it in your website settings.",
  "Shown in every language that has no translation below.": "Shown in every language that has no translation below.",
  "Shown on every size as live text, so changing it never repaints the art.": "Shown on every size as live text, so changing it never repaints the art.",
  "Shown on the end card as live text, so changing it never repaints the art.": "Shown on the end card as live text, so changing it never repaints the art.",
  "Shown on the game next to your prizes, never won. For example: $500, 10 free spins, 20% cashback.": "Shown on the game next to your prizes, never won. For example: $500, 10 free spins, 20% cashback.",
  "Shown once the page loads; search engines and shares read it through prerender": "Shown once the page loads; search engines and shares read it through prerender",
  "Shown once. Save it now: you need it to sign in to webmail or a mail client.": "Shown once. Save it now: you need it to sign in to webmail or a mail client.",
  "Side panel": "Side panel",
  "Sign in": "Sign in",
  "Sign in again to manage the blog": "Sign in again to manage the blog",
  "Sign in with Google": "Sign in with Google",
  "Sign in with Telegram": "Sign in with Telegram",
  "Sign in.": "Sign in.",
  "Sign out": "Sign out",
  "Sign out of this account?": "Sign out of this account?",
  "Sign out of this device": "Sign out of this device",
  "Sign the document.": "Sign the document.",
  "Sign up with Google": "Sign up with Google",
  "Sign up with Telegram": "Sign up with Telegram",
  "Sign-in could not be completed": "Sign-in could not be completed",
  "Sign-ins, password and payout changes. Email is always on.": "Sign-ins, password and payout changes. Email is always on.",
  "Sign-ups are counted from tracking links, so this page's cannot be shown yet.": "Sign-ups are counted from tracking links, so this page's cannot be shown yet.",
  "Sign-ups are counted from tracking links, so this page's cannot be shown. Get its link in Marketing.": "Sign-ups are counted from tracking links, so this page's cannot be shown. Get its link in Marketing.",
  "Sign-ups for this page can't be shown": "Sign-ups for this page can't be shown",
  "Sign-ups from this page": "Sign-ups from this page",
  "Signed on {{date}}. Your brand is secured and everything is in order.": "Signed on {{date}}. Your brand is secured and everything is in order.",
  "Significant terms": "Significant terms",
  "Signing you in...": "Signing you in...",
  "Simple Video": "Simple Video",
  "Single clip needs the latest backend. Use the Video Ads tab to keep going.": "Single clip needs the latest backend. Use the Video Ads tab to keep going.",
  "Single page": "Single page",
  "Site added": "Site added",
  "Site defaults": "Site defaults",
  "Site defaults already cover every page": "Site defaults already cover every page",
  "Site defaults written for {{n}} languages.": "Site defaults written for {{n}} languages.",
  "Site defaults written for 1 language.": "Site defaults written for 1 language.",
  "Site IDs": "Site IDs",
  "Site name": "Site name",
  "Site page": "Site page",
  "Site pages": "Site pages",
  "Site preview": "Site preview",
  "Site URL (optional)": "Site URL (optional)",
  "Size": "Size",
  "Size · {{n}}%": "Size · {{n}}%",
  "Size of the {{layer}} layer": "Size of the {{layer}} layer",
  "Sizes": "Sizes",
  "Sizes of the same shape are redrawn with it: {{sizes}}.": "Sizes of the same shape are redrawn with it: {{sizes}}.",
  "Sizes of the same shape change with it: {{sizes}}.": "Sizes of the same shape change with it: {{sizes}}.",
  "Sizes this version has no image for are left out. Redraw them first to include them.": "Sizes this version has no image for are left out. Redraw them first to include them.",
  "Sketching the concept…": "Sketching the concept…",
  "Sketching the final shot of scene {{n}}": "Sketching the final shot of scene {{n}}",
  "Skip": "Skip",
  "skipped": "skipped",
  "Skipped": "Skipped",
  "Slightly above market": "Slightly above market",
  "Slow cinematic push-in on the \"{{headline}}\" key visual while a soft golden light sweeps across it.": "Slow cinematic push-in on the \"{{headline}}\" key visual while a soft golden light sweeps across it.",
  "Slow cinematic push-in on the key visual as the \"{{headline}}\" offer animates in as bold, on-brand headline text.": "Slow cinematic push-in on the key visual as the \"{{headline}}\" offer animates in as bold, on-brand headline text.",
  "Slow reveal from deep shadow as the {{brand}} hero emerges and the \"{{headline}}\" offer fades up as bold, on-brand headline text.": "Slow reveal from deep shadow as the {{brand}} hero emerges and the \"{{headline}}\" offer fades up as bold, on-brand headline text.",
  "Slow reveal of the \"{{headline}}\" artwork emerging from soft shadow into light.": "Slow reveal of the \"{{headline}}\" artwork emerging from soft shadow into light.",
  "Slow reveal of the artwork emerging from soft shadow as the \"{{headline}}\" offer fades in as bold, on-brand headline text.": "Slow reveal of the artwork emerging from soft shadow as the \"{{headline}}\" offer fades in as bold, on-brand headline text.",
  "Slow, luxurious dolly through soft light and depth as the {{brand}} hero glides into view and the \"{{headline}}\" offer fades in as elegant, on-brand headline text.": "Slow, luxurious dolly through soft light and depth as the {{brand}} hero glides into view and the \"{{headline}}\" offer fades in as elegant, on-brand headline text.",
  "Slow, opulent push through gold light and rich texture as the {{brand}} hero commands the frame and the \"{{headline}}\" offer glides in as premium, on-brand headline text.": "Slow, opulent push through gold light and rich texture as the {{brand}} hero commands the frame and the \"{{headline}}\" offer glides in as premium, on-brand headline text.",
  "Slug": "Slug",
  "Small": "Small",
  "Small print": "Small print",
  "Small print under the game": "Small print under the game",
  "Smaller than 1200×630: it may look soft when shared": "Smaller than 1200×630: it may look soft when shared",
  "SMS": "SMS",
  "Snap push-in on the artwork with ticking-clock energy as the \"{{headline}}\" offer flashes in as urgent, bold on-brand headline text.": "Snap push-in on the artwork with ticking-clock energy as the \"{{headline}}\" offer flashes in as urgent, bold on-brand headline text.",
  "Snap-zoom to the payoff as the \"{{cta}}\" call to action ignites as a bold, tappable on-screen button.": "Snap-zoom to the payoff as the \"{{cta}}\" call to action ignites as a bold, tappable on-screen button.",
  "Social": "Social",
  "Social media": "Social media",
  "Social media ads": "Social media ads",
  "Social share": "Social share",
  "Social story": "Social story",
  "Soft": "Soft",
  "Solana": "Solana",
  "Sole proprietor": "Sole proprietor",
  "Solid colour": "Solid colour",
  "Some art could not be generated and its credits were refunded. Generate again to retry it.": "Some art could not be generated and its credits were refunded. Generate again to retry it.",
  "Some copy sits where the logo goes on this size. Look it over, or generate a new version.": "Some copy sits where the logo goes on this size. Look it over, or generate a new version.",
  "Some copy sits where the logo goes on this size. Look it over, or redraw it.": "Some copy sits where the logo goes on this size. Look it over, or redraw it.",
  "Some creatives didn't finish": "Some creatives didn't finish",
  "some existing discounts may no longer apply.": "some existing discounts may no longer apply.",
  "Some numbers changed while they were read and may not match. Reload to read them again.": "Some numbers changed while they were read and may not match. Reload to read them again.",
  "Some of it could not be generated and its credits were refunded. Generate again to retry it.": "Some of it could not be generated and its credits were refunded. Generate again to retry it.",
  "Some of your content has no art in this look yet. Generate art in this style first.": "Some of your content has no art in this look yet. Generate art in this style first.",
  "Some of your content has no art in your style yet. Regenerate your website art to switch your site.": "Some of your content has no art in your style yet. Regenerate your website art to switch your site.",
  "Some of your content only has art in your own style, so your site cannot go back yet.": "Some of your content only has art in your own style, so your site cannot go back yet.",
  "Some of your site's images aren't served over https, so they can't be shared.": "Some of your site's images aren't served over https, so they can't be shared.",
  "Some of your website art is drawn in this look. Generate the rest before you switch.": "Some of your website art is drawn in this look. Generate the rest before you switch.",
  "Some parts couldn't be finished.": "Some parts couldn't be finished.",
  "Some sizes could not be rendered and their credits were refunded. Generate the banners again to try them.": "Some sizes could not be rendered and their credits were refunded. Generate the banners again to try them.",
  "Some sizes could not be rendered and their credits were refunded. Redraw them from the size menu.": "Some sizes could not be rendered and their credits were refunded. Redraw them from the size menu.",
  "Something sits where the game is played on this background. Look it over, or generate again.": "Something sits where the game is played on this background. Look it over, or generate again.",
  "Something went wrong": "Something went wrong",
  "Something went wrong applying this. Please try again.": "Something went wrong applying this. Please try again.",
  "Something went wrong on our side.": "Something went wrong on our side.",
  "Something went wrong on our side. Please try again.": "Something went wrong on our side. Please try again.",
  "Something went wrong reaching our secure payment service. Check your connection and try again — you won’t be charged until you confirm.": "Something went wrong reaching our secure payment service. Check your connection and try again — you won’t be charged until you confirm.",
  "Something went wrong reaching our secure payment service. Check your connection and try again. You won’t be charged until you confirm.": "Something went wrong reaching our secure payment service. Check your connection and try again. You won’t be charged until you confirm.",
  "Something went wrong starting your purchase.": "Something went wrong starting your purchase.",
  "Something went wrong. Please try again.": "Something went wrong. Please try again.",
  "Somewhere else": "Somewhere else",
  "Soon": "Soon",
  "Sort code": "Sort code",
  "Sort players": "Sort players",
  "Sound": "Sound",
  "Source": "Source",
  "Source image": "Source image",
  "Source title": "Source title",
  "Sources": "Sources",
  "Sources and further reading": "Sources and further reading",
  "South America": "South America",
  "Space, Enter or a comma finishes an entry.": "Space, Enter or a comma finishes an entry.",
  "Spanish": "Spanish",
  "Spanish (Mexico)": "Spanish (Mexico)",
  "SPEI": "SPEI",
  "Spei Debug": "Spei Debug",
  "SPEI transfers usually arrive within minutes, and can take up to one business day. We'll email you the moment yours lands.": "SPEI transfers usually arrive within minutes, and can take up to one business day. We'll email you the moment yours lands.",
  "Spent": "Spent",
  "SPF record, so your mail is authorised": "SPF record, so your mail is authorised",
  "Spinning up your casino…": "Spinning up your casino…",
  "Spinning up your game servers": "Spinning up your game servers",
  "Sport": "Sport",
  "Sports": "Sports",
  "Sports carousel": "Sports carousel",
  "Spotlight": "Spotlight",
  "Square": "Square",
  "Stacked": "Stacked",
  "Stacked logo": "Stacked logo",
  "Staff": "Staff",
  "Stakes": "Stakes",
  "Standalone assets for social, ads, or anywhere off your site. Create a new one, or open a saved creative to edit or download it.": "Standalone assets for social, ads, or anywhere off your site. Create a new one, or open a saved creative to edit or download it.",
  "Start": "Start",
  "Start a new style": "Start a new style",
  "Start a new translation group": "Start a new translation group",
  "Start building your iGaming website": "Start building your iGaming website",
  "Start date": "Start date",
  "Start date (optional)": "Start date (optional)",
  "Start from": "Start from",
  "Start from a collection inspired by casinos in your market, then make it your own.": "Start from a collection inspired by casinos in your market, then make it your own.",
  "Start here": "Start here",
  "Start here each day: how {{brand}} is doing, where it is heading, and every player who joins.": "Start here each day: how {{brand}} is doing, where it is heading, and every player who joins.",
  "Start over": "Start over",
  "Start Promoting Today": "Start Promoting Today",
  "Start with /": "Start with /",
  "Start with Create new": "Start with Create new",
  "Start with your first ad": "Start with your first ad",
  "Start with your ingredients": "Start with your ingredients",
  "Start writing your article": "Start writing your article",
  "starting": "starting",
  "Starting": "Starting",
  "Starting checkout…": "Starting checkout…",
  "Starting secure checkout…": "Starting secure checkout…",
  "Starting...": "Starting...",
  "Starting…": "Starting…",
  "State / province / region": "State / province / region",
  "State / province / region (optional)": "State / province / region (optional)",
  "Stats": "Stats",
  "Stats appear once an embed is live.": "Stats appear once an embed is live.",
  "Stats not available": "Stats not available",
  "Status": "Status",
  "STATUS": "STATUS",
  "Stay on this code": "Stay on this code",
  "Stays up to date without edits": "Stays up to date without edits",
  "Steady performer, Lumio holding the line": "Steady performer, Lumio holding the line",
  "Steers what the mood board sets. Your words win when they disagree.": "Steers what the mood board sets. Your words win when they disagree.",
  "Stellar": "Stellar",
  "Step {{n}}": "Step {{n}}",
  "STEP {{n}} OF {{total}}": "STEP {{n}} OF {{total}}",
  "Step {{n}}: {{name}}": "Step {{n}}: {{name}}",
  "STEP 1": "STEP 1",
  "STEP 1 — Choose campaign style": "STEP 1 — Choose campaign style",
  "STEP 1: Choose campaign style": "STEP 1: Choose campaign style",
  "STEP 2": "STEP 2",
  "STEP 2 — Activate campaign": "STEP 2 — Activate campaign",
  "STEP 2: Activate campaign": "STEP 2: Activate campaign",
  "STEP 3": "STEP 3",
  "Steps": "Steps",
  "Steps title": "Steps title",
  "Stickers": "Stickers",
  "Stickiness": "Stickiness",
  "Still having trouble? ": "Still having trouble? ",
  "Stitching your scenes together": "Stitching your scenes together",
  "Stop": "Stop",
  "Stop generating": "Stop generating",
  "Stopped": "Stopped",
  "Stopped. Your credits were refunded.": "Stopped. Your credits were refunded.",
  "Stopping…": "Stopping…",
  "Storage": "Storage",
  "Storyboard": "Storyboard",
  "Storyboard ads": "Storyboard ads",
  "Storyboard ready": "Storyboard ready",
  "Storyboard, no video · {{when}}": "Storyboard, no video · {{when}}",
  "Straight to the casino": "Straight to the casino",
  "Straight to the website": "Straight to the website",
  "Streaming is starting": "Streaming is starting",
  "Street address": "Street address",
  "Strong": "Strong",
  "Strong password": "Strong password",
  "Studying the light, materials and colour": "Studying the light, materials and colour",
  "Style": "Style",
  "Style definition": "Style definition",
  "Style deleted.": "Style deleted.",
  "Style in use. New banners and images follow it.": "Style in use. New banners and images follow it.",
  "Style name": "Style name",
  "Style paused.": "Style paused.",
  "Style, mood or colours": "Style, mood or colours",
  "Styles": "Styles",
  "Styles ({{shown}}/{{total}})": "Styles ({{shown}}/{{total}})",
  "Sub-line": "Sub-line",
  "Subheading": "Subheading",
  "Subheadline": "Subheadline",
  "Subject": "Subject",
  "Suggest a name": "Suggest a name",
  "Suggest a name for {{name}}": "Suggest a name for {{name}}",
  "Suggested": "Suggested",
  "Suggested Campaign Details": "Suggested Campaign Details",
  "Suggested from your filters. Type to use your own.": "Suggested from your filters. Type to use your own.",
  "Suggested Promotion Details": "Suggested Promotion Details",
  "Suggested: {{name}}": "Suggested: {{name}}",
  "Suggestions": "Suggestions",
  "Summary": "Summary",
  "Summary for AI assistants": "Summary for AI assistants",
  "Support agent ({{username}}) currently signed in.": "Support agent ({{username}}) currently signed in.",
  "Support agent currently signed in.": "Support agent currently signed in.",
  "Support Cases": "Support Cases",
  "support@whitelabels.com": "support@whitelabels.com",
  "Surfaces": "Surfaces",
  "Surpass your competition, offer the ultimate experience.": "Surpass your competition, offer the ultimate experience.",
  "Suspected": "Suspected",
  "Suspected automation": "Suspected automation",
  "Suspected: {{n}}": "Suspected: {{n}}",
  "Suspended": "Suspended",
  "Sustainable": "Sustainable",
  "Swap sides": "Swap sides",
  "Sweep down through the coin storm to the payoff as the \"{{cta}}\" call to action lights up as a bold on-screen button, the \"{{subtitle}}\" detail crisp beside it.": "Sweep down through the coin storm to the payoff as the \"{{cta}}\" call to action lights up as a bold on-screen button, the \"{{subtitle}}\" detail crisp beside it.",
  "Sweep down through the coins to the payoff as the \"{{cta}}\" call to action lights up as a bold on-screen button.": "Sweep down through the coins to the payoff as the \"{{cta}}\" call to action lights up as a bold on-screen button.",
  "Sweep to the payoff as the \"{{cta}}\" call to action ignites as a bold, glowing on-screen button.": "Sweep to the payoff as the \"{{cta}}\" call to action ignites as a bold, glowing on-screen button.",
  "SWIFT / BIC code": "SWIFT / BIC code",
  "Switch my site": "Switch my site",
  "Switch to Custom?": "Switch to Custom?",
  "Switching to your next offer": "Switching to your next offer",
  "Switching your site": "Switching your site",
  "Switching your site is free.": "Switching your site is free.",
  "Switching your site to {{style}}": "Switching your site to {{style}}",
  "Switching your site to this look…": "Switching your site to this look…",
  "Switching your site to your new art": "Switching your site to your new art",
  "Symbol": "Symbol",
  "Symbol + name": "Symbol + name",
  "Symbol + name · horizontal": "Symbol + name · horizontal",
  "Symbol + name · vertical": "Symbol + name · vertical",
  "Symbol + short name": "Symbol + short name",
  "Symbols": "Symbols",
  "System": "System",
  "T&Cs link pressed: in the live ad it opens {{url}}": "T&Cs link pressed: in the live ad it opens {{url}}",
  "Tablet": "Tablet",
  "Tablet preview": "Tablet preview",
  "Tags": "Tags",
  "Tailwind": "Tailwind",
  "Tailwinds and watch-outs aren't available yet": "Tailwinds and watch-outs aren't available yet",
  "Take a look": "Take a look",
  "Take a moment to review your order before launch.": "Take a moment to review your order before launch.",
  "Take your website live": "Take your website live",
  "Taking a close look at your artwork": "Taking a close look at your artwork",
  "Taking the page offline. This can take a few seconds…": "Taking the page offline. This can take a few seconds…",
  "Taking your website live…": "Taking your website live…",
  "Target": "Target",
  "Target length": "Target length",
  "Target to beat": "Target to beat",
  "Targeted Players": "Targeted Players",
  "Tax & verification": "Tax & verification",
  "Tax ID": "Tax ID",
  "Tax ID / national ID": "Tax ID / national ID",
  "Teams (optional)": "Teams (optional)",
  "Technical details": "Technical details",
  "Telegram (optional)": "Telegram (optional)",
  "Tell me about {{parts}}": "Tell me about {{parts}}",
  "Tell me more about {{name}}": "Tell me more about {{name}}",
  "Tell us the name the payment will come from.": "Tell us the name the payment will come from.",
  "Tell us the name the transfer will come from.": "Tell us the name the transfer will come from.",
  "Tell us what you need help with…": "Tell us what you need help with…",
  "Template": "Template",
  "Tenant ID": "Tenant ID",
  "Tenant not found": "Tenant not found",
  "Terms": "Terms",
  "Terms & Conditions": "Terms & Conditions",
  "Terms and conditions link": "Terms and conditions link",
  "Terms title": "Terms title",
  "Test accounts could not be checked, so test visits may be counted.": "Test accounts could not be checked, so test visits may be counted.",
  "Text": "Text",
  "Text colour": "Text colour",
  "Text position": "Text position",
  "That art style isn't ready to draw with yet. Pick another, or finish it on the Art Style tab.": "That art style isn't ready to draw with yet. Pick another, or finish it on the Art Style tab.",
  "That asset couldn't be loaded right now.": "That asset couldn't be loaded right now.",
  "That background generation failed. Please try again.": "That background generation failed. Please try again.",
  "That banner kit couldn't be found.": "That banner kit couldn't be found.",
  "That code is not right. Check the code from the email and try again.": "That code is not right. Check the code from the email and try again.",
  "That couldn't be created. Please try again.": "That couldn't be created. Please try again.",
  "That couldn't be deleted. Please try again.": "That couldn't be deleted. Please try again.",
  "That couldn't be exported. Please try again.": "That couldn't be exported. Please try again.",
  "That couldn't be published. Please try again.": "That couldn't be published. Please try again.",
  "That couldn't be reverted. Please try again.": "That couldn't be reverted. Please try again.",
  "That couldn't be saved. Please try again.": "That couldn't be saved. Please try again.",
  "That couldn't be started. Please try again.": "That couldn't be started. Please try again.",
  "That couldn't be stopped. Please try again.": "That couldn't be stopped. Please try again.",
  "That couldn't be undone. Please try again.": "That couldn't be undone. Please try again.",
  "That couldn't be uploaded. Please try again.": "That couldn't be uploaded. Please try again.",
  "That doesn't look like a Google verification record. Copy the whole value that starts with google-site-verification=.": "That doesn't look like a Google verification record. Copy the whole value that starts with google-site-verification=.",
  "That file can’t be used. Upload a PNG or SVG under 12MB.": "That file can’t be used. Upload a PNG or SVG under 12MB.",
  "That file is not an image.": "That file is not an image.",
  "That file isn't an image": "That file isn't an image",
  "That file isn't supported. Use a PNG, JPG or SVG under 10 MB.": "That file isn't supported. Use a PNG, JPG or SVG under 10 MB.",
  "That file isn't supported. Use a PNG, JPG or SVG under 12 MB.": "That file isn't supported. Use a PNG, JPG or SVG under 12 MB.",
  "That generation did not finish": "That generation did not finish",
  "That group already belongs to a dynamic page": "That group already belongs to a dynamic page",
  "That HTML5 banner couldn't be found.": "That HTML5 banner couldn't be found.",
  "That image banner couldn't be found.": "That image banner couldn't be found.",
  "That image could not be added. Please try another.": "That image could not be added. Please try another.",
  "That image could not be read. Please try another.": "That image could not be read. Please try another.",
  "That image couldn't be loaded. Please try another.": "That image couldn't be loaded. Please try another.",
  "That image couldn't be read. Please pick another one.": "That image couldn't be read. Please pick another one.",
  "That image couldn't be read. Try another one.": "That image couldn't be read. Try another one.",
  "That image couldn't be uploaded. Please try again.": "That image couldn't be uploaded. Please try again.",
  "That image is over 5 MB": "That image is over 5 MB",
  "That image is too long and thin. Try a less extreme shape.": "That image is too long and thin. Try a less extreme shape.",
  "That image is too small. Try a larger one.": "That image is too small. Try a larger one.",
  "That is {{pct}}% fewer than {{previous}}.": "That is {{pct}}% fewer than {{previous}}.",
  "That is {{pct}}% more than {{previous}}.": "That is {{pct}}% more than {{previous}}.",
  "That is a dynamic page: pick it from Dynamic routes": "That is a dynamic page: pick it from Dynamic routes",
  "That is a site page: pick it from Site pages": "That is a site page: pick it from Site pages",
  "That is about the same as {{previous}}.": "That is about the same as {{previous}}.",
  "That landing page couldn't be found.": "That landing page couldn't be found.",
  "That layer couldn't be changed. Please try again.": "That layer couldn't be changed. Please try again.",
  "That list could not be removed.": "That list could not be removed.",
  "That list could not be saved.": "That list could not be saved.",
  "That logo couldn't be updated. Your current logos are unchanged.": "That logo couldn't be updated. Your current logos are unchanged.",
  "That mini-game couldn't be found.": "That mini-game couldn't be found.",
  "That name is reserved for the casino's CRM mail. Pick another one.": "That name is reserved for the casino's CRM mail. Pick another one.",
  "That name is reserved for the mail system ({{names}}). Pick another one.": "That name is reserved for the mail system ({{names}}). Pick another one.",
  "That path can't be used. Choose another one.": "That path can't be used. Choose another one.",
  "That route is already in the list": "That route is already in the list",
  "That size couldn't be prepared. Please try again.": "That size couldn't be prepared. Please try again.",
  "That storyboard ad couldn't be generated. Your credits were refunded. Please try again.": "That storyboard ad couldn't be generated. Your credits were refunded. Please try again.",
  "That top-up didn't go through. Check your ads budget above before trying again.": "That top-up didn't go through. Check your ads budget above before trying again.",
  "That version already has its art. Edit it to start a new version.": "That version already has its art. Edit it to start a new version.",
  "That version couldn't be archived.": "That version couldn't be archived.",
  "That version couldn't be deleted.": "That version couldn't be deleted.",
  "That version couldn't be found. Close the banner and open it again.": "That version couldn't be found. Close the banner and open it again.",
  "That version couldn't be found. Close the kit and open it again.": "That version couldn't be found. Close the kit and open it again.",
  "That version couldn't be recovered.": "That version couldn't be recovered.",
  "That version is already generated. Edit it to start a new version.": "That version is already generated. Edit it to start a new version.",
  "That version or page could not be found. Reopen the page and try again.": "That version or page could not be found. Reopen the page and try again.",
  "That video ad couldn't be found.": "That video ad couldn't be found.",
  "That video ad couldn't be generated. Your credits were refunded. Please try again.": "That video ad couldn't be generated. Your credits were refunded. Please try again.",
  "That video couldn't be generated. Please try again.": "That video couldn't be generated. Please try again.",
  "That's for the HTML file or meta tag method. In Search Console, add a Domain property and copy its TXT record instead.": "That's for the HTML file or meta tag method. In Search Console, add a Domain property and copy its TXT record instead.",
  "The 'Published' tag marks what's live on your site; use 'Publish to site' to change it.": "The 'Published' tag marks what's live on your site; use 'Publish to site' to change it.",
  "The 'Published' tag marks what's live on your site; use 'Publish to site' to change it. Tap '+' to create a new variant from the selected version.": "The 'Published' tag marks what's live on your site; use 'Publish to site' to change it. Tap '+' to create a new variant from the selected version.",
  "The \"{{headline}}\" scene a touch closer, bright highlights building energy across the frame.": "The \"{{headline}}\" scene a touch closer, bright highlights building energy across the frame.",
  "The \"{{headline}}\" scene fully lit and sharp, the new game hero clearly in view.": "The \"{{headline}}\" scene fully lit and sharp, the new game hero clearly in view.",
  "The {{brand}} jackpot moment at full blast, a fountain of gold coins framing the \"{{headline}}\" offer as bold on-brand headline text.": "The {{brand}} jackpot moment at full blast, a fountain of gold coins framing the \"{{headline}}\" offer as bold on-brand headline text.",
  "The {{brand}} scene a touch closer, with the \"{{headline}}\" offer set as bold, on-brand headline text over the artwork.": "The {{brand}} scene a touch closer, with the \"{{headline}}\" offer set as bold, on-brand headline text over the artwork.",
  "The {{brand}} scene inside a storm of gold coins, the \"{{headline}}\" offer blazing across the frame as bold on-brand headline text.": "The {{brand}} scene inside a storm of gold coins, the \"{{headline}}\" offer blazing across the frame as bold on-brand headline text.",
  "The {{brand}} scene mid-explosion, gold coins scattering, the \"{{headline}}\" offer blazing across the frame as bold on-brand headline text.": "The {{brand}} scene mid-explosion, gold coins scattering, the \"{{headline}}\" offer blazing across the frame as bold on-brand headline text.",
  "The {{brand}} scene on a high, the \"{{headline}}\" offer set as bold on-brand headline text with a first win glowing.": "The {{brand}} scene on a high, the \"{{headline}}\" offer set as bold on-brand headline text with a first win glowing.",
  "the {{n}} days before": "the {{n}} days before",
  "The {{size}} banner": "The {{size}} banner",
  "the 30 days before": "the 30 days before",
  "the 7 days before": "the 7 days before",
  "the 90 days before": "the 90 days before",
  "The ad's tracking link couldn't be sent to this page.": "The ad's tracking link couldn't be sent to this page.",
  "The affiliate program is not set up for this brand. Contact support to enable it.": "The affiliate program is not set up for this brand. Contact support to enable it.",
  "The AI assistant texts are written only with this language, so they are skipped.": "The AI assistant texts are written only with this language, so they are skipped.",
  "The answer that is right": "The answer that is right",
  "The answer, in a sentence or two.": "The answer, in a sentence or two.",
  "The art appears in the preview as it lands.": "The art appears in the preview as it lands.",
  "The art in this style couldn't be finished": "The art in this style couldn't be finished",
  "The art in this style couldn't be started. Please try again.": "The art in this style couldn't be started. Please try again.",
  "The article was left as it was. You can try again.": "The article was left as it was. You can try again.",
  "The article will be removed from your casino blog and its public URL will stop working.": "The article will be removed from your casino blog and its public URL will stop working.",
  "The article will be visible on your casino blog right away.": "The article will be visible on your casino blog right away.",
  "The automatic check could not read this text back. Look it over before you use it.": "The automatic check could not read this text back. Look it over before you use it.",
  "The automatic check could not run on this size. Look it over before you use it.": "The automatic check could not run on this size. Look it over before you use it.",
  "The automatic check was not sure about this background. Look it over, or generate again.": "The automatic check was not sure about this background. Look it over, or generate again.",
  "The automatic check was not sure about this size. Look it over, or generate a new version.": "The automatic check was not sure about this size. Look it over, or generate a new version.",
  "The automatic check was not sure about this size. Look it over, or redraw it.": "The automatic check was not sure about this size. Look it over, or redraw it.",
  "The background image blocks download for now. Try a colour or gradient background to export.": "The background image blocks download for now. Try a colour or gradient background to export.",
  "The banner kit ZIP couldn't be prepared. Please try again.": "The banner kit ZIP couldn't be prepared. Please try again.",
  "The bar you are aiming at": "The bar you are aiming at",
  "The blog could not be loaded.": "The blog could not be loaded.",
  "The blog is live": "The blog is live",
  "The blog is off": "The blog is off",
  "The blog is on Autopilot": "The blog is on Autopilot",
  "The blog service is not configured": "The blog service is not configured",
  "The body, in the same markdown the article uses.": "The body, in the same markdown the article uses.",
  "the brand is still deploying": "the brand is still deploying",
  "the brand is switching": "the brand is switching",
  "The cards couldn't be regenerated. Please try again.": "The cards couldn't be regenerated. Please try again.",
  "The cards couldn't be regenerated. Your credits were refunded.": "The cards couldn't be regenerated. Your credits were refunded.",
  "The category \"Start here\" guide. It opens the cluster and every other article links up to it.": "The category \"Start here\" guide. It opens the cluster and every other article links up to it.",
  "The category page disappears from your casino blog. Articles are not deleted.": "The category page disappears from your casino blog. Articles are not deleted.",
  "The change could not be saved": "The change could not be saved",
  "The check could not read the copy back exactly on this size. Look it over, or generate a new version.": "The check could not read the copy back exactly on this size. Look it over, or generate a new version.",
  "The check could not read the copy back exactly on this size. Look it over, or redraw it.": "The check could not read the copy back exactly on this size. Look it over, or redraw it.",
  "The check could not read the new words back exactly. Look it over, or change it again.": "The check could not read the new words back exactly. Look it over, or change it again.",
  "The check read \"{{read}}\" on this layer. Look it over, or change the text.": "The check read \"{{read}}\" on this layer. Look it over, or change the text.",
  "The clip took too long to generate and was stopped. Try again, or pick a faster model. Your credits were refunded.": "The clip took too long to generate and was stopped. Try again, or pick a faster model. Your credits were refunded.",
  "The contract status could not be loaded.": "The contract status could not be loaded.",
  "The copy comes from the feature, so every banner matches your site.": "The copy comes from the feature, so every banner matches your site.",
  "The copy comes from the game, so every banner matches your site.": "The copy comes from the game, so every banner matches your site.",
  "The copy comes from the promotion, so every banner matches the live offer.": "The copy comes from the promotion, so every banner matches the live offer.",
  "The copy is live text on every size, so editing it never repaints the art. The whole banner clicks through to your landing page.": "The copy is live text on every size, so editing it never repaints the art. The whole banner clicks through to your landing page.",
  "The countries could not be loaded. Close and open the sheet to try again.": "The countries could not be loaded. Close and open the sheet to try again.",
  "the day before": "the day before",
  "the deployment failed": "the deployment failed",
  "The draft and its content are deleted. This cannot be undone.": "The draft and its content are deleted. This cannot be undone.",
  "The embed couldn't be published. Please try again.": "The embed couldn't be published. Please try again.",
  "The end card shows the offer, its terms and the button to your landing page.": "The end card shows the offer, its terms and the button to your landing page.",
  "The end date is before the start date.": "The end date is before the start date.",
  "The exact question a reader would search": "The exact question a reader would search",
  "The export couldn't be prepared. Please try again.": "The export couldn't be prepared. Please try again.",
  "The export profiles couldn't be loaded. Close this and try again.": "The export profiles couldn't be loaded. Close this and try again.",
  "The first games of this list are the ones players meet first on {{brand}}'s homepage, and they get the most plays.": "The first games of this list are the ones players meet first on {{brand}}'s homepage, and they get the most plays.",
  "The first stands left of the game, the second right. Generate with Scene art on to draw them.": "The first stands left of the game, the second right. Generate with Scene art on to draw them.",
  "The first stands left of the offer, the second right. Generate with Scene art on to draw them.": "The first stands left of the offer, the second right. Generate with Scene art on to draw them.",
  "The game catalogue could not be loaded, so this list's games cannot be shown. Please try again.": "The game catalogue could not be loaded, so this list's games cannot be shown. Please try again.",
  "The game is set when the mini-game is made. Make a new mini-game to play another one.": "The game is set when the mini-game is made. Make a new mini-game to play another one.",
  "The game lists on your Homepage and their order.": "The game lists on your Homepage and their order.",
  "The game shows no characters.": "The game shows no characters.",
  "The games can be reordered by hand": "The games can be reordered by hand",
  "The games couldn't be loaded. Close the mini-game and open it again to retry.": "The games couldn't be loaded. Close the mini-game and open it again to retry.",
  "The HTML5 export couldn't be prepared. Please try again.": "The HTML5 export couldn't be prepared. Please try again.",
  "The image banner ZIP couldn't be prepared. Please try again.": "The image banner ZIP couldn't be prepared. Please try again.",
  "The image could not be uploaded": "The image could not be uploaded",
  "The image couldn't be redrawn. Please try again.": "The image couldn't be redrawn. Please try again.",
  "The image is too large": "The image is too large",
  "The kind of game.": "The kind of game.",
  "The landing page could not be finished": "The landing page could not be finished",
  "The last extraction didn't finish. No credits were used.": "The last extraction didn't finish. No credits were used.",
  "the last step. The credits it needs show on the button; your style comes back in four samples.": "the last step. The credits it needs show on the button; your style comes back in four samples.",
  "The layers couldn't be saved. Please try again.": "The layers couldn't be saved. Please try again.",
  "The lettering redraws on Generate. Until then the page shows the text as it is.": "The lettering redraws on Generate. Until then the page shows the text as it is.",
  "The link expires in 15 minutes.": "The link expires in 15 minutes.",
  "The link itself stays the same, so ads already out keep working. Only where it sends people changes.": "The link itself stays the same, so ads already out keep working. Only where it sends people changes.",
  "The links to this page couldn't be loaded.": "The links to this page couldn't be loaded.",
  "The lists on this page could not be loaded.": "The lists on this page could not be loaded.",
  "The live page is updated.": "The live page is updated.",
  "The live version is from {{when}}. Update the live page to publish the one on screen.": "The live version is from {{when}}. Update the live page to publish the one on screen.",
  "The look Lumio uses for everything it draws for you.": "The look Lumio uses for everything it draws for you.",
  "The mailbox could not be created. Try again in a moment.": "The mailbox could not be created. Try again in a moment.",
  "The mailbox could not be deleted. Try again in a moment.": "The mailbox could not be deleted. Try again in a moment.",
  "The mailbox is ready": "The mailbox is ready",
  "The mailbox is ready.": "The mailbox is ready.",
  "The mailbox service cannot be reached right now.": "The mailbox service cannot be reached right now.",
  "The mailbox service is not available in this environment.": "The mailbox service is not available in this environment.",
  "The main subject may show more than once on this size. Look it over, or generate a new version.": "The main subject may show more than once on this size. Look it over, or generate a new version.",
  "The main subject may show more than once on this size. Look it over, or redraw it.": "The main subject may show more than once on this size. Look it over, or redraw it.",
  "The movement of real cash": "The movement of real cash",
  "The new image couldn't be applied.": "The new image couldn't be applied.",
  "The new image couldn't be applied. Please try again.": "The new image couldn't be applied. Please try again.",
  "The new image couldn't be applied. Your credits were refunded.": "The new image couldn't be applied. Your credits were refunded.",
  "The new image couldn't be discarded. Please try again.": "The new image couldn't be discarded. Please try again.",
  "The new image couldn't be drawn. Your credits were refunded.": "The new image couldn't be drawn. Your credits were refunded.",
  "The new image is live on your site.": "The new image is live on your site.",
  "The new layer couldn't be kept. Save now to keep it.": "The new layer couldn't be kept. Save now to keep it.",
  "The next article needs {{n}} credits. Top up and it is written within minutes.": "The next article needs {{n}} credits. Top up and it is written within minutes.",
  "The next article needs 1 credit. Top up and it is written within minutes.": "The next article needs 1 credit. Top up and it is written within minutes.",
  "The offer and call to action come from the promotion and the game text is fixed, all in the ad's language, so the game never promises more than the live offer.": "The offer and call to action come from the promotion and the game text is fixed, all in the ad's language, so the game never promises more than the live offer.",
  "The offer and call to action come from the promotion and the game text is fixed, so the game never promises more than the live offer.": "The offer and call to action come from the promotion and the game text is fixed, so the game never promises more than the live offer.",
  "The offer comes from the promotion, so the game never promises more than the live offer.": "The offer comes from the promotion, so the game never promises more than the live offer.",
  "The old password for {{address}} stops working immediately, and sending breaks until you enter the new one in your destination inbox. Receiving is unaffected.": "The old password for {{address}} stops working immediately, and sending breaks until you enter the new one in your destination inbox. Receiving is unaffected.",
  "The ones after it are free of charge too.": "The ones after it are free of charge too.",
  "The page carries your welcome offer.": "The page carries your welcome offer.",
  "The page couldn't be published. Please try again.": "The page couldn't be published. Please try again.",
  "The page couldn't be unpublished, so it was not archived. Please try again.": "The page couldn't be unpublished, so it was not archived. Please try again.",
  "The page couldn't be unpublished. Please try again.": "The page couldn't be unpublished. Please try again.",
  "The page is offline and archived.": "The page is offline and archived.",
  "The page is offline, but it could not be archived.": "The page is offline, but it could not be archived.",
  "The page opens in {{language}}.": "The page opens in {{language}}.",
  "The page opens in this language. Visitors can still switch to your website's other languages.": "The page opens in this language. Visitors can still switch to your website's other languages.",
  "The page shows no characters.": "The page shows no characters.",
  "The page shows the text as it is until the lettering is drawn again.": "The page shows the text as it is until the lettering is drawn again.",
  "The page updates as Lumio's work lands.": "The page updates as Lumio's work lands.",
  "The page will live at {{url}}": "The page will live at {{url}}",
  "The page you're looking for may have moved, folded, or never existed. Let's get you back to the action.": "The page you're looking for may have moved, folded, or never existed. Let's get you back to the action.",
  "The pages live on your landing domain couldn't be loaded.": "The pages live on your landing domain couldn't be loaded.",
  "The pages people open most, and how long they stay": "The pages people open most, and how long they stay",
  "The pages your ads and links send players to. Pick a full-screen game or an offer page, add your offer, let Lumio draw its art and write its copy, then publish it on your landing domain.": "The pages your ads and links send players to. Pick a full-screen game or an offer page, add your offer, let Lumio draw its art and write its copy, then publish it on your landing domain.",
  "The password could not be changed. Try again in a moment.": "The password could not be changed. Try again in a moment.",
  "The password is not stored. Change it to set a new one.": "The password is not stored. Change it to set a new one.",
  "The person signing for the company.": "The person signing for the company.",
  "The picture may carry a drawn logo or brand name. Look it over, or generate a new version.": "The picture may carry a drawn logo or brand name. Look it over, or generate a new version.",
  "The picture may carry a drawn logo or brand name. Look it over, or redraw it.": "The picture may carry a drawn logo or brand name. Look it over, or redraw it.",
  "The plan is assigned as this affiliate's default across all brands.": "The plan is assigned as this affiliate's default across all brands.",
  "The plan is created and assigned as this affiliate's default across all brands.": "The plan is created and assigned as this affiliate's default across all brands.",
  "The plan's fixed fee is charged per affiliate each month, not per player, so it isn't included.": "The plan's fixed fee is charged per affiliate each month, not per player, so it isn't included.",
  "the preferences are loading": "the preferences are loading",
  "the preferences did not load, reload the page": "the preferences did not load, reload the page",
  "The preview couldn't be built. It retries on your next edit.": "The preview couldn't be built. It retries on your next edit.",
  "The preview couldn't be loaded.": "The preview couldn't be loaded.",
  "The preview couldn't be loaded. It retries on your next edit.": "The preview couldn't be loaded. It retries on your next edit.",
  "The price could not be read, so nothing can be charged. Open Mailbox again to retry.": "The price could not be read, so nothing can be charged. Open Mailbox again to retry.",
  "The promotion's page on your website": "The promotion's page on your website",
  "The promotion's text could not be prepared in this language.": "The promotion's text could not be prepared in this language.",
  "The provider did not say why. Contact support.": "The provider did not say why. Contact support.",
  "The same {{brand}} scene from slightly closer, warm light gathering around the \"{{headline}}\" text.": "The same {{brand}} scene from slightly closer, warm light gathering around the \"{{headline}}\" text.",
  "The samples couldn't be started. Please try again.": "The samples couldn't be started. Please try again.",
  "The scene a touch closer, with the \"{{headline}}\" offer set as bold, bright on-brand headline text across the frame.": "The scene a touch closer, with the \"{{headline}}\" offer set as bold, bright on-brand headline text across the frame.",
  "The scene fully lit and cinematic, the \"{{headline}}\" offer set as bold on-brand headline text over the new-game hero.": "The scene fully lit and cinematic, the \"{{headline}}\" offer set as bold on-brand headline text over the new-game hero.",
  "The scene fully lit and sharp, with the \"{{headline}}\" offer set as bold, on-brand headline text over the new game hero.": "The scene fully lit and sharp, with the \"{{headline}}\" offer set as bold, on-brand headline text over the new game hero.",
  "The SEO fields are written FROM the article: the meta description, the takeaways and the FAQ all describe what the body actually says.": "The SEO fields are written FROM the article: the meta description, the takeaways and the FAQ all describe what the body actually says.",
  "The setup status could not be checked. Try again in a moment.": "The setup status could not be checked. Try again in a moment.",
  "The shot list no longer matches the clip length. Regenerate the storyboard to fix it.": "The shot list no longer matches the clip length. Regenerate the storyboard to fix it.",
  "The single-clip generator: each ad is one continuous clip made from a timed shot list. Open one to edit or regenerate it, download or delete it, or create a new one.": "The single-clip generator: each ad is one continuous clip made from a timed shot list. Open one to edit or regenerate it, download or delete it, or create a new one.",
  "the site is not live yet": "the site is not live yet",
  "The size catalogue couldn't be loaded. Close the banner and open it again to retry.": "The size catalogue couldn't be loaded. Close the banner and open it again to retry.",
  "The size catalogue couldn't be loaded. Close the kit and open it again to retry.": "The size catalogue couldn't be loaded. Close the kit and open it again to retry.",
  "The software their phone or computer runs": "The software their phone or computer runs",
  "The spot where the logo goes is busy on this size. Look it over, or generate a new version.": "The spot where the logo goes is busy on this size. Look it over, or generate a new version.",
  "The spot where the logo goes is busy on this size. Look it over, or redraw it.": "The spot where the logo goes is busy on this size. Look it over, or redraw it.",
  "The storyboard couldn't be generated. Please try again.": "The storyboard couldn't be generated. Please try again.",
  "The studio that makes the games.": "The studio that makes the games.",
  "The style couldn't be deleted. Please try again.": "The style couldn't be deleted. Please try again.",
  "The style couldn't be duplicated. Please try again.": "The style couldn't be duplicated. Please try again.",
  "The style couldn't be extracted. No credits were used. Please try again.": "The style couldn't be extracted. No credits were used. Please try again.",
  "The style couldn't be extracted. Please try again.": "The style couldn't be extracted. Please try again.",
  "The style couldn't be paused. Please try again.": "The style couldn't be paused. Please try again.",
  "The style couldn't be turned on. Please try again.": "The style couldn't be turned on. Please try again.",
  "The style is set when the banner is made. Make a new HTML5 banner to use another one.": "The style is set when the banner is made. Make a new HTML5 banner to use another one.",
  "The styles couldn't be loaded. Close the banner and open it again to retry.": "The styles couldn't be loaded. Close the banner and open it again to retry.",
  "The styles couldn't be loaded. Close this and try again.": "The styles couldn't be loaded. Close this and try again.",
  "The templates couldn't be loaded, so there is nothing to preview yet.": "The templates couldn't be loaded, so there is nothing to preview yet.",
  "The templates couldn't be loaded. Close this page and open it again to retry.": "The templates couldn't be loaded. Close this page and open it again to retry.",
  "The text couldn't be prepared in this language. Open Language to try again.": "The text couldn't be prepared in this language. Open Language to try again.",
  "The title and description come from Search result.": "The title and description come from Search result.",
  "The top-up hasn't landed yet.": "The top-up hasn't landed yet.",
  "The tracking links of your ads that send visitors to this page.": "The tracking links of your ads that send visitors to this page.",
  "The version on screen goes live again at {{url}} for every visitor at once. Tracking links to this address work again.": "The version on screen goes live again at {{url}} for every visitor at once. Tracking links to this address work again.",
  "The version on screen goes live at {{url}} for every visitor at once.": "The version on screen goes live at {{url}} for every visitor at once.",
  "The version on screen replaces the live page at {{url}} for every visitor at once.": "The version on screen replaces the live page at {{url}} for every visitor at once.",
  "The video provider blocked beat {{n}} for its content policy. Retrying will not clear it. Reword that beat on the storyboard above (remove any brand names, real people, characters or logos you don't own), then resume. Your credits were refunded.": "The video provider blocked beat {{n}} for its content policy. Retrying will not clear it. Reword that beat on the storyboard above (remove any brand names, real people, characters or logos you don't own), then resume. Your credits were refunded.",
  "The video provider blocked this clip for its content policy. Edit the shot list or regenerate the storyboard, then try again. Your credits were refunded.": "The video provider blocked this clip for its content policy. Edit the shot list or regenerate the storyboard, then try again. Your credits were refunded.",
  "The video provider rejected this clip: {{reason}}. Edit the shot list or regenerate the storyboard, then try again. Your credits were refunded.": "The video provider rejected this clip: {{reason}}. Edit the shot list or regenerate the storyboard, then try again. Your credits were refunded.",
  "The website traffic request is too large to calculate": "The website traffic request is too large to calculate",
  "The website's languages could not be read.": "The website's languages could not be read.",
  "The writing itself happens afterwards and lands when it is done.": "The writing itself happens afterwards and lands when it is done.",
  "Theme": "Theme",
  "Themes": "Themes",
  "Themes catalog": "Themes catalog",
  "Then {{price}} each month starting on {{date}}.": "Then {{price}} each month starting on {{date}}.",
  "Then click Verify in Search Console. Google can take a few minutes, sometimes up to a day, to see the record.": "Then click Verify in Search Console. Google can take a few minutes, sometimes up to a day, to see the record.",
  "There aren't enough AI credits for this article. Top up your balance and ask me again.": "There aren't enough AI credits for this article. Top up your balance and ask me again.",
  "There is no finished website art to switch to yet. Regenerate your website art first.": "There is no finished website art to switch to yet. Regenerate your website art first.",
  "There were no browsers {{previous}}.": "There were no browsers {{previous}}.",
  "There were no people {{previous}}.": "There were no people {{previous}}.",
  "There were no visitors {{previous}}.": "There were no visitors {{previous}}.",
  "There's no room left to keep this logo on this device. Restore a logo you replaced earlier, then try again.": "There's no room left to keep this logo on this device. Restore a logo you replaced earlier, then try again.",
  "These come from your site's template and show on every site built on it, so they can't be changed for one brand.": "These come from your site's template and show on every site built on it, so they can't be changed for one brand.",
  "These details are valid until {{date}}.": "These details are valid until {{date}}.",
  "These exact words are painted into every size and checked on each render.": "These exact words are painted into every size and checked on each render.",
  "These numbers are {{n}} minutes old. Newer visits show after the next update.": "These numbers are {{n}} minutes old. Newer visits show after the next update.",
  "These samples couldn't be drawn. Your credits were refunded.": "These samples couldn't be drawn. Your credits were refunded.",
  "They stay as they are.": "They stay as they are.",
  "this ad": "this ad",
  "This article": "This article",
  "This article does not exist anymore.": "This article does not exist anymore.",
  "This article is live": "This article is live",
  "This article will be deleted permanently, along with everything written in it. This cannot be undone.": "This article will be deleted permanently, along with everything written in it. This cannot be undone.",
  "This background may carry lettering or a sign. Look it over, or generate again.": "This background may carry lettering or a sign. Look it over, or generate again.",
  "This background may show coins, chips or cards. Look it over, or generate again.": "This background may show coins, chips or cards. Look it over, or generate again.",
  "This banner has no definition to draw from any more. Start from the current banner instead.": "This banner has no definition to draw from any more. Start from the current banner instead.",
  "This banner kit couldn't be generated": "This banner kit couldn't be generated",
  "This banner's new look couldn't be drawn": "This banner's new look couldn't be drawn",
  "This beat took too long and was stopped. Try a shorter duration, then resume.": "This beat took too long and was stopped. Try a shorter duration, then resume.",
  "This blog was suspended by the platform.": "This blog was suspended by the platform.",
  "This brand has no active gamification features yet.": "This brand has no active gamification features yet.",
  "This brand has no domain on record, so it has no mail yet.": "This brand has no domain on record, so it has no mail yet.",
  "This brand has no landing domain yet": "This brand has no landing domain yet",
  "This brand has no landing domain yet, so the page cannot be published. Once your landing domain is set up, publish it from here.": "This brand has no landing domain yet, so the page cannot be published. Once your landing domain is set up, publish it from here.",
  "This brand has no landing page yet.": "This brand has no landing page yet.",
  "This brand has no marketing offers yet.": "This brand has no marketing offers yet.",
  "This brand has no promotion art yet.": "This brand has no promotion art yet.",
  "This brand has no promotions yet. Create one in All Promotions & Creatives first.": "This brand has no promotions yet. Create one in All Promotions & Creatives first.",
  "This brand has no website address yet.": "This brand has no website address yet.",
  "This brand has no website address yet. Pick a landing page, or try again once the website is set up.": "This brand has no website address yet. Pick a landing page, or try again once the website is set up.",
  "This brand is still loading. Please try again in a moment.": "This brand is still loading. Please try again in a moment.",
  "This brand needs a marketing offer": "This brand needs a marketing offer",
  "This brand needs a marketing offer first: a quick landing page promotes it.": "This brand needs a marketing offer first: a quick landing page promotes it.",
  "This brand's blog is not turned on yet.": "This brand's blog is not turned on yet.",
  "This brand's blog is not turned on yet. Use the switch beside the page title.": "This brand's blog is not turned on yet. Use the switch beside the page title.",
  "This browser won't let us keep your logo. Check its privacy settings and try again.": "This browser won't let us keep your logo. Check its privacy settings and try again.",
  "This checkout is no longer active. Go back and start again to pick up where you left off.": "This checkout is no longer active. Go back and start again to pick up where you left off.",
  "This code has expired. Request a new one below.": "This code has expired. Request a new one below.",
  "This costs {{n}} credits": "This costs {{n}} credits",
  "This device": "This device",
  "This domain already has the maximum number of Google verification records.": "This domain already has the maximum number of Google verification records.",
  "This domain can't be used. Please enter a domain you own.": "This domain can't be used. Please enter a domain you own.",
  "This domain is already used by another Whitelabels.com instance and can't be connected. Contact support@whitelabels.com for further assistance.": "This domain is already used by another Whitelabels.com instance and can't be connected. Contact support@whitelabels.com for further assistance.",
  "This draws all {{n}} of the banner's formats (one per aspect ratio) so every placement on your site fits and stays in sync.": "This draws all {{n}} of the banner's formats (one per aspect ratio) so every placement on your site fits and stays in sync.",
  "This draws just the main banner so you can iterate fast. Generate its other formats when you're ready to publish.": "This draws just the main banner so you can iterate fast. Generate its other formats when you're ready to publish.",
  "This environment supports one choice per filter.": "This environment supports one choice per filter.",
  "This feature is not available.": "This feature is not available.",
  "This field is required": "This field is required",
  "This game has no extra settings.": "This game has no extra settings.",
  "This HTML5 banner's art couldn't be generated": "This HTML5 banner's art couldn't be generated",
  "This image banner couldn't be generated": "This image banner couldn't be generated",
  "This image banner has no render for this size.": "This image banner has no render for this size.",
  "This image can't be redrawn right now.": "This image can't be redrawn right now.",
  "This image is a different shape from the {{ratio}} this logo uses, so it will sit with empty space around it wherever the logo appears.": "This image is a different shape from the {{ratio}} this logo uses, so it will sit with empty space around it wherever the logo appears.",
  "This image is smaller than the recommended {{width}} × {{height}} px, so it may look soft on sharper screens.": "This image is smaller than the recommended {{width}} × {{height}} px, so it may look soft on sharper screens.",
  "This is a paid mailbox.": "This is a paid mailbox.",
  "This is taking a little longer than usual.": "This is taking a little longer than usual.",
  "This is where you grow: the features you offer, the campaigns that bring players, the promotions that keep them.": "This is where you grow: the features you offer, the campaigns that bring players, the promotions that keep them.",
  "This is where your money movements land: monthly credit settlements, marketing and affiliate spend, and platform invoices.": "This is where your money movements land: monthly credit settlements, marketing and affiliate spend, and platform invoices.",
  "This is your draft as it stands, including changes you have not saved yet.": "This is your draft as it stands, including changes you have not saved yet.",
  "this landing page": "this landing page",
  "This landing page couldn't be generated": "This landing page couldn't be generated",
  "This landing page is not live": "This landing page is not live",
  "This landing page needs {{n}} more credits.": "This landing page needs {{n}} more credits.",
  "This link is invalid or has expired": "This link is invalid or has expired",
  "This list has unpublished changes.": "This list has unpublished changes.",
  "This list isn't on this page. Your draft shows wherever the list appears.": "This list isn't on this page. Your draft shows wherever the list appears.",
  "This logo is being updated": "This logo is being updated",
  "This look isn't available for your site.": "This look isn't available for your site.",
  "This mailbox can be set up once its domain is ready to receive mail.": "This mailbox can be set up once its domain is ready to receive mail.",
  "This mailbox costs {{price}}.": "This mailbox costs {{price}}.",
  "This mailbox is free of charge.": "This mailbox is free of charge.",
  "This mini-game's art couldn't be generated": "This mini-game's art couldn't be generated",
  "This month": "This month",
  "This month to date · figures in USD": "This month to date · figures in USD",
  "This month's Overview": "This month's Overview",
  "This name identifies your party in the contract.": "This name identifies your party in the contract.",
  "This network requires a destination tag / memo. Sending without it can permanently lose your funds.": "This network requires a destination tag / memo. Sending without it can permanently lose your funds.",
  "This new image can't be applied anymore.": "This new image can't be applied anymore.",
  "This new image expired before it was applied.": "This new image expired before it was applied.",
  "This new image is already live on your site.": "This new image is already live on your site.",
  "This one didn't draw. Your credits were refunded.": "This one didn't draw. Your credits were refunded.",
  "This one is free, forever.": "This one is free, forever.",
  "This order is not saved yet.": "This order is not saved yet.",
  "This pack cannot be purchased right now. Please try again.": "This pack cannot be purchased right now. Please try again.",
  "This page can't be arranged here": "This page can't be arranged here",
  "This page has nothing to preview.": "This page has nothing to preview.",
  "This page is about no promotion: it carries the offer alone.": "This page is about no promotion: it carries the offer alone.",
  "This page is live and the ad's tracking link goes here.": "This page is live and the ad's tracking link goes here.",
  "This page is live and the ads' tracking links go here.": "This page is live and the ads' tracking links go here.",
  "This page is live, but {{name}}'s tracking link doesn't go to it yet.": "This page is live, but {{name}}'s tracking link doesn't go to it yet.",
  "This page isn't in play.": "This page isn't in play.",
  "This page no longer exists on your site; its meta is not published. Delete the route or pick another page.": "This page no longer exists on your site; its meta is not published. Delete the route or pick another page.",
  "This page of your website does not show any game lists.": "This page of your website does not show any game lists.",
  "This page was made outside the Studio. You can view it and copy its address here, but it can only be edited where it was made.": "This page was made outside the Studio. You can view it and copy its address here, but it can only be edited where it was made.",
  "This page wasn't made in Studio, so the sign-ups its tracking links bring in can't be counted here yet.": "This page wasn't made in Studio, so the sign-ups its tracking links bring in can't be counted here yet.",
  "This page's address is dynamic: the same title and description apply to every page under it.": "This page's address is dynamic: the same title and description apply to every page under it.",
  "This page's footer text is set on Site defaults.": "This page's footer text is set on Site defaults.",
  "This page's own link": "This page's own link",
  "This page's own link, separate from your ads' tracking links. Share it yourself anywhere (a post, a message, an email): the sign-ups it brings are credited to this page.": "This page's own link, separate from your ads' tracking links. Share it yourself anywhere (a post, a message, an email): the sign-ups it brings are credited to this page.",
  "This permanently deletes the website you started building. This can't be undone.": "This permanently deletes the website you started building. This can't be undone.",
  "This permanently destroys the mailbox and everything in it. It cannot be undone. The address becomes available again.": "This permanently destroys the mailbox and everything in it. It cannot be undone. The address becomes available again.",
  "This permanently destroys the mailbox and the {{n}} messages in it. It cannot be undone. The address becomes available again.": "This permanently destroys the mailbox and the {{n}} messages in it. It cannot be undone. The address becomes available again.",
  "This promotion has no key art to animate. Pick another one.": "This promotion has no key art to animate. Pick another one.",
  "This replaces your live art": "This replaces your live art",
  "This reset link is invalid or has expired": "This reset link is invalid or has expired",
  "This scene has not been generated yet.": "This scene has not been generated yet.",
  "This section is being built.": "This section is being built.",
  "This settles your pending invoice and activates {{name}} {{tier}}.": "This settles your pending invoice and activates {{name}} {{tier}}.",
  "This signs out only this support agent session. Any other sessions for this account stay signed in.": "This signs out only this support agent session. Any other sessions for this account stay signed in.",
  "This size couldn't be separated into layers. Your credits were refunded.": "This size couldn't be separated into layers. Your credits were refunded.",
  "This size is redrawn from the same hero image. The other sizes stay as they are.": "This size is redrawn from the same hero image. The other sizes stay as they are.",
  "This size is redrawn from the same hero image. The rest of the kit stays as it is.": "This size is redrawn from the same hero image. The rest of the kit stays as it is.",
  "This slug is already used by another article": "This slug is already used by another article",
  "This slug is already used by another category": "This slug is already used by another category",
  "This step is coming soon.": "This step is coming soon.",
  "This style is in use": "This style is in use",
  "This subject has no headline to put on the banners.": "This subject has no headline to put on the banners.",
  "This takes a moment. You can leave this page; setup continues without you.": "This takes a moment. You can leave this page; setup continues without you.",
  "This takes about a minute or two. The link appears here once the page is live.": "This takes about a minute or two. The link appears here once the page is live.",
  "This Telegram account is already linked to another account.": "This Telegram account is already linked to another account.",
  "This template is drawn for a {{aspect}} image.": "This template is drawn for a {{aspect}} image.",
  "This template isn't available any more. Pick another one.": "This template isn't available any more. Pick another one.",
  "This template shows up to {{n}} steps.": "This template shows up to {{n}} steps.",
  "This usually takes a few minutes. You can leave this page; the ad will be here when you come back.": "This usually takes a few minutes. You can leave this page; the ad will be here when you come back.",
  "This usually takes about {{minutes}} minutes. You can leave this page; the ad will be here when you come back.": "This usually takes about {{minutes}} minutes. You can leave this page; the ad will be here when you come back.",
  "This version already holds everything you ticked.": "This version already holds everything you ticked.",
  "This version has its art. Generate again for a fresh set; copy and settings never need new art.": "This version has its art. Generate again for a fresh set; copy and settings never need new art.",
  "This version has its art. Generate again for a fresh set; copy and sizes you already have never need new art.": "This version has its art. Generate again for a fresh set; copy and sizes you already have never need new art.",
  "This version has no hero image yet. Generate one with Lumio or use your own.": "This version has no hero image yet. Generate one with Lumio or use your own.",
  "This version is generated. An edit starts a new version from it.": "This version is generated. An edit starts a new version from it.",
  "This version is generated. Edit anything to start a new version.": "This version is generated. Edit anything to start a new version.",
  "This version is generated. Start a new version from it to change it.": "This version is generated. Start a new version from it to change it.",
  "This version is live": "This version is live",
  "This version is the live one.": "This version is the live one.",
  "This version only has its main banner so far. Generate its other formats to use it across every spot on your site.": "This version only has its main banner so far. Generate its other formats to use it across every spot on your site.",
  "This voucher code isn't valid.": "This voucher code isn't valid.",
  "This voucher has already been used.": "This voucher has already been used.",
  "This week": "This week",
  "Those formats couldn't be generated. Please try again.": "Those formats couldn't be generated. Please try again.",
  "Three steps, under a minute": "Three steps, under a minute",
  "Through: {{name}}": "Through: {{name}}",
  "Thu": "Thu",
  "Thunderbird": "Thunderbird",
  "Tiered": "Tiered",
  "Tiered rev share": "Tiered rev share",
  "Tiered, from {{percent}}%": "Tiered, from {{percent}}%",
  "Time": "Time",
  "Time on page": "Time on page",
  "Time on site": "Time on site",
  "Time range": "Time range",
  "Times these pages were opened": "Times these pages were opened",
  "Times this page was opened": "Times this page was opened",
  "Times your website was opened": "Times your website was opened",
  "Tip": "Tip",
  "Title": "Title",
  "Title length 1–60": "Title length 1–60",
  "Title not used by another page": "Title not used by another page",
  "Title starts with the focus keyword": "Title starts with the focus keyword",
  "Title template": "Title template",
  "Title template: {{template}}, set automatically, not written by Lumio": "Title template: {{template}}, set automatically, not written by Lumio",
  "TL": "TL",
  "To": "To",
  "to {{to}}": "to {{to}}",
  "To date": "To date",
  "To your payout method": "To your payout method",
  "today": "today",
  "Today": "Today",
  "Today's Performance": "Today's Performance",
  "Toggle {{name}}": "Toggle {{name}}",
  "Token / asset": "Token / asset",
  "Tone of voice": "Tone of voice",
  "Too many filter conditions. Remove a choice to continue.": "Too many filter conditions. Remove a choice to continue.",
  "Top 10 Websites": "Top 10 Websites",
  "Top games": "Top games",
  "Top Games": "Top Games",
  "Top marketing assets": "Top marketing assets",
  "Top nav (desktop)": "Top nav (desktop)",
  "Top nav (mobile)": "Top nav (mobile)",
  "Top navigation": "Top navigation",
  "Top pick": "Top pick",
  "Top Players": "Top Players",
  "Top up": "Top up",
  "Top up ${{tuAmount}}": "Top up ${{tuAmount}}",
  "Top Up ${{tuAmount}}": "Top Up ${{tuAmount}}",
  "Top up Amount": "Top up Amount",
  "Top Up Budget": "Top Up Budget",
  "Top up your credits, then try again.": "Top up your credits, then try again.",
  "Topic": "Topic",
  "Total": "Total",
  "Total acquisition spend": "Total acquisition spend",
  "TOTAL AVAILABLE BALANCE": "TOTAL AVAILABLE BALANCE",
  "Total commission": "Total commission",
  "Total Commission": "Total Commission",
  "Total Cost": "Total Cost",
  "TOTAL DEDUCTIONS": "TOTAL DEDUCTIONS",
  "Total deposited by FTDs": "Total deposited by FTDs",
  "Total due today": "Total due today",
  "Total Spend": "Total Spend",
  "Total spend cap across all channels, per day": "Total spend cap across all channels, per day",
  "Total Turnover": "Total Turnover",
  "Tournament": "Tournament",
  "TR": "TR",
  "Tracking link": "Tracking link",
  "Tracking Link (optional)": "Tracking Link (optional)",
  "Tracking link created. It sends people to {{where}}.": "Tracking link created. It sends people to {{where}}.",
  "Tracking link created. It sends people to your website.": "Tracking link created. It sends people to your website.",
  "Tracking link ready": "Tracking link ready",
  "Tracking links": "Tracking links",
  "Tracking links of your ads that send visitors to this page": "Tracking links of your ads that send visitors to this page",
  "Tracking the conversion from Handle to Gross Profit": "Tracking the conversion from Handle to Gross Profit",
  "Traffic breakdown": "Traffic breakdown",
  "Transaction details": "Transaction details",
  "Transaction receipt": "Transaction receipt",
  "Transfer": "Transfer",
  "Transfer registered": "Transfer registered",
  "Transfer these details from your bank": "Transfer these details from your bank",
  "Translated title": "Translated title",
  "Translation of": "Translation of",
  "Transparent background": "Transparent background",
  "Tron (TRC-20)": "Tron (TRC-20)",
  "True Cost / FTD": "True Cost / FTD",
  "Try again": "Try again",
  "Try it": "Try it",
  "Trying a new camera angle for scene {{n}}": "Trying a new camera angle for scene {{n}}",
  "Trying the clip again with safer settings": "Trying the clip again with safer settings",
  "TTL": "TTL",
  "TTL (Seconds)": "TTL (Seconds)",
  "TTL copied to clipboard": "TTL copied to clipboard",
  "Tuned to work best for": "Tuned to work best for",
  "Turn a promotion's key art into a short, premium video clip with Lumio.": "Turn a promotion's key art into a short, premium video clip with Lumio.",
  "Turn affiliate players into depositors": "Turn affiliate players into depositors",
  "Turn Autopilot on or off": "Turn Autopilot on or off",
  "Turn Autopilot on?": "Turn Autopilot on?",
  "Turn off": "Turn off",
  "Turn on": "Turn on",
  "Turn on a kit to see its sizes here.": "Turn on a kit to see its sizes here.",
  "Turn on at least one size to generate.": "Turn on at least one size to generate.",
  "Turn on for adult-oriented styles: images are drawn with Seedream": "Turn on for adult-oriented styles: images are drawn with Seedream",
  "Turn on later": "Turn on later",
  "Turn the blog off?": "Turn the blog off?",
  "Turn the blog on": "Turn the blog on",
  "Turn the blog on or off": "Turn the blog on or off",
  "Turn the button on to add a call to action.": "Turn the button on to add a call to action.",
  "Turning it back on can be refused for up to 24 hours after the last time the blog was enabled.": "Turning it back on can be refused for up to 24 hours after the last time the blog was enabled.",
  "Turnover / FTD": "Turnover / FTD",
  "Tweaking scene {{n}} to follow content guidelines": "Tweaking scene {{n}} to follow content guidelines",
  "Two characters are picked. Remove one to pick another.": "Two characters are picked. Remove one to pick another.",
  "Type": "Type",
  "Type a label, then Enter": "Type a label, then Enter",
  "Type any address": "Type any address",
  "Type DELETE to confirm": "Type DELETE to confirm",
  "Type the address and click Connect.": "Type the address and click Connect.",
  "Type to search your site's pages": "Type to search your site's pages",
  "Type your own domain name here": "Type your own domain name here",
  "Type your own name here": "Type your own name here",
  "Typed in or bookmarked": "Typed in or bookmarked",
  "UK and EU": "UK and EU",
  "Unallocated ${{amount}}": "Unallocated ${{amount}}",
  "Unavailable game": "Unavailable game",
  "Unavailable game (ID {{id}})": "Unavailable game (ID {{id}})",
  "Unclassified": "Unclassified",
  "Under a minute": "Under a minute",
  "Under the offer": "Under the offer",
  "Understand what lies ahead to make informed choices from day one.": "Understand what lies ahead to make informed choices from day one.",
  "Undo": "Undo",
  "Undo last publish": "Undo last publish",
  "Undo publish": "Undo publish",
  "Undo your last publish?": "Undo your last publish?",
  "Undoing…": "Undoing…",
  "Unique tracking link": "Unique tracking link",
  "Unique Tracking Link": "Unique Tracking Link",
  "United States": "United States",
  "Unknown": "Unknown",
  "Unknown affiliate": "Unknown affiliate",
  "Unknown device": "Unknown device",
  "Unknown location": "Unknown location",
  "Unknown player": "Unknown player",
  "Unknown provider": "Unknown provider",
  "Unlocking soon": "Unlocking soon",
  "Unnamed character": "Unnamed character",
  "Unnamed mascot": "Unnamed mascot",
  "Unpublish": "Unpublish",
  "Unpublish and archive": "Unpublish and archive",
  "Unpublish and archive?": "Unpublish and archive?",
  "Unpublish the article before deleting it": "Unpublish the article before deleting it",
  "Unpublish this article?": "Unpublish this article?",
  "Unpublish this landing page?": "Unpublish this landing page?",
  "Unpublished": "Unpublished",
  "Unpublished changes": "Unpublished changes",
  "Unpublished landing page · {{url}}": "Unpublished landing page · {{url}}",
  "Unpublishing…": "Unpublishing…",
  "Unread mail waiting": "Unread mail waiting",
  "Until {{date}}": "Until {{date}}",
  "Untitled": "Untitled",
  "Untitled article": "Untitled article",
  "Untitled banner kit": "Untitled banner kit",
  "Untitled conversation": "Untitled conversation",
  "Untitled creative": "Untitled creative",
  "Untitled HTML5 banner": "Untitled HTML5 banner",
  "Untitled image banner": "Untitled image banner",
  "Untitled landing page": "Untitled landing page",
  "Untitled look": "Untitled look",
  "Untitled mini-game": "Untitled mini-game",
  "Untitled style": "Untitled style",
  "Untitled video ad": "Untitled video ad",
  "Up to {{n}} days.": "Up to {{n}} days.",
  "Up to {{n}} images of your own brand character. Used wherever it fits.": "Up to {{n}} images of your own brand character. Used wherever it fits.",
  "Up to {{n}} images that set the whole video's look and feel.": "Up to {{n}} images that set the whole video's look and feel.",
  "Up to {{n}} images. They set the look: rendering, light, materials and colour.": "Up to {{n}} images. They set the look: rendering, light, materials and colour.",
  "Up to {{n}} steps": "Up to {{n}} steps",
  "Up to 5 keywords: one focus keyword and four secondary ones": "Up to 5 keywords: one focus keyword and four secondary ones",
  "Update": "Update",
  "Update live page": "Update live page",
  "Update the live page?": "Update the live page?",
  "Updated": "Updated",
  "Updated {{date}}": "Updated {{date}}",
  "Updated {{n}} minutes ago.": "Updated {{n}} minutes ago.",
  "Updated Ads Budget": "Updated Ads Budget",
  "Updated after each save": "Updated after each save",
  "Updating {{label}}… this can take a few minutes.": "Updating {{label}}… this can take a few minutes.",
  "Updating the preview…": "Updating the preview…",
  "Updating your balance…": "Updating your balance…",
  "Updating your wallet balance…": "Updating your wallet balance…",
  "Updating…": "Updating…",
  "Upgrade cancelled for {{name}}": "Upgrade cancelled for {{name}}",
  "Upgrade now": "Upgrade now",
  "Upgrade to {{tier}} to unlock": "Upgrade to {{tier}} to unlock",
  "Upgrade to Level {{level}} to unlock": "Upgrade to Level {{level}} to unlock",
  "Upload": "Upload",
  "Upload & regenerate": "Upload & regenerate",
  "Upload a custom logo": "Upload a custom logo",
  "Upload a hero image": "Upload a hero image",
  "Upload an image": "Upload an image",
  "Upload another logo": "Upload another logo",
  "Upload your own": "Upload your own",
  "Upload your own artwork and Lumio fits it to this spot.": "Upload your own artwork and Lumio fits it to this spot.",
  "Upload your own image to swap this banner out": "Upload your own image to swap this banner out",
  "Upload your own logo": "Upload your own logo",
  "Uploaded logo": "Uploaded logo",
  "Uploading the image…": "Uploading the image…",
  "Uploading your logo and removing its background…": "Uploading your logo and removing its background…",
  "Uploading…": "Uploading…",
  "URL": "URL",
  "Use * only at the end, as /prefix/*": "Use * only at the end, as /prefix/*",
  "Use a full https address on {{host}}": "Use a full https address on {{host}}",
  "Use a JPG, PNG, GIF or WEBP image": "Use a JPG, PNG, GIF or WEBP image",
  "Use a number from {{min}} to {{max}}.": "Use a number from {{min}} to {{max}}.",
  "Use a valid number.": "Use a valid number.",
  "Use an https:// address or a path that starts with /": "Use an https:// address or a path that starts with /",
  "Use art from your promotions": "Use art from your promotions",
  "Use at least {{n}} characters.": "Use at least {{n}} characters.",
  "Use at least 8 characters.": "Use at least 8 characters.",
  "Use at most {{max}} characters.": "Use at most {{max}} characters.",
  "Use at most {{n}} characters.": "Use at most {{n}} characters.",
  "Use at most 54 characters.": "Use at most 54 characters.",
  "Use letters, numbers, dots or dashes only.": "Use letters, numbers, dots or dashes only.",
  "Use lowercase letters, digits, hyphens and underscores only.": "Use lowercase letters, digits, hyphens and underscores only.",
  "Use Lumio's hero instead": "Use Lumio's hero instead",
  "Use my brand": "Use my brand",
  "Use one of the following options to activate your monthly subscription": "Use one of the following options to activate your monthly subscription",
  "Use our professional tools to boost your brand visibility and draw in more players.": "Use our professional tools to boost your brand visibility and draw in more players.",
  "Use selected features": "Use selected features",
  "Use selected games": "Use selected games",
  "Use site default": "Use site default",
  "Use suggested name": "Use suggested name",
  "Use the following configuration to connect your domain with your casino on Whitelabels.com. Domain propagation can take anywhere from 5 mins to 48 hours.": "Use the following configuration to connect your domain with your casino on Whitelabels.com. Domain propagation can take anywhere from 5 mins to 48 hours.",
  "Use the up and down arrows to reorder, then Publish to site to commit.": "Use the up and down arrows to reorder, then Publish to site to commit.",
  "Use these images when drawing": "Use these images when drawing",
  "Use this banner as the background": "Use this banner as the background",
  "Use this image": "Use this image",
  "Use this promotion": "Use this promotion",
  "Use this style": "Use this style",
  "Use this theme": "Use this theme",
  "Use your own artwork": "Use your own artwork",
  "Used as your website favicon, the small icon in the browser tab.": "Used as your website favicon, the small icon in the browser tab.",
  "Used in your website footer.": "Used in your website footer.",
  "Used in your website header and in the emails your players receive.": "Used in your website header and in the emails your players receive.",
  "Used in your website header at some screen sizes.": "Used in your website header at some screen sizes.",
  "Used in your website header on mobile.": "Used in your website header on mobile.",
  "Used on your loading and splash screens.": "Used on your loading and splash screens.",
  "User list": "User list",
  "Uses the template's default.": "Uses the template's default.",
  "Using {{language}}": "Using {{language}}",
  "Valuation Revenue x Network Multiple": "Valuation Revenue x Network Multiple",
  "Value": "Value",
  "Value copied to clipboard": "Value copied to clipboard",
  "VAT number (optional)": "VAT number (optional)",
  "Vector file · scales to any size": "Vector file · scales to any size",
  "Venezuelan": "Venezuelan",
  "Verification record added to {{domain}}": "Verification record added to {{domain}}",
  "Verification records": "Verification records",
  "Verified bots": "Verified bots",
  "Verify that you own {{domain}} in Google Search Console to see how your site performs in Google Search.": "Verify that you own {{domain}} in Google Search Console to see how your site performs in Google Search.",
  "Verify your email": "Verify your email",
  "Verify your email to continue": "Verify your email to continue",
  "Verify your email to unlock brand deployment. Check your inbox for the confirmation link.": "Verify your email to unlock brand deployment. Check your inbox for the confirmation link.",
  "Verify your Owner Hub email address to see affiliate stats.": "Verify your Owner Hub email address to see affiliate stats.",
  "Verify your Owner Hub email address to use affiliates.": "Verify your Owner Hub email address to use affiliates.",
  "Verifying your email...": "Verifying your email...",
  "Version": "Version",
  "Version {{n}}": "Version {{n}}",
  "Version archived.": "Version archived.",
  "Version deleted.": "Version deleted.",
  "Version recovered.": "Version recovered.",
  "Versions": "Versions",
  "Versions workspace": "Versions workspace",
  "via": "via",
  "Via landing page": "Via landing page",
  "Vibe": "Vibe",
  "Vibrant push-in through neon glow and reflections as the \"{{headline}}\" offer flickers in as bold, electric on-brand headline text.": "Vibrant push-in through neon glow and reflections as the \"{{headline}}\" offer flickers in as bold, electric on-brand headline text.",
  "Video": "Video",
  "Video ${{amount}}": "Video ${{amount}}",
  "Video ad": "Video ad",
  "Video ad name": "Video ad name",
  "Video ad performance": "Video ad performance",
  "Video ad ready": "Video ad ready",
  "video ads": "video ads",
  "Video ads": "Video ads",
  "Video Ads": "Video Ads",
  "Video Ads can't open without their prices, which could not be read. Try again in a moment.": "Video Ads can't open without their prices, which could not be read. Try again in a moment.",
  "Video ads for this category are coming soon. For now, you can advertise a promotion.": "Video ads for this category are coming soon. For now, you can advertise a promotion.",
  "Video Ads v2.0": "Video Ads v2.0",
  "Video generation is off for this art style": "Video generation is off for this art style",
  "Video model": "Video model",
  "Video stops the scroll on social feeds.": "Video stops the scroll on social feeds.",
  "Video stops the scroll. Turn a promotion or a game into a short video ad for social and ad networks.": "Video stops the scroll. Turn a promotion or a game into a short video ad for social and ad networks.",
  "Video stops the scroll. Turn a promotion or a game into a short video ad for social feeds and ad networks: a storyboard first, then the clip.": "Video stops the scroll. Turn a promotion or a game into a short video ad for social feeds and ad networks: a storyboard first, then the clip.",
  "Video URL (optional)": "Video URL (optional)",
  "Videos": "Videos",
  "View": "View",
  "View {{email}}": "View {{email}}",
  "View {{title}} details": "View {{title}} details",
  "View articles": "View articles",
  "View beat": "View beat",
  "View deploy steps": "View deploy steps",
  "View deployment status": "View deployment status",
  "View deployment status for {{name}}": "View deployment status for {{name}}",
  "View details": "View details",
  "View DNS settings": "View DNS settings",
  "View DNS Settings": "View DNS Settings",
  "View final prompt": "View final prompt",
  "View in Creatives": "View in Creatives",
  "View invoice": "View invoice",
  "View invoice {{number}}": "View invoice {{number}}",
  "View linked invoice": "View linked invoice",
  "View on site": "View on site",
  "View performance": "View performance",
  "View status": "View status",
  "Views": "Views",
  "Views are not available right now": "Views are not available right now",
  "Views are not collected yet": "Views are not collected yet",
  "VIP": "VIP",
  "VIP Contribution": "VIP Contribution",
  "VIP luxury": "VIP luxury",
  "Viral moment": "Viral moment",
  "Visa": "Visa",
  "Visit Brand": "Visit Brand",
  "Visit now": "Visit now",
  "Visit site": "Visit site",
  "Visitor counts are unavailable for this selection by page or over time.": "Visitor counts are unavailable for this selection by page or over time.",
  "Visitor stats show up here once your website is published and people start visiting it.": "Visitor stats show up here once your website is published and people start visiting it.",
  "Visitors": "Visitors",
  "Visitors on each of your addresses": "Visitors on each of your addresses",
  "Visitors over time": "Visitors over time",
  "Visitors who open this link land on the casino homepage and the link loses its tracking. Publish the page again, or pick another destination.": "Visitors who open this link land on the casino homepage and the link loses its tracking. Publish the page again, or pick another destination.",
  "Visits": "Visits",
  "Visits are tracking sessions. One person can make several visits.": "Visits are tracking sessions. One person can make several visits.",
  "Visits show up here a few minutes after people open the page.": "Visits show up here a few minutes after people open the page.",
  "Visits show up here a few minutes after people open the pages.": "Visits show up here a few minutes after people open the pages.",
  "Visits show up here a few minutes after people open your website.": "Visits show up here a few minutes after people open your website.",
  "Voucher code": "Voucher code",
  "vs before": "vs before",
  "vs last": "vs last",
  "vs last 6 months": "vs last 6 months",
  "vs last 90 days": "vs last 90 days",
  "vs last month": "vs last month",
  "vs last week": "vs last week",
  "vs last year": "vs last year",
  "vs market": "vs market",
  "vs prev period": "vs prev period",
  "vs previous 2 years": "vs previous 2 years",
  "vs previous 30 days": "vs previous 30 days",
  "vs previous 6 months": "vs previous 6 months",
  "vs previous 60 days": "vs previous 60 days",
  "vs previous 7 days": "vs previous 7 days",
  "vs previous 90 days": "vs previous 90 days",
  "vs previous day": "vs previous day",
  "vs previous year": "vs previous year",
  "vs the {{n}} days before": "vs the {{n}} days before",
  "vs the 30 days before": "vs the 30 days before",
  "vs the 7 days before": "vs the 7 days before",
  "vs the 90 days before": "vs the 90 days before",
  "vs the day before": "vs the day before",
  "vs yesterday": "vs yesterday",
  "vs yesterday at this time": "vs yesterday at this time",
  "VS. Whitelabels.com Network": "VS. Whitelabels.com Network",
  "Wagered per depositor": "Wagered per depositor",
  "Wait for Lumio to finish.": "Wait for Lumio to finish.",
  "Waiting for a free video slot": "Waiting for a free video slot",
  "Waiting for DNS": "Waiting for DNS",
  "Waiting for its turn": "Waiting for its turn",
  "Waiting for your deposit…": "Waiting for your deposit…",
  "Waiting for your site to finish other changes…": "Waiting for your site to finish other changes…",
  "Wallet": "Wallet",
  "WALLET": "WALLET",
  "Wallet activity": "Wallet activity",
  "Wallet address": "Wallet address",
  "Wallet deposit": "Wallet deposit",
  "Wallet history": "Wallet history",
  "Want a different logo?": "Want a different logo?",
  "Want a free mailbox?": "Want a free mailbox?",
  "Want a personalized art style?": "Want a personalized art style?",
  "Want new banners?": "Want new banners?",
  "Want partners to bring you players?": "Want partners to bring you players?",
  "Want the blog live?": "Want the blog live?",
  "Want to change what players meet first?": "Want to change what players meet first?",
  "Want to create {{kind}}?": "Want to create {{kind}}?",
  "Want to personalize this banner?": "Want to personalize this banner?",
  "Warmer, more gold, keep it premium": "Warmer, more gold, keep it premium",
  "Warming up the CDN edge nodes": "Warming up the CDN edge nodes",
  "Watch": "Watch",
  "We are still setting up visitor stats for your website. Please check back soon.": "We are still setting up visitor stats for your website. Please check back soon.",
  "We Bring the Tools": "We Bring the Tools",
  "We can set up your {{provider}} domain for you automatically.": "We can set up your {{provider}} domain for you automatically.",
  "We can't check your player count right now, so replacing logos is unavailable for the moment. Everything else here still works.": "We can't check your player count right now, so replacing logos is unavailable for the moment. Everything else here still works.",
  "We could not check how fresh these numbers are.": "We could not check how fresh these numbers are.",
  "We could not create your account": "We could not create your account",
  "We could not load this chart. Try again in a moment.": "We could not load this chart. Try again in a moment.",
  "We could not load this. Try again in a moment.": "We could not load this. Try again in a moment.",
  "We could not load your pages. Try again in a moment.": "We could not load your pages. Try again in a moment.",
  "We could not load your visitor numbers.": "We could not load your visitor numbers.",
  "We could not load your website stats": "We could not load your website stats",
  "We could not make the PDF. Please try again.": "We could not make the PDF. Please try again.",
  "We couldn't add the record right now. Please try again.": "We couldn't add the record right now. Please try again.",
  "We couldn't change your password. Please try again.": "We couldn't change your password. Please try again.",
  "We couldn't check {{domain}} right now.": "We couldn't check {{domain}} right now.",
  "We couldn't check whether {{domain}} already receives email. You can continue; if mail is set up elsewhere, forwarding will replace it.": "We couldn't check whether {{domain}} already receives email. You can continue; if mail is set up elsewhere, forwarding will replace it.",
  "We couldn't check your domain right now.": "We couldn't check your domain right now.",
  "We couldn't find any creatives for this brand yet. Once your site's banners are generated, they'll appear here to edit.": "We couldn't find any creatives for this brand yet. Once your site's banners are generated, they'll appear here to edit.",
  "We couldn't find your logo yet.": "We couldn't find your logo yet.",
  "We couldn't get your Pix code. Check your connection and try again.": "We couldn't get your Pix code. Check your connection and try again.",
  "We couldn't get your transfer details. Check your connection and try again.": "We couldn't get your transfer details. Check your connection and try again.",
  "We couldn't load a live preview for this brand yet. You can still edit each banner in the Banners tab.": "We couldn't load a live preview for this brand yet. You can still edit each banner in the Banners tab.",
  "We couldn't load player activity, so every deposit, bet and win below reads as zero.": "We couldn't load player activity, so every deposit, bet and win below reads as zero.",
  "We couldn't load the configurator. Please refresh and try again.": "We couldn't load the configurator. Please refresh and try again.",
  "We couldn't load the setup. Please refresh and try again.": "We couldn't load the setup. Please refresh and try again.",
  "We couldn't load this list": "We couldn't load this list",
  "We couldn't load this new look. Please try again later.": "We couldn't load this new look. Please try again later.",
  "We couldn't load this page": "We couldn't load this page",
  "We couldn't load what your home page shows first": "We couldn't load what your home page shows first",
  "We couldn't load your full player list, so only players with activity are shown.": "We couldn't load your full player list, so only players with activity are shown.",
  "We couldn't load your players. Please try again.": "We couldn't load your players. Please try again.",
  "We couldn't load your sessions. Please try again.": "We couldn't load your sessions. Please try again.",
  "We couldn't load your tracking links, so this list isn't narrowed to the landing page.": "We couldn't load your tracking links, so this list isn't narrowed to the landing page.",
  "We couldn't process your last payment. Your casino service will be discontinued if payment isn't completed.": "We couldn't process your last payment. Your casino service will be discontinued if payment isn't completed.",
  "We couldn’t process your logo. Please try again.": "We couldn’t process your logo. Please try again.",
  "We couldn't publish some lists. Try again.": "We couldn't publish some lists. Try again.",
  "We couldn't publish the lists on this page. Try again.": "We couldn't publish the lists on this page. Try again.",
  "We couldn't publish these changes. Try again.": "We couldn't publish these changes. Try again.",
  "We couldn't publish these lists. Try again.": "We couldn't publish these lists. Try again.",
  "We couldn't publish this list. Try again.": "We couldn't publish this list. Try again.",
  "We couldn't reach your website": "We couldn't reach your website",
  "We couldn't read that image. Try another file.": "We couldn't read that image. Try another file.",
  "We couldn't read your main wallet balance, so this top-up can't be confirmed yet.": "We couldn't read your main wallet balance, so this top-up can't be confirmed yet.",
  "We couldn't rebuild every variant. Replace the missing ones individually.": "We couldn't rebuild every variant. Replace the missing ones individually.",
  "We couldn't send the code. Please try again.": "We couldn't send the code. Please try again.",
  "We couldn't send your request. Please try again.": "We couldn't send your request. Please try again.",
  "We couldn’t start checkout": "We couldn’t start checkout",
  "We couldn't start the card payment. Check your connection and try again.": "We couldn't start the card payment. Check your connection and try again.",
  "We couldn't start this change. If something else is still being updated, wait for it to finish and try again.": "We couldn't start this change. If something else is still being updated, wait for it to finish and try again.",
  "We couldn't undo the publish. Try again.": "We couldn't undo the publish. Try again.",
  "We couldn't upload that logo right now. Please try again.": "We couldn't upload that logo right now. Please try again.",
  "We don't have full domain details for this casino.": "We don't have full domain details for this casino.",
  "We have sent an email to:": "We have sent an email to:",
  "We have sent you a secure login link to your email address.": "We have sent you a secure login link to your email address.",
  "We keep invoices and payment records for as long as tax and accounting laws require (typically 5 to 7 years).": "We keep invoices and payment records for as long as tax and accounting laws require (typically 5 to 7 years).",
  "We need your email to save your work to your account and sign you back in.": "We need your email to save your work to your account and sign you back in.",
  "We promote your website where your audience is": "We promote your website where your audience is",
  "We received your account deletion request and emailed you a confirmation. Our data protection team will review it and email you with the next steps.": "We received your account deletion request and emailed you a confirmation. Our data protection team will review it and email you with the next steps.",
  "We received your account deletion request and sent a confirmation to {{email}}. Our data protection team will review it and email you with the next steps.": "We received your account deletion request and sent a confirmation to {{email}}. Our data protection team will review it and email you with the next steps.",
  "We sent a link to your email to finish signing in.": "We sent a link to your email to finish signing in.",
  "We sent the contract to {{email}} again.": "We sent the contract to {{email}} again.",
  "We sent the contract to {{email}} on {{date}}. Check your inbox.": "We sent the contract to {{email}} on {{date}}. Check your inbox.",
  "We sent the contract to {{email}}.": "We sent the contract to {{email}}.",
  "We will deduct {{price}} from your balance, once": "We will deduct {{price}} from your balance, once",
  "We will email you a confirmation code to set a new password.": "We will email you a confirmation code to set a new password.",
  "We will use your logo on the website and on channels used to communicate with players, such as emails and notifications.": "We will use your logo on the website and on channels used to communicate with players, such as emails and notifications.",
  "We’ll analyze the market in {{region}} and recommend the best gamification setup for your brand": "We’ll analyze the market in {{region}} and recommend the best gamification setup for your brand",
  "We'll confirm by email as soon as your SPEI transfer arrives. You can start personalizing your brand in Owner Studio right away.": "We'll confirm by email as soon as your SPEI transfer arrives. You can start personalizing your brand in Owner Studio right away.",
  "We’ll email you a magic link for a password-free sign in.": "We’ll email you a magic link for a password-free sign in.",
  "We'll give you the account details for the transfer on the next screen.": "We'll give you the account details for the transfer on the next screen.",
  "We'll give you the account details for the transfer on the next screen. Tell us who to send the confirmation to, and the name the transfer will come from.": "We'll give you the account details for the transfer on the next screen. Tell us who to send the confirmation to, and the name the transfer will come from.",
  "We'll show you a Pix QR code and a Pix Copia e Cola code on the next screen.": "We'll show you a Pix QR code and a Pix Copia e Cola code on the next screen.",
  "We're confirming your payment. This can take a few minutes, no action needed.": "We're confirming your payment. This can take a few minutes, no action needed.",
  "We're finishing this. You'll be able to run it from here.": "We're finishing this. You'll be able to run it from here.",
  "We're still waiting for your bank transfer to arrive. You can finish setting everything up now, and launch as soon as the payment lands. We'll email you the moment it does.": "We're still waiting for your bank transfer to arrive. You can finish setting everything up now, and launch as soon as the payment lands. We'll email you the moment it does.",
  "We've lost track of that update. It may still be running, so check back in a minute.": "We've lost track of that update. It may still be running, so check back in a minute.",
  "Weak password": "Weak password",
  "Weakest CPA, Lumio scaled it back": "Weakest CPA, Lumio scaled it back",
  "Web": "Web",
  "Web ${{amount}}": "Web ${{amount}}",
  "Web Ads": "Web Ads",
  "Web Networks": "Web Networks",
  "Webmail": "Webmail",
  "Webmail could not be opened. Sign in with the mailbox password instead.": "Webmail could not be opened. Sign in with the mailbox password instead.",
  "Website": "Website",
  "WEBSITE": "WEBSITE",
  "Website · Blog": "Website · Blog",
  "Website · Game Lists": "Website · Game Lists",
  "Website · Logos": "Website · Logos",
  "Website · Website Creatives": "Website · Website Creatives",
  "Website analytics": "Website analytics",
  "Website Analytics": "Website Analytics",
  "Website and landing pages": "Website and landing pages",
  "Website art": "Website art",
  "Website browsers": "Website browsers",
  "Website creation": "Website creation",
  "Website Creatives": "Website Creatives",
  "Website Creatives sections": "Website Creatives sections",
  "Website Currency": "Website Currency",
  "Website currency saved": "Website currency saved",
  "Website data": "Website data",
  "Website domain": "Website domain",
  "Website Domain": "Website Domain",
  "Website Logos": "Website Logos",
  "Website look": "Website look",
  "Website Name": "Website Name",
  "Website pages": "Website pages",
  "Website people": "Website people",
  "Website Settings": "Website Settings",
  "Website stats are not available yet": "Website stats are not available yet",
  "Website traffic data is not ready": "Website traffic data is not ready",
  "Website traffic quality is busy; try again": "Website traffic quality is busy; try again",
  "Website traffic quality took too long": "Website traffic quality took too long",
  "Website visitors": "Website visitors",
  "Website visits": "Website visits",
  "Website, then <0/>, whenever you want a look of your own.": "Website, then <0/>, whenever you want a look of your own.",
  "Website, then <0/>, whenever you want another.": "Website, then <0/>, whenever you want another.",
  "Website, then <0/>: the switch beside its title turns it on.": "Website, then <0/>: the switch beside its title turns it on.",
  "Website, then Blog: <0/> starts every post.": "Website, then Blog: <0/> starts every post.",
  "Website, then Blog: the <0/> switch, whenever you want your blog to post by itself.": "Website, then Blog: the <0/> switch, whenever you want your blog to post by itself.",
  "Welcome bonus": "Welcome bonus",
  "Welcome bonus storyboard": "Welcome bonus storyboard",
  "Welcome bonuses, cash drops, drops & wins.": "Welcome bonuses, cash drops, drops & wins.",
  "Welcome offer": "Welcome offer",
  "Welcome to {{brand}}": "Welcome to {{brand}}",
  "What {{label}} is used for": "What {{label}} is used for",
  "What a video ad can be about": "What a video ad can be about",
  "What an HTML5 banner can advertise": "What an HTML5 banner can advertise",
  "What an image banner can advertise": "What an image banner can advertise",
  "What credits are for": "What credits are for",
  "What do you want to advertise?": "What do you want to advertise?",
  "What is the domain you want to connect?": "What is the domain you want to connect?",
  "What is the domain you want to link to {{brand}}?": "What is the domain you want to link to {{brand}}?",
  "What it cost is not refunded.": "What it cost is not refunded.",
  "What Lumio generates": "What Lumio generates",
  "What Lumio reads to build your style.": "What Lumio reads to build your style.",
  "What Lumio writes": "What Lumio writes",
  "What makes this person worth reading on this subject": "What makes this person worth reading on this subject",
  "What people use to open these pages": "What people use to open these pages",
  "What people use to open this page": "What people use to open this page",
  "What people use to open your website": "What people use to open your website",
  "What players see: the website with its banners, games and blog, and the ads you run elsewhere.": "What players see: the website with its banners, games and blog, and the ads you run elsewhere.",
  "What should change?": "What should change?",
  "What should this article cover? Say it in your own words.": "What should this article cover? Say it in your own words.",
  "What the article is about": "What the article is about",
  "What the article's claims rest on, printed as a numbered list at the end.": "What the article's claims rest on, printed as a numbered list at the end.",
  "What the casino won from their play": "What the casino won from their play",
  "What the diagram shows": "What the diagram shows",
  "What the games are about.": "What the games are about.",
  "What to add": "What to add",
  "What to aim for": "What to aim for",
  "What to edit on this page": "What to edit on this page",
  "What visitors see first on your home page, before its sections.": "What visitors see first on your home page, before its sections.",
  "What we delete": "What we delete",
  "What would you like to name your iGaming website?": "What would you like to name your iGaming website?",
  "WhatsApp": "WhatsApp",
  "Wheel": "Wheel",
  "Wheel disc": "Wheel disc",
  "Wheel frame": "Wheel frame",
  "Wheel frame, lit": "Wheel frame, lit",
  "Wheel hub": "Wheel hub",
  "Wheel pointer": "Wheel pointer",
  "When it is on, every new banner and image Lumio makes for your brand follows this style.": "When it is on, every new banner and image Lumio makes for your brand follows this style.",
  "When you upload a new primary logo, our AI regenerates every variant from it. This can take a few minutes.": "When you upload a new primary logo, our AI regenerates every variant from it. This can take a few minutes.",
  "Whenever you have news.": "Whenever you have news.",
  "Whenever you like.": "Whenever you like.",
  "Where affiliates send players": "Where affiliates send players",
  "Where it runs": "Where it runs",
  "Where people come from": "Where people come from",
  "Where should this link send people?": "Where should this link send people?",
  "Where should this publish?": "Where should this publish?",
  "Where the button goes": "Where the button goes",
  "Where visitors come from": "Where visitors come from",
  "Where you're signed in": "Where you're signed in",
  "Which games should be in this list?": "Which games should be in this list?",
  "Which of your art styles this draw follows. Manage them on the Art Style tab.": "Which of your art styles this draw follows. Manage them on the Art Style tab.",
  "Which of your characters appears. Auto picks a different one each time.": "Which of your characters appears. Auto picks a different one each time.",
  "Which of your mascots appears. Auto picks a different one each time.": "Which of your mascots appears. Auto picks a different one each time.",
  "Which system?": "Which system?",
  "Whip around the celebration as the win detonates, light flares sweeping while the \"{{subtitle}}\" detail rockets in as bright supporting text.": "Whip around the celebration as the win detonates, light flares sweeping while the \"{{subtitle}}\" detail rockets in as bright supporting text.",
  "Whirl through the cascading coins as the reward peaks and the \"{{subtitle}}\" detail rockets in as bright supporting text.": "Whirl through the cascading coins as the reward peaks and the \"{{subtitle}}\" detail rockets in as bright supporting text.",
  "Why estimated?": "Why estimated?",
  "Why that is the right answer.": "Why that is the right answer.",
  "Win amount": "Win amount",
  "Win message": "Win message",
  "Win message title": "Win message title",
  "Win-back": "Win-back",
  "Windows PC": "Windows PC",
  "Windows phone": "Windows phone",
  "Wins": "Wins",
  "Wiring everything up…": "Wiring everything up…",
  "Wiring up the bonus and rewards engine": "Wiring up the bonus and rewards engine",
  "With no password we return a one-time invite link for the partner to set their own.": "With no password we return a one-time invite link for the partner to set their own.",
  "With none added, your promotions' key visuals drive the look and feel.": "With none added, your promotions' key visuals drive the look and feel.",
  "With these filters, one browser on your site and on its landing pages counts once.": "With these filters, one browser on your site and on its landing pages counts once.",
  "Withdrawal": "Withdrawal",
  "Withdrawal currency": "Withdrawal currency",
  "Withdrawal rejected": "Withdrawal rejected",
  "Withdrawals": "Withdrawals",
  "Within budget": "Within budget",
  "Won't renew": "Won't renew",
  "Won't renew · ends {{date}}": "Won't renew · ends {{date}}",
  "Wordmark": "Wordmark",
  "Wordmark · black": "Wordmark · black",
  "Wordmark · horizontal": "Wordmark · horizontal",
  "Wordmark · white": "Wordmark · white",
  "Wordmark (black)": "Wordmark (black)",
  "Wordmark (white)": "Wordmark (white)",
  "Words": "Words",
  "Words: {{count}}": "Words: {{count}}",
  "Working on it…": "Working on it…",
  "World Wide": "World Wide",
  "Worth fixing (you can also do it after publishing):": "Worth fixing (you can also do it after publishing):",
  "Write a text for this page": "Write a text for this page",
  "Write the article body": "Write the article body",
  "Write the article first": "Write the article first",
  "Write the headline and call to action, then confirm the copy to generate.": "Write the headline and call to action, then confirm the copy to generate.",
  "Write this article": "Write this article",
  "Write your first article": "Write your first article",
  "Write your legal line": "Write your legal line",
  "Write your own text": "Write your own text",
  "Writing": "Writing",
  "Writing {{n}} articles": "Writing {{n}} articles",
  "Writing 1 article": "Writing 1 article",
  "Writing the draft…": "Writing the draft…",
  "Writing the quiz…": "Writing the quiz…",
  "Writing your style": "Writing your style",
  "Written by": "Written by",
  "Written for {{written}}.": "Written for {{written}}.",
  "www.": "www.",
  "XRP Ledger": "XRP Ledger",
  "Yes": "Yes",
  "Yes, show me": "Yes, show me",
  "yesterday": "yesterday",
  "Yesterday": "Yesterday",
  "yesterday at this time": "yesterday at this time",
  "You": "You",
  "You & Market": "You & Market",
  "You already have that mailbox.": "You already have that mailbox.",
  "You and Market": "You and Market",
  "You are about to create a tailored setup. Please note that choosing individual gamification features may result in different pricing compared to our recommended bundles, and ": "You are about to create a tailored setup. Please note that choosing individual gamification features may result in different pricing compared to our recommended bundles, and ",
  "You are not ranked yet. Here is the field you are joining: real numbers from brands that started where you are.": "You are not ranked yet. Here is the field you are joining: real numbers from brands that started where you are.",
  "You are still signed in on this device.": "You are still signed in on this device.",
  "You can always add or remove gamification features later.": "You can always add or remove gamification features later.",
  "You can change the logo within 14 days after going live, or until you hit 50 registered users.": "You can change the logo within 14 days after going live, or until you hit 50 registered users.",
  "You can now personalize your new brand and take it live by visiting Owner Studio.": "You can now personalize your new brand and take it live by visiting Owner Studio.",
  "You can now sign in with your new password.": "You can now sign in with your new password.",
  "You can resend the contract again in a few minutes.": "You can resend the contract again in a few minutes.",
  "You can retry the regeneration on the Art Style page.": "You can retry the regeneration on the Art Style page.",
  "You can safely close this page. You’ve got everything you need in your inbox.": "You can safely close this page. You’ve got everything you need in your inbox.",
  "You can start a new brand anytime from the brand switcher at the top of the page.": "You can start a new brand anytime from the brand switcher at the top of the page.",
  "You can start again tomorrow.": "You can start again tomorrow.",
  "You can still change it until {{count}} players have registered.": "You can still change it until {{count}} players have registered.",
  "You can still replace your logos. To protect your brand and your players, changes stay open until {{maxUsers}} players have registered ({{registeredUsers}} so far).": "You can still replace your logos. To protect your brand and your players, changes stay open until {{maxUsers}} players have registered ({{registeredUsers}} so far).",
  "You can still replace your primary logo — {{daysLeft}} days left in the {{maxDays}}-day window, and {{registeredUsers}} of {{maxUsers}} players registered.": "You can still replace your primary logo — {{daysLeft}} days left in the {{maxDays}}-day window, and {{registeredUsers}} of {{maxUsers}} players registered.",
  "You can still replace your primary logo: {{daysLeft}} days left in the {{maxDays}}-day window, and {{registeredUsers}} of {{maxUsers}} players registered.": "You can still replace your primary logo: {{daysLeft}} days left in the {{maxDays}}-day window, and {{registeredUsers}} of {{maxUsers}} players registered.",
  "You can still try its own page in Marketing Assets.": "You can still try its own page in Marketing Assets.",
  "You changed the setup. Regenerate the storyboard to match.": "You changed the setup. Regenerate the storyboard to match.",
  "You choose every game. The list changes only when you edit it.": "You choose every game. The list changes only when you edit it.",
  "You do not have access to this tenant": "You do not have access to this tenant",
  "You have {{count}} decisions waiting on you.": "You have {{count}} decisions waiting on you.",
  "You have {{count}} decisions waiting on you._one": "You have {{count}} decision waiting on you.",
  "You have {{count}} decisions waiting on you._other": "You have {{count}} decisions waiting on you.",
  "You have a new logo": "You have a new logo",
  "You have no active sessions.": "You have no active sessions.",
  "You need a USD Main wallet to buy credits.": "You need a USD Main wallet to buy credits.",
  "You start here": "You start here",
  "You started building a website but haven't completed checkout. Pick up right where you left off.": "You started building a website but haven't completed checkout. Pick up right where you left off.",
  "You vs Market": "You vs Market",
  "You'll be charged {{amount}}": "You'll be charged {{amount}}",
  "You'll find the DNS configuration any time in your Settings area.": "You'll find the DNS configuration any time in your Settings area.",
  "You'll pay by card.": "You'll pay by card.",
  "You'll sign in to your account on a secure {{provider}} page and approve the connection. We never see your password. This process does not transfer your domain. It stays in your {{provider}} account, fully yours.": "You'll sign in to your account on a secure {{provider}} page and approve the connection. We never see your password. This process does not transfer your domain. It stays in your {{provider}} account, fully yours.",
  "You’re all caught up. No proposals waiting.": "You’re all caught up. No proposals waiting.",
  "You're all set.": "You're all set.",
  "You're buying": "You're buying",
  "You're responsible for the artwork you upload. Don't upload anything illegal, or anything you don't hold the rights to use.": "You're responsible for the artwork you upload. Don't upload anything illegal, or anything you don't hold the rights to use.",
  "you@email.com": "you@email.com",
  "you@example.com": "you@example.com",
  "YOUR": "YOUR",
  "Your {{brandName}} brand is secured": "Your {{brandName}} brand is secured",
  "Your {{kind}} start here": "Your {{kind}} start here",
  "Your account email must be verified before you can manage affiliates. Verify it in Settings, then reload.": "Your account email must be verified before you can manage affiliates. Verify it in Settings, then reload.",
  "Your active style changed since this art was drawn. Regenerate your website art to bring it up to date.": "Your active style changed since this art was drawn. Regenerate your website art to bring it up to date.",
  "Your ad is ready. It's in the Finished ad card on the canvas, where you can play, download or pick a version.": "Your ad is ready. It's in the Finished ad card on the canvas, where you can play, download or pick a version.",
  "Your ad keeps its place in line": "Your ad keeps its place in line",
  "Your address list could not be read. Try again in a few minutes.": "Your address list could not be read. Try again in a few minutes.",
  "Your address list could not be refreshed, so public and internal addresses come from the last known list.": "Your address list could not be refreshed, so public and internal addresses come from the last known list.",
  "Your Affiliates": "Your Affiliates",
  "Your affiliates and campaigns could not be loaded. Close and open the sheet to try again.": "Your affiliates and campaigns could not be loaded. Close and open the sheet to try again.",
  "Your AI credit top-ups and the credits used to generate visuals and content appear here.": "Your AI credit top-ups and the credits used to generate visuals and content appear here.",
  "Your art in this look": "Your art in this look",
  "Your art style": "Your art style",
  "Your art style couldn't be loaded.": "Your art style couldn't be loaded.",
  "Your art style couldn't be sent to your website.": "Your art style couldn't be sent to your website.",
  "Your art style couldn't be used for your website.": "Your art style couldn't be used for your website.",
  "Your art style starts here": "Your art style starts here",
  "Your art styles": "Your art styles",
  "Your art styles couldn't be loaded.": "Your art styles couldn't be loaded.",
  "Your Asset": "Your Asset",
  "Your balance": "Your balance",
  "Your banner kits": "Your banner kits",
  "Your banners are in here": "Your banners are in here",
  "Your best marketing assets will rank here": "Your best marketing assets will rank here",
  "Your blog is off": "Your blog is off",
  "Your blog is ready, and players can read it the moment it is on.": "Your blog is ready, and players can read it the moment it is on.",
  "Your blog isn't available yet": "Your blog isn't available yet",
  "Your blog starts here": "Your blog starts here",
  "YOUR BRAND": "YOUR BRAND",
  "YOUR BRAND HERE": "YOUR BRAND HERE",
  "Your brand is secured": "Your brand is secured",
  "Your brand is set to launch! Take a moment to review your brand setup and investment information.": "Your brand is set to launch! Take a moment to review your brand setup and investment information.",
  "Your brand name is too long for the contract. Contact support.": "Your brand name is too long for the contract. Contact support.",
  "Your brand's logos in every format.": "Your brand's logos in every format.",
  "Your brand's own characters. Give each one up to {{n}} images of the same character.": "Your brand's own characters. Give each one up to {{n}} images of the same character.",
  "Your brand's own characters. Give each one up to {{n}} images of the same character. Transparent PNG cut-outs work best.": "Your brand's own characters. Give each one up to {{n}} images of the same character. Transparent PNG cut-outs work best.",
  "your casino": "your casino",
  "Your casino blog stops being served right away. Nothing is deleted, but every one of its public pages answers not found until you turn it back on.": "Your casino blog stops being served right away. Nothing is deleted, but every one of its public pages answers not found until you turn it back on.",
  "Your casino is fully deployed.": "Your casino is fully deployed.",
  "Your changes couldn't be saved. Please try again.": "Your changes couldn't be saved. Please try again.",
  "Your characters": "Your characters",
  "Your characters appear wherever they fit": "Your characters appear wherever they fit",
  "Your checkout session expired": "Your checkout session expired",
  "Your checkout session expired. Go back and start again.": "Your checkout session expired. Go back and start again.",
  "Your copy changed, so the lettering redraws on Generate. Until then the page shows the new text as it is.": "Your copy changed, so the lettering redraws on Generate. Until then the page shows the new text as it is.",
  "Your copy changed. The page shows the new text as it is until the lettering is drawn again.": "Your copy changed. The page shows the new text as it is until the lettering is drawn again.",
  "Your creative is now live.": "Your creative is now live.",
  "Your creative is ready.": "Your creative is ready.",
  "Your credits were refunded. Please try again.": "Your credits were refunded. Please try again.",
  "Your current contract will be cancelled and a new one sent.": "Your current contract will be cancelled and a new one sent.",
  "Your custom art style is paused, so new banners and images stop following it.": "Your custom art style is paused, so new banners and images stop following it.",
  "Your custom creatives": "Your custom creatives",
  "Your details": "Your details",
  "Your domain is too long for the contract. Contact support.": "Your domain is too long for the contract. Contact support.",
  "Your earnings after player winnings": "Your earnings after player winnings",
  "Your email address is confirmed. You can continue in the studio.": "Your email address is confirmed. You can continue in the studio.",
  "Your email address is too long for the contract. Contact support.": "Your email address is too long for the contract. Contact support.",
  "Your email is managed by your account and can't be changed here.": "Your email is managed by your account and can't be changed here.",
  "Your first 30 days": "Your first 30 days",
  "Your first mailbox sets up mail for this domain.": "Your first mailbox sets up mail for this domain.",
  "Your foundation": "Your foundation",
  "Your gamification art, with its prize, challenge and shop icons": "Your gamification art, with its prize, challenge and shop icons",
  "Your hero, welcome bonus, promotion banners and gamification art": "Your hero, welcome bonus, promotion banners and gamification art",
  "your homepage": "your homepage",
  "your homepage and promotions page": "your homepage and promotions page",
  "Your homepage keeps the games it opens with.": "Your homepage keeps the games it opens with.",
  "Your homepage opens with your games first.": "Your homepage opens with your games first.",
  "Your HTML5 banners": "Your HTML5 banners",
  "Your HTML5 banners couldn't be loaded. Reload the page to try again.": "Your HTML5 banners couldn't be loaded. Reload the page to try again.",
  "Your iGaming website is live.": "Your iGaming website is live.",
  "Your iGaming website is ready": "Your iGaming website is ready",
  "Your image": "Your image",
  "Your image banners": "Your image banners",
  "Your image banners couldn't be loaded. Reload the page to try again.": "Your image banners couldn't be loaded. Reload the page to try again.",
  "Your images": "Your images",
  "your inbox": "your inbox",
  "Your Influencers": "Your Influencers",
  "Your ingredients changed since this style was written.": "Your ingredients changed since this style was written.",
  "Your ingredients changed since this style was written. Extract again to include them.": "Your ingredients changed since this style was written. Extract again to include them.",
  "Your landing domain couldn't be read, so the page can't be published right now.": "Your landing domain couldn't be read, so the page can't be published right now.",
  "Your landing page is live.": "Your landing page is live.",
  "Your landing page is offline.": "Your landing page is offline.",
  "Your landing page is taking longer than usual": "Your landing page is taking longer than usual",
  "Your landing pages": "Your landing pages",
  "Your landing pages couldn't be loaded. Reload the page to try again.": "Your landing pages couldn't be loaded. Reload the page to try again.",
  "Your language changes right away and is saved to your account.": "Your language changes right away and is saved to your account.",
  "Your last change couldn't be saved. It's still here, so you can try again.": "Your last change couldn't be saved. It's still here, so you can try again.",
  "Your last extraction didn't finish, so new samples would use your previous style. Extract again to use your latest ingredients.": "Your last extraction didn't finish, so new samples would use your previous style. Extract again to use your latest ingredients.",
  "Your last logo change failed": "Your last logo change failed",
  "Your last publish may not have reached your site.": "Your last publish may not have reached your site.",
  "Your last publish was undone.": "Your last publish was undone.",
  "Your latest changes couldn't be saved. Please try again.": "Your latest changes couldn't be saved. Please try again.",
  "Your list": "Your list",
  "Your list is empty": "Your list is empty",
  "Your login link has expired": "Your login link has expired",
  "Your logo": "Your logo",
  "Your logo could not be placed on this size. Generate a new version to try again.": "Your logo could not be placed on this size. Generate a new version to try again.",
  "Your logo could not be placed on this size. Redraw it to try again.": "Your logo could not be placed on this size. Redraw it to try again.",
  "Your logo lives in here": "Your logo lives in here",
  "Your logo stays as it is": "Your logo stays as it is",
  "Your logo, copy and button are not restyled.": "Your logo, copy and button are not restyled.",
  "Your logos are being generated": "Your logos are being generated",
  "Your logos are locked": "Your logos are locked",
  "Your logos are locked and can no longer be replaced.": "Your logos are locked and can no longer be replaced.",
  "Your logos are locked. To protect your brand and your players, logos can't be changed once {{maxUsers}} players have registered ({{registeredUsers}} so far).": "Your logos are locked. To protect your brand and your players, logos can't be changed once {{maxUsers}} players have registered ({{registeredUsers}} so far).",
  "Your logos may have changed. Reload the page to see the current set.": "Your logos may have changed. Reload the page to see the current set.",
  "Your logos were rebuilt from the new primary logo": "Your logos were rebuilt from the new primary logo",
  "Your mail client needs these to connect: it will not find them by itself.": "Your mail client needs these to connect: it will not find them by itself.",
  "Your mailboxes can be set up once the domain is ready to receive mail. That usually takes a few minutes, and can take up to 48 hours to reach every network.": "Your mailboxes can be set up once the domain is ready to receive mail. That usually takes a few minutes, and can take up to 48 hours to reach every network.",
  "Your main logo · every variant is generated from it.": "Your main logo · every variant is generated from it.",
  "Your main logo and each of its variants. Download any of them, or replace one with your own artwork.": "Your main logo and each of its variants. Download any of them, or replace one with your own artwork.",
  "Your main logo and the variants generated from it. Download any variant, or replace your primary logo while the edit window is open.": "Your main logo and the variants generated from it. Download any variant, or replace your primary logo while the edit window is open.",
  "Your main logo, used across your website and emails.": "Your main logo, used across your website and emails.",
  "Your main wallet does not cover this mailbox, so it was not created and nothing was charged. Add funds, then create it again.": "Your main wallet does not cover this mailbox, so it was not created and nothing was charged. Add funds, then create it again.",
  "Your Main wallet doesn't cover this. Add {{amount}} to it first.": "Your Main wallet doesn't cover this. Add {{amount}} to it first.",
  "Your main wallet holds {{balance}}. Add {{shortfall}} to cover this top-up.": "Your main wallet holds {{balance}}. Add {{shortfall}} to cover this top-up.",
  "Your main wallet is held in {{held}}, and this top-up is priced in {{priced}}, so it can't fund this one.": "Your main wallet is held in {{held}}, and this top-up is priced in {{priced}}, so it can't fund this one.",
  "Your market's collections could not be read": "Your market's collections could not be read",
  "Your marketing offers aren't available right now ({{reason}}). You can continue without one.": "Your marketing offers aren't available right now ({{reason}}). You can continue without one.",
  "Your marketing offers aren't available right now. You can continue without one.": "Your marketing offers aren't available right now. You can continue without one.",
  "Your marketing offers couldn't be loaded. You can continue without one.": "Your marketing offers couldn't be loaded. You can continue without one.",
  "Your message is a little too short": "Your message is a little too short",
  "Your mini-games": "Your mini-games",
  "Your mini-games couldn't be loaded. Reload the page to try again.": "Your mini-games couldn't be loaded. Reload the page to try again.",
  "Your new art is kept. You can switch to it again at any time.": "Your new art is kept. You can switch to it again at any time.",
  "Your new iGaming website is waiting": "Your new iGaming website is waiting",
  "Your new website art is ready": "Your new website art is ready",
  "Your new website is ready to customize. Complete a few quick steps to take it live.": "Your new website is ready to customize. Complete a few quick steps to take it live.",
  "Your offer": "Your offer",
  "Your online casino will operate in": "Your online casino will operate in",
  "Your original look couldn't be put back": "Your original look couldn't be put back",
  "Your original look couldn't be put back. Please try again.": "Your original look couldn't be put back. Please try again.",
  "Your own game lists are not available yet.": "Your own game lists are not available yet.",
  "Your own game lists could not be loaded.": "Your own game lists could not be loaded.",
  "Your own id": "Your own id",
  "Your own image URL": "Your own image URL",
  "Your own order from the start": "Your own order from the start",
  "Your page with your changes. They show in this preview only.": "Your page with your changes. They show in this preview only.",
  "Your parcel is on its way": "Your parcel is on its way",
  "Your partners live in Acquisition": "Your partners live in Acquisition",
  "Your password has been changed.": "Your password has been changed.",
  "Your payment went through, but the new balance hasn't appeared yet. It can take a few minutes.": "Your payment went through, but the new balance hasn't appeared yet. It can take a few minutes.",
  "Your PDF is downloaded.": "Your PDF is downloaded.",
  "Your pending {{name}} {{tier}} upgrade won't go through and the {{amount}} invoice will be cancelled. This can't be undone, and you won't be charged.": "Your pending {{name}} {{tier}} upgrade won't go through and the {{amount}} invoice will be cancelled. This can't be undone, and you won't be charged.",
  "Your pool is empty. Create banners in All Promotions & Creatives first.": "Your pool is empty. Create banners in All Promotions & Creatives first.",
  "Your previous contract expired.": "Your previous contract expired.",
  "Your previous contract was cancelled.": "Your previous contract was cancelled.",
  "Your previous contract was declined.": "Your previous contract was declined.",
  "Your primary art style": "Your primary art style",
  "Your primary logo and every generated variant will appear here once the Logos step of your website's deployment finishes. You can follow its progress in Technical details below.": "Your primary logo and every generated variant will appear here once the Logos step of your website's deployment finishes. You can follow its progress in Technical details below.",
  "Your primary logo and every variant will appear here once the Logos step of your website's deployment finishes.": "Your primary logo and every variant will appear here once the Logos step of your website's deployment finishes.",
  "Your primary logo and its variants will appear here once they have been generated.": "Your primary logo and its variants will appear here once they have been generated.",
  "Your profile: name, company, address and sign-in email": "Your profile: name, company, address and sign-in email",
  "Your promotion's link by default. The visitor's tracking is added to it when the page is live.": "Your promotion's link by default. The visitor's tracking is added to it when the page is live.",
  "your promotions page": "your promotions page",
  "Your Pulse page comes into focus as new data arrives.": "Your Pulse page comes into focus as new data arrives.",
  "Your question": "Your question",
  "your region": "your region",
  "Your roadmap": "Your roadmap",
  "Your samples and website art follow them.": "Your samples and website art follow them.",
  "Your samples appear here as soon as your style is written.": "Your samples appear here as soon as your style is written.",
  "Your samples are still drawing.": "Your samples are still drawing.",
  "Your samples may still be drawing. We couldn't confirm they started, so your credits were refunded. Regenerate samples draws a new set.": "Your samples may still be drawing. We couldn't confirm they started, so your credits were refunded. Regenerate samples draws a new set.",
  "Your section": "Your section",
  "Your session expired. Please try connecting again.": "Your session expired. Please try connecting again.",
  "Your session has ended, so sign in again to continue.": "Your session has ended, so sign in again to continue.",
  "Your session has ended, so sign in again to see your mailboxes.": "Your session has ended, so sign in again to see your mailboxes.",
  "Your settings and saved preferences": "Your settings and saved preferences",
  "Your signed copy is being prepared. Try again in a minute.": "Your signed copy is being prepared. Try again in a minute.",
  "Your single-clip video ads": "Your single-clip video ads",
  "Your site already shows its original look.": "Your site already shows its original look.",
  "Your site already shows this style, so players see the new art as each part is drawn. It can take a few hours; you can leave this page.": "Your site already shows this style, so players see the new art as each part is drawn. It can take a few hours; you can leave this page.",
  "Your site already shows this style, so players see the new art as each part is drawn. The art they see now is not kept. Your original look stays available.": "Your site already shows this style, so players see the new art as each part is drawn. The art they see now is not kept. Your original look stays available.",
  "Your site changed since this image was drawn, so it can't be applied. Your credits were refunded.": "Your site changed since this image was drawn, so it can't be applied. Your credits were refunded.",
  "Your site couldn't be switched": "Your site couldn't be switched",
  "Your site couldn't be switched. Please try again.": "Your site couldn't be switched. Please try again.",
  "Your site goes back to what it showed before your last publish.": "Your site goes back to what it showed before your last publish.",
  "Your site has no art to redraw yet.": "Your site has no art to redraw yet.",
  "Your site images": "Your site images",
  "Your site is back on the previous published order.": "Your site is back on the previous published order.",
  "Your site is back on this list's own order.": "Your site is back on this list's own order.",
  "Your site is busy right now. Please try again shortly.": "Your site is busy right now. Please try again shortly.",
  "Your site is busy with other changes. Please try again in a few minutes.": "Your site is busy with other changes. Please try again in a few minutes.",
  "Your site keeps its current art until the new art is ready": "Your site keeps its current art until the new art is ready",
  "Your site keeps its current look until you set this one as primary. Preview it on your site first.": "Your site keeps its current look until you set this one as primary. Preview it on your site first.",
  "Your site keeps its current look until you switch. Preview it on your site first.": "Your site keeps its current look until you switch. Preview it on your site first.",
  "Your site placements will appear here once your creatives are generated.": "Your site placements will appear here once your creatives are generated.",
  "Your site shows these changes once you publish them. A hidden list keeps its place, so showing it again puts it back there.": "Your site shows these changes once you publish them. A hidden list keeps its place, so showing it again puts it back there.",
  "Your site shows your own look, so players see the new art as each part is drawn. The art they see now is not kept.": "Your site shows your own look, so players see the new art as each part is drawn. The art they see now is not kept.",
  "Your site switches to the new art once all of it is drawn. It can take a few hours; you can leave this page.": "Your site switches to the new art once all of it is drawn. It can take a few hours; you can leave this page.",
  "Your site switches to the new art once all of it is drawn. Until then, players see your current look.": "Your site switches to the new art once all of it is drawn. Until then, players see your current look.",
  "Your site was busy with other changes for too long.": "Your site was busy with other changes for too long.",
  "Your site's original look isn't on record, so it can't be put back.": "Your site's original look isn't on record, so it can't be put back.",
  "Your site's pages": "Your site's pages",
  "Your style changed since these samples were drawn.": "Your style changed since these samples were drawn.",
  "Your style is no longer primary.": "Your style is no longer primary.",
  "your style, drawn in four samples.": "your style, drawn in four samples.",
  "Your style's characters, wherever they fit": "Your style's characters, wherever they fit",
  "Your tracking link is not ready yet. Open the affiliate console to copy it, or try again shortly.": "Your tracking link is not ready yet. Open the affiliate console to copy it, or try again shortly.",
  "Your tracking link is not ready yet. Try again shortly.": "Your tracking link is not ready yet. Try again shortly.",
  "Your tracking links are out there. As soon as someone signs up through one, its asset ranks here.": "Your tracking links are out there. As soon as someone signs up through one, its asset ranks here.",
  "Your uploaded creative": "Your uploaded creative",
  "Your video ads": "Your video ads",
  "Your video ads couldn't be loaded. Reload the page to try again.": "Your video ads couldn't be loaded. Reload the page to try again.",
  "Your video is ready.": "Your video is ready.",
  "Your wallet": "Your wallet",
  "Your wallet · ({{balance}})": "Your wallet · ({{balance}})",
  "Your website": "Your website",
  "Your website and landing pages together": "Your website and landing pages together",
  "your website and new banners follow it.": "your website and new banners follow it.",
  "Your website art": "Your website art",
  "Your website art can't be changed here right now.": "Your website art can't be changed here right now.",
  "Your website art couldn't be finished": "Your website art couldn't be finished",
  "Your website art couldn't be started. Please try again.": "Your website art couldn't be started. Please try again.",
  "Your website art in {{style}} is ready": "Your website art in {{style}} is ready",
  "Your website art in this look is ready. Set it as primary to show it to players.": "Your website art in this look is ready. Set it as primary to show it to players.",
  "Your website art is already being changed. You can follow it on this page.": "Your website art is already being changed. You can follow it on this page.",
  "Your website art is being redrawn. This banner's new look shows here as soon as it's done.": "Your website art is being redrawn. This banner's new look shows here as soon as it's done.",
  "Your website art is being regenerated. Try again once that is done.": "Your website art is being regenerated. Try again once that is done.",
  "Your website couldn't be reached.": "Your website couldn't be reached.",
  "Your website did not send the games in this list. Please try again.": "Your website did not send the games in this list. Please try again.",
  "Your website did not send the sections of this page. Please try again.": "Your website did not send the sections of this page. Please try again.",
  "Your website doesn't list the sections of this page, so they can't be hidden or added to here.": "Your website doesn't list the sections of this page, so they can't be hidden or added to here.",
  "Your website has no art in this look yet": "Your website has no art in this look yet",
  "Your website has no footer legal text, so the page shows none.": "Your website has no footer legal text, so the page shows none.",
  "Your website has no legal text in this page's languages.": "Your website has no legal text in this page's languages.",
  "Your website is competitive": "Your website is competitive",
  "Your website is deployed and serving players.": "Your website is deployed and serving players.",
  "Your website is leading the market": "Your website is leading the market",
  "Your website is live": "Your website is live",
  "Your website is live 🎉": "Your website is live 🎉",
  "Your website is not available yet": "Your website is not available yet",
  "Your website is not live yet": "Your website is not live yet",
  "Your website is set to launch!": "Your website is set to launch!",
  "Your website isn't deployed yet, so country access can't be saved.": "Your website isn't deployed yet, so country access can't be saved.",
  "Your website needs attention": "Your website needs attention",
  "Your website shows {{style}}": "Your website shows {{style}}",
  "Your website shows its original look": "Your website shows its original look",
  "Your website shows this look now.": "Your website shows this look now.",
  "Your website shows your art style": "Your website shows your art style",
  "Your website switches to {{look}}.": "Your website switches to {{look}}.",
  "Your website theme": "Your website theme",
  "Your website's art style will appear here soon.": "Your website's art style will appear here soon.",
  "Your website's colours and button style, so the banner looks like your site. You can still change them.": "Your website's colours and button style, so the banner looks like your site. You can still change them.",
  "Your website's colours and button style, so the game looks like your site. You can still change them.": "Your website's colours and button style, so the game looks like your site. You can still change them.",
  "Your website's homepage": "Your website's homepage",
  "Your website's languages couldn't be loaded.": "Your website's languages couldn't be loaded.",
  "Your website's legal footer couldn't be loaded.": "Your website's legal footer couldn't be loaded.",
  "Your website's operating region cannot be changed later.": "Your website's operating region cannot be changed later.",
  "Your welcome bonus, hero and promotion banners": "Your welcome bonus, hero and promotion banners",
  "Your welcome offer": "Your welcome offer",
  "Your welcome offer leads the page. Pick a promotion or up to 4 games to lead with instead.": "Your welcome offer leads the page. Pick a promotion or up to 4 games to lead with instead.",
  "Yours live here, in <0/>.": "Yours live here, in <0/>.",
  "Zoom in": "Zoom in",
  "Zoom out": "Zoom out"
}
